var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

module.exports = function (e, n) {
  "use strict";

  var t = {};

  function __webpack_require__(n) {
    if (t[n]) {
      return t[n].exports;
    }

    var a = t[n] = {
      i: n,
      l: false,
      exports: {}
    };
    e[n].call(a.exports, a, a.exports, __webpack_require__);
    a.l = true;
    return a.exports;
  }

  return __webpack_require__(732);
}({
  336: function _(e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: true
    });
    var a = t(946);
    var r = t(623);

    var LightweightWriter = /*#__PURE__*/function (_r$SceneWriter) {
      _inherits(LightweightWriter, _r$SceneWriter);

      function LightweightWriter() {
        var _this;

        _classCallCheck(this, LightweightWriter);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(LightweightWriter).apply(this, arguments));
        _this.instanceCount = 0;
        _this.nameMapping = {};
        return _this;
      }

      _createClass(LightweightWriter, [{
        key: "addEntity",
        value: function addEntity(e, n) {
          if (this.entities.has(e)) {
            throw new Error("There is already an entity with name \"".concat(e, "\""));
          }

          this.nameMapping[e] = ++this.instanceCount;
          this.entities.set(e, n);
        }
      }, {
        key: "getEntityName",
        value: function getEntityName(e) {
          var n = _get(_getPrototypeOf(LightweightWriter.prototype), "getEntityName", this).call(this, e);

          if (!n) {
            return n;
          }

          return "" + this.nameMapping[n];
        }
      }, {
        key: "stepPrologue",
        value: function stepPrologue() {
          return "dcl.subscribe('sceneStart');\n";
        }
      }, {
        key: "stepStartEntity",
        value: function stepStartEntity(e, n) {
          return "dcl.addEntity('".concat(n, "');\n");
        }
      }, {
        key: "stepSetEntityParent",
        value: function stepSetEntityParent(e, n, t) {
          var a = "0";

          if (t) {
            a = this.getEntityName(t);

            if (!a) {
              throw new Error("Parent entity of \"".concat(_get(_getPrototypeOf(LightweightWriter.prototype), "getEntityName", this).call(this, e), "\" is missing, you should add parents first."));
            }
          }

          return "dcl.setParent('".concat(n, "', '").concat(a, "');\n");
        }
      }, {
        key: "stepWriteComponentDeclaration",
        value: function stepWriteComponentDeclaration(e, n, t, r) {
          if (a.getComponentName(n) === "engine.transform") {
            return "dcl.updateEntityComponent('".concat(this.getEntityName(e), "', 'engine.transform', ").concat(a.getComponentClassId(n), ", JSON.stringify(").concat(JSON.stringify(n), "));\n");
          }

          return "dcl.componentCreated('".concat(t, "', '").concat(a.getComponentName(n), "', ").concat(a.getComponentClassId(n), ");\ndcl.componentUpdated('").concat(t, "', JSON.stringify(").concat(JSON.stringify(n), "));\n");
        }
      }, {
        key: "stepSetComponentParent",
        value: function stepSetComponentParent(e, n, t, r) {
          var o = a.getComponentClassId(r);

          if (o !== null) {
            if (a.isDisposableComponent(r)) {
              return "dcl.attachEntityComponent('".concat(n, "', '").concat(a.getComponentName(r), "', '").concat(t, "');\n");
            }
          }

          return "";
        }
      }, {
        key: "writeComponent",
        value: function writeComponent(e, n, t) {
          return "";
        }
      }]);

      return LightweightWriter;
    }(r.SceneWriter);

    n.LightweightWriter = LightweightWriter;
  },
  546: function _(e, n) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: true
    });

    function isLowerCaseChar(e) {
      return !!e && e.length === 1 && e.toLowerCase() === e;
    }

    n.isLowerCaseChar = isLowerCaseChar;

    function toCamelCase(e) {
      var n = "";
      var t = true;

      for (var a = 0; a < e.length; a++) {
        n += t ? e[a].toLowerCase() : e[a];

        if (a < e.length - 2 && isLowerCaseChar(e[a + 2])) {
          t = false;
        }
      }

      return n;
    }

    n.toCamelCase = toCamelCase;
    n.blacklist = ["Shape", "ObservableComponent"];
  },
  623: function _(e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: true
    });
    var a = t(546);

    var SceneWriter = /*#__PURE__*/function () {
      function SceneWriter(e, n) {
        _classCallCheck(this, SceneWriter);

        this.entities = new Map();
        this.DCL = e;
        this.map = n || t(847);
      }

      _createClass(SceneWriter, [{
        key: "addEntity",
        value: function addEntity(e, n) {
          if (this.entities.has(e)) {
            throw new Error("There is already an entity with name \"".concat(e, "\""));
          }

          this.entities.set(e, n);
        }
      }, {
        key: "emitCode",
        value: function emitCode() {
          var _this2 = this;

          var e = [];
          e.push(this.stepPrologue());
          var n = {
            instanceToName: new Map(),
            takenNames: new Set()
          };
          this.entities.forEach(function (t) {
            e.push(_this2.writeEntity(t, n).trim() + "\n");
          });
          return e.join("\n");
        }
      }, {
        key: "writeEntity",
        value: function writeEntity(e, n) {
          var t = [];
          var r = this.getEntityName(e);
          t.push(this.stepStartEntity(e, r));
          var o = e.getParent();
          t.push(this.stepSetEntityParent(e, r, o));
          var d = Object.keys(e.components);

          for (var _i = 0, _d = d; _i < _d.length; _i++) {
            var _o = _d[_i];
            var _d2 = e.components[_o];

            try {
              var _o2 = n.instanceToName.get(_d2);

              if (!_o2) {
                var _r = this.getConstructorName(_d2);

                var i = a.toCamelCase(_r);
                var c = 1;
                _o2 = i;

                while (n.takenNames.has(_o2)) {
                  c++;
                  _o2 = "".concat(i).concat(c);
                }

                var s = this.writeComponent(_o2, _r, _d2);
                n.takenNames.add(_o2);
                n.instanceToName.set(_d2, _o2);
                t.push(this.stepWriteComponentDeclaration(e, _d2, _o2, s));
              }

              t.push(this.stepSetComponentParent(e, r, _o2, _d2));
            } catch (e) {
              console.log(e, e.stack);
            }
          }

          return t.join("");
        }
      }, {
        key: "stepPrologue",
        value: function stepPrologue() {
          return "";
        }
      }, {
        key: "stepStartEntity",
        value: function stepStartEntity(e, n) {
          return "const ".concat(n, " = new Entity('").concat(n, "')\n");
        }
      }, {
        key: "stepSetEntityParent",
        value: function stepSetEntityParent(e, n, t) {
          if (t) {
            var _e = this.getEntityName(t);

            if (!_e) {
              throw new Error("Parent entity of \"".concat(n, "\" is missing, you should add parents first."));
            }

            return "engine.addEntity(".concat(n, ")\n").concat(n, ".setParent(").concat(_e, ")\n");
          }

          return "engine.addEntity(".concat(n, ")\n");
        }
      }, {
        key: "stepWriteComponentDeclaration",
        value: function stepWriteComponentDeclaration(e, n, t, a) {
          return "const ".concat(t, " = ").concat(a, "\n");
        }
      }, {
        key: "stepSetComponentParent",
        value: function stepSetComponentParent(e, n, t, a) {
          return "".concat(n, ".addComponentOrReplace(").concat(t, ")\n");
        }
      }, {
        key: "getConstructorName",
        value: function getConstructorName(e) {
          var n = this.map.members[0];
          var t = n.members.filter(function (e) {
            return e.kind === "Class" && !a.blacklist.includes(e.name);
          }).map(function (e) {
            return e.name;
          });

          var _iterator = _createForOfIteratorHelper(t),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _n = _step.value;

              if (e instanceof this.DCL[_n]) {
                return _n;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }, {
        key: "writeComponent",
        value: function writeComponent(e, n, t) {
          if (n === "Transform") {
            return "new Transform(".concat(this.getTransformComponentData(t.data), ")");
          } else {
            var _a = "new ".concat(n, "(").concat(this.getConstructorValues(n, t.data), ")");

            var r = this.getConstructorParameters(n).reduce(function (e, n) {
              return e.add(n);
            }, new Set());
            var o = this.getReadOnlyProperties(n).reduce(function (e, n) {
              return e.add(n);
            }, new Set());
            var d = Object.keys(t.data).filter(function (e) {
              return !r.has(e) && !o.has(e);
            });

            var _iterator2 = _createForOfIteratorHelper(d),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _n2 = _step2.value;
                _a += "\n".concat(e, ".").concat(_n2, " = ").concat(JSON.stringify(t.data[_n2]));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return _a;
          }
        }
      }, {
        key: "getEntityName",
        value: function getEntityName(e) {
          var _iterator3 = _createForOfIteratorHelper(this.entities),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _n3 = _step3.value;

              if (_n3[1] === e) {
                return _n3[0];
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }, {
        key: "getConstructorValues",
        value: function getConstructorValues(e, n) {
          var t = this.getConstructorParameters(e);

          if (!t) {
            return "";
          }

          var a = t.map(function (e) {
            return JSON.stringify(n[e]);
          });
          return a.join(", ");
        }
      }, {
        key: "getConstructorParameters",
        value: function getConstructorParameters(e) {
          var n = this.map.members[0];
          var t = n.members.find(function (n) {
            return n.name === e;
          });
          var a = t.members.find(function (e) {
            return e.kind === "Constructor";
          });

          if (a) {
            return a.parameters.map(function (e) {
              return e.parameterName;
            });
          }

          return [];
        }
      }, {
        key: "getReadOnlyProperties",
        value: function getReadOnlyProperties(e) {
          var n = this.map.members[0];
          var t = n.members.find(function (n) {
            return n.name === e;
          });
          var a = t.members.filter(function (e) {
            return e.kind === "Property" && e.excerptTokens.some(function (e) {
              return e.text.toLowerCase().includes("readonly");
            });
          }).map(function (e) {
            return e.name;
          });
          return a;
        }
      }, {
        key: "getTransformComponentData",
        value: function getTransformComponentData(e) {
          var n = [];

          for (var _t in e) {
            if (e[_t] instanceof this.DCL.Vector3) {
              n.push("".concat(_t, ": new Vector3(").concat(e[_t].x, ", ").concat(e[_t].y, ", ").concat(e[_t].z, ")"));
            }

            if (e[_t] instanceof this.DCL.Quaternion) {
              n.push("".concat(_t, ": new Quaternion(").concat(e[_t].x, ", ").concat(e[_t].y, ", ").concat(e[_t].z, ", ").concat(e[_t].w, ")"));
            }
          }

          return "{\n  ".concat(n.join(",\n  "), "\n}");
        }
      }]);

      return SceneWriter;
    }();

    n.SceneWriter = SceneWriter;
  },
  732: function _(e, n, t) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: true
    });
    var a = t(623);
    n.SceneWriter = a.SceneWriter;
    var r = t(336);
    n.LightweightWriter = r.LightweightWriter;
    n.default = a.SceneWriter;
  },
  847: function _(e) {
    e.exports = {
      metadata: {
        toolPackage: "@microsoft/api-extractor",
        toolVersion: "7.4.4",
        schemaVersion: 1003,
        oldestForwardsCompatibleVersion: 1001
      },
      kind: "Package",
      canonicalReference: "decentraland-ecs!",
      docComment: "",
      name: "decentraland-ecs",
      members: [{
        kind: "EntryPoint",
        canonicalReference: "decentraland-ecs!",
        name: "",
        members: [{
          kind: "Enum",
          canonicalReference: "decentraland-ecs!ActionButton:enum",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum ActionButton "
          }],
          releaseTag: "Public",
          name: "ActionButton",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!ActionButton.ANY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ANY = "
            }, {
              kind: "Content",
              text: '"ANY"'
            }],
            releaseTag: "Public",
            name: "ANY",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!ActionButton.POINTER:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "POINTER = "
            }, {
              kind: "Content",
              text: '"POINTER"'
            }],
            releaseTag: "Public",
            name: "POINTER",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!ActionButton.PRIMARY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "PRIMARY = "
            }, {
              kind: "Content",
              text: '"PRIMARY"'
            }],
            releaseTag: "Public",
            name: "PRIMARY",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!ActionButton.SECONDARY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "SECONDARY = "
            }, {
              kind: "Content",
              text: '"SECONDARY"'
            }],
            releaseTag: "Public",
            name: "SECONDARY",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Angle:class",
          docComment: "/**\n * Defines angle representation\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Angle "
          }],
          releaseTag: "Public",
          name: "Angle",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Angle:constructor(1)",
            docComment: '/**\n * Creates an Angle object of "radians" radians (float).\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "constructor(radians: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "radians",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Angle.BetweenTwoPoints:member(1)",
            docComment: "/**\n * Gets a new Angle object valued with the angle value in radians between the two given vectors\n *\n * @param a - defines first vector\n *\n * @param b - defines second vector\n *\n * @returns a new Angle\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static BetweenTwoPoints(a: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Angle",
              canonicalReference: "decentraland-ecs!Angle:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "BetweenTwoPoints"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Angle#degrees:member(1)",
            docComment: "/**\n * Get value in degrees\n *\n * @returns the Angle value in degrees (float)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "degrees(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "degrees"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Angle.FromDegrees:member(1)",
            docComment: "/**\n * Gets a new Angle object from the given float in degrees\n *\n * @param degrees - defines the angle value in degrees\n *\n * @returns a new Angle\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromDegrees(degrees: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Angle",
              canonicalReference: "decentraland-ecs!Angle:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "degrees",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "FromDegrees"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Angle.FromRadians:member(1)",
            docComment: "/**\n * Gets a new Angle object from the given float in radians\n *\n * @param radians - defines the angle value in radians\n *\n * @returns a new Angle\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromRadians(radians: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Angle",
              canonicalReference: "decentraland-ecs!Angle:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "radians",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "FromRadians"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Angle#radians:member(1)",
            docComment: "/**\n * Get value in radians\n *\n * @returns the Angle value in radians (float)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radians(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "radians"
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!AnimationParams:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type AnimationParams = "
          }, {
            kind: "Content",
            text: "{\n    looping?: boolean;\n    speed?: number;\n    weight?: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "AnimationParams",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!AnimationState:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class AnimationState extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "AnimationState",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!AnimationState:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `AnimationState` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(clip: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", params?: "
            }, {
              kind: "Reference",
              text: "AnimationParams",
              canonicalReference: "decentraland-ecs!AnimationParams:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "clip",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "params",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#clip:member",
            docComment: "/**\n * Name of the animation in the model\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly clip: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "clip",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#looping:member",
            docComment: "/**\n * Does the animation loop?, default: true\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "looping: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "looping",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#pause:member(1)",
            docComment: "/**\n * Pauses the animation\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "pause(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "pause"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#play:member(1)",
            docComment: "/**\n * Starts the animation\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "play(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "play"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#playing:member",
            docComment: "/**\n * Is the animation playing? default: true\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "playing: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "playing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#reset:member(1)",
            docComment: "/**\n * Resets the animation state to the frame 0\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "reset(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "reset"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#setParams:member(1)",
            docComment: "/**\n * Sets the clip parameters\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setParams(params: "
            }, {
              kind: "Reference",
              text: "AnimationParams",
              canonicalReference: "decentraland-ecs!AnimationParams:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "params",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "setParams"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#shouldReset:member",
            docComment: "/**\n * Does any anyone asked to reset the animation? default: false\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "shouldReset: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shouldReset",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#speed:member",
            docComment: "/**\n * The animation speed\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "speed: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "speed",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#stop:member(1)",
            docComment: "/**\n * Resets and pauses the animation\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "stop(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "stop"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AnimationState#toJSON:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AnimationState#weight:member",
            docComment: "/**\n * Weight of the animation, values from 0 to 1, used to blend several animations. default: 1\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "weight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "weight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Animator:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Animator extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Animator",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!Animator#addClip:member(1)",
            docComment: "/**\n * Adds an AnimationState to the animation lists.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addClip(clip: "
            }, {
              kind: "Reference",
              text: "AnimationState",
              canonicalReference: "decentraland-ecs!AnimationState:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "clip",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addClip"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Animator#getClip:member(1)",
            docComment: "/**\n * Gets the animation clip instance for the specified clip name. If the clip doesn't exist a new one will be created.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getClip(clipName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "AnimationState",
              canonicalReference: "decentraland-ecs!AnimationState:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "clipName",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getClip"
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Arc2:class",
          docComment: "/**\n * This represents an arc in a 2d space.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Arc2 "
          }],
          releaseTag: "Public",
          name: "Arc2",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Arc2:constructor(1)",
            docComment: "/**\n * Creates an Arc object from the three given points : start, middle and end.\n *\n * @param startPoint - Defines the start point of the arc\n *\n * @param midPoint - Defines the midlle point of the arc\n *\n * @param endPoint - Defines the end point of the arc\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    startPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", \n    midPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", \n    endPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "startPoint",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "midPoint",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "endPoint",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#angle:member",
            docComment: "/**\n * Defines the angle of the arc (from mid point to end point).\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "angle: "
            }, {
              kind: "Reference",
              text: "Angle",
              canonicalReference: "decentraland-ecs!Angle:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "angle",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#centerPoint:member",
            docComment: "/**\n * Defines the center point of the arc.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "centerPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "centerPoint",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#endPoint:member",
            docComment: "/**\n * Defines the end point of the arc\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "endPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "endPoint",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#midPoint:member",
            docComment: "/**\n * Defines the mid point of the arc\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "midPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "midPoint",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#orientation:member",
            docComment: "/**\n * Defines the orientation of the arc (clock wise/counter clock wise).\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "orientation: "
            }, {
              kind: "Reference",
              text: "Orientation",
              canonicalReference: "decentraland-ecs!Orientation:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "orientation",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#radius:member",
            docComment: "/**\n * Defines the radius of the arc.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radius: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radius",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#startAngle:member",
            docComment: "/**\n * Defines the start angle of the arc (from start point to middle point).\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "startAngle: "
            }, {
              kind: "Reference",
              text: "Angle",
              canonicalReference: "decentraland-ecs!Angle:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "startAngle",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Arc2#startPoint:member",
            docComment: "/**\n * Defines the start point of the arc\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "startPoint: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "startPoint",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Attachable:class",
          docComment: "/**\n * Entities can be attached to each other by using the `setParent` method. However, there are cases where we might want to attach entities to other objects that are not entities created by the same scene (for example, the player's avatar). For those cases, we have this class.\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare abstract class Attachable "
          }],
          releaseTag: "Public",
          name: "Attachable",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Attachable.AVATAR:member",
            docComment: "/**\n * Used to attach entities to the avatar. Entities will follow the avatar when it moves\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static readonly AVATAR: "
            }, {
              kind: "Reference",
              text: "Attachable",
              canonicalReference: "decentraland-ecs!Attachable:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "AVATAR",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Attachable.FIRST_PERSON_CAMERA:member",
            docComment: "/**\n * Used to attach entities to the camera. When in first person mode, the attached entities will also rotate with the camera\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static readonly FIRST_PERSON_CAMERA: "
            }, {
              kind: "Reference",
              text: "Attachable",
              canonicalReference: "decentraland-ecs!Attachable:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "FIRST_PERSON_CAMERA",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!AudioClip:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class AudioClip extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "AudioClip",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!AudioClip:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `AudioClip` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "url",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioClip#loop:member",
            docComment: "/**\n * Is this clip looping by default?\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "loop: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "loop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioClip#url:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "url",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioClip#volume:member",
            docComment: "/**\n * Clip's master volume. This volume affects all the AudioSources. Valid ranges from 0 to 1\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "volume: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "volume",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!AudioSource:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class AudioSource extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "AudioSource",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!AudioSource:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `AudioSource` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(audioClip: "
            }, {
              kind: "Reference",
              text: "AudioClip",
              canonicalReference: "decentraland-ecs!AudioClip:class"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "audioClip",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#audioClip:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly audioClip: "
            }, {
              kind: "Reference",
              text: "AudioClip",
              canonicalReference: "decentraland-ecs!AudioClip:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "audioClip",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#audioClipId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly audioClipId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "audioClipId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#loop:member",
            docComment: "/**\n * Is this clip looping by default?\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "loop: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "loop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#pitch:member",
            docComment: "/**\n * Pitch, default: 1.0, range from 0.0 to MaxFloat\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "pitch: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "pitch",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#playing:member",
            docComment: "/**\n * Is this AudioSource playing?\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "playing: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "playing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AudioSource#playOnce:member(1)",
            docComment: "/**\n * Disables the looping and plays the current source once. If the sound was playing, it stops and starts over.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "playOnce(): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "playOnce"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioSource#volume:member",
            docComment: "/**\n * Clip's master volume. This volume affects all the AudioSources. Valid ranges from 0 to 1\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "volume: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "volume",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!AudioStream:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class AudioStream extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "AudioStream",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!AudioStream:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `AudioStream` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "url",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioStream#playing:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "playing: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "playing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioStream#url:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "url",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AudioStream#volume:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "volume: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "volume",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!AvatarForRenderer:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type AvatarForRenderer = "
          }, {
            kind: "Content",
            text: "{\n    bodyShape: "
          }, {
            kind: "Reference",
            text: "WearableId",
            canonicalReference: "decentraland-ecs!WearableId:type"
          }, {
            kind: "Content",
            text: ";\n    skinColor: "
          }, {
            kind: "Reference",
            text: "ReadOnlyColor4",
            canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
          }, {
            kind: "Content",
            text: ";\n    hairColor: "
          }, {
            kind: "Reference",
            text: "ReadOnlyColor4",
            canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
          }, {
            kind: "Content",
            text: ";\n    eyeColor: "
          }, {
            kind: "Reference",
            text: "ReadOnlyColor4",
            canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
          }, {
            kind: "Content",
            text: ";\n    wearables: "
          }, {
            kind: "Reference",
            text: "WearableId",
            canonicalReference: "decentraland-ecs!WearableId:type"
          }, {
            kind: "Content",
            text: "[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "AvatarForRenderer",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 12
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!AvatarShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class AvatarShape extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "AvatarShape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#bodyShape:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "bodyShape: "
            }, {
              kind: "Reference",
              text: "WearableId",
              canonicalReference: "decentraland-ecs!WearableId:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "bodyShape",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!AvatarShape.Dummy:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static Dummy(): "
            }, {
              kind: "Reference",
              text: "AvatarShape",
              canonicalReference: "decentraland-ecs!AvatarShape:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Dummy"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#expressionTriggerId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "expressionTriggerId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "expressionTriggerId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#expressionTriggerTimestamp:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "expressionTriggerTimestamp: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "expressionTriggerTimestamp",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#eyeColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "eyeColor: "
            }, {
              kind: "Reference",
              text: "ReadOnlyColor4",
              canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "eyeColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#hairColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hairColor: "
            }, {
              kind: "Reference",
              text: "ReadOnlyColor4",
              canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hairColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#id:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "id: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "id",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#name:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "name: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "name",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#skinColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "skinColor: "
            }, {
              kind: "Reference",
              text: "ReadOnlyColor4",
              canonicalReference: "decentraland-ecs!ReadOnlyColor4:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "skinColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#useDummyModel:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "useDummyModel: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "useDummyModel",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!AvatarShape#wearables:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "wearables: "
            }, {
              kind: "Reference",
              text: "WearableId",
              canonicalReference: "decentraland-ecs!WearableId:type"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "wearables",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Axis:class",
          docComment: "/**\n * Defines the 3 main axes\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Axis "
          }],
          releaseTag: "Public",
          name: "Axis",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Axis.X:member",
            docComment: "/**\n * X axis\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static X: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "X",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Axis.Y:member",
            docComment: "/**\n * Y axis\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Y: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "Y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Axis.Z:member",
            docComment: "/**\n * Z axis\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Z: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "Z",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }],
          implementsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!BasicAvatarInfo:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface BasicAvatarInfo "
          }],
          releaseTag: "Public",
          name: "BasicAvatarInfo",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!BasicAvatarInfo#name:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "name: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "name",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!BasicAvatarInfo#userId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "userId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "userId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!BasicMaterial:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class BasicMaterial extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "BasicMaterial",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!BasicMaterial#alphaTest:member",
            docComment: "/**\n * A number between 0 and 1. Any pixel with an alpha lower than this value will be shown as transparent.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "alphaTest: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alphaTest",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!BasicMaterial#texture:member",
            docComment: "/**\n * The source of the texture image.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "texture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "VideoTexture",
              canonicalReference: "decentraland-ecs!VideoTexture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "texture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!BezierCurve:class",
          docComment: "/**\n * Class used to represent a Bezier curve\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class BezierCurve "
          }],
          releaseTag: "Public",
          name: "BezierCurve",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!BezierCurve.Interpolate:member(1)",
            docComment: '/**\n * Returns the cubic Bezier interpolated value (float) at "t" (float) from the given x1, y1, x2, y2 floats\n *\n * @param t - defines the time\n *\n * @param x1 - defines the left coordinate on X axis\n *\n * @param y1 - defines the left coordinate on Y axis\n *\n * @param x2 - defines the right coordinate on X axis\n *\n * @param y2 - defines the right coordinate on Y axis\n *\n * @returns the interpolated value\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Interpolate(t: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", x1: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y1: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", x2: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y2: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "t",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "x1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "y1",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "x2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "y2",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "Interpolate"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Billboard:class",
          docComment: "/**\n * Billboard defines a behavior that makes the entity face the camera in any moment.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Billboard extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Billboard",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Billboard:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Billboard` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(x?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", y?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", z?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Billboard#x:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "x: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "x",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Billboard#y:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "y: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Billboard#z:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "z: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "z",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!BodyShapeRespresentation:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type BodyShapeRespresentation = "
          }, {
            kind: "Content",
            text: "{\n    bodyShapes: string[];\n    mainFile: string;\n    contents: "
          }, {
            kind: "Reference",
            text: "FileAndHash",
            canonicalReference: "decentraland-ecs!FileAndHash:type"
          }, {
            kind: "Content",
            text: "[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "BodyShapeRespresentation",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 4
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!BoxShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class BoxShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "BoxShape",
          members: [],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Camera:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Camera "
          }],
          releaseTag: "Public",
          name: "Camera",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Camera:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Camera` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor();"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: []
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Camera#feetPosition:member",
            docComment: "/**\n * Feet position, relative to the parcel.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly feetPosition: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "feetPosition",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Camera#position:member",
            docComment: "/**\n * Camera position, relative to the parcel.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly position: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "position",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Camera#rotation:member",
            docComment: "/**\n * Camera rotation\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly rotation: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "rotation",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Camera#worldPosition:member",
            docComment: "/**\n * Camera position, absolute.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly worldPosition: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "worldPosition",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!CircleShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class CircleShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "CircleShape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!CircleShape#arc:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "arc?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "arc",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CircleShape#segments:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "segments?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "segments",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Color3:class",
          docComment: "/**\n * Class used to hold a RBG color\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Color3 "
          }],
          releaseTag: "Public",
          name: "Color3",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Color3:constructor(1)",
            docComment: "/**\n * Creates a new Color3 object from red, green, blue values, all between 0 and 1\n *\n * @param r - defines the red component (between 0 and 1, default is 0)\n *\n * @param g - defines the green component (between 0 and 1, default is 0)\n *\n * @param b - defines the blue component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    r?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    g?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    b?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#add:member(1)",
            docComment: "/**\n * Creates a new Color3 set with the added values of the current Color3 and of the given one\n *\n * @param otherColor - defines the second operand\n *\n * @returns the new Color3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#addToRef:member(1)",
            docComment: '/**\n * Stores the result of the addition of the current Color3 and given one rgb values into "result"\n *\n * @param otherColor - defines the second operand\n *\n * @param result - defines Color3 object to store the result into\n *\n * @returns the unmodified current Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "addToRef(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#asArray:member(1)",
            docComment: "/**\n * Returns a new array populated with 3 numeric elements : red, green and blue values\n *\n * @returns the new array\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color3#b:member",
            docComment: "/**\n * Defines the blue component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "b",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Black:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a black color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Black(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Black"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Blue:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a blue color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Blue(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Blue"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#clampToRef:member(1)",
            docComment: '/**\n * Clamps the rgb values by the min and max values and stores the result into "result"\n *\n * @param min - defines minimum clamping value (default is 0)\n *\n * @param max - defines maximum clamping value (default is 1)\n *\n * @param result - defines color to store the result into\n *\n * @returns the original Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "clampToRef(min: "
            }, {
              kind: "Content",
              text: "number | undefined"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number | undefined"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "clampToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#clone:member(1)",
            docComment: "/**\n * Copy the current object\n *\n * @returns a new Color3 copied the current one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#copyFrom:member(1)",
            docComment: "/**\n * Copies the rgb values from the source in the current Color3\n *\n * @param source - defines the source Color3 object\n *\n * @returns the updated Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(source: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#copyFromFloats:member(1)",
            docComment: "/**\n * Updates the Color3 rgb values from the given floats\n *\n * @param r - defines the red component to read from\n *\n * @param g - defines the green component to read from\n *\n * @param b - defines the blue component to read from\n *\n * @returns the current Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#equals:member(1)",
            docComment: "/**\n * Determines equality between Color3 objects\n *\n * @param otherColor - defines the second operand\n *\n * @returns true if the rgb values are equal to the given ones\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#equalsFloats:member(1)",
            docComment: "/**\n * Determines equality between the current Color3 object and a set of r,b,g values\n *\n * @param r - defines the red component to check\n *\n * @param g - defines the green component to check\n *\n * @param b - defines the blue component to check\n *\n * @returns true if the rgb values are equal to the given ones\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equalsFloats(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "equalsFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.FromArray:member(1)",
            docComment: "/**\n * Creates a new Vector3 from the starting index of the given array\n *\n * @param array - defines the source array\n *\n * @param offset - defines an offset in the source array\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.FromHexString:member(1)",
            docComment: "/**\n * Creates a new Color3 from the string containing valid hexadecimal values\n *\n * @param hex - defines a string containing valid hexadecimal values\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromHexString(hex: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "hex",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "FromHexString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.FromInts:member(1)",
            docComment: "/**\n * Creates a new Color3 from integer values (less than 256)\n *\n * @param r - defines the red component to read from (value between 0 and 255)\n *\n * @param g - defines the green component to read from (value between 0 and 255)\n *\n * @param b - defines the blue component to read from (value between 0 and 255)\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromInts(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "FromInts"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color3#g:member",
            docComment: "/**\n * Defines the green component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "g",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#getClassName:member(1)",
            docComment: '/**\n * Returns the string "Color3"\n *\n * @returns "Color3"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#getHashCode:member(1)",
            docComment: "/**\n * Compute the Color3 hash code\n *\n * @returns an unique number that can be used to hash Color3 objects\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Gray:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a gray color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Gray(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Gray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Green:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a green color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Green(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Green"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Lerp:member(1)",
            docComment: '/**\n * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3\n *\n * @param start - defines the start Color3 value\n *\n * @param end - defines the end Color3 value\n *\n * @param amount - defines the gradient value between start and end\n *\n * @returns a new Color3 object\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(start: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.LerpToRef:member(1)",
            docComment: '/**\n * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3\n *\n * @param left - defines the start value\n *\n * @param right - defines the end value\n *\n * @param amount - defines the gradient factor\n *\n * @param result - defines the Color3 object where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LerpToRef(left: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Magenta:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a magenta color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Magenta(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Magenta"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#multiply:member(1)",
            docComment: "/**\n * Multiply each Color3 rgb values by the given Color3 rgb values in a new Color3 object\n *\n * @param otherColor - defines the second operand\n *\n * @returns the new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#multiplyToRef:member(1)",
            docComment: '/**\n * Multiply the rgb values of the Color3 and the given Color3 and stores the result in the object "result"\n *\n * @param otherColor - defines the second operand\n *\n * @param result - defines the Color3 object where to store the result\n *\n * @returns the current Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Purple:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a purple color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Purple(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Purple"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color3#r:member",
            docComment: "/**\n * Defines the red component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "r",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Random:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a random color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Random(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Random"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Red:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a red color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Red(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Red"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#scale:member(1)",
            docComment: "/**\n * Multiplies in place each rgb value by scale\n *\n * @param scale - defines the scaling factor\n *\n * @returns the updated Color3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current Color3 values by a factor and add the result to a given Color3\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines color to store the result into\n *\n * @returns the unmodified current Color3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#scaleToRef:member(1)",
            docComment: '/**\n * Multiplies the rgb values by scale and stores the result into "result"\n *\n * @param scale - defines the scaling factor\n *\n * @param result - defines the Color3 object where to store the result\n *\n * @returns the unmodified current Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#set:member(1)",
            docComment: "/**\n * Updates the Color3 rgb values from the given floats\n *\n * @param r - defines the red component to read from\n *\n * @param g - defines the green component to read from\n *\n * @param b - defines the blue component to read from\n *\n * @returns the current Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#subtract:member(1)",
            docComment: "/**\n * Returns a new Color3 set with the subtracted values of the given one from the current Color3\n *\n * @param otherColor - defines the second operand\n *\n * @returns the new Color3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#subtractToRef:member(1)",
            docComment: '/**\n * Stores the result of the subtraction of given one from the current Color3 rgb values into "result"\n *\n * @param otherColor - defines the second operand\n *\n * @param result - defines Color3 object to store the result into\n *\n * @returns the unmodified current Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractToRef(otherColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "subtractToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Teal:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a teal color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Teal(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Teal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toArray:member(1)",
            docComment: "/**\n * Stores in the given array from the given starting index the red, green, blue values as successive elements\n *\n * @param array - defines the array where to store the r,g,b components\n *\n * @param index - defines an optional index in the target array to define where to start storing values\n *\n * @returns the current Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", index?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toColor4:member(1)",
            docComment: "/**\n * Returns a new Color4 object from the current Color3 and the given alpha\n *\n * @param alpha - defines the alpha component on the new Color4 object (default is 1)\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toColor4(alpha?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "alpha",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toColor4"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toGammaSpace:member(1)",
            docComment: "/**\n * Computes a new Color3 converted from the current one to gamma space\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toGammaSpace(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toGammaSpace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toGammaSpaceToRef:member(1)",
            docComment: '/**\n * Converts the Color3 values to gamma space and stores the result in "convertedColor"\n *\n * @param convertedColor - defines the Color3 object where to store the gamma space version\n *\n * @returns the unmodified Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "toGammaSpaceToRef(convertedColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "convertedColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toGammaSpaceToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toHexString:member(1)",
            docComment: "/**\n * Compute the Color3 hexadecimal code as a string\n *\n * @returns a string containing the hexadecimal representation of the Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toHexString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toHexString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toJSON:member(1)",
            docComment: "/**\n * Serializes Color3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "{\n        r: number;\n        g: number;\n        b: number;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toLinearSpace:member(1)",
            docComment: "/**\n * Computes a new Color3 converted from the current one to linear space\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toLinearSpace(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toLinearSpace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toLinearSpaceToRef:member(1)",
            docComment: '/**\n * Converts the Color3 values to linear space and stores the result in "convertedColor"\n *\n * @param convertedColor - defines the Color3 object where to store the linear space version\n *\n * @returns the unmodified Color3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "toLinearSpaceToRef(convertedColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "convertedColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toLinearSpaceToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toLuminance:member(1)",
            docComment: "/**\n * Returns the luminance value\n *\n * @returns a float value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toLuminance(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toLuminance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3#toString:member(1)",
            docComment: "/**\n * Creates a string with the Color3 current values\n *\n * @returns the string representation of the Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.White:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a white color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static White(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "White"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color3.Yellow:member(1)",
            docComment: "/**\n * Returns a Color3 value containing a yellow color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Yellow(): "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Yellow"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Color4:class",
          docComment: "/**\n * Class used to hold a RBGA color\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Color4 "
          }],
          releaseTag: "Public",
          name: "Color4",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Color4:constructor(1)",
            docComment: "/**\n * Creates a new Color4 object from red, green, blue values, all between 0 and 1\n *\n * @param r - defines the red component (between 0 and 1, default is 0)\n *\n * @param g - defines the green component (between 0 and 1, default is 0)\n *\n * @param b - defines the blue component (between 0 and 1, default is 0)\n *\n * @param a - defines the alpha component (between 0 and 1, default is 1)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    r?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    g?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    b?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    a?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color4#a:member",
            docComment: "/**\n * Defines the alpha component (between 0 and 1, default is 1)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "a",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#add:member(1)",
            docComment: "/**\n * Creates a new Color4 set with the added values of the current Color4 and of the given one\n *\n * @param right - defines the second operand\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#addInPlace:member(1)",
            docComment: "/**\n * Adds in place the given Color4 values to the current Color4 object\n *\n * @param right - defines the second operand\n *\n * @returns the current updated Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addInPlace(right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#asArray:member(1)",
            docComment: "/**\n * Creates a new array populated with 4 numeric elements : red, green, blue, alpha values\n *\n * @returns the new array\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color4#b:member",
            docComment: "/**\n * Defines the blue component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "b",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Black:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a black color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Black(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Black"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Blue:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a blue color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Blue(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Blue"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.CheckColors4:member(1)",
            docComment: "/**\n * Check the content of a given array and convert it to an array containing RGBA data If the original array was already containing count * 4 values then it is returned directly\n *\n * @param colors - defines the array to check\n *\n * @param count - defines the number of RGBA data to expect\n *\n * @returns an array containing count * 4 values (RGBA)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static CheckColors4(colors: "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ", count: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "colors",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "count",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "CheckColors4"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#clampToRef:member(1)",
            docComment: '/**\n * Clamps the rgb values by the min and max values and stores the result into "result"\n *\n * @param min - defines minimum clamping value (default is 0)\n *\n * @param max - defines maximum clamping value (default is 1)\n *\n * @param result - defines color to store the result into.\n *\n * @returns the cuurent Color4\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "clampToRef(min: "
            }, {
              kind: "Content",
              text: "number | undefined"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number | undefined"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "clampToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Clear:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a transparent color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Clear(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Clear"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#clone:member(1)",
            docComment: "/**\n * Creates a new Color4 copied from the current one\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#copyFrom:member(1)",
            docComment: "/**\n * Copies the given Color4 values into the current one\n *\n * @param source - defines the source Color4 object\n *\n * @returns the current updated Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(source: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#copyFromFloats:member(1)",
            docComment: "/**\n * Copies the given float values into the current one\n *\n * @param r - defines the red component to read from\n *\n * @param g - defines the green component to read from\n *\n * @param b - defines the blue component to read from\n *\n * @param a - defines the alpha component to read from\n *\n * @returns the current updated Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.FromArray:member(1)",
            docComment: "/**\n * Creates a new Color4 from the starting index element of the given array\n *\n * @param array - defines the source array to read from\n *\n * @param offset - defines the offset in the source array\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.FromColor3:member(1)",
            docComment: "/**\n * Creates a new Color4 from a Color3 and an alpha value\n *\n * @param color3 - defines the source Color3 to read from\n *\n * @param alpha - defines the alpha component (1.0 by default)\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromColor3(color3: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ", alpha?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "color3",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "alpha",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromColor3"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.FromHexString:member(1)",
            docComment: "/**\n * Creates a new Color4 from the string containing valid hexadecimal values\n *\n * @param hex - defines a string containing valid hexadecimal values\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromHexString(hex: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "hex",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "FromHexString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.FromInts:member(1)",
            docComment: "/**\n * Creates a new Color3 from integer values (less than 256)\n *\n * @param r - defines the red component to read from (value between 0 and 255)\n *\n * @param g - defines the green component to read from (value between 0 and 255)\n *\n * @param b - defines the blue component to read from (value between 0 and 255)\n *\n * @param a - defines the alpha component to read from (value between 0 and 255)\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromInts(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "FromInts"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color4#g:member",
            docComment: "/**\n * Defines the green component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "g",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#getClassName:member(1)",
            docComment: '/**\n * Returns the string "Color4"\n *\n * @returns "Color4"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#getHashCode:member(1)",
            docComment: "/**\n * Compute the Color4 hash code\n *\n * @returns an unique number that can be used to hash Color4 objects\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Gray:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a gray color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Gray(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Gray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Green:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a green color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Green(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Green"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Lerp:member(1)",
            docComment: '/**\n * Creates a new Color4 object set with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object\n *\n * @param left - defines the start value\n *\n * @param right - defines the end value\n *\n * @param amount - defines the gradient factor\n *\n * @returns a new Color4 object\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(left: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.LerpToRef:member(1)",
            docComment: '/**\n * Set the given "result" with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object\n *\n * @param left - defines the start value\n *\n * @param right - defines the end value\n *\n * @param amount - defines the gradient factor\n *\n * @param result - defines the Color4 object where to store data\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LerpToRef(left: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Magenta:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a magenta color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Magenta(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Magenta"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#multiply:member(1)",
            docComment: "/**\n * Multipy an Color4 value by another and return a new Color4 object\n *\n * @param color - defines the Color4 value to multiply by\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "color",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#multiplyToRef:member(1)",
            docComment: "/**\n * Multipy a Color4 value by another and push the result in a reference value\n *\n * @param color - defines the Color4 value to multiply by\n *\n * @param result - defines the Color4 to fill the result in\n *\n * @returns the result Color4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "color",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Purple:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a purple color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Purple(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Purple"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Color4#r:member",
            docComment: "/**\n * Defines the red component (between 0 and 1, default is 0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "r",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Red:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a red color\n *\n * @returns a new Color3 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Red(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Red"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#scale:member(1)",
            docComment: "/**\n * Creates a new Color4 with the current Color4 values multiplied by scale\n *\n * @param scale - defines the scaling factor to apply\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current Color4 values by a factor and add the result to a given Color4\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Color4 object where to store the result\n *\n * @returns the unmodified current Color4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#scaleToRef:member(1)",
            docComment: '/**\n * Multiplies the current Color4 values by scale and stores the result in "result"\n *\n * @param scale - defines the scaling factor to apply\n *\n * @param result - defines the Color4 object where to store the result\n *\n * @returns the current unmodified Color4\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#set:member(1)",
            docComment: "/**\n * Copies the given float values into the current one\n *\n * @param r - defines the red component to read from\n *\n * @param g - defines the green component to read from\n *\n * @param b - defines the blue component to read from\n *\n * @param a - defines the alpha component to read from\n *\n * @returns the current updated Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(r: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", g: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "r",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "g",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#subtract:member(1)",
            docComment: "/**\n * Creates a new Color4 set with the subtracted values of the given one from the current Color4\n *\n * @param right - defines the second operand\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#subtractToRef:member(1)",
            docComment: '/**\n * Subtracts the given ones from the current Color4 values and stores the results in "result"\n *\n * @param right - defines the second operand\n *\n * @param result - defines the Color4 object where to store the result\n *\n * @returns the current Color4 object\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractToRef(right: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "subtractToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Teal:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a teal color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Teal(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Teal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toArray:member(1)",
            docComment: "/**\n * Stores from the starting index in the given array the Color4 successive values\n *\n * @param array - defines the array where to store the r,g,b components\n *\n * @param index - defines an optional index in the target array to define where to start storing values\n *\n * @returns the current Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(array: "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ", index?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toGammaSpace:member(1)",
            docComment: "/**\n * Computes a new Color4 converted from the current one to gamma space\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toGammaSpace(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toGammaSpace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toGammaSpaceToRef:member(1)",
            docComment: '/**\n * Converts the Color4 values to gamma space and stores the result in "convertedColor"\n *\n * @param convertedColor - defines the Color4 object where to store the gamma space version\n *\n * @returns the unmodified Color4\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "toGammaSpaceToRef(convertedColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "convertedColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toGammaSpaceToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toHexString:member(1)",
            docComment: "/**\n * Compute the Color4 hexadecimal code as a string\n *\n * @returns a string containing the hexadecimal representation of the Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toHexString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toHexString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toLinearSpace:member(1)",
            docComment: "/**\n * Computes a new Color4 converted from the current one to linear space\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toLinearSpace(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toLinearSpace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toLinearSpaceToRef:member(1)",
            docComment: '/**\n * Converts the Color4 values to linear space and stores the result in "convertedColor"\n *\n * @param convertedColor - defines the Color4 object where to store the linear space version\n *\n * @returns the unmodified Color4\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "toLinearSpaceToRef(convertedColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "convertedColor",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toLinearSpaceToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4#toString:member(1)",
            docComment: "/**\n * Creates a string with the Color4 current values\n *\n * @returns the string representation of the Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.White:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a white color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static White(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "White"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Color4.Yellow:member(1)",
            docComment: "/**\n * Returns a Color4 value containing a yellow color\n *\n * @returns a new Color4 object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Yellow(): "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Yellow"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!Component:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function Component(componentName: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ", classId?: "
          }, {
            kind: "Content",
            text: "number"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "<TFunction extends "
          }, {
            kind: "Reference",
            text: "ComponentConstructor",
            canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
          }, {
            kind: "Content",
            text: "<any>>(target: TFunction) => void | TFunction"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 8
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "componentName",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            parameterName: "classId",
            parameterTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            }
          }],
          name: "Component"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ComponentAdded:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ComponentAdded "
          }],
          releaseTag: "Public",
          name: "ComponentAdded",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!ComponentAdded:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `ComponentAdded` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ", componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", classId: "
            }, {
              kind: "Content",
              text: "number | null"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "componentName",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "classId",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentAdded#classId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "classId: "
            }, {
              kind: "Content",
              text: "number | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "classId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentAdded#componentName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentAdded#entity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!ComponentConstructor:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface ComponentConstructor<T extends "
          }, {
            kind: "Reference",
            text: "ComponentLike",
            canonicalReference: "decentraland-ecs!ComponentLike:interface"
          }, {
            kind: "Content",
            text: "> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "ComponentConstructor",
          members: [{
            kind: "ConstructSignature",
            canonicalReference: "decentraland-ecs!ComponentConstructor:new(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "new (...args: "
            }, {
              kind: "Content",
              text: "any[]"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "args",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!ComponentConstructor#isComponent:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isComponent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isComponent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!ComponentConstructor#originalClassName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "originalClassName?: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "originalClassName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!ComponentLike:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface ComponentLike "
          }],
          releaseTag: "Public",
          name: "ComponentLike",
          members: [],
          extendsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ComponentRemoved:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ComponentRemoved "
          }],
          releaseTag: "Public",
          name: "ComponentRemoved",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!ComponentRemoved:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `ComponentRemoved` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ", componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", component: "
            }, {
              kind: "Reference",
              text: "ComponentLike",
              canonicalReference: "decentraland-ecs!ComponentLike:interface"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "componentName",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentRemoved#component:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "component: "
            }, {
              kind: "Reference",
              text: "ComponentLike",
              canonicalReference: "decentraland-ecs!ComponentLike:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "component",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentRemoved#componentName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ComponentRemoved#entity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ConeShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ConeShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "ConeShape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#arc:member",
            docComment: "/**\n * Sets the ratio (max 1) to apply to the circumference to slice the cone. Defaults to 360.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "arc: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "arc",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#openEnded:member",
            docComment: "/**\n * Adds two extra faces per subdivision to enclose the cone around its height axis. Defaults to false.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "openEnded: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "openEnded",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#radius:member",
            docComment: "/**\n * Sets the radius of the top and bottom caps at once.\n *\n * Properties `radiusTop` and `radiusBottom` are prioritized over this one.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radius: "
            }, {
              kind: "Content",
              text: "number | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radius",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#radiusBottom:member",
            docComment: "/**\n * The radius of the base of the cone. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radiusBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radiusBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#radiusTop:member",
            docComment: "/**\n * The radius of the top of a truncated cone. Defaults to 0.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radiusTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radiusTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#segmentsHeight:member",
            docComment: "/**\n * Sets the number of rings along the cone height (positive integer). Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "segmentsHeight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "segmentsHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ConeShape#segmentsRadial:member",
            docComment: "/**\n * Sets the number of cone sides (positive integer). Defaults to 36.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "segmentsRadial: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "segmentsRadial",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Curve3:class",
          docComment: "/**\n * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space. A Curve3 is designed from a series of successive Vector3. {@link https://doc.babylonjs.com/how_to/how_to_use_curve3}\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Curve3 "
          }],
          releaseTag: "Public",
          name: "Curve3",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Curve3:constructor(1)",
            docComment: "/**\n * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space. A Curve3 is designed from a series of successive Vector3. {@link http://doc.babylonjs.com/tutorials/How_to_use_Curve3#curve3-object | Tutorial}\n *\n * @param points - points which make up the curve\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(points: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "points",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3#continue:member(1)",
            docComment: "/**\n * Returns a new instance of Curve3 object : var curve = curveA.continue(curveB); This new Curve3 is built by translating and sticking the curveB at the end of the curveA. curveA and curveB keep unchanged.\n *\n * @param curve - the curve to continue from this curve\n *\n * @returns the newly constructed curve\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "continue(curve: "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "curve",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "continue"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3.CreateCatmullRomSpline:member(1)",
            docComment: "/**\n * Returns a Curve3 object along a CatmullRom Spline curve :\n *\n * @param points - (array of Vector3) the points the spline must pass through. At least, four points required\n *\n * @param nbPoints - (integer) the wanted number of points between each curve control points\n *\n * @param closed - (boolean) optional with default false, when true forms a closed loop from the points\n *\n * @returns the created Curve3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static CreateCatmullRomSpline(points: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ", nbPoints: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", closed?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "points",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "nbPoints",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "closed",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "CreateCatmullRomSpline"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3.CreateCubicBezier:member(1)",
            docComment: "/**\n * Returns a Curve3 object along a Cubic Bezier curve : http://doc.babylonjs.com/tutorials/How_to_use_Curve3#cubic-bezier-curve\n *\n * @param v0 - (Vector3) the origin point of the Cubic Bezier\n *\n * @param v1 - (Vector3) the first control point\n *\n * @param v2 - (Vector3) the second control point\n *\n * @param v3 - (Vector3) the end point of the Cubic Bezier\n *\n * @param nbPoints - (integer) the wanted number of points in the curve\n *\n * @returns the created Curve3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static CreateCubicBezier(v0: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", v1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", v2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", v3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", nbPoints: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "v0",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "v1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "v2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "v3",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "nbPoints",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "CreateCubicBezier"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3.CreateHermiteSpline:member(1)",
            docComment: "/**\n * Returns a Curve3 object along a Hermite Spline curve : http://doc.babylonjs.com/tutorials/How_to_use_Curve3#hermite-spline\n *\n * @param p1 - (Vector3) the origin point of the Hermite Spline\n *\n * @param t1 - (Vector3) the tangent vector at the origin point\n *\n * @param p2 - (Vector3) the end point of the Hermite Spline\n *\n * @param t2 - (Vector3) the tangent vector at the end point\n *\n * @param nbPoints - (integer) the wanted number of points in the curve\n *\n * @returns the created Curve3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static CreateHermiteSpline(p1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", t1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", p2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", t2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", nbPoints: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "p1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "t1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "p2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "t2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "nbPoints",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "CreateHermiteSpline"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3.CreateQuadraticBezier:member(1)",
            docComment: "/**\n * Returns a Curve3 object along a Quadratic Bezier curve : http://doc.babylonjs.com/tutorials/How_to_use_Curve3#quadratic-bezier-curve\n *\n * @param v0 - (Vector3) the origin point of the Quadratic Bezier\n *\n * @param v1 - (Vector3) the control point\n *\n * @param v2 - (Vector3) the end point of the Quadratic Bezier\n *\n * @param nbPoints - (integer) the wanted number of points in the curve\n *\n * @returns the created Curve3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static CreateQuadraticBezier(v0: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", v1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", v2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", nbPoints: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Curve3",
              canonicalReference: "decentraland-ecs!Curve3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "v0",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "v1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "v2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "nbPoints",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "CreateQuadraticBezier"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3#getPoints:member(1)",
            docComment: "/**\n * @returns the Curve3 stored array of successive Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getPoints(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getPoints"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Curve3#length:member(1)",
            docComment: "/**\n * @returns the computed length (float) of the curve.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "length(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "length"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!CylinderShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class CylinderShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "CylinderShape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#arc:member",
            docComment: "/**\n * Sets the ratio (max 1) to apply to the circumference to slice the cylinder. Defaults to 360.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "arc: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "arc",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#openEnded:member",
            docComment: "/**\n * Adds two extra faces per subdivision to enclose the cylinder around its height axis. Defaults to false.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "openEnded: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "openEnded",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#radius:member",
            docComment: "/**\n * Sets the radius of the top and bottom caps at once.\n *\n * Properties `radiusTop` and `radiusBottom` are prioritized over this one.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radius: "
            }, {
              kind: "Content",
              text: "number | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radius",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#radiusBottom:member",
            docComment: "/**\n * The radius of the base of the cylinder. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radiusBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radiusBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#radiusTop:member",
            docComment: "/**\n * The radius of the top of the cylinder. Defaults to 0.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "radiusTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "radiusTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#segmentsHeight:member",
            docComment: "/**\n * Sets the number of rings along the cylinder height (positive integer). Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "segmentsHeight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "segmentsHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!CylinderShape#segmentsRadial:member",
            docComment: "/**\n * Sets the number of cylinder sides (positive integer). Defaults to 36.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "segmentsRadial: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "segmentsRadial",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!DecentralandInterface:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type DecentralandInterface = "
          }, {
            kind: "Content",
            text: "{\n    DEBUG: boolean;\n    updateEntity?: never;\n    log(...a: any[]): void;\n    error(message: string, data?: any): void;\n    openExternalUrl(url: string): void;\n    openNFTDialog(assetContractAddress: string, tokenId: string, comment: string | null): void;\n    onUpdate(cb: (deltaTime: number) => void): void;\n    onStart(cb: "
          }, {
            kind: "Reference",
            text: "Function",
            canonicalReference: "!Function:interface"
          }, {
            kind: "Content",
            text: "): void;\n    addEntity(entityId: string): void;\n    removeEntity(entityId: string): void;\n    updateEntityComponent(entityId: string, componentName: string, classId: number, json: string): void;\n    attachEntityComponent(entityId: string, componentName: string, componentId: string): void;\n    removeEntityComponent(entityId: string, componentName: string): void;\n    setParent(entityId: string, parentId: string): void;\n    query(queryType: string, payload: any): void;\n    componentCreated(componentId: string, componentName: string, classId: number): void;\n    componentDisposed(componentId: string): void;\n    componentUpdated(componentId: string, json: string): void;\n    onEvent(cb: (event: "
          }, {
            kind: "Reference",
            text: "EngineEvent",
            canonicalReference: "decentraland-ecs!EngineEvent:type"
          }, {
            kind: "Content",
            text: ") => void): void;\n    subscribe(eventName: string): void;\n    unsubscribe(eventName: string): void;\n    loadModule(moduleName: string): "
          }, {
            kind: "Reference",
            text: "PromiseLike",
            canonicalReference: "!PromiseLike:interface"
          }, {
            kind: "Content",
            text: "<"
          }, {
            kind: "Reference",
            text: "ModuleDescriptor",
            canonicalReference: "decentraland-ecs!ModuleDescriptor:type"
          }, {
            kind: "Content",
            text: ">;\n    callRpc(rpcHandle: string, methodName: string, args: "
          }, {
            kind: "Reference",
            text: "ArrayLike",
            canonicalReference: "!ArrayLike:interface"
          }, {
            kind: "Content",
            text: "<any>): "
          }, {
            kind: "Reference",
            text: "PromiseLike",
            canonicalReference: "!PromiseLike:interface"
          }, {
            kind: "Content",
            text: "<any>;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "DecentralandInterface",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 14
          }
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!DEG2RAD:var",
          docComment: "/**\n * Constant used to convert from Euler degrees to radians\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "DEG2RAD: "
          }, {
            kind: "Content",
            text: "number"
          }],
          releaseTag: "Public",
          name: "DEG2RAD",
          variableTypeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!DisposableComponent:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function DisposableComponent(componentName: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ", classId: "
          }, {
            kind: "Content",
            text: "number"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "<TFunction extends "
          }, {
            kind: "Reference",
            text: "DisposableComponentConstructor",
            canonicalReference: "decentraland-ecs!DisposableComponentConstructor:interface"
          }, {
            kind: "Content",
            text: "<any>>(target: TFunction) => void | TFunction"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 8
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "componentName",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            parameterName: "classId",
            parameterTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            }
          }],
          name: "DisposableComponent"
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!DisposableComponentConstructor:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface DisposableComponentConstructor<T extends "
          }, {
            kind: "Reference",
            text: "DisposableComponentLike",
            canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
          }, {
            kind: "Content",
            text: "> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "DisposableComponentConstructor",
          members: [{
            kind: "ConstructSignature",
            canonicalReference: "decentraland-ecs!DisposableComponentConstructor:new(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "new (...args: "
            }, {
              kind: "Content",
              text: "any[]"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "args",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!DisposableComponentConstructor#isComponent:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isComponent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isComponent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!DisposableComponentConstructor#isDisposableComponent:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isDisposableComponent?: "
            }, {
              kind: "Content",
              text: "true"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isDisposableComponent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!DisposableComponentConstructor#originalClassName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "originalClassName?: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "originalClassName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!DisposableComponentCreated:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class DisposableComponentCreated "
          }],
          releaseTag: "Public",
          name: "DisposableComponentCreated",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!DisposableComponentCreated:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `DisposableComponentCreated` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", classId: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "componentId",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "componentName",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "classId",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentCreated#classId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "classId: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "classId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentCreated#componentId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentCreated#componentName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!DisposableComponentLike:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface DisposableComponentLike extends "
          }, {
            kind: "Reference",
            text: "ComponentLike",
            canonicalReference: "decentraland-ecs!ComponentLike:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "DisposableComponentLike",
          members: [{
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!DisposableComponentLike#onDispose:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onDispose?(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "onDispose"
          }],
          extendsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!DisposableComponentRemoved:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class DisposableComponentRemoved "
          }],
          releaseTag: "Public",
          name: "DisposableComponentRemoved",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!DisposableComponentRemoved:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `DisposableComponentRemoved` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "componentId",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentRemoved#componentId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!DisposableComponentUpdated:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class DisposableComponentUpdated "
          }],
          releaseTag: "Public",
          name: "DisposableComponentUpdated",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!DisposableComponentUpdated:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `DisposableComponentUpdated` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", component: "
            }, {
              kind: "Reference",
              text: "DisposableComponentLike",
              canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "componentId",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentUpdated#component:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "component: "
            }, {
              kind: "Reference",
              text: "DisposableComponentLike",
              canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "component",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!DisposableComponentUpdated#componentId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "componentId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "componentId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!double:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type double = "
          }, {
            kind: "Content",
            text: "number"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "double",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Engine:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Engine implements "
          }, {
            kind: "Reference",
            text: "IEngine",
            canonicalReference: "decentraland-ecs!IEngine:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Engine",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Engine:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Engine` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(rootEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "rootEntity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#addEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addEntity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#addSystem:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addSystem(system: "
            }, {
              kind: "Reference",
              text: "ISystem",
              canonicalReference: "decentraland-ecs!ISystem:interface"
            }, {
              kind: "Content",
              text: ", priority?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "ISystem",
              canonicalReference: "decentraland-ecs!ISystem:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "system",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "priority",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addSystem"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Engine#avatarEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly avatarEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "avatarEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#disposeComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "disposeComponent(component: "
            }, {
              kind: "Reference",
              text: "DisposableComponentLike",
              canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "disposeComponent"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Engine#eventManager:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly eventManager: "
            }, {
              kind: "Reference",
              text: "EventManager",
              canonicalReference: "decentraland-ecs!EventManager:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "eventManager",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Engine#firstPersonCameraEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly firstPersonCameraEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "firstPersonCameraEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#getComponentGroup:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentGroup(...requires: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<any>[]"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "ComponentGroup",
              canonicalReference: "decentraland-ecs!ComponentGroup:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "requires",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            name: "getComponentGroup"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#getEntitiesWithComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getEntitiesWithComponent(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, any>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getEntitiesWithComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#getEntitiesWithComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getEntitiesWithComponent(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<any>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            name: "getEntitiesWithComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#registerComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "registerComponent(component: "
            }, {
              kind: "Reference",
              text: "DisposableComponentLike",
              canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "registerComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#removeComponentGroup:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponentGroup(componentGroup: "
            }, {
              kind: "Reference",
              text: "ComponentGroup",
              canonicalReference: "decentraland-ecs!ComponentGroup:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "componentGroup",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "removeComponentGroup"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#removeEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "removeEntity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#removeSystem:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeSystem(system: "
            }, {
              kind: "Reference",
              text: "ISystem",
              canonicalReference: "decentraland-ecs!ISystem:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "system",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "removeSystem"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Engine#rootEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly rootEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "rootEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#update:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "update(dt: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "dt",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "update"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Engine#updateComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "updateComponent(component: "
            }, {
              kind: "Reference",
              text: "DisposableComponentLike",
              canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "updateComponent"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!engine:var",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "engine: "
          }, {
            kind: "Reference",
            text: "Engine",
            canonicalReference: "decentraland-ecs!Engine:class"
          }],
          releaseTag: "Public",
          name: "engine",
          variableTypeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!EngineEvent:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type EngineEvent<T extends "
          }, {
            kind: "Reference",
            text: "IEventNames",
            canonicalReference: "decentraland-ecs!IEventNames:type"
          }, {
            kind: "Content",
            text: " "
          }, {
            kind: "Content",
            text: "= "
          }, {
            kind: "Reference",
            text: "IEventNames",
            canonicalReference: "decentraland-ecs!IEventNames:type"
          }, {
            kind: "Content",
            text: ", V = "
          }, {
            kind: "Reference",
            text: "IEvents",
            canonicalReference: "decentraland-ecs!IEvents:interface"
          }, {
            kind: "Content",
            text: "[T]"
          }, {
            kind: "Content",
            text: "> = "
          }, {
            kind: "Content",
            text: "{\n    type: T;\n    data: V;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "EngineEvent",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            defaultTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            }
          }, {
            typeParameterName: "V",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 6,
              endIndex: 8
            }
          }],
          typeTokenRange: {
            startIndex: 9,
            endIndex: 10
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Entity:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Entity implements "
          }, {
            kind: "Reference",
            text: "IEntity",
            canonicalReference: "decentraland-ecs!IEntity:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Entity",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Entity:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Entity` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(name?: "
            }, {
              kind: "Content",
              text: "string | undefined"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "name",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#addComponent:member(1)",
            docComment: "/**\n * Adds a component. If the component already exist, it throws an Error.\n *\n * @param component - component instance.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "addComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#addComponentOrReplace:member(1)",
            docComment: "/**\n * Adds or replaces a component in the entity.\n *\n * @param component - component instance.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addComponentOrReplace<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "addComponentOrReplace"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#alive:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "alive: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alive",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#children:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "children: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "children",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 5
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#components:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly components: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, any>"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "components",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#eventManager:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "eventManager: "
            }, {
              kind: "Reference",
              text: "EventManager",
              canonicalReference: "decentraland-ecs!EventManager:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "eventManager",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getComponent:member(1)",
            docComment: "/**\n * Gets a component, if it doesn't exist, it throws an Error.\n *\n * @param component - component class or name\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getComponent<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getComponentOrCreate:member(1)",
            docComment: "/**\n * Gets a component, if it doesn't exist, it creates the component and returns it.\n *\n * @param component - component class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrCreate<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T> & {\n        new (): T;\n    }"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponentOrCreate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getComponentOrNull:member(1)",
            docComment: "/**\n * Gets a component, if it doesn't exist, it returns null.\n *\n * @param component - component class or name\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrNull<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getComponentOrNull"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getComponentOrNull:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrNull<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponentOrNull"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#getParent:member(1)",
            docComment: "/**\n * Gets the parent entity\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getParent(): "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getParent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#hasComponent:member(1)",
            docComment: "/**\n * Returns a boolean indicating if a component is present in the entity.\n *\n * @param component - component class, instance or name\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "hasComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#hasComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "hasComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#hasComponent:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "hasComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#isAddedToEngine:member(1)",
            docComment: "/**\n * Returns true if the entity is already added to the engine. Returns false if no engine was defined.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "isAddedToEngine(): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "isAddedToEngine"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#name:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "name?: "
            }, {
              kind: "Content",
              text: "string | undefined"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "name",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#removeComponent:member(1)",
            docComment: "/**\n * Removes a component instance from the entity.\n *\n * @param component - component instance to remove\n *\n * @param triggerRemovedEvent - should this action trigger an event?\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "removeComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#removeComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "removeComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#removeComponent:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<any>"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "removeComponent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Entity#setParent:member(1)",
            docComment: "/**\n * Sets the parent entity\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setParent(_parent: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "Attachable",
              canonicalReference: "decentraland-ecs!Attachable:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "_parent",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "setParent"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Entity#uuid:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly uuid: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uuid",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!Epsilon:var",
          docComment: "/**\n * Constant used to define the minimal number value in Babylon.js\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "Epsilon = 0.000001"
          }],
          releaseTag: "Public",
          name: "Epsilon",
          variableTypeTokenRange: {
            startIndex: 0,
            endIndex: 0
          }
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!error:function(1)",
          docComment: "/**\n * Error function. Prints a console error. Only works in debug mode, otherwise it does nothing.\n *\n * @param error - string or Error object.\n *\n * @param data - any debug information.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function error(error: "
          }, {
            kind: "Content",
            text: "string | "
          }, {
            kind: "Reference",
            text: "Error",
            canonicalReference: "!Error:interface"
          }, {
            kind: "Content",
            text: ", data?: "
          }, {
            kind: "Content",
            text: "any"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 6,
            endIndex: 7
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "error",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }, {
            parameterName: "data",
            parameterTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            }
          }],
          name: "error"
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!EventConstructor:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function EventConstructor(): "
          }, {
            kind: "Reference",
            text: "ClassDecorator",
            canonicalReference: "!ClassDecorator:type"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 1,
            endIndex: 2
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [],
          name: "EventConstructor"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!EventManager:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class EventManager "
          }],
          releaseTag: "Public",
          name: "EventManager",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!EventManager#addListener:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addListener<T, X>(eventClass: "
            }, {
              kind: "Reference",
              text: "IEventConstructor",
              canonicalReference: "decentraland-ecs!IEventConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ", listener: "
            }, {
              kind: "Content",
              text: "X"
            }, {
              kind: "Content",
              text: ", listenerFunction: "
            }, {
              kind: "Content",
              text: "(this: X, event: T) => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eventClass",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "listener",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "listenerFunction",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }, {
              typeParameterName: "X",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "addListener"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!EventManager#fireEvent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fireEvent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(event: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "event",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "fireEvent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!EventManager#removeListener:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeListener<X>(listener: "
            }, {
              kind: "Content",
              text: "X"
            }, {
              kind: "Content",
              text: ", eventClass: "
            }, {
              kind: "Reference",
              text: "IEventConstructor",
              canonicalReference: "decentraland-ecs!IEventConstructor:interface"
            }, {
              kind: "Content",
              text: "<any>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "listener",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "eventClass",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 5
              }
            }],
            typeParameters: [{
              typeParameterName: "X",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "removeListener"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!executeTask:function(1)",
          docComment: "/**\n * Executes an asynchronous task\n *\n * @param task - the task to execute\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function executeTask<T>(task: "
          }, {
            kind: "Content",
            text: "() => "
          }, {
            kind: "Reference",
            text: "Promise",
            canonicalReference: "!Promise:interface"
          }, {
            kind: "Content",
            text: "<T>"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Reference",
            text: "TaskResult",
            canonicalReference: "decentraland-ecs!TaskResult:type"
          }, {
            kind: "Content",
            text: "<T>"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 7
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "task",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            }
          }],
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "executeTask"
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!FileAndHash:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type FileAndHash = "
          }, {
            kind: "Content",
            text: "{\n    file: string;\n    hash: string;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "FileAndHash",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!float:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type float = "
          }, {
            kind: "Content",
            text: "number"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "float",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!FloatArray:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type FloatArray = "
          }, {
            kind: "Content",
            text: "number[]"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "FloatArray",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Font:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Font extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Font",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Font:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Font` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src?: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Font#src:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "src",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!Fonts:enum",
          docComment: "",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum Fonts "
          }],
          releaseTag: "Public",
          name: "Fonts",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Fonts.LiberationSans:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "LiberationSans = "
            }, {
              kind: "Content",
              text: '"builtin:LiberationSans SDF"'
            }],
            releaseTag: "Public",
            name: "LiberationSans",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Fonts.SanFrancisco:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "SanFrancisco = "
            }, {
              kind: "Content",
              text: '"builtin:SF-UI-Text-Regular SDF"'
            }],
            releaseTag: "Public",
            name: "SanFrancisco",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Fonts.SanFrancisco_Heavy:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "SanFrancisco_Heavy = "
            }, {
              kind: "Content",
              text: '"builtin:SF-UI-Text-Heavy SDF"'
            }],
            releaseTag: "Public",
            name: "SanFrancisco_Heavy",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Fonts.SanFrancisco_Semibold:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "SanFrancisco_Semibold = "
            }, {
              kind: "Content",
              text: '"builtin:SF-UI-Text-Semibold SDF"'
            }],
            releaseTag: "Public",
            name: "SanFrancisco_Semibold",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Frustum:class",
          docComment: "/**\n * Reprasents a camera frustum\n *\n * @beta\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Frustum "
          }],
          releaseTag: "Beta",
          name: "Frustum",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetBottomPlaneToRef:member(1)",
            docComment: "/**\n * Gets the bottom frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetBottomPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetBottomPlaneToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetFarPlaneToRef:member(1)",
            docComment: "/**\n * Gets the far frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetFarPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetFarPlaneToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetLeftPlaneToRef:member(1)",
            docComment: "/**\n * Gets the left frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetLeftPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetLeftPlaneToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetNearPlaneToRef:member(1)",
            docComment: "/**\n * Gets the near frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetNearPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetNearPlaneToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetPlanes:member(1)",
            docComment: "/**\n * Gets the planes representing the frustum\n *\n * @param transform - matrix to be applied to the returned planes\n *\n * @returns a new array of 6 Frustum planes computed by the given transformation matrix.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetPlanes(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 5
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "GetPlanes"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetPlanesToRef:member(1)",
            docComment: '/**\n * Sets the given array "frustumPlanes" with the 6 Frustum planes computed by the given transformation matrix.\n *\n * @param transform - transformation matrix to be applied to the resulting frustum planes\n *\n * @param frustumPlanes - the resuling frustum planes\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static GetPlanesToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlanes: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlanes",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 5
              }
            }],
            name: "GetPlanesToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetRightPlaneToRef:member(1)",
            docComment: "/**\n * Gets the right frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetRightPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetRightPlaneToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Frustum.GetTopPlaneToRef:member(1)",
            docComment: "/**\n * Gets the top frustum plane transformed by the transform matrix\n *\n * @param transform - transformation matrix to be applied to the resulting frustum plane\n *\n * @param frustumPlane - the resuling frustum plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetTopPlaneToRef(transform: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", frustumPlane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Beta",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transform",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "frustumPlane",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "GetTopPlaneToRef"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!getComponentClassId:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function getComponentClassId<T extends "
          }, {
            kind: "Reference",
            text: "Record",
            canonicalReference: "!Record:type"
          }, {
            kind: "Content",
            text: "<any, any> "
          }, {
            kind: "Content",
            text: "= "
          }, {
            kind: "Content",
            text: "any"
          }, {
            kind: "Content",
            text: ">(component: "
          }, {
            kind: "Content",
            text: "T | "
          }, {
            kind: "Reference",
            text: "ComponentConstructor",
            canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
          }, {
            kind: "Content",
            text: "<T>"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "number | null"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 10,
            endIndex: 11
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "component",
            parameterTypeTokenRange: {
              startIndex: 6,
              endIndex: 9
            }
          }],
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            defaultTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            }
          }],
          name: "getComponentClassId"
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!getComponentId:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function getComponentId<T extends "
          }, {
            kind: "Reference",
            text: "DisposableComponentLike",
            canonicalReference: "decentraland-ecs!DisposableComponentLike:interface"
          }, {
            kind: "Content",
            text: ">(component: "
          }, {
            kind: "Content",
            text: "T"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 6
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "component",
            parameterTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            }
          }],
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "getComponentId"
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!getComponentName:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function getComponentName<T extends "
          }, {
            kind: "Reference",
            text: "Record",
            canonicalReference: "!Record:type"
          }, {
            kind: "Content",
            text: "<any, any> "
          }, {
            kind: "Content",
            text: "= "
          }, {
            kind: "Content",
            text: "any"
          }, {
            kind: "Content",
            text: ">(component: "
          }, {
            kind: "Content",
            text: "T | "
          }, {
            kind: "Reference",
            text: "ComponentConstructor",
            canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
          }, {
            kind: "Content",
            text: "<T>"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 10,
            endIndex: 11
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "component",
            parameterTypeTokenRange: {
              startIndex: 6,
              endIndex: 9
            }
          }],
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            defaultTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            }
          }],
          name: "getComponentName"
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!Gizmo:enum",
          docComment: "/**\n * Gizmo identifiers\n *\n * @beta\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum Gizmo "
          }],
          releaseTag: "Beta",
          name: "Gizmo",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Gizmo.MOVE:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "MOVE = "
            }, {
              kind: "Content",
              text: '"MOVE"'
            }],
            releaseTag: "Beta",
            name: "MOVE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Gizmo.NONE:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "NONE = "
            }, {
              kind: "Content",
              text: '"NONE"'
            }],
            releaseTag: "Beta",
            name: "NONE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Gizmo.ROTATE:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ROTATE = "
            }, {
              kind: "Content",
              text: '"ROTATE"'
            }],
            releaseTag: "Beta",
            name: "ROTATE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Gizmo.SCALE:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "SCALE = "
            }, {
              kind: "Content",
              text: '"SCALE"'
            }],
            releaseTag: "Beta",
            name: "SCALE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!GizmoDragEndEvent:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type GizmoDragEndEvent = "
          }, {
            kind: "Content",
            text: "{\n    type: 'gizmoDragEnded';\n    transforms: {\n        position: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n        rotation: "
          }, {
            kind: "Reference",
            text: "ReadOnlyQuaternion",
            canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
          }, {
            kind: "Content",
            text: ";\n        scale: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n        entityId: string;\n    }[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "GizmoDragEndEvent",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 8
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Gizmos:class",
          docComment: "/**\n * Enables gizmos in the entity. Gizmos only work in EDITOR, PREVIEW or DEBUG modes.\n *\n * @beta\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Gizmos extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Beta",
          name: "Gizmos",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#cycle:member",
            docComment: "/**\n * Cycle through gizmos using click.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "cycle: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "cycle",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#localReference:member",
            docComment: "/**\n * Align the gizmos to match the local reference system\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "localReference: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "localReference",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#position:member",
            docComment: "/**\n * Enable position gizmo\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "position: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "position",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#rotation:member",
            docComment: "/**\n * Enable rotation gizmo\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "rotation: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "rotation",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#scale:member",
            docComment: "/**\n * Enable scale gizmo\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scale: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "scale",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Gizmos#selectedGizmo:member",
            docComment: "/**\n * If cycle is false, this will be the selected gizmo\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "selectedGizmo?: "
            }, {
              kind: "Reference",
              text: "Gizmo",
              canonicalReference: "decentraland-ecs!Gizmo:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "selectedGizmo",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!GizmoSelectedEvent:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type GizmoSelectedEvent = "
          }, {
            kind: "Content",
            text: "{\n    type: 'gizmoSelected';\n    gizmoType: 'MOVE' | 'ROTATE' | 'SCALE' | 'NONE';\n    entities: string[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "GizmoSelectedEvent",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!GlobalInputEventResult:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type GlobalInputEventResult = "
          }, {
            kind: "Reference",
            text: "InputEventResult",
            canonicalReference: "decentraland-ecs!InputEventResult:type"
          }, {
            kind: "Content",
            text: " & {\n    type: "
          }, {
            kind: "Reference",
            text: "InputEventType",
            canonicalReference: "decentraland-ecs!InputEventType:enum"
          }, {
            kind: "Content",
            text: ";\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "GlobalInputEventResult",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 5
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!GlobalPointerDown:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class GlobalPointerDown extends "
          }, {
            kind: "Reference",
            text: "PointerEventComponent",
            canonicalReference: "decentraland-ecs!PointerEventComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "GlobalPointerDown",
          members: [],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!GlobalPointerUp:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class GlobalPointerUp extends "
          }, {
            kind: "Reference",
            text: "PointerEventComponent",
            canonicalReference: "decentraland-ecs!PointerEventComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "GlobalPointerUp",
          members: [],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!GLTFShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class GLTFShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "GLTFShape",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!GLTFShape:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `GLTFShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!GLTFShape#src:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "src",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!HitEntityInfo:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface HitEntityInfo "
          }],
          releaseTag: "Public",
          name: "HitEntityInfo",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!HitEntityInfo#entityId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entityId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entityId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!HitEntityInfo#isValid:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isValid: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isValid",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!HitEntityInfo#meshName:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "meshName: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "meshName",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!IEngine:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface IEngine "
          }],
          releaseTag: "Public",
          name: "IEngine",
          members: [{
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEngine#addEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addEntity"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEngine#addSystem:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addSystem(system: "
            }, {
              kind: "Reference",
              text: "ISystem",
              canonicalReference: "decentraland-ecs!ISystem:interface"
            }, {
              kind: "Content",
              text: ", priority: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "system",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "priority",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addSystem"
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEngine#avatarEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly avatarEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "avatarEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEngine#entities:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly entities: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ">>"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entities",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 7
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEngine#firstPersonCameraEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly firstPersonCameraEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "firstPersonCameraEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEngine#removeEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "removeEntity"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEngine#removeSystem:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeSystem(system: "
            }, {
              kind: "Reference",
              text: "ISystem",
              canonicalReference: "decentraland-ecs!ISystem:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "system",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "removeSystem"
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEngine#rootEntity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "rootEntity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "rootEntity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!IEntity:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface IEntity "
          }],
          releaseTag: "Public",
          name: "IEntity",
          members: [{
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#addComponent:member(1)",
            docComment: "/**\n * Adds a component. If the component already exist, it throws an Error.\n *\n * @param component - component instance.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "addComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#addComponentOrReplace:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "addComponentOrReplace<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "addComponentOrReplace"
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEntity#alive:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "alive: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alive",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEntity#children:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "children: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "children",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 5
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEntity#components:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly components: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, any>"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "components",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEntity#eventManager:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "eventManager: "
            }, {
              kind: "Reference",
              text: "EventManager",
              canonicalReference: "decentraland-ecs!EventManager:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "eventManager",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponent<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponent:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T> | string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponentOrCreate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrCreate<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T> & {\n        new (): T;\n    }"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponentOrCreate"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponentOrNull:member(1)",
            docComment: "/**\n * Gets a component, if it doesn't exist, it returns null.\n *\n * @param component - component class or name\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrNull<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getComponentOrNull"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponentOrNull:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrNull<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponentOrNull"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getComponentOrNull:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getComponentOrNull<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T> | string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "getComponentOrNull"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#getParent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getParent(): "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getParent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#hasComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T = "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "hasComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#hasComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "hasComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#hasComponent:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "hasComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#hasComponent:member(4)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hasComponent<T>(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<T> | string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 4,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "hasComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#isAddedToEngine:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isAddedToEngine(): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "isAddedToEngine"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#removeComponent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent(component: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "removeComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#removeComponent:member(2)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent<T extends "
            }, {
              kind: "Content",
              text: "object"
            }, {
              kind: "Content",
              text: ">(component: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 1,
                endIndex: 2
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "removeComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#removeComponent:member(3)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent(component: "
            }, {
              kind: "Reference",
              text: "ComponentConstructor",
              canonicalReference: "decentraland-ecs!ComponentConstructor:interface"
            }, {
              kind: "Content",
              text: "<any>"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "removeComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#removeComponent:member(4)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "removeComponent(component: "
            }, {
              kind: "Content",
              text: "object | string | "
            }, {
              kind: "Reference",
              text: "Function",
              canonicalReference: "!Function:interface"
            }, {
              kind: "Content",
              text: ", triggerRemovedEvent: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 4,
            parameters: [{
              parameterName: "component",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "triggerRemovedEvent",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "removeComponent"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IEntity#setParent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "setParent(e: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "Attachable",
              canonicalReference: "decentraland-ecs!Attachable:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "e",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "setParent"
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEntity#uuid:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly uuid: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uuid",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!IEventConstructor:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface IEventConstructor<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "IEventConstructor",
          members: [{
            kind: "ConstructSignature",
            canonicalReference: "decentraland-ecs!IEventConstructor:new(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "new (...args: "
            }, {
              kind: "Content",
              text: "any[]"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "args",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }],
          extendsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!IEventNames:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type IEventNames = "
          }, {
            kind: "Content",
            text: "keyof "
          }, {
            kind: "Reference",
            text: "IEvents",
            canonicalReference: "decentraland-ecs!IEvents:interface"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "IEventNames",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 3
          }
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!IEvents:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface IEvents "
          }],
          releaseTag: "Public",
          name: "IEvents",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#builderSceneStart:member",
            docComment: "/**\n * This is triggered once the builder scene is loaded.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "builderSceneStart: "
            }, {
              kind: "Content",
              text: "{}"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "builderSceneStart",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#builderSceneUnloaded:member",
            docComment: "/**\n * This is triggered once the builder scene is unloaded.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "builderSceneUnloaded: "
            }, {
              kind: "Content",
              text: "{}"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "builderSceneUnloaded",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#chatMessage:member",
            docComment: "/**\n * `chatMessage` is triggered when the user sends a message through chat entity.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "chatMessage: "
            }, {
              kind: "Content",
              text: "{\n        id: string;\n        sender: string;\n        message: string;\n        isCommand: boolean;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "chatMessage",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#comms:member",
            docComment: "/**\n * This event gets triggered after receiving a comms message.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "comms: "
            }, {
              kind: "Content",
              text: "{\n        sender: string;\n        message: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "comms",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#entitiesOutOfBoundaries:member",
            docComment: "/**\n * After checking entities outside the fences, if any is outside, this event will be triggered with all the entities outside the scene.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "entitiesOutOfBoundaries: "
            }, {
              kind: "Content",
              text: "{\n        entities: string[];\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entitiesOutOfBoundaries",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#entityBackInScene:member",
            docComment: "/**\n * This event gets triggered when an entity enters the scene fences.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "entityBackInScene: "
            }, {
              kind: "Content",
              text: "{\n        entityId: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entityBackInScene",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#entityOutOfScene:member",
            docComment: "/**\n * This event gets triggered when an entity leaves the scene fences.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "entityOutOfScene: "
            }, {
              kind: "Content",
              text: "{\n        entityId: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entityOutOfScene",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#gizmoEvent:member",
            docComment: "/**\n * For gizmos\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "gizmoEvent: "
            }, {
              kind: "Reference",
              text: "GizmoDragEndEvent",
              canonicalReference: "decentraland-ecs!GizmoDragEndEvent:type"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "GizmoSelectedEvent",
              canonicalReference: "decentraland-ecs!GizmoSelectedEvent:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "gizmoEvent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#limitsExceeded:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "limitsExceeded: "
            }, {
              kind: "Content",
              text: "{\n        given: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, number>;\n        limit: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, number>;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "limitsExceeded",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 6
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#metricsUpdate:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "metricsUpdate: "
            }, {
              kind: "Content",
              text: "{\n        given: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, number>;\n        limit: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<string, number>;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "metricsUpdate",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 6
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onAnimationEnd:member",
            docComment: "/**\n * `onAnimationEnd` is triggered when an animation clip gets finish\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "onAnimationEnd: "
            }, {
              kind: "Content",
              text: "{\n        clipName: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onAnimationEnd",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onBlur:member",
            docComment: "/**\n * `onBlur` is triggered when an entity loses its focus. Dispatched by the `ui-input` and `ui-password` entities when the value is changed. It triggers a callback.\n *\n * Notice: Only entities with ID will be listening for click events.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "onBlur: "
            }, {
              kind: "Content",
              text: "{\n        entityId: string;\n        pointerId: number;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onChange:member",
            docComment: "/**\n * `onChange` is triggered when an entity changes its own internal state. Dispatched by the `ui-*` entities when their value is changed. It triggers a callback. Notice: Only entities with ID will be listening for click events.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "onChange: "
            }, {
              kind: "Content",
              text: "{\n        value?: any;\n        pointerId?: number;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onChange",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onClick:member",
            docComment: "/**\n * The onClick event is only used for UI elements\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "onClick: "
            }, {
              kind: "Content",
              text: "{\n        entityId: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onClick",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onEnter:member",
            docComment: '/**\n * `onEnter` is triggered when the user hits the "Enter" key from the keyboard Used principally by the Chat internal scene\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "onEnter: "
            }, {
              kind: "Content",
              text: "{}"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onEnter",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onFocus:member",
            docComment: "/**\n * `onFocus` is triggered when an entity focus is active. Dispatched by the `ui-input` and `ui-password` entities when the value is changed. It triggers a callback.\n *\n * Notice: Only entities with ID will be listening for click events.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "onFocus: "
            }, {
              kind: "Content",
              text: "{\n        entityId: string;\n        pointerId: number;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onFocus",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#onTextSubmit:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onTextSubmit: "
            }, {
              kind: "Content",
              text: "{\n        text: string;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onTextSubmit",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#pointerDown:member",
            docComment: "/**\n * `pointerDown` is triggered when the user press an input pointer. It could be a VR controller, a touch screen or the mouse.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "pointerDown: "
            }, {
              kind: "Reference",
              text: "InputEventResult",
              canonicalReference: "decentraland-ecs!InputEventResult:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "pointerDown",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#pointerEvent:member",
            docComment: "/**\n * `pointerEvent` is triggered when the user press or releases an input pointer. It could be a VR controller, a touch screen or the mouse.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "pointerEvent: "
            }, {
              kind: "Reference",
              text: "GlobalInputEventResult",
              canonicalReference: "decentraland-ecs!GlobalInputEventResult:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "pointerEvent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#pointerUp:member",
            docComment: "/**\n * `pointerUp` is triggered when the user releases an input pointer. It could be a VR controller, a touch screen or the mouse.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "pointerUp: "
            }, {
              kind: "Reference",
              text: "InputEventResult",
              canonicalReference: "decentraland-ecs!InputEventResult:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "pointerUp",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#positionChanged:member",
            docComment: "/**\n * `positionChanged` is triggered when the position of the camera changes This event is throttled to 10 times per second.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "positionChanged: "
            }, {
              kind: "Content",
              text: "{\n        position: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";\n        cameraPosition: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";\n        playerHeight: number;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "positionChanged",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 6
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#raycastResponse:member",
            docComment: "/**\n * `raycastResponse` is triggered in response to a raycast query\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "raycastResponse: "
            }, {
              kind: "Reference",
              text: "RaycastResponse",
              canonicalReference: "decentraland-ecs!RaycastResponse:class"
            }, {
              kind: "Content",
              text: "<any>"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "raycastResponse",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#rotationChanged:member",
            docComment: "/**\n * `rotationChanged` is triggered when the rotation of the camera changes. This event is throttled to 10 times per second.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "rotationChanged: "
            }, {
              kind: "Content",
              text: "{\n        rotation: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";\n        quaternion: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ";\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "rotationChanged",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 6
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#sceneStart:member",
            docComment: "/**\n * This is triggered once the scene should start.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "sceneStart: "
            }, {
              kind: "Content",
              text: "{}"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sceneStart",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!IEvents#uuidEvent:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "uuidEvent: "
            }, {
              kind: "Content",
              text: "{\n        uuid: string;\n        payload: any;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uuidEvent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Input:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Input "
          }],
          releaseTag: "Public",
          name: "Input",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!Input.ensureInstance:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static ensureInstance(): "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "ensureInstance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Input#handlePointerEvent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "handlePointerEvent(data: "
            }, {
              kind: "Reference",
              text: "GlobalInputEventResult",
              canonicalReference: "decentraland-ecs!GlobalInputEventResult:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "data",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "handlePointerEvent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Input#isButtonPressed:member(1)",
            docComment: "/**\n * Allows to know if a button is pressed\n *\n * Returns true if the button is pressed\n *\n * @param buttonId - The id of the button.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "isButtonPressed(buttonId: "
            }, {
              kind: "Reference",
              text: "ActionButton",
              canonicalReference: "decentraland-ecs!ActionButton:enum"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "{\n        BUTTON_DOWN: boolean;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "buttonId",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "isButtonPressed"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Input#subscribe:member(1)",
            docComment: "/**\n * Subscribes to an input event and triggers the provided callback.\n *\n * Returns a function that can be called to remove the subscription.\n *\n * @param eventName - The name of the event (see InputEventKind).\n *\n * @param buttonId - The id of the button.\n *\n * @param useRaycast - Enables getting raycast information.\n *\n * @param fn - A callback function to be called when the event is triggered.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subscribe(eventName: "
            }, {
              kind: "Reference",
              text: "InputEventKind",
              canonicalReference: "decentraland-ecs!InputEventKind:type"
            }, {
              kind: "Content",
              text: ", buttonId: "
            }, {
              kind: "Reference",
              text: "ActionButton",
              canonicalReference: "decentraland-ecs!ActionButton:enum"
            }, {
              kind: "Content",
              text: ", useRaycast: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", fn: "
            }, {
              kind: "Content",
              text: "(e: "
            }, {
              kind: "Reference",
              text: "LocalActionButtonEvent",
              canonicalReference: "decentraland-ecs!LocalActionButtonEvent:type"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "() => false | "
            }, {
              kind: "Reference",
              text: "Subscription",
              canonicalReference: "decentraland-ecs!~Subscription:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eventName",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "buttonId",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "useRaycast",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "fn",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 10
              }
            }],
            name: "subscribe"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Input#unsubscribe:member(1)",
            docComment: "/**\n * Removes an existing input event subscription.\n *\n * @param eventName - The name of the event (see InputEventKind).\n *\n * @param buttonId - The id of the button.\n *\n * @param fn - The callback function used when subscribing to the event.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "unsubscribe(eventName: "
            }, {
              kind: "Reference",
              text: "InputEventKind",
              canonicalReference: "decentraland-ecs!InputEventKind:type"
            }, {
              kind: "Content",
              text: ", buttonId: "
            }, {
              kind: "Reference",
              text: "ActionButton",
              canonicalReference: "decentraland-ecs!ActionButton:enum"
            }, {
              kind: "Content",
              text: ", fn: "
            }, {
              kind: "Content",
              text: "(e: "
            }, {
              kind: "Reference",
              text: "LocalActionButtonEvent",
              canonicalReference: "decentraland-ecs!LocalActionButtonEvent:type"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "false | "
            }, {
              kind: "Reference",
              text: "Subscription",
              canonicalReference: "decentraland-ecs!~Subscription:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eventName",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "buttonId",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "fn",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 8
              }
            }],
            name: "unsubscribe"
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!InputEventKind:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type InputEventKind = "
          }, {
            kind: "Content",
            text: "'BUTTON_DOWN' | 'BUTTON_UP'"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "InputEventKind",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!InputEventResult:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type InputEventResult = "
          }, {
            kind: "Content",
            text: "{\n    origin: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n    direction: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n    buttonId: number;\n    hit?: {\n        length: number;\n        hitPoint: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n        meshName: string;\n        normal: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n        worldNormal: "
          }, {
            kind: "Reference",
            text: "ReadOnlyVector3",
            canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
          }, {
            kind: "Content",
            text: ";\n        entityId: string;\n    };\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "InputEventResult",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 12
          }
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!InputEventType:enum",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum InputEventType "
          }],
          releaseTag: "Public",
          name: "InputEventType",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!InputEventType.DOWN:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "DOWN = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "DOWN",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!InputEventType.UP:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "UP = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "UP",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!InputState:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type InputState = "
          }, {
            kind: "Reference",
            text: "Record",
            canonicalReference: "!Record:type"
          }, {
            kind: "Content",
            text: "<"
          }, {
            kind: "Reference",
            text: "ActionButton",
            canonicalReference: "decentraland-ecs!ActionButton:enum"
          }, {
            kind: "Content",
            text: ", {\n    BUTTON_DOWN: boolean;\n}>"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "InputState",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 5
          }
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!IPhysicsCast:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface IPhysicsCast "
          }],
          releaseTag: "Public",
          name: "IPhysicsCast",
          members: [{
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IPhysicsCast#hitAll:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitAll(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitEntities",
              canonicalReference: "decentraland-ecs!RaycastHitEntities:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", id?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }, {
              parameterName: "id",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "hitAll"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!IPhysicsCast#hitFirst:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitFirst(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitEntity",
              canonicalReference: "decentraland-ecs!RaycastHitEntity:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", id?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }, {
              parameterName: "id",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "hitFirst"
          }],
          extendsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!isDisposableComponent:function(1)",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function isDisposableComponent(component: "
          }, {
            kind: "Reference",
            text: "ComponentLike",
            canonicalReference: "decentraland-ecs!ComponentLike:interface"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "boolean"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 3,
            endIndex: 4
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "component",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "isDisposableComponent"
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!ISize:interface",
          docComment: "/**\n * Interface for the size containing width and height\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface ISize "
          }],
          releaseTag: "Public",
          name: "ISize",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!ISize#height:member",
            docComment: "/**\n * Heighht\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "height",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!ISize#width:member",
            docComment: "/**\n * Width\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "width",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!ISystem:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface ISystem "
          }],
          releaseTag: "Public",
          name: "ISystem",
          members: [{
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!ISystem#activate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "activate?(engine: "
            }, {
              kind: "Reference",
              text: "IEngine",
              canonicalReference: "decentraland-ecs!IEngine:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "engine",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "activate"
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!ISystem#active:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "active?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "active",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!ISystem#deactivate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "deactivate?(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "deactivate"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!ISystem#onAddEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onAddEntity?(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "onAddEntity"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!ISystem#onRemoveEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onRemoveEntity?(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "onRemoveEntity"
          }, {
            kind: "MethodSignature",
            canonicalReference: "decentraland-ecs!ISystem#update:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "update?(dt: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "dt",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "update"
          }],
          extendsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!LocalActionButtonEvent:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type LocalActionButtonEvent = "
          }, {
            kind: "Reference",
            text: "GlobalInputEventResult",
            canonicalReference: "decentraland-ecs!GlobalInputEventResult:type"
          }, {
            kind: "Content",
            text: " & {\n    origin: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n    direction: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n    button: "
          }, {
            kind: "Reference",
            text: "ActionButton",
            canonicalReference: "decentraland-ecs!ActionButton:enum"
          }, {
            kind: "Content",
            text: ";\n    hit?: "
          }, {
            kind: "Reference",
            text: "GlobalInputEventResult",
            canonicalReference: "decentraland-ecs!GlobalInputEventResult:type"
          }, {
            kind: "Content",
            text: "['hit'] & {\n        hitPoint: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n        normal: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n        worldNormal: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n    };\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "LocalActionButtonEvent",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 17
          }
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!log:function(1)",
          docComment: "/**\n * Log function. Only works in debug mode, otherwise it does nothing.\n *\n * @param args - any loggable parameter\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function log(...args: "
          }, {
            kind: "Content",
            text: "any[]"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 3,
            endIndex: 4
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "args",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "log"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Material:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Material extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Material",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#albedoColor:member",
            docComment: "/**\n * AKA Diffuse Color in other nomenclature. Defaults to #CCCCCC.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "albedoColor?: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "albedoColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#albedoTexture:member",
            docComment: "/**\n * Texture applied as material.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "albedoTexture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: " | "
            }, {
              kind: "Reference",
              text: "VideoTexture",
              canonicalReference: "decentraland-ecs!VideoTexture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "albedoTexture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#alphaTest:member",
            docComment: "/**\n * Cutoff level for ALPHATEST mode. Range is between 0 and 1. Defaults to 0.5\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "alphaTest?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alphaTest",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#alphaTexture:member",
            docComment: "/**\n * Texture applied as opacity. Default: the same texture used in albedoTexture.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "alphaTexture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alphaTexture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#ambientColor:member",
            docComment: "/**\n * AKA Diffuse Color in other nomenclature. Defaults to black.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "ambientColor?: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "ambientColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#bumpTexture:member",
            docComment: "/**\n * Stores surface normal data used to displace a mesh in a texture.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "bumpTexture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "bumpTexture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#directIntensity:member",
            docComment: "/**\n * Intensity of the direct lights e.g. the four lights available in scene. This impacts both the direct diffuse and specular highlights. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "directIntensity?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "directIntensity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#disableLighting:member",
            docComment: "/**\n * If sets to true, disables all the lights affecting the material. Defaults to false.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "disableLighting?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "disableLighting",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#emissiveColor:member",
            docComment: "/**\n * The color emitted from the material. Defaults to black.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "emissiveColor?: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "emissiveColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#emissiveIntensity:member",
            docComment: "/**\n * Intensity of the emissive part of the material. This helps controlling the emissive effect without modifying the emissive color. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "emissiveIntensity?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "emissiveIntensity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#emissiveTexture:member",
            docComment: "/**\n * Emissive texture.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "emissiveTexture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "emissiveTexture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#environmentIntensity:member",
            docComment: "/**\n * Intensity of the environment e.g. how much the environment will light the object either through harmonics for rough material or through the refelction for shiny ones. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "environmentIntensity?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "environmentIntensity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#metallic:member",
            docComment: "/**\n * Specifies the metallic scalar of the metallic/roughness workflow. Can also be used to scale the metalness values of the metallic texture. Defaults to 0.5.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "metallic?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "metallic",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#microSurface:member",
            docComment: "/**\n * AKA Glossiness in other nomenclature. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "microSurface?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "microSurface",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#reflectionColor:member",
            docComment: "/**\n * The color reflected from the material. Defaults to white.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "reflectionColor?: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "reflectionColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#reflectivityColor:member",
            docComment: "/**\n * AKA Specular Color in other nomenclature. Defaults to white.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "reflectivityColor?: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "reflectivityColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#refractionTexture:member",
            docComment: "/**\n * Stores the refracted light information in a texture.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "refractionTexture?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "refractionTexture",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#roughness:member",
            docComment: "/**\n * Specifies the roughness scalar of the metallic/roughness workflow. Can also be used to scale the roughness values of the metallic texture. Defaults to 0.5.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "roughness?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "roughness",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#specularIntensity:member",
            docComment: "/**\n * This is a special control allowing the reduction of the specular highlights coming from the four lights of the scene. Those highlights may not be needed in full environment lighting. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "specularIntensity?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "specularIntensity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Material#transparencyMode:member",
            docComment: "/**\n * Sets the transparency mode of the material. Defaults to -1.\n *\n * | Value | Type | | ----- | ---------------------------------------------- | | 0 | OPAQUE (default) | | 1 | ALPHATEST | | 2 | ALPHABLEND | | 3 | ALPHATESTANDBLEND | | 4 | AUTO (ALPHABLEND if alpha OPAQUE otherwise |\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "transparencyMode: "
            }, {
              kind: "Reference",
              text: "TransparencyMode",
              canonicalReference: "decentraland-ecs!TransparencyMode:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "transparencyMode",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Matrix:class",
          docComment: "/**\n * Class used to store matrix data (4x4)\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Matrix "
          }],
          releaseTag: "Public",
          name: "Matrix",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Matrix:constructor(1)",
            docComment: "/**\n * Creates an empty matrix (filled with zeros)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor();"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: []
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#add:member(1)",
            docComment: "/**\n * Adds the current matrix with a second one\n *\n * @param other - defines the matrix to add\n *\n * @returns a new matrix as the addition of the current matrix and the given one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(other: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#addAtIndex:member(1)",
            docComment: "/**\n * add a value at the specified position in the current Matrix\n *\n * @param index - the index of the value within the matrix. between 0 and 15.\n *\n * @param value - the value to be added\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addAtIndex(index: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addAtIndex"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#addToRef:member(1)",
            docComment: '/**\n * Sets the given matrix "result" to the addition of the current matrix and the given one\n *\n * @param other - defines the matrix to add\n *\n * @param result - defines the target matrix\n *\n * @returns the current matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "addToRef(other: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#addToSelf:member(1)",
            docComment: "/**\n * Adds in place the given matrix to the current matrix\n *\n * @param other - defines the second operand\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addToSelf(other: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addToSelf"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#asArray:member(1)",
            docComment: "/**\n * Returns the matrix as a FloatArray\n *\n * @returns the matrix underlying array.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#clone:member(1)",
            docComment: "/**\n * Clone the current matrix\n *\n * @returns a new matrix from the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Compose:member(1)",
            docComment: "/**\n * Creates a new matrix composed by merging scale (vector3), rotation (quaternion) and translation (vector3)\n *\n * @param scale - defines the scale vector3\n *\n * @param rotation - defines the rotation quaternion\n *\n * @param translation - defines the translation vector3\n *\n * @returns a new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Compose(scale: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", rotation: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", translation: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "rotation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "translation",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Compose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.ComposeToRef:member(1)",
            docComment: "/**\n * Sets a matrix to a value composed by merging scale (vector3), rotation (quaternion) and translation (vector3)\n *\n * @param scale - defines the scale vector3\n *\n * @param rotation - defines the rotation quaternion\n *\n * @param translation - defines the translation vector3\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static ComposeToRef(scale: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", rotation: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", translation: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "rotation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "translation",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "ComposeToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#copyFrom:member(1)",
            docComment: "/**\n * Copy the current matrix from the given one\n *\n * @param other - defines the source matrix\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(other: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#copyToArray:member(1)",
            docComment: "/**\n * Populates the given array from the starting index with the current matrix values\n *\n * @param array - defines the target array\n *\n * @param offset - defines the offset in the target array where to start storing values\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyToArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "copyToArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#decompose:member(1)",
            docComment: "/**\n * Decomposes the current Matrix into a translation, rotation and scaling components\n *\n * @param scale - defines the scale vector3 given as a reference to update\n *\n * @param rotation - defines the rotation quaternion given as a reference to update\n *\n * @param translation - defines the translation vector3 given as a reference to update\n *\n * @returns true if operation was successful\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "decompose(scale?: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", rotation?: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", translation?: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "rotation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "translation",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "decompose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.DecomposeLerp:member(1)",
            docComment: '/**\n * Builds a new matrix whose values are computed by: * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices\n *\n * @param startValue - defines the first matrix\n *\n * @param endValue - defines the second matrix\n *\n * @param gradient - defines the gradient between the two matrices\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DecomposeLerp(startValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", endValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", gradient: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "startValue",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "endValue",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gradient",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "DecomposeLerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.DecomposeLerpToRef:member(1)",
            docComment: '/**\n * Update a matrix to values which are computed by: * decomposing the the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices\n *\n * @param startValue - defines the first matrix\n *\n * @param endValue - defines the second matrix\n *\n * @param gradient - defines the gradient between the two matrices\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DecomposeLerpToRef(startValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", endValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", gradient: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "startValue",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "endValue",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gradient",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "DecomposeLerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#determinant:member(1)",
            docComment: "/**\n * Gets the determinant of the matrix\n *\n * @returns the matrix determinant\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "determinant(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "determinant"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#equals:member(1)",
            docComment: "/**\n * Check equality between this matrix and a second one\n *\n * @param value - defines the second matrix to compare\n *\n * @returns true is the current matrix and the given one values are strictly equal\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(value: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromArray:member(1)",
            docComment: "/**\n * Creates a matrix from an array\n *\n * @param array - defines the source array\n *\n * @param offset - defines an offset in the source array\n *\n * @returns a new Matrix set from the starting index of the given array\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromArrayToRef:member(1)",
            docComment: "/**\n * Copy the content of an array into a given matrix\n *\n * @param array - defines the source array\n *\n * @param offset - defines an offset in the source array\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "FromArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromFloatArrayToRefScaled:member(1)",
            docComment: "/**\n * Stores an array into a matrix after having multiplied each component by a given factor\n *\n * @param array - defines the source array\n *\n * @param offset - defines the offset in the source array\n *\n * @param scale - defines the scaling factor\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatArrayToRefScaled(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "FromFloatArrayToRefScaled"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromQuaternionToRef:member(1)",
            docComment: "/**\n * Creates a rotation matrix from a quaternion and stores it in a target matrix\n *\n * @param quat - defines the quaternion to use\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromQuaternionToRef(quat: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "quat",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromQuaternionToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromValues:member(1)",
            docComment: "/**\n * Creates new matrix from a list of values (16)\n *\n * @param initialM11 - defines 1st value of 1st row\n *\n * @param initialM12 - defines 2nd value of 1st row\n *\n * @param initialM13 - defines 3rd value of 1st row\n *\n * @param initialM14 - defines 4th value of 1st row\n *\n * @param initialM21 - defines 1st value of 2nd row\n *\n * @param initialM22 - defines 2nd value of 2nd row\n *\n * @param initialM23 - defines 3rd value of 2nd row\n *\n * @param initialM24 - defines 4th value of 2nd row\n *\n * @param initialM31 - defines 1st value of 3rd row\n *\n * @param initialM32 - defines 2nd value of 3rd row\n *\n * @param initialM33 - defines 3rd value of 3rd row\n *\n * @param initialM34 - defines 4th value of 3rd row\n *\n * @param initialM41 - defines 1st value of 4th row\n *\n * @param initialM42 - defines 2nd value of 4th row\n *\n * @param initialM43 - defines 3rd value of 4th row\n *\n * @param initialM44 - defines 4th value of 4th row\n *\n * @returns the new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromValues(initialM11: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM12: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM13: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM14: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM21: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM22: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM23: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM24: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM31: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM32: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM33: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM34: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM41: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM42: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM43: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM44: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 33,
              endIndex: 34
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "initialM11",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "initialM12",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "initialM13",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "initialM14",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "initialM21",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "initialM22",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }, {
              parameterName: "initialM23",
              parameterTypeTokenRange: {
                startIndex: 13,
                endIndex: 14
              }
            }, {
              parameterName: "initialM24",
              parameterTypeTokenRange: {
                startIndex: 15,
                endIndex: 16
              }
            }, {
              parameterName: "initialM31",
              parameterTypeTokenRange: {
                startIndex: 17,
                endIndex: 18
              }
            }, {
              parameterName: "initialM32",
              parameterTypeTokenRange: {
                startIndex: 19,
                endIndex: 20
              }
            }, {
              parameterName: "initialM33",
              parameterTypeTokenRange: {
                startIndex: 21,
                endIndex: 22
              }
            }, {
              parameterName: "initialM34",
              parameterTypeTokenRange: {
                startIndex: 23,
                endIndex: 24
              }
            }, {
              parameterName: "initialM41",
              parameterTypeTokenRange: {
                startIndex: 25,
                endIndex: 26
              }
            }, {
              parameterName: "initialM42",
              parameterTypeTokenRange: {
                startIndex: 27,
                endIndex: 28
              }
            }, {
              parameterName: "initialM43",
              parameterTypeTokenRange: {
                startIndex: 29,
                endIndex: 30
              }
            }, {
              parameterName: "initialM44",
              parameterTypeTokenRange: {
                startIndex: 31,
                endIndex: 32
              }
            }],
            name: "FromValues"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromValuesToRef:member(1)",
            docComment: "/**\n * Stores a list of values (16) inside a given matrix\n *\n * @param initialM11 - defines 1st value of 1st row\n *\n * @param initialM12 - defines 2nd value of 1st row\n *\n * @param initialM13 - defines 3rd value of 1st row\n *\n * @param initialM14 - defines 4th value of 1st row\n *\n * @param initialM21 - defines 1st value of 2nd row\n *\n * @param initialM22 - defines 2nd value of 2nd row\n *\n * @param initialM23 - defines 3rd value of 2nd row\n *\n * @param initialM24 - defines 4th value of 2nd row\n *\n * @param initialM31 - defines 1st value of 3rd row\n *\n * @param initialM32 - defines 2nd value of 3rd row\n *\n * @param initialM33 - defines 3rd value of 3rd row\n *\n * @param initialM34 - defines 4th value of 3rd row\n *\n * @param initialM41 - defines 1st value of 4th row\n *\n * @param initialM42 - defines 2nd value of 4th row\n *\n * @param initialM43 - defines 3rd value of 4th row\n *\n * @param initialM44 - defines 4th value of 4th row\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromValuesToRef(initialM11: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM12: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM13: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM14: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM21: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM22: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM23: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM24: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM31: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM32: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM33: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM34: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM41: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM42: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM43: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", initialM44: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 35,
              endIndex: 36
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "initialM11",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "initialM12",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "initialM13",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "initialM14",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "initialM21",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "initialM22",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }, {
              parameterName: "initialM23",
              parameterTypeTokenRange: {
                startIndex: 13,
                endIndex: 14
              }
            }, {
              parameterName: "initialM24",
              parameterTypeTokenRange: {
                startIndex: 15,
                endIndex: 16
              }
            }, {
              parameterName: "initialM31",
              parameterTypeTokenRange: {
                startIndex: 17,
                endIndex: 18
              }
            }, {
              parameterName: "initialM32",
              parameterTypeTokenRange: {
                startIndex: 19,
                endIndex: 20
              }
            }, {
              parameterName: "initialM33",
              parameterTypeTokenRange: {
                startIndex: 21,
                endIndex: 22
              }
            }, {
              parameterName: "initialM34",
              parameterTypeTokenRange: {
                startIndex: 23,
                endIndex: 24
              }
            }, {
              parameterName: "initialM41",
              parameterTypeTokenRange: {
                startIndex: 25,
                endIndex: 26
              }
            }, {
              parameterName: "initialM42",
              parameterTypeTokenRange: {
                startIndex: 27,
                endIndex: 28
              }
            }, {
              parameterName: "initialM43",
              parameterTypeTokenRange: {
                startIndex: 29,
                endIndex: 30
              }
            }, {
              parameterName: "initialM44",
              parameterTypeTokenRange: {
                startIndex: 31,
                endIndex: 32
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 33,
                endIndex: 34
              }
            }],
            name: "FromValuesToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.FromXYZAxesToRef:member(1)",
            docComment: "/**\n * Sets the given matrix as a rotation matrix composed from the 3 left handed axes\n *\n * @param xaxis - defines the value of the 1st axis\n *\n * @param yaxis - defines the value of the 2nd axis\n *\n * @param zaxis - defines the value of the 3rd axis\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromXYZAxesToRef(xaxis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", yaxis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", zaxis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "xaxis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "yaxis",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "zaxis",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "FromXYZAxesToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.GetAsMatrix2x2:member(1)",
            docComment: "/**\n * Extracts a 2x2 matrix from a given matrix and store the result in a FloatArray\n *\n * @param matrix - defines the matrix to use\n *\n * @returns a new FloatArray array with 4 elements : the 2x2 matrix extracted from the given matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetAsMatrix2x2(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "GetAsMatrix2x2"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.GetAsMatrix3x3:member(1)",
            docComment: "/**\n * Extracts a 3x3 matrix from a given matrix and store the result in a FloatArray\n *\n * @param matrix - defines the matrix to use\n *\n * @returns a new FloatArray array with 9 elements : the 3x3 matrix extracted from the given matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetAsMatrix3x3(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "GetAsMatrix3x3"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getClassName:member(1)",
            docComment: '/**\n * Returns the name of the current matrix class\n *\n * @returns the string "Matrix"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getHashCode:member(1)",
            docComment: "/**\n * Gets the hash code of the current matrix\n *\n * @returns the hash code\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getRotationMatrix:member(1)",
            docComment: "/**\n * Gets only rotation part of the current matrix\n *\n * @returns a new matrix sets to the extracted rotation matrix from the current one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getRotationMatrix(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getRotationMatrix"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getRotationMatrixToRef:member(1)",
            docComment: '/**\n * Extracts the rotation matrix from the current one and sets it as the given "result"\n *\n * @param result - defines the target matrix to store data to\n *\n * @returns the current matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getRotationMatrixToRef(result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getRotationMatrixToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getRow:member(1)",
            docComment: "/**\n * Gets specific row of the matrix\n *\n * @param index - defines the number of the row to get\n *\n * @returns the index-th row of the current matrix as a new Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getRow(index: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Nullable",
              canonicalReference: "decentraland-ecs!Nullable:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getRow"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getTranslation:member(1)",
            docComment: "/**\n * Gets the translation value of the current matrix\n *\n * @returns a new Vector3 as the extracted translation from the matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getTranslation(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getTranslation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#getTranslationToRef:member(1)",
            docComment: "/**\n * Fill a Vector3 with the extracted translation from the matrix\n *\n * @param result - defines the Vector3 where to store the translation\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getTranslationToRef(result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getTranslationToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Identity:member(1)",
            docComment: "/**\n * Creates a new identity matrix\n *\n * @returns a new identity matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Identity(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Identity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.IdentityToRef:member(1)",
            docComment: "/**\n * Creates a new identity matrix and stores the result in a given matrix\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static IdentityToRef(result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "IdentityToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#invert:member(1)",
            docComment: "/**\n * Inverts the current matrix in place\n *\n * @returns the current inverted matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "invert(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "invert"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Invert:member(1)",
            docComment: "/**\n * Creates a new matrix as the invert of a given matrix\n *\n * @param source - defines the source matrix\n *\n * @returns the new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Invert(source: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Invert"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#invertToRef:member(1)",
            docComment: "/**\n * Sets the given matrix to the current inverted Matrix\n *\n * @param other - defines the target matrix\n *\n * @returns the unmodified current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "invertToRef(other: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "invertToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#isIdentity:member(1)",
            docComment: "/**\n * Check if the current matrix is identity\n *\n * @returns true is the matrix is the identity matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "isIdentity(): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "isIdentity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#isIdentityAs3x2:member(1)",
            docComment: "/**\n * Check if the current matrix is identity as a texture matrix (3x2 store in 4x4)\n *\n * @returns true is the matrix is the identity matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "isIdentityAs3x2(): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "isIdentityAs3x2"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Lerp:member(1)",
            docComment: '/**\n * Returns a new Matrix whose values are the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".\n *\n * @param startValue - defines the start value\n *\n * @param endValue - defines the end value\n *\n * @param gradient - defines the gradient factor\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(startValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", endValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", gradient: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "startValue",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "endValue",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gradient",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.LerpToRef:member(1)",
            docComment: '/**\n * Set the given matrix "result" as the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".\n *\n * @param startValue - defines the start value\n *\n * @param endValue - defines the end value\n *\n * @param gradient - defines the gradient factor\n *\n * @param result - defines the Matrix object where to store data\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LerpToRef(startValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", endValue: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", gradient: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "startValue",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "endValue",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gradient",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.LookAtLH:member(1)",
            docComment: '/**\n * Gets a new rotation matrix used to rotate an entity so as it looks at the target vector3, from the eye vector3 position, the up vector3 being oriented like "up" This function works in left handed mode\n *\n * @param eye - defines the final position of the entity\n *\n * @param target - defines where the entity should look at\n *\n * @param up - defines the up vector for the entity\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LookAtLH(eye: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eye",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "LookAtLH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.LookAtLHToRef:member(1)",
            docComment: '/**\n * Sets the given "result" Matrix to a rotation matrix used to rotate an entity so that it looks at the target vector3, from the eye vector3 position, the up vector3 being oriented like "up". This function works in left handed mode\n *\n * @param eye - defines the final position of the entity\n *\n * @param target - defines where the entity should look at\n *\n * @param up - defines the up vector for the entity\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LookAtLHToRef(eye: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eye",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LookAtLHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.LookAtRH:member(1)",
            docComment: '/**\n * Gets a new rotation matrix used to rotate an entity so as it looks at the target vector3, from the eye vector3 position, the up vector3 being oriented like "up" This function works in right handed mode\n *\n * @param eye - defines the final position of the entity\n *\n * @param target - defines where the entity should look at\n *\n * @param up - defines the up vector for the entity\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LookAtRH(eye: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eye",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "LookAtRH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.LookAtRHToRef:member(1)",
            docComment: '/**\n * Sets the given "result" Matrix to a rotation matrix used to rotate an entity so that it looks at the target vector3, from the eye vector3 position, the up vector3 being oriented like "up". This function works in right handed mode\n *\n * @param eye - defines the final position of the entity\n *\n * @param target - defines where the entity should look at\n *\n * @param up - defines the up vector for the entity\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LookAtRHToRef(eye: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eye",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LookAtRHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#multiply:member(1)",
            docComment: "/**\n * Multiply two matrices\n *\n * @param other - defines the second operand\n *\n * @returns a new matrix set with the multiplication result of the current Matrix and the given one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(other: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#multiplyAtIndex:member(1)",
            docComment: "/**\n * mutiply the specified position in the current Matrix by a value\n *\n * @param index - the index of the value within the matrix. between 0 and 15.\n *\n * @param value - the value to be added\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyAtIndex(index: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyAtIndex"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#multiplyToArray:member(1)",
            docComment: '/**\n * Sets the FloatArray "result" from the given index "offset" with the multiplication of the current matrix and the given one\n *\n * @param other - defines the second operand\n *\n * @param result - defines the array where to store the multiplication\n *\n * @param offset - defines the offset in the target array where to start storing values\n *\n * @returns the current matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToArray(other: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 10,
              endIndex: 11
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 8,
                endIndex: 9
              }
            }],
            name: "multiplyToArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#multiplyToRef:member(1)",
            docComment: '/**\n * Sets the given matrix "result" with the multiplication result of the current Matrix and the given one\n *\n * @param other - defines the second operand\n *\n * @param result - defines the matrix where to store the multiplication\n *\n * @returns the current matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(other: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoLH:member(1)",
            docComment: "/**\n * Create a left-handed orthographic projection matrix\n *\n * @param width - defines the viewport width\n *\n * @param height - defines the viewport height\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a left-handed orthographic projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoLH(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "OrthoLH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoLHToRef:member(1)",
            docComment: "/**\n * Store a left-handed orthographic projection to a given matrix\n *\n * @param width - defines the viewport width\n *\n * @param height - defines the viewport height\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoLHToRef(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "OrthoLHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoOffCenterLH:member(1)",
            docComment: "/**\n * Create a left-handed orthographic projection matrix\n *\n * @param left - defines the viewport left coordinate\n *\n * @param right - defines the viewport right coordinate\n *\n * @param bottom - defines the viewport bottom coordinate\n *\n * @param top - defines the viewport top coordinate\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a left-handed orthographic projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoOffCenterLH(left: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", bottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", top: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "bottom",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "top",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "OrthoOffCenterLH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoOffCenterLHToRef:member(1)",
            docComment: "/**\n * Stores a left-handed orthographic projection into a given matrix\n *\n * @param left - defines the viewport left coordinate\n *\n * @param right - defines the viewport right coordinate\n *\n * @param bottom - defines the viewport bottom coordinate\n *\n * @param top - defines the viewport top coordinate\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoOffCenterLHToRef(left: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", bottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", top: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 15,
              endIndex: 16
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "bottom",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "top",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 13,
                endIndex: 14
              }
            }],
            name: "OrthoOffCenterLHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoOffCenterRH:member(1)",
            docComment: "/**\n * Creates a right-handed orthographic projection matrix\n *\n * @param left - defines the viewport left coordinate\n *\n * @param right - defines the viewport right coordinate\n *\n * @param bottom - defines the viewport bottom coordinate\n *\n * @param top - defines the viewport top coordinate\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a right-handed orthographic projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoOffCenterRH(left: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", bottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", top: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "bottom",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "top",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "OrthoOffCenterRH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.OrthoOffCenterRHToRef:member(1)",
            docComment: "/**\n * Stores a right-handed orthographic projection into a given matrix\n *\n * @param left - defines the viewport left coordinate\n *\n * @param right - defines the viewport right coordinate\n *\n * @param bottom - defines the viewport bottom coordinate\n *\n * @param top - defines the viewport top coordinate\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static OrthoOffCenterRHToRef(left: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", bottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", top: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 15,
              endIndex: 16
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "bottom",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "top",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 13,
                endIndex: 14
              }
            }],
            name: "OrthoOffCenterRHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveFovLH:member(1)",
            docComment: "/**\n * Creates a left-handed perspective projection matrix\n *\n * @param fov - defines the horizontal field of view\n *\n * @param aspect - defines the aspect ratio\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a left-handed perspective projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveFovLH(fov: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", aspect: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fov",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "aspect",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "PerspectiveFovLH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveFovLHToRef:member(1)",
            docComment: "/**\n * Stores a left-handed perspective projection into a given matrix\n *\n * @param fov - defines the horizontal field of view\n *\n * @param aspect - defines the aspect ratio\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n *\n * @param isVerticalFovFixed - defines it the fov is vertically fixed (default) or horizontally\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveFovLHToRef(fov: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", aspect: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", isVerticalFovFixed?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fov",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "aspect",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "isVerticalFovFixed",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "PerspectiveFovLHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveFovRH:member(1)",
            docComment: "/**\n * Creates a right-handed perspective projection matrix\n *\n * @param fov - defines the horizontal field of view\n *\n * @param aspect - defines the aspect ratio\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a right-handed perspective projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveFovRH(fov: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", aspect: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fov",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "aspect",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "PerspectiveFovRH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveFovRHToRef:member(1)",
            docComment: "/**\n * Stores a right-handed perspective projection into a given matrix\n *\n * @param fov - defines the horizontal field of view\n *\n * @param aspect - defines the aspect ratio\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n *\n * @param isVerticalFovFixed - defines it the fov is vertically fixed (default) or horizontally\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveFovRHToRef(fov: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", aspect: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", isVerticalFovFixed?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fov",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "aspect",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "isVerticalFovFixed",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "PerspectiveFovRHToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveFovWebVRToRef:member(1)",
            docComment: "/**\n * Stores a perspective projection for WebVR info a given matrix\n *\n * @param fov - defines the field of view\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @param result - defines the target matrix\n *\n * @param rightHanded - defines if the matrix must be in right-handed mode (false by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveFovWebVRToRef(fov: "
            }, {
              kind: "Content",
              text: "{\n        upDegrees: number;\n        downDegrees: number;\n        leftDegrees: number;\n        rightDegrees: number;\n    }"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", rightHanded?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fov",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "rightHanded",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "PerspectiveFovWebVRToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.PerspectiveLH:member(1)",
            docComment: "/**\n * Creates a left-handed perspective projection matrix\n *\n * @param width - defines the viewport width\n *\n * @param height - defines the viewport height\n *\n * @param znear - defines the near clip plane\n *\n * @param zfar - defines the far clip plane\n *\n * @returns a new matrix as a left-handed perspective projection matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PerspectiveLH(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", znear: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", zfar: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "znear",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "zfar",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "PerspectiveLH"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Reflection:member(1)",
            docComment: "/**\n * Computes a reflection matrix from a plane\n *\n * @param plane - defines the reflection plane\n *\n * @returns a new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Reflection(plane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "plane",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Reflection"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.ReflectionToRef:member(1)",
            docComment: "/**\n * Computes a reflection matrix from a plane\n *\n * @param plane - defines the reflection plane\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static ReflectionToRef(plane: "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "plane",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "ReflectionToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#removeRotationAndScaling:member(1)",
            docComment: "/**\n * Remove rotation and scaling part from the matrix\n *\n * @returns the updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "removeRotationAndScaling(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "removeRotationAndScaling"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#reset:member(1)",
            docComment: "/**\n * Sets all the matrix elements to zero\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "reset(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "reset"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationAxis:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the given axis\n *\n * @param axis - defines the axis to use\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAxis(axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RotationAxis"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationAxisToRef:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the given axis and stores it in a given matrix\n *\n * @param axis - defines the axis to use\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAxisToRef(axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationAxisToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationX:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the X axis\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationX(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "RotationX"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationXToRef:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the X axis and stores it in a given matrix\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationXToRef(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RotationXToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationY:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the Y axis\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationY(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "RotationY"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationYawPitchRoll:member(1)",
            docComment: "/**\n * Creates a rotation matrix\n *\n * @param yaw - defines the yaw angle in radians (Y axis)\n *\n * @param pitch - defines the pitch angle in radians (X axis)\n *\n * @param roll - defines the roll angle in radians (X axis)\n *\n * @returns the new rotation matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationYawPitchRoll(yaw: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", pitch: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", roll: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "yaw",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "pitch",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "roll",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationYawPitchRoll"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationYawPitchRollToRef:member(1)",
            docComment: "/**\n * Creates a rotation matrix and stores it in a given matrix\n *\n * @param yaw - defines the yaw angle in radians (Y axis)\n *\n * @param pitch - defines the pitch angle in radians (X axis)\n *\n * @param roll - defines the roll angle in radians (X axis)\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationYawPitchRollToRef(yaw: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", pitch: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", roll: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "yaw",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "pitch",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "roll",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "RotationYawPitchRollToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationYToRef:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the Y axis and stores it in a given matrix\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationYToRef(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RotationYToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationZ:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the Z axis\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @returns the new matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationZ(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "RotationZ"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.RotationZToRef:member(1)",
            docComment: '/**\n * Creates a new rotation matrix for "angle" radians around the Z axis and stores it in a given matrix\n *\n * @param angle - defines the angle (in radians) to use\n *\n * @param result - defines the target matrix\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static RotationZToRef(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RotationZToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#scale:member(1)",
            docComment: "/**\n * Compute a new matrix set with the current matrix values multiplied by scale (float)\n *\n * @param scale - defines the scale factor\n *\n * @returns a new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current matrix values by a factor and add the result to a given matrix\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Matrix to store the result\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#scaleToRef:member(1)",
            docComment: "/**\n * Scale the current matrix values by a factor to a given result matrix\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the matrix to store the result\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Scaling:member(1)",
            docComment: "/**\n * Creates a scaling matrix\n *\n * @param x - defines the scale factor on X axis\n *\n * @param y - defines the scale factor on Y axis\n *\n * @param z - defines the scale factor on Z axis\n *\n * @returns the new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Scaling(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Scaling"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.ScalingToRef:member(1)",
            docComment: "/**\n * Creates a scaling matrix and stores it in a given matrix\n *\n * @param x - defines the scale factor on X axis\n *\n * @param y - defines the scale factor on Y axis\n *\n * @param z - defines the scale factor on Z axis\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static ScalingToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "ScalingToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#setRow:member(1)",
            docComment: "/**\n * Sets the index-th row of the current matrix to the vector4 values\n *\n * @param index - defines the number of the row to set\n *\n * @param row - defines the target vector4\n *\n * @returns the updated current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setRow(index: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", row: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "row",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "setRow"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#setRowFromFloats:member(1)",
            docComment: "/**\n * Sets the index-th row of the current matrix with the given 4 x float values\n *\n * @param index - defines the row index\n *\n * @param x - defines the x component to set\n *\n * @param y - defines the y component to set\n *\n * @param z - defines the z component to set\n *\n * @param w - defines the w component to set\n *\n * @returns the updated current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setRowFromFloats(index: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "setRowFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#setTranslation:member(1)",
            docComment: "/**\n * Inserts the translation vector in the current matrix\n *\n * @param vector3 - defines the translation to insert\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setTranslation(vector3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector3",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "setTranslation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#setTranslationFromFloats:member(1)",
            docComment: "/**\n * Inserts the translation vector (using 3 floats) in the current matrix\n *\n * @param x - defines the 1st component of the translation\n *\n * @param y - defines the 2nd component of the translation\n *\n * @param z - defines the 3rd component of the translation\n *\n * @returns the current updated matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setTranslationFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "setTranslationFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#toArray:member(1)",
            docComment: "/**\n * Returns the matrix as a FloatArray\n *\n * @returns the matrix underlying array\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(): "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#toggleModelMatrixHandInPlace:member(1)",
            docComment: "/**\n * Toggles model matrix from being right handed to left handed in place and vice versa\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toggleModelMatrixHandInPlace(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toggleModelMatrixHandInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#toggleProjectionMatrixHandInPlace:member(1)",
            docComment: "/**\n * Toggles projection matrix from being right handed to left handed in place and vice versa\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toggleProjectionMatrixHandInPlace(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toggleProjectionMatrixHandInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#toNormalMatrix:member(1)",
            docComment: "/**\n * Writes to the given matrix a normal matrix, computed from this one (using values from identity matrix for fourth row and column).\n *\n * @param ref - matrix to store the result\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toNormalMatrix(ref: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ref",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toNormalMatrix"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Translation:member(1)",
            docComment: "/**\n * Creates a translation matrix\n *\n * @param x - defines the translation on X axis\n *\n * @param y - defines the translation on Y axis\n *\n * @param z - defines the translationon Z axis\n *\n * @returns the new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Translation(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Translation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.TranslationToRef:member(1)",
            docComment: "/**\n * Creates a translation matrix and stores it in a given matrix\n *\n * @param x - defines the translation on X axis\n *\n * @param y - defines the translation on Y axis\n *\n * @param z - defines the translationon Z axis\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TranslationToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "TranslationToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#transpose:member(1)",
            docComment: "/**\n * Compute the transpose of the matrix\n *\n * @returns the new transposed matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "transpose(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "transpose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Transpose:member(1)",
            docComment: "/**\n * Compute the transpose of a given matrix\n *\n * @param matrix - defines the matrix to transpose\n *\n * @returns the new matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Transpose(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Transpose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix#transposeToRef:member(1)",
            docComment: "/**\n * Compute the transpose of the matrix and store it in a given matrix\n *\n * @param result - defines the target matrix\n *\n * @returns the current matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "transposeToRef(result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "transposeToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.TransposeToRef:member(1)",
            docComment: "/**\n * Compute the transpose of a matrix and store it in a target matrix\n *\n * @param matrix - defines the matrix to transpose\n *\n * @param result - defines the target matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TransposeToRef(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "TransposeToRef"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Matrix#updateFlag:member",
            docComment: "/**\n * Gets the update flag of the matrix which is an unique number for the matrix. It will be incremented every time the matrix data change. You can use it to speed the comparison between two versions of the same matrix.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "updateFlag: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "updateFlag",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Matrix.Zero:member(1)",
            docComment: "/**\n * Creates a new zero matrix\n *\n * @returns a new zero matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!MessageBus:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class MessageBus "
          }],
          releaseTag: "Public",
          name: "MessageBus",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!MessageBus:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `MessageBus` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor();"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: []
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!MessageBus#emit:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "emit(message: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", payload: "
            }, {
              kind: "Reference",
              text: "Record",
              canonicalReference: "!Record:type"
            }, {
              kind: "Content",
              text: "<any, any>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "message",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "payload",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 5
              }
            }],
            name: "emit"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!MessageBus#on:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "on(message: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", callback: "
            }, {
              kind: "Content",
              text: "(value: any, sender: string) => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['comms']>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "message",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "on"
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!MethodDescriptor:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type MethodDescriptor = "
          }, {
            kind: "Content",
            text: "{\n    name: string;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "MethodDescriptor",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!MinimapSceneInfo:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type MinimapSceneInfo = "
          }, {
            kind: "Content",
            text: "{\n    name: string;\n    owner: string;\n    description: string;\n    previewImageUrl: string | undefined;\n    type: number;\n    parcels: {\n        x: number;\n        y: number;\n    }[];\n    isPOI: boolean;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "MinimapSceneInfo",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ModuleDescriptor:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ModuleDescriptor = "
          }, {
            kind: "Content",
            text: "{\n    rpcHandle: string;\n    methods: "
          }, {
            kind: "Reference",
            text: "MethodDescriptor",
            canonicalReference: "decentraland-ecs!MethodDescriptor:type"
          }, {
            kind: "Content",
            text: "[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ModuleDescriptor",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 4
          }
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!movePlayerTo:function(1)",
          docComment: "/**\n * move player to a position inside the scene\n *\n * @param  - position PositionType\n *\n * @param  - cameraTarget PositionType\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function movePlayerTo(position: "
          }, {
            kind: "Reference",
            text: "PositionType",
            canonicalReference: "decentraland-ecs!~PositionType:type"
          }, {
            kind: "Content",
            text: ", cameraTarget?: "
          }, {
            kind: "Reference",
            text: "PositionType",
            canonicalReference: "decentraland-ecs!~PositionType:type"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 6
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "position",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            parameterName: "cameraTarget",
            parameterTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            }
          }],
          name: "movePlayerTo"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!MultiObserver:class",
          docComment: "/**\n * Represent a list of observers registered to multiple Observables object.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class MultiObserver<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "MultiObserver",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!MultiObserver#dispose:member(1)",
            docComment: "/**\n * Release associated resources\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "dispose(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "dispose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!MultiObserver.Watch:member(1)",
            docComment: "/**\n * Raise a callback when one of the observable will notify\n *\n * @param observables - defines a list of observables to watch\n *\n * @param callback - defines the callback to call on notification\n *\n * @param mask - defines the mask used to filter notifications\n *\n * @param scope - defines the current scope used to restore the JS context\n *\n * @returns the new MultiObserver\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Watch<T>(observables: "
            }, {
              kind: "Reference",
              text: "Observable",
              canonicalReference: "decentraland-ecs!Observable:class"
            }, {
              kind: "Content",
              text: "<T>[]"
            }, {
              kind: "Content",
              text: ", callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", scope?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "MultiObserver",
              canonicalReference: "decentraland-ecs!MultiObserver:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 12,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "observables",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 7
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 8,
                endIndex: 9
              }
            }, {
              parameterName: "scope",
              parameterTypeTokenRange: {
                startIndex: 10,
                endIndex: 11
              }
            }],
            typeParameters: [{
              typeParameterName: "T",
              constraintTokenRange: {
                startIndex: 0,
                endIndex: 0
              },
              defaultTypeTokenRange: {
                startIndex: 0,
                endIndex: 0
              }
            }],
            name: "Watch"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!newId:function(1)",
          docComment: "/**\n * Generates a new prefixed id\n *\n * @beta\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function newId(type: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 3,
            endIndex: 4
          },
          releaseTag: "Beta",
          overloadIndex: 1,
          parameters: [{
            parameterName: "type",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "newId"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!NFTShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class NFTShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "NFTShape",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!NFTShape:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `NFTShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!NFTShape:constructor(2)",
            docComment: "/**\n * Constructs a new instance of the `NFTShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", color: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "color",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!NFTShape:constructor(3)",
            docComment: "/**\n * Constructs a new instance of the `NFTShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", args: "
            }, {
              kind: "Reference",
              text: "NFTShapeConstructorArgs",
              canonicalReference: "decentraland-ecs!NFTShapeConstructorArgs:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 3,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "args",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!NFTShape#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!NFTShape#src:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "src",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!NFTShape#style:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly style: "
            }, {
              kind: "Reference",
              text: "PictureFrameStyle",
              canonicalReference: "decentraland-ecs!PictureFrameStyle:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "style",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!NFTShapeConstructorArgs:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type NFTShapeConstructorArgs = "
          }, {
            kind: "Content",
            text: "{\n    color?: "
          }, {
            kind: "Reference",
            text: "Color3",
            canonicalReference: "decentraland-ecs!Color3:class"
          }, {
            kind: "Content",
            text: ";\n    style?: "
          }, {
            kind: "Reference",
            text: "PictureFrameStyle",
            canonicalReference: "decentraland-ecs!PictureFrameStyle:enum"
          }, {
            kind: "Content",
            text: ";\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "NFTShapeConstructorArgs",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 6
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!Nullable:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type Nullable<T> = "
          }, {
            kind: "Content",
            text: "T | null"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "Nullable",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OBJShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OBJShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "OBJShape",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OBJShape:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OBJShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OBJShape#src:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "src",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Observable:class",
          docComment: "/**\n * The Observable class is a simple implementation of the Observable pattern.\n *\n * There's one slight particularity though: a given Observable can notify its observer using a particular mask value, only the Observers registered with this mask value will be notified. This enable a more fine grained execution without having to rely on multiple different Observable objects. For instance you may have a given Observable that have four different types of notifications: Move (mask = 0x01), Stop (mask = 0x02), Turn Right (mask = 0X04), Turn Left (mask = 0X08). A given observer can register itself with only Move and Stop (mask = 0x03), then it will only be notified when one of these two occurs and will never be for Turn Left/Right.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Observable<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "Observable",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Observable:constructor(1)",
            docComment: "/**\n * Creates a new observable\n *\n * @param onObserverAdded - defines a callback to call when a new observer is added\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(onObserverAdded?: "
            }, {
              kind: "Content",
              text: "(observer: "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<T>) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "onObserverAdded",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#add:member(1)",
            docComment: "/**\n * Create a new Observer with the specified callback\n *\n * @param callback - the callback that will be executed for that Observer\n *\n * @param mask - the mask used to filter observers\n *\n * @param insertFirst - if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.\n *\n * @param scope - optional scope for the callback to be called from\n *\n * @param unregisterOnFirstCall - defines if the observer as to be unregistered after the next notification\n *\n * @returns the new observer created for the callback\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", insertFirst?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", scope?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ", unregisterOnFirstCall?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "null | "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 16
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "insertFirst",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "scope",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "unregisterOnFirstCall",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#addOnce:member(1)",
            docComment: "/**\n * Create a new Observer with the specified callback and unregisters after the next notification\n *\n * @param callback - the callback that will be executed for that Observer\n *\n * @returns the new observer created for the callback\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addOnce(callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "null | "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }],
            name: "addOnce"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#clear:member(1)",
            docComment: "/**\n * Clear the list of observers\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clear(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clear"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#clone:member(1)",
            docComment: "/**\n * Clone the current observable\n *\n * @returns a new observable\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Observable",
              canonicalReference: "decentraland-ecs!Observable:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#hasObservers:member(1)",
            docComment: "/**\n * Gets a boolean indicating if the observable has at least one observer\n *\n * @returns true is the Observable has at least one Observer registered\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "hasObservers(): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "hasObservers"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#hasSpecificMask:member(1)",
            docComment: "/**\n * Does this observable handles observer registered with a given mask\n *\n * @param mask - defines the mask to be tested\n *\n * @returns whether or not one observer registered with the given mask is handeled\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "hasSpecificMask(mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "hasSpecificMask"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#notifyObserver:member(1)",
            docComment: "/**\n * Notify a specific observer\n *\n * @param observer - defines the observer to notify\n *\n * @param eventData - defines the data to be sent to each callback\n *\n * @param mask - is used to filter observers defaults to -1\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "notifyObserver(observer: "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ", eventData: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ", mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "observer",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "eventData",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "notifyObserver"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#notifyObservers:member(1)",
            docComment: "/**\n * Notify all Observers by calling their respective callback with the given data Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute\n *\n * @param eventData - defines the data to send to all observers\n *\n * @param mask - defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)\n *\n * @param target - defines the original target of the state\n *\n * @param currentTarget - defines the current target of the state\n *\n * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "notifyObservers(eventData: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ", mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", target?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ", currentTarget?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eventData",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "currentTarget",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "notifyObservers"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#notifyObserversWithPromise:member(1)",
            docComment: "/**\n * Calling this will execute each callback, expecting it to be a promise or return a value. If at any point in the chain one function fails, the promise will fail and the execution will not continue. This is useful when a chain of events (sometimes async events) is needed to initialize a certain object and it is crucial that all callbacks will be executed. The order of the callbacks is kept, callbacks are not executed parallel.\n *\n * @param eventData - The data to be sent to each callback\n *\n * @param mask - is used to filter observers defaults to -1\n *\n * @param target - defines the callback target (see EventState)\n *\n * @param currentTarget - defines he current object in the bubbling phase\n *\n * @returns will return a Promise than resolves when all callbacks executed successfully.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "notifyObserversWithPromise(eventData: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ", mask?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", target?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ", currentTarget?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Promise",
              canonicalReference: "!Promise:interface"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 11
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "eventData",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "currentTarget",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "notifyObserversWithPromise"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#remove:member(1)",
            docComment: "/**\n * Remove an Observer from the Observable object\n *\n * @param observer - the instance of the Observer to remove\n *\n * @returns false if it doesn't belong to this Observable\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "remove(observer: "
            }, {
              kind: "Content",
              text: "null | "
            }, {
              kind: "Reference",
              text: "Observer",
              canonicalReference: "decentraland-ecs!Observer:class"
            }, {
              kind: "Content",
              text: "<T>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "observer",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }],
            name: "remove"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Observable#removeCallback:member(1)",
            docComment: "/**\n * Remove a callback from the Observable object\n *\n * @param callback - the callback to remove\n *\n * @param scope - optional scope. If used only the callbacks with this scope will be removed\n *\n * @returns false if it doesn't belong to this Observable\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "removeCallback(callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", scope?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "scope",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "removeCallback"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ObservableComponent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ObservableComponent "
          }],
          releaseTag: "Public",
          name: "ObservableComponent",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent.component:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static component(target: "
            }, {
              kind: "Reference",
              text: "ObservableComponent",
              canonicalReference: "decentraland-ecs!ObservableComponent:class"
            }, {
              kind: "Content",
              text: ", propertyKey: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "propertyKey",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "component"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObservableComponent#data:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "data: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "data",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObservableComponent#dirty:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "dirty: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "dirty",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent.field:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static field(target: "
            }, {
              kind: "Reference",
              text: "ObservableComponent",
              canonicalReference: "decentraland-ecs!ObservableComponent:class"
            }, {
              kind: "Content",
              text: ", propertyKey: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "propertyKey",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "field"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent#onChange:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onChange(fn: "
            }, {
              kind: "Reference",
              text: "ObservableComponentSubscription",
              canonicalReference: "decentraland-ecs!ObservableComponentSubscription:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "fn",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "onChange"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent.readonly:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static readonly(target: "
            }, {
              kind: "Reference",
              text: "ObservableComponent",
              canonicalReference: "decentraland-ecs!ObservableComponent:class"
            }, {
              kind: "Content",
              text: ", propertyKey: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "propertyKey",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "readonly"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent#toJSON:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObservableComponent.uiValue:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static uiValue(target: "
            }, {
              kind: "Reference",
              text: "ObservableComponent",
              canonicalReference: "decentraland-ecs!ObservableComponent:class"
            }, {
              kind: "Content",
              text: ", propertyKey: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "propertyKey",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "uiValue"
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ObservableComponentSubscription:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ObservableComponentSubscription = "
          }, {
            kind: "Content",
            text: "(key: string, newVal: any, oldVal: any) => void"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ObservableComponentSubscription",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Observer:class",
          docComment: "/**\n * Represent an Observer registered to a given Observable object.\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Observer<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "Observer",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Observer#_willBeUnregistered:member",
            docComment: "/**\n * For internal usage\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "_willBeUnregistered: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "_willBeUnregistered",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Observer:constructor(1)",
            docComment: "/**\n * Creates a new observer\n *\n * @param callback - defines the callback to call when the observer is notified\n *\n * @param mask - defines the mask of the observer (used to filter notifications)\n *\n * @param scope - defines the current scope used to restore the JS context\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", \n    mask: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    scope?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "scope",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Observer#callback:member",
            docComment: "/**\n * Defines the callback to call when the observer is notified\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "callback: "
            }, {
              kind: "Content",
              text: "(eventData: T, eventState: "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "callback",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Observer#mask:member",
            docComment: "/**\n * Defines the mask of the observer (used to filter notifications)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "mask: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "mask",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Observer#scope:member",
            docComment: "/**\n * Defines the current scope used to restore the JS context\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scope: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "scope",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Observer#unregisterOnNextCall:member",
            docComment: "/**\n * Gets or sets a property defining that the observer as to be unregistered after the next notification\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "unregisterOnNextCall: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "unregisterOnNextCall",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ObserverEventState:class",
          docComment: "/**\n * A class serves as a medium between the observable and its observers\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ObserverEventState "
          }],
          releaseTag: "Public",
          name: "ObserverEventState",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!ObserverEventState:constructor(1)",
            docComment: "/**\n * Create a new EventState\n *\n * @param mask - defines the mask associated with this state\n *\n * @param skipNextObservers - defines a flag which will instruct the observable to skip following observers when set to true\n *\n * @param target - defines the original target of the state\n *\n * @param currentTarget - defines the current target of the state\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(mask: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", skipNextObservers?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", target?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ", currentTarget?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "skipNextObservers",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "currentTarget",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObserverEventState#currentTarget:member",
            docComment: "/**\n * The current object in the bubbling phase\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "currentTarget?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "currentTarget",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!ObserverEventState#initalize:member(1)",
            docComment: "/**\n * Initialize the current event state\n *\n * @param mask - defines the mask associated with this state\n *\n * @param skipNextObservers - defines a flag which will instruct the observable to skip following observers when set to true\n *\n * @param target - defines the original target of the state\n *\n * @param currentTarget - defines the current target of the state\n *\n * @returns the current event state\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "initalize(mask: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", skipNextObservers?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ", target?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ", currentTarget?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "ObserverEventState",
              canonicalReference: "decentraland-ecs!ObserverEventState:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "mask",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "skipNextObservers",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "currentTarget",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "initalize"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObserverEventState#lastReturnValue:member",
            docComment: "/**\n * This will be populated with the return value of the last function that was executed. If it is the first function in the callback chain it will be the event data.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "lastReturnValue?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "lastReturnValue",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObserverEventState#mask:member",
            docComment: "/**\n * Get the mask value that were used to trigger the event corresponding to this EventState object\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "mask: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "mask",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObserverEventState#skipNextObservers:member",
            docComment: "/**\n * An Observer can set this property to true to prevent subsequent observers of being notified\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "skipNextObservers: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "skipNextObservers",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ObserverEventState#target:member",
            docComment: "/**\n * The object that originally notified the event\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "target?: "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "target",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnAnimationEnd:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnAnimationEnd extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onAnimationEnd'> "
          }],
          releaseTag: "Public",
          name: "OnAnimationEnd",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnAnimationEnd#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnBlur:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnBlur extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onBlur'> "
          }],
          releaseTag: "Public",
          name: "OnBlur",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnBlur:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnBlur` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onBlur']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnBlur#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnChanged:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnChanged extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onChange'> "
          }],
          releaseTag: "Public",
          name: "OnChanged",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnChanged:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnChanged` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onChange']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnChanged#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnClick:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnClick extends "
          }, {
            kind: "Reference",
            text: "OnPointerUUIDEvent",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onClick'> "
          }],
          releaseTag: "Public",
          name: "OnClick",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnClick:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnClick` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onClick']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnClick:constructor(2)",
            docComment: "/**\n * Constructs a new instance of the `OnClick` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onClick']) => void"
            }, {
              kind: "Content",
              text: ", options: "
            }, {
              kind: "Reference",
              text: "OnPointerUUIDEventOptions",
              canonicalReference: "decentraland-ecs!OnPointerUUIDEventOptions:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "options",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnClick#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnEnter:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnEnter extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onEnter'> "
          }],
          releaseTag: "Public",
          name: "OnEnter",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnEnter:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnEnter` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onEnter']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnEnter#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnFocus:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnFocus extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onFocus'> "
          }],
          releaseTag: "Public",
          name: "OnFocus",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnFocus:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnFocus` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onFocus']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnFocus#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnGizmoEvent:class",
          docComment: "/**\n * This event is triggered after the user finalizes dragging a gizmo.\n *\n * @beta\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnGizmoEvent extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'gizmoEvent'> "
          }],
          releaseTag: "Beta",
          name: "OnGizmoEvent",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnGizmoEvent#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Beta",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnPointerDown:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnPointerDown extends "
          }, {
            kind: "Reference",
            text: "OnPointerUUIDEvent",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'pointerDown'> "
          }],
          releaseTag: "Public",
          name: "OnPointerDown",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnPointerDown:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnPointerDown` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['pointerDown']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnPointerDown:constructor(2)",
            docComment: "/**\n * Constructs a new instance of the `OnPointerDown` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['pointerDown']) => void"
            }, {
              kind: "Content",
              text: ", options: "
            }, {
              kind: "Reference",
              text: "OnPointerUUIDEventOptions",
              canonicalReference: "decentraland-ecs!OnPointerUUIDEventOptions:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "options",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerDown#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnPointerUp:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnPointerUp extends "
          }, {
            kind: "Reference",
            text: "OnPointerUUIDEvent",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'pointerUp'> "
          }],
          releaseTag: "Public",
          name: "OnPointerUp",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnPointerUp:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnPointerUp` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['pointerUp']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnPointerUp:constructor(2)",
            docComment: "/**\n * Constructs a new instance of the `OnPointerUp` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['pointerUp']) => void"
            }, {
              kind: "Content",
              text: ", options: "
            }, {
              kind: "Reference",
              text: "OnPointerUUIDEventOptions",
              canonicalReference: "decentraland-ecs!OnPointerUUIDEventOptions:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 2,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }, {
              parameterName: "options",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerUp#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnPointerUUIDEvent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnPointerUUIDEvent<T extends "
          }, {
            kind: "Content",
            text: "keyof "
          }, {
            kind: "Reference",
            text: "IEvents",
            canonicalReference: "decentraland-ecs!IEvents:interface"
          }, {
            kind: "Content",
            text: "> extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "OnPointerUUIDEvent",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent#button:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "button: "
            }, {
              kind: "Reference",
              text: "ActionButton",
              canonicalReference: "decentraland-ecs!ActionButton:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "button",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent#distance:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "distance: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "distance",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent#hoverText:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hoverText: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hoverText",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent#showFeedback:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "showFeedback: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "showFeedback",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!OnPointerUUIDEvent#toJSON:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "{\n        uuid: string;\n        type: string | undefined;\n        button: "
            }, {
              kind: "Reference",
              text: "ActionButton",
              canonicalReference: "decentraland-ecs!ActionButton:enum"
            }, {
              kind: "Content",
              text: ";\n        hoverText: string;\n        distance: number;\n        showFeedback: boolean;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }],
          extendsTokenRange: {
            startIndex: 4,
            endIndex: 6
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!OnPointerUUIDEventOptions:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type OnPointerUUIDEventOptions = "
          }, {
            kind: "Content",
            text: "{\n    button?: "
          }, {
            kind: "Reference",
            text: "ActionButton",
            canonicalReference: "decentraland-ecs!ActionButton:enum"
          }, {
            kind: "Content",
            text: ";\n    hoverText?: string;\n    showFeedback?: boolean;\n    distance?: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "OnPointerUUIDEventOptions",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 4
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnTextSubmit:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnTextSubmit extends "
          }, {
            kind: "Reference",
            text: "OnUUIDEvent",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
          }, {
            kind: "Content",
            text: "<'onTextSubmit'> "
          }],
          releaseTag: "Public",
          name: "OnTextSubmit",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnTextSubmit:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnTextSubmit` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "['onTextSubmit']) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnTextSubmit#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!OnUUIDEvent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class OnUUIDEvent<T extends "
          }, {
            kind: "Content",
            text: "keyof "
          }, {
            kind: "Reference",
            text: "IEvents",
            canonicalReference: "decentraland-ecs!IEvents:interface"
          }, {
            kind: "Content",
            text: "> extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "OnUUIDEvent",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!OnUUIDEvent:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `OnUUIDEvent` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "IEvents",
              canonicalReference: "decentraland-ecs!IEvents:interface"
            }, {
              kind: "Content",
              text: "[T]) => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnUUIDEvent#callback:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "callback: "
            }, {
              kind: "Content",
              text: "(event: any) => void"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "callback",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!OnUUIDEvent#toJSON:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "{\n        uuid: string;\n        type: string | undefined;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnUUIDEvent#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly type: "
            }, {
              kind: "Content",
              text: "string | undefined"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!OnUUIDEvent#uuid:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly uuid: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uuid",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!OnUUIDEvent.uuidEvent:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static uuidEvent(target: "
            }, {
              kind: "Reference",
              text: "ObservableComponent",
              canonicalReference: "decentraland-ecs!ObservableComponent:class"
            }, {
              kind: "Content",
              text: ", propertyKey: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "propertyKey",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "uuidEvent"
          }],
          extendsTokenRange: {
            startIndex: 4,
            endIndex: 6
          },
          implementsTokenRanges: []
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!openExternalURL:function(1)",
          docComment: "",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function openExternalURL(url: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 3,
            endIndex: 4
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "url",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "openExternalURL"
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!openNFTDialog:function(1)",
          docComment: "/**\n * Popup NFT info dialog\n *\n * @param  - scr 'ethereum://contractAddress/tokenID'\n *\n * @param  - comment optional. add a comment.\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare function openNFTDialog(scr: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ", comment?: "
          }, {
            kind: "Content",
            text: "string | null"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 5,
            endIndex: 6
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "scr",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            parameterName: "comment",
            parameterTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            }
          }],
          name: "openNFTDialog"
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!Orientation:enum",
          docComment: "/**\n * Defines potential orientation for back face culling\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum Orientation "
          }],
          releaseTag: "Public",
          name: "Orientation",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Orientation.CCW:member",
            docComment: "/**\n * Counter clockwise\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "CCW = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "CCW",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Orientation.CW:member",
            docComment: "/**\n * Clockwise\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "CW = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "CW",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!ParentChanged:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class ParentChanged "
          }],
          releaseTag: "Public",
          name: "ParentChanged",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!ParentChanged:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `ParentChanged` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ", parent: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "parent",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 5
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ParentChanged#entity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!ParentChanged#parent:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "parent: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "parent",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Path2:class",
          docComment: "/**\n * Represents a 2D path made up of multiple 2D points\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Path2 "
          }],
          releaseTag: "Public",
          name: "Path2",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Path2:constructor(1)",
            docComment: "/**\n * Creates a Path2 object from the starting 2D coordinates x and y.\n *\n * @param x - the starting points x value\n *\n * @param y - the starting points y value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#addArcTo:member(1)",
            docComment: "/**\n * Adds _numberOfSegments_ segments according to the arc definition (middle point coordinates, end point coordinates, the arc start point being the current Path2 last point) to the current Path2.\n *\n * @param midX - middle point x value\n *\n * @param midY - middle point y value\n *\n * @param endX - end point x value\n *\n * @param endY - end point y value\n *\n * @param numberOfSegments - (default: 36)\n *\n * @returns the updated Path2.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addArcTo(midX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", midY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", endX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", endY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", numberOfSegments?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Path2",
              canonicalReference: "decentraland-ecs!Path2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "midX",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "midY",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "endX",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "endY",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "numberOfSegments",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "addArcTo"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#addLineTo:member(1)",
            docComment: "/**\n * Adds a new segment until the given coordinates (x, y) to the current Path2.\n *\n * @param x - the added points x value\n *\n * @param y - the added points y value\n *\n * @returns the updated Path2.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addLineTo(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Path2",
              canonicalReference: "decentraland-ecs!Path2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addLineTo"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#close:member(1)",
            docComment: "/**\n * Closes the Path2.\n *\n * @returns the Path2.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "close(): "
            }, {
              kind: "Reference",
              text: "Path2",
              canonicalReference: "decentraland-ecs!Path2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "close"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Path2#closed:member",
            docComment: "/**\n * If the path start and end point are the same\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "closed: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "closed",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#getPointAtLengthPosition:member(1)",
            docComment: "/**\n * Retreives the point at the distance aways from the starting point\n *\n * @param normalizedLengthPosition - the length along the path to retreive the point from\n *\n * @returns a new Vector2 located at a percentage of the Path2 total length on this path.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getPointAtLengthPosition(normalizedLengthPosition: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "normalizedLengthPosition",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getPointAtLengthPosition"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#getPoints:member(1)",
            docComment: "/**\n * Gets the points which construct the path\n *\n * @returns the Path2 internal array of points.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getPoints(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getPoints"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2#length:member(1)",
            docComment: "/**\n * Gets the sum of the distance between each sequential point in the path\n *\n * @returns the Path2 total length (float).\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "length(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "length"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path2.StartingAt:member(1)",
            docComment: "/**\n * Creates a new path starting from an x and y position\n *\n * @param x - starting x value\n *\n * @param y - starting y value\n *\n * @returns a new Path2 starting at the coordinates (x, y).\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static StartingAt(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Path2",
              canonicalReference: "decentraland-ecs!Path2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "StartingAt"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Path3D:class",
          docComment: "/**\n * Represents a 3D path made up of multiple 3D points\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Path3D "
          }],
          releaseTag: "Public",
          name: "Path3D",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Path3D:constructor(1)",
            docComment: "/**\n * new Path3D(path, normal, raw) Creates a Path3D. A Path3D is a logical math object, so not a mesh. please read the description in the tutorial : http://doc.babylonjs.com/tutorials/How_to_use_Path3D\n *\n * @param path - an array of Vector3, the curve axis of the Path3D\n *\n * @param normal - (options) Vector3, the first wanted normal to the curve. Ex (0, 1, 0) for a vertical normal.\n *\n * @param raw - (optional, default false) : boolean, if true the returned Path3D isn't normalized. Useful to depict path acceleration or speed.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    path: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ", firstNormal?: "
            }, {
              kind: "Reference",
              text: "Nullable",
              canonicalReference: "decentraland-ecs!Nullable:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", raw?: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "path",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "firstNormal",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 8
              }
            }, {
              parameterName: "raw",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#getBinormals:member(1)",
            docComment: "/**\n * Returns an array populated with binormal vectors on each Path3D curve point.\n *\n * @returns an array populated with binormal vectors on each Path3D curve point.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getBinormals(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getBinormals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#getCurve:member(1)",
            docComment: "/**\n * Returns the Path3D array of successive Vector3 designing its curve.\n *\n * @returns the Path3D array of successive Vector3 designing its curve.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getCurve(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getCurve"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#getDistances:member(1)",
            docComment: "/**\n * Returns an array populated with distances (float) of the i-th point from the first curve point.\n *\n * @returns an array populated with distances (float) of the i-th point from the first curve point.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getDistances(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getDistances"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#getNormals:member(1)",
            docComment: "/**\n * Returns an array populated with normal vectors on each Path3D curve point.\n *\n * @returns an array populated with normal vectors on each Path3D curve point.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getNormals(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getNormals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#getTangents:member(1)",
            docComment: "/**\n * Returns an array populated with tangent vectors on each Path3D curve point.\n *\n * @returns an array populated with tangent vectors on each Path3D curve point.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getTangents(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getTangents"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Path3D#path:member",
            docComment: "/**\n * an array of Vector3, the curve axis of the Path3D\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "path: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "path",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Path3D#update:member(1)",
            docComment: "/**\n * Forces the Path3D tangent, normal, binormal and distance recomputation.\n *\n * @param path - path which all values are copied into the curves points\n *\n * @param firstNormal - which should be projected onto the curve\n *\n * @returns the same object updated.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "update(path: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ", firstNormal?: "
            }, {
              kind: "Reference",
              text: "Nullable",
              canonicalReference: "decentraland-ecs!Nullable:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Path3D",
              canonicalReference: "decentraland-ecs!Path3D:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "path",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "firstNormal",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 8
              }
            }],
            name: "update"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!PhysicsCast:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class PhysicsCast implements "
          }, {
            kind: "Reference",
            text: "IPhysicsCast",
            canonicalReference: "decentraland-ecs!IPhysicsCast:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "PhysicsCast",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast.ensureInstance:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "static ensureInstance(): "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "ensureInstance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#getRayFromCamera:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getRayFromCamera(distance: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "distance",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "getRayFromCamera"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#getRayFromPositions:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "getRayFromPositions(from: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", to: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "from",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "to",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "getRayFromPositions"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#handleRaycastHitAllResponse:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "handleRaycastHitAllResponse(response: "
            }, {
              kind: "Reference",
              text: "RaycastResponse",
              canonicalReference: "decentraland-ecs!RaycastResponse:class"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "RaycastHitEntities",
              canonicalReference: "decentraland-ecs!RaycastHitEntities:interface"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "response",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "handleRaycastHitAllResponse"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#handleRaycastHitFirstResponse:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "handleRaycastHitFirstResponse(response: "
            }, {
              kind: "Reference",
              text: "RaycastResponse",
              canonicalReference: "decentraland-ecs!RaycastResponse:class"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "RaycastHitEntity",
              canonicalReference: "decentraland-ecs!RaycastHitEntity:interface"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "response",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 5
              }
            }],
            name: "handleRaycastHitFirstResponse"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#hitAll:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitAll(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitEntities",
              canonicalReference: "decentraland-ecs!RaycastHitEntities:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", id?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }, {
              parameterName: "id",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "hitAll"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#hitAllAvatars:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitAllAvatars(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitAvatars",
              canonicalReference: "decentraland-ecs!RaycastHitAvatars:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }],
            name: "hitAllAvatars"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#hitFirst:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitFirst(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitEntity",
              canonicalReference: "decentraland-ecs!RaycastHitEntity:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ", id?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }, {
              parameterName: "id",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "hitFirst"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PhysicsCast#hitFirstAvatar:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitFirstAvatar(ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ", hitCallback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "RaycastHitAvatar",
              canonicalReference: "decentraland-ecs!RaycastHitAvatar:interface"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ray",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "hitCallback",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 6
              }
            }],
            name: "hitFirstAvatar"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!PictureFrameStyle:enum",
          docComment: "",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum PictureFrameStyle "
          }],
          releaseTag: "Public",
          name: "PictureFrameStyle",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Baroque_Ornament:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Baroque_Ornament = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "Baroque_Ornament",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Blocky:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Blocky = "
            }, {
              kind: "Content",
              text: "5"
            }],
            releaseTag: "Public",
            name: "Blocky",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Canvas:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Canvas = "
            }, {
              kind: "Content",
              text: "21"
            }],
            releaseTag: "Public",
            name: "Canvas",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Classic:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Classic = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "Classic",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Diamond_Ornament:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Diamond_Ornament = "
            }, {
              kind: "Content",
              text: "2"
            }],
            releaseTag: "Public",
            name: "Diamond_Ornament",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Gold_Carved:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Gold_Carved = "
            }, {
              kind: "Content",
              text: "7"
            }],
            releaseTag: "Public",
            name: "Gold_Carved",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Gold_Edges:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Gold_Edges = "
            }, {
              kind: "Content",
              text: "6"
            }],
            releaseTag: "Public",
            name: "Gold_Edges",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Gold_Rounded:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Gold_Rounded = "
            }, {
              kind: "Content",
              text: "9"
            }],
            releaseTag: "Public",
            name: "Gold_Rounded",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Gold_Wide:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Gold_Wide = "
            }, {
              kind: "Content",
              text: "8"
            }],
            releaseTag: "Public",
            name: "Gold_Wide",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Metal_Medium:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Metal_Medium = "
            }, {
              kind: "Content",
              text: "10"
            }],
            releaseTag: "Public",
            name: "Metal_Medium",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Metal_Rounded:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Metal_Rounded = "
            }, {
              kind: "Content",
              text: "13"
            }],
            releaseTag: "Public",
            name: "Metal_Rounded",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Metal_Slim:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Metal_Slim = "
            }, {
              kind: "Content",
              text: "12"
            }],
            releaseTag: "Public",
            name: "Metal_Slim",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Metal_Wide:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Metal_Wide = "
            }, {
              kind: "Content",
              text: "11"
            }],
            releaseTag: "Public",
            name: "Metal_Wide",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Minimal_Black:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Minimal_Black = "
            }, {
              kind: "Content",
              text: "15"
            }],
            releaseTag: "Public",
            name: "Minimal_Black",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Minimal_Grey:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Minimal_Grey = "
            }, {
              kind: "Content",
              text: "4"
            }],
            releaseTag: "Public",
            name: "Minimal_Grey",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Minimal_White:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Minimal_White = "
            }, {
              kind: "Content",
              text: "16"
            }],
            releaseTag: "Public",
            name: "Minimal_White",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Minimal_Wide:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Minimal_Wide = "
            }, {
              kind: "Content",
              text: "3"
            }],
            releaseTag: "Public",
            name: "Minimal_Wide",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Pins:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Pins = "
            }, {
              kind: "Content",
              text: "14"
            }],
            releaseTag: "Public",
            name: "Pins",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Tape:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Tape = "
            }, {
              kind: "Content",
              text: "17"
            }],
            releaseTag: "Public",
            name: "Tape",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Wood_Slim:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Wood_Slim = "
            }, {
              kind: "Content",
              text: "18"
            }],
            releaseTag: "Public",
            name: "Wood_Slim",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Wood_Twigs:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Wood_Twigs = "
            }, {
              kind: "Content",
              text: "20"
            }],
            releaseTag: "Public",
            name: "Wood_Twigs",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!PictureFrameStyle.Wood_Wide:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "Wood_Wide = "
            }, {
              kind: "Content",
              text: "19"
            }],
            releaseTag: "Public",
            name: "Wood_Wide",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Plane:class",
          docComment: "/**\n * Represens a plane by the equation ax + by + cz + d = 0\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Plane "
          }],
          releaseTag: "Public",
          name: "Plane",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Plane:constructor(1)",
            docComment: "/**\n * Creates a Plane object according to the given floats a, b, c, d and the plane equation : ax + by + cz + d = 0\n *\n * @param a - a component of the plane\n *\n * @param b - b component of the plane\n *\n * @param c - c component of the plane\n *\n * @param d - d component of the plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", c: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", d: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "c",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "d",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#asArray:member(1)",
            docComment: "/**\n * @returns the plane coordinates as a new array of 4 elements [a, b, c, d].\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#clone:member(1)",
            docComment: "/**\n * @returns a new plane copied from the current Plane.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#copyFromPoints:member(1)",
            docComment: "/**\n * Updates the current Plane from the plane defined by the three given points.\n *\n * @param point1 - one of the points used to contruct the plane\n *\n * @param point2 - one of the points used to contruct the plane\n *\n * @param point3 - one of the points used to contruct the plane\n *\n * @returns the updated Plane.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromPoints(point1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", point2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", point3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "point1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "point2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "point3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "copyFromPoints"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Plane#d:member",
            docComment: "/**\n * d component of the plane\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "d: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "d",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#dotCoordinate:member(1)",
            docComment: "/**\n * Calcualtte the dot product between the point and the plane normal\n *\n * @param point - point to calculate the dot product with\n *\n * @returns the dot product (float) of the point coordinates and the plane normal.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "dotCoordinate(point: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "point",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "dotCoordinate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane.FromArray:member(1)",
            docComment: "/**\n * Creates a plane from an array\n *\n * @param array - the array to create a plane from\n *\n * @returns a new Plane from the given array.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 4,
              endIndex: 5
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane.FromPoints:member(1)",
            docComment: "/**\n * Creates a plane from three points\n *\n * @param point1 - point used to create the plane\n *\n * @param point2 - point used to create the plane\n *\n * @param point3 - point used to create the plane\n *\n * @returns a new Plane defined by the three given points.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromPoints(point1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", point2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", point3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "point1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "point2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "point3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "FromPoints"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane.FromPositionAndNormal:member(1)",
            docComment: '/**\n * Creates a plane from an origin point and a normal\n *\n * @param origin - origin of the plane to be constructed\n *\n * @param normal - normal of the plane to be constructed\n *\n * @returns a new Plane the normal vector to this plane at the given origin point. Note : the vector "normal" is updated because normalized.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromPositionAndNormal(origin: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", normal: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "origin",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "normal",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromPositionAndNormal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#getClassName:member(1)",
            docComment: '/**\n * @returns the string "Plane".\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#getHashCode:member(1)",
            docComment: "/**\n * @returns the Plane hash code.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#isFrontFacingTo:member(1)",
            docComment: '/**\n * Checks if the plane is facing a given direction\n *\n * @param direction - the direction to check if the plane is facing\n *\n * @param epsilon - value the dot product is compared against (returns true if dot &lt;= epsilon)\n *\n * @returns True is the vector "direction" is the same side than the plane normal.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "isFrontFacingTo(direction: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", epsilon: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "direction",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "epsilon",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "isFrontFacingTo"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Plane#normal:member",
            docComment: "/**\n * Normal of the plane (a,b,c)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normal: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "normal",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#normalize:member(1)",
            docComment: "/**\n * Normalize the current Plane in place.\n *\n * @returns the updated Plane.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalize(): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#signedDistanceTo:member(1)",
            docComment: "/**\n * Calculates the distance to a point\n *\n * @param point - point to calculate distance to\n *\n * @returns the signed distance (float) from the given point to the Plane.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "signedDistanceTo(point: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "point",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "signedDistanceTo"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane.SignedDistanceToPlaneFromPositionAndNormal:member(1)",
            docComment: '/**\n * Calculates the distance from a plane and a point\n *\n * @param origin - origin of the plane to be constructed\n *\n * @param normal - normal of the plane to be constructed\n *\n * @param point - point to calculate distance to\n *\n * @returns the signed distance between the plane defined by the normal vector at the "origin"" point and the given other point.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static SignedDistanceToPlaneFromPositionAndNormal(origin: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", normal: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", point: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "origin",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "normal",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "point",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "SignedDistanceToPlaneFromPositionAndNormal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Plane#transform:member(1)",
            docComment: "/**\n * Applies a transformation the plane and returns the result\n *\n * @param transformation - the transformation matrix to be applied to the plane\n *\n * @returns a new Plane as the result of the transformation of the current Plane by the given matrix.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "transform(transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Plane",
              canonicalReference: "decentraland-ecs!Plane:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "transform"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!PlaneShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class PlaneShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "PlaneShape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!PlaneShape#height:member",
            docComment: "/**\n * Sets the vertical length of the plane. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "height",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!PlaneShape#uvs:member",
            docComment: "/**\n * Sets the UV coordinates for the plane. Used to map specific pieces of a Material's texture into the plane's geometry.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "uvs?: "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uvs",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!PlaneShape#width:member",
            docComment: "/**\n * Sets the horizontal length of the plane. Defaults to 1.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "width",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!PointerEvent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class PointerEvent<GlobalInputEventResult> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "GlobalInputEventResult",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "PointerEvent",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!PointerEvent:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `PointerEvent` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(payload: "
            }, {
              kind: "Content",
              text: "GlobalInputEventResult"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "payload",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!PointerEvent#payload:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly payload: "
            }, {
              kind: "Content",
              text: "GlobalInputEventResult"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "payload",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!PointerEventComponent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class PointerEventComponent "
          }],
          releaseTag: "Public",
          name: "PointerEventComponent",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!PointerEventComponent:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `PointerEventComponent` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "LocalActionButtonEvent",
              canonicalReference: "decentraland-ecs!LocalActionButtonEvent:type"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "callback",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!PointerEventComponent#callback:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly callback: "
            }, {
              kind: "Content",
              text: "(event: "
            }, {
              kind: "Reference",
              text: "LocalActionButtonEvent",
              canonicalReference: "decentraland-ecs!LocalActionButtonEvent:type"
            }, {
              kind: "Content",
              text: ") => void"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "callback",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!PointerEventSystem:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class PointerEventSystem implements "
          }, {
            kind: "Reference",
            text: "ISystem",
            canonicalReference: "decentraland-ecs!ISystem:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "PointerEventSystem",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!PointerEventSystem#activate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "activate(engine: "
            }, {
              kind: "Reference",
              text: "Engine",
              canonicalReference: "decentraland-ecs!Engine:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "engine",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "activate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!PointerEventSystem#deactivate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "deactivate(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "deactivate"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ProfileForRenderer:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ProfileForRenderer = "
          }, {
            kind: "Content",
            text: "{\n    userId: string;\n    name: string;\n    description: string;\n    email: string;\n    avatar: "
          }, {
            kind: "Reference",
            text: "AvatarForRenderer",
            canonicalReference: "decentraland-ecs!AvatarForRenderer:type"
          }, {
            kind: "Content",
            text: ";\n    inventory: "
          }, {
            kind: "Reference",
            text: "WearableId",
            canonicalReference: "decentraland-ecs!WearableId:type"
          }, {
            kind: "Content",
            text: "[];\n    snapshots: {\n        face: string;\n        body: string;\n    };\n    version: number;\n    hasConnectedWeb3: boolean;\n    updatedAt?: number;\n    createdAt?: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ProfileForRenderer",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 6
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Quaternion:class",
          docComment: "/**\n * Class used to store quaternion data {@link https://en.wikipedia.org/wiki/Quaternion} {@link http://doc.babylonjs.com/features/position,_rotation,_scaling}\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Quaternion "
          }],
          releaseTag: "Public",
          name: "Quaternion",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Quaternion:constructor(1)",
            docComment: "/**\n * Creates a new Quaternion from the given floats\n *\n * @param x - defines the first component (0 by default)\n *\n * @param y - defines the second component (0 by default)\n *\n * @param z - defines the third component (0 by default)\n *\n * @param w - defines the fourth component (1.0 by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    x?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    y?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    z?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    w?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Angle:member(1)",
            docComment: "/**\n * Returns the angle in degrees between two rotations a and b.\n *\n * @param quat1 - defines the first quaternion\n *\n * @param quat2 - defines the second quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Angle(quat1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", quat2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "quat1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "quat2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Angle"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#angleAxis:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "angleAxis(degress: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "degress",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "angleAxis"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.AreClose:member(1)",
            docComment: "/**\n * Checks if the two quaternions are close to each other\n *\n * @param quat0 - defines the first quaternion to check\n *\n * @param quat1 - defines the second quaternion to check\n *\n * @returns true if the two quaternions are close to each other\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static AreClose(quat0: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", quat1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "quat0",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "quat1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "AreClose"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#asArray:member(1)",
            docComment: "/**\n * Copy the quaternion to an array\n *\n * @returns a new array populated with 4 elements from the quaternion coordinates\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#clone:member(1)",
            docComment: "/**\n * Clone the current quaternion\n *\n * @returns a new quaternion copied from the current one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#conjugate:member(1)",
            docComment: "/**\n * Conjugates in place (1-q) the current quaternion\n *\n * @returns a new quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "conjugate(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "conjugate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#conjugateInPlace:member(1)",
            docComment: "/**\n * Conjugates in place (1-q) the current quaternion\n *\n * @returns the current updated quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "conjugateInPlace(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "conjugateInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#conjugateToRef:member(1)",
            docComment: "/**\n * Conjugates (1-q) the current quaternion and stores the result in the given quaternion\n *\n * @param ref - defines the target quaternion\n *\n * @returns the current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "conjugateToRef(ref: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "ref",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "conjugateToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#copyFrom:member(1)",
            docComment: "/**\n * Copy a quaternion to the current one\n *\n * @param other - defines the other quaternion\n *\n * @returns the updated current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(other: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#copyFromFloats:member(1)",
            docComment: "/**\n * Updates the current quaternion with the given float coordinates\n *\n * @param x - defines the x coordinate\n *\n * @param y - defines the y coordinate\n *\n * @param z - defines the z coordinate\n *\n * @param w - defines the w coordinate\n *\n * @returns the updated current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Dot:member(1)",
            docComment: '/**\n * Returns the dot product (float) between the quaternions "left" and "right"\n *\n * @param left - defines the left operand\n *\n * @param right - defines the right operand\n *\n * @returns the dot product\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Dot(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Dot"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#equals:member(1)",
            docComment: "/**\n * Check if two quaternions are equals\n *\n * @param otherQuaternion - defines the second operand\n *\n * @returns true if the current quaternion and the given one coordinates are strictly equals\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(otherQuaternion: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherQuaternion",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Euler:member(1)",
            docComment: "/**\n * Returns a rotation that rotates z degrees around the z axis, x degrees around the x axis, and y degrees around the y axis.\n *\n * @param x - the rotation on the x axis in euler degrees\n *\n * @param y - the rotation on the y axis in euler degrees\n *\n * @param z - the rotation on the z axis in euler degrees\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Euler(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Euler"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.FromArray:member(1)",
            docComment: "/**\n * Creates a new quaternion from data stored into an array\n *\n * @param array - defines the data source\n *\n * @param offset - defines the offset in the source array where the data starts\n *\n * @returns a new quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.FromEulerAnglesRef:member(1)",
            docComment: "/**\n * Creates a new quaternion from a set of euler angles and stores it in the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromEulerAnglesRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "FromEulerAnglesRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#fromRotationMatrix:member(1)",
            docComment: "/**\n * Updates the current quaternion from the given rotation matrix values\n *\n * @param matrix - defines the source matrix\n *\n * @returns the current updated quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "fromRotationMatrix(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "fromRotationMatrix"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.FromRotationMatrix:member(1)",
            docComment: "/**\n * Creates a new quaternion from a rotation matrix\n *\n * @param matrix - defines the source matrix\n *\n * @returns a new quaternion created from the given rotation matrix values\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromRotationMatrix(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "FromRotationMatrix"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.FromRotationMatrixToRef:member(1)",
            docComment: "/**\n * Updates the given quaternion with the given rotation matrix values\n *\n * @param matrix - defines the source matrix\n *\n * @param result - defines the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromRotationMatrixToRef(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromRotationMatrixToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.FromToRotation:member(1)",
            docComment: "/**\n * Creates a rotation which rotates from fromDirection to toDirection.\n *\n * @param from - defines the first Vector\n *\n * @param to - defines the second Vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromToRotation(from: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", to: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "from",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "to",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromToRotation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#getClassName:member(1)",
            docComment: '/**\n * Gets the class name of the quaternion\n *\n * @returns the string "Quaternion"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#getHashCode:member(1)",
            docComment: "/**\n * Gets a hash code for this quaternion\n *\n * @returns the quaternion hash code\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Hermite:member(1)",
            docComment: "/**\n * Interpolate between two quaternions using Hermite interpolation\n *\n * @param value1 - defines first quaternion\n *\n * @param tangent1 - defines the incoming tangent\n *\n * @param value2 - defines second quaternion\n *\n * @param tangent2 - defines the outgoing tangent\n *\n * @param amount - defines the target quaternion\n *\n * @returns the new interpolated quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Hermite(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", tangent1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", tangent2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "tangent1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "tangent2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "Hermite"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Inverse:member(1)",
            docComment: "/**\n * Inverse a given quaternion\n *\n * @param q - defines the source quaternion\n *\n * @returns a new quaternion as the inverted current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Inverse(q: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Inverse"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.IsIdentity:member(1)",
            docComment: "/**\n * Gets a boolean indicating if the given quaternion is identity\n *\n * @param quaternion - defines the quaternion to check\n *\n * @returns true if the quaternion is identity\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static IsIdentity(quaternion: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "quaternion",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "IsIdentity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.LookRotation:member(1)",
            docComment: "/**\n * Creates a rotation with the specified forward and upwards directions.\n *\n * @param forward - the direction to look in\n *\n * @param up - the vector that defines in which direction up is\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static LookRotation(forward: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up?: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "forward",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "LookRotation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#multiply:member(1)",
            docComment: '/**\n * Multiplies two quaternions\n *\n * @param q1 - defines the second operand\n *\n * @returns a new quaternion set as the multiplication result of the current one with the given one "q1"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiply(q1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#multiplyInPlace:member(1)",
            docComment: '/**\n * Updates the current quaternion with the multiplication of itself with the given one "q1"\n *\n * @param q1 - defines the second operand\n *\n * @returns the currentupdated quaternion\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyInPlace(q1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiplyInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#multiplyToRef:member(1)",
            docComment: '/**\n * Sets the given "result" as the the multiplication result of the current one with the given one "q1"\n *\n * @param q1 - defines the second operand\n *\n * @param result - defines the target quaternion\n *\n * @returns the current quaternion\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(q1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#normalize:member(1)",
            docComment: "/**\n * Normalize in place the current quaternion\n *\n * @returns the current updated quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalize(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotateTowards:member(1)",
            docComment: "/**\n * The from quaternion is rotated towards to by an angular step of maxDegreesDelta.\n *\n * @param from - defines the first quaternion\n *\n * @param to - defines the second quaternion\n *\n * @param maxDegreesDelta - the interval step\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotateTowards(from: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", to: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", maxDegreesDelta: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "from",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "to",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "maxDegreesDelta",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotateTowards"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationAlphaBetaGamma:member(1)",
            docComment: "/**\n * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation\n *\n * @param alpha - defines the rotation around first axis\n *\n * @param beta - defines the rotation around second axis\n *\n * @param gamma - defines the rotation around third axis\n *\n * @returns the new quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAlphaBetaGamma(alpha: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", beta: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", gamma: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "alpha",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "beta",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gamma",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationAlphaBetaGamma"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationAlphaBetaGammaToRef:member(1)",
            docComment: "/**\n * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation and stores it in the target quaternion\n *\n * @param alpha - defines the rotation around first axis\n *\n * @param beta - defines the rotation around second axis\n *\n * @param gamma - defines the rotation around third axis\n *\n * @param result - defines the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAlphaBetaGammaToRef(alpha: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", beta: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", gamma: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "alpha",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "beta",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "gamma",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "RotationAlphaBetaGammaToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationAxis:member(1)",
            docComment: "/**\n * Creates a quaternion from a rotation around an axis\n *\n * @param axis - defines the axis to use\n *\n * @param angle - defines the angle to use (in Euler degrees)\n *\n * @returns a new quaternion created from the given axis (Vector3) and angle in radians (float)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAxis(axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RotationAxis"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationAxisToRef:member(1)",
            docComment: "/**\n * Creates a rotation around an axis and stores it into the given quaternion\n *\n * @param axis - defines the axis to use\n *\n * @param angle - defines the angle to use (in Euler degrees)\n *\n * @param result - defines the target quaternion\n *\n * @returns the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationAxisToRef(axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationAxisToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationQuaternionFromAxis:member(1)",
            docComment: "/**\n * Creates a new quaternion containing the rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation)\n *\n * @param axis1 - defines the first axis\n *\n * @param axis2 - defines the second axis\n *\n * @param axis3 - defines the third axis\n *\n * @returns the new quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationQuaternionFromAxis(axis1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "axis2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "axis3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationQuaternionFromAxis"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationQuaternionFromAxisToRef:member(1)",
            docComment: "/**\n * Creates a rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation) and stores it in the target quaternion\n *\n * @param axis1 - defines the first axis\n *\n * @param axis2 - defines the second axis\n *\n * @param axis3 - defines the third axis\n *\n * @param ref - defines the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationQuaternionFromAxisToRef(axis1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", ref: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "axis2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "axis3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "ref",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "RotationQuaternionFromAxisToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationYawPitchRoll:member(1)",
            docComment: "/**\n * Creates a new quaternion from the given Euler float angles (y, x, z)\n *\n * @param yaw - defines the rotation around Y axis\n *\n * @param pitch - defines the rotation around X axis\n *\n * @param roll - defines the rotation around Z axis\n *\n * @returns the new quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationYawPitchRoll(yaw: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", pitch: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", roll: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "yaw",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "pitch",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "roll",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationYawPitchRoll"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.RotationYawPitchRollToRef:member(1)",
            docComment: "/**\n * Creates a new rotation from the given Euler float angles (y, x, z) and stores it in the target quaternion\n *\n * @param yaw - defines the rotation around Y axis\n *\n * @param pitch - defines the rotation around X axis\n *\n * @param roll - defines the rotation around Z axis\n *\n * @param result - defines the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationYawPitchRollToRef(yaw: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", pitch: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", roll: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "yaw",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "pitch",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "roll",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "RotationYawPitchRollToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#scale:member(1)",
            docComment: '/**\n * Multiplies the current quaternion by a scale factor\n *\n * @param value - defines the scale factor\n *\n * @returns a new quaternion set by multiplying the current quaternion coordinates by the float "scale"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scale(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current quaternion values by a factor and add the result to a given quaternion\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Quaternion object where to store the result\n *\n * @returns the unmodified current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#scaleInPlace:member(1)",
            docComment: "/**\n * Multiplies in place the current quaternion by a scale factor\n *\n * @param value - defines the scale factor\n *\n * @returns the current modified quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleInPlace(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scaleInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#scaleToRef:member(1)",
            docComment: "/**\n * Scale the current quaternion values by a factor and stores the result to a given quaternion\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Quaternion object where to store the result\n *\n * @returns the unmodified current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#set:member(1)",
            docComment: "/**\n * Updates the current quaternion from the given float coordinates\n *\n * @param x - defines the x coordinate\n *\n * @param y - defines the y coordinate\n *\n * @param z - defines the z coordinate\n *\n * @param w - defines the w coordinate\n *\n * @returns the updated current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#setEuler:member(1)",
            docComment: "/**\n * Updates the current quaternion from the given euler angles\n *\n * @returns the updated current quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setEuler(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "setEuler"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#setFromToRotation:member(1)",
            docComment: "/**\n * Creates a rotation which rotates from fromDirection to toDirection.\n *\n * @param from - defines the first Vector\n *\n * @param to - defines the second Vector\n *\n * @param up - defines the direction\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setFromToRotation(from: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", to: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", up?: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "from",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "to",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "up",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "setFromToRotation"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Slerp:member(1)",
            docComment: "/**\n * Interpolates between two quaternions\n *\n * @param left - defines first quaternion\n *\n * @param right - defines second quaternion\n *\n * @param amount - defines the gradient to use\n *\n * @returns the new interpolated quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Slerp(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Slerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.SlerpToRef:member(1)",
            docComment: "/**\n * Interpolates between two quaternions and stores it into a target quaternion\n *\n * @param left - defines first quaternion\n *\n * @param right - defines second quaternion\n *\n * @param amount - defines the gradient to use\n *\n * @param result - defines the target quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static SlerpToRef(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyQuaternion",
              canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "SlerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#subtract:member(1)",
            docComment: "/**\n * Subtract two quaternions\n *\n * @param other - defines the second operand\n *\n * @returns a new quaternion as the subtraction result of the given one from the current one\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(other: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#toRotationMatrix:member(1)",
            docComment: "/**\n * Updates the given rotation matrix with the current quaternion values\n *\n * @param result - defines the target matrix\n *\n * @returns the current unchanged quaternion\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toRotationMatrix(result: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "toRotationMatrix"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion#toString:member(1)",
            docComment: "/**\n * Gets a string representation for the current quaternion\n *\n * @returns a string with the Quaternion coordinates\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Quaternion#w:member",
            docComment: "/**\n * defines the fourth component (1.0 by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "w",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Quaternion#x:member",
            docComment: "/**\n * defines the first component (0 by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "x",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Quaternion#y:member",
            docComment: "/**\n * defines the second component (0 by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Quaternion#z:member",
            docComment: "/**\n * defines the third component (0 by default)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "z",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Quaternion.Zero:member(1)",
            docComment: "/**\n * Creates an empty quaternion\n *\n * @returns a new quaternion set to (0.0, 0.0, 0.0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!QueryType:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type QueryType = "
          }, {
            kind: "Content",
            text: "'HitFirst' | 'HitAll' | 'HitFirstAvatar' | 'HitAllAvatars'"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "QueryType",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!RAD2DEG:var",
          docComment: "/**\n * Constant used to convert from radians to Euler degrees\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "RAD2DEG: "
          }, {
            kind: "Content",
            text: "number"
          }],
          releaseTag: "Public",
          name: "RAD2DEG",
          variableTypeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!Ray:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface Ray "
          }],
          releaseTag: "Public",
          name: "Ray",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!Ray#direction:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "direction: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "direction",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!Ray#distance:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "distance: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "distance",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!Ray#origin:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "origin: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "origin",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!RaycastEventSystem:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class RaycastEventSystem implements "
          }, {
            kind: "Reference",
            text: "ISystem",
            canonicalReference: "decentraland-ecs!ISystem:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "RaycastEventSystem",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!RaycastEventSystem#activate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "activate(engine: "
            }, {
              kind: "Reference",
              text: "Engine",
              canonicalReference: "decentraland-ecs!Engine:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "engine",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "activate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!RaycastEventSystem#deactivate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "deactivate(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "deactivate"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!RaycastHit:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface RaycastHit "
          }],
          releaseTag: "Public",
          name: "RaycastHit",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHit#didHit:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "didHit: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "didHit",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHit#hitNormal:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitNormal: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hitNormal",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHit#hitPoint:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hitPoint: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hitPoint",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHit#ray:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ray: "
            }, {
              kind: "Reference",
              text: "Ray",
              canonicalReference: "decentraland-ecs!Ray:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "ray",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: []
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!RaycastHitAvatar:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface RaycastHitAvatar extends "
          }, {
            kind: "Reference",
            text: "RaycastHit",
            canonicalReference: "decentraland-ecs!RaycastHit:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "RaycastHitAvatar",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHitAvatar#avatar:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "avatar: "
            }, {
              kind: "Reference",
              text: "BasicAvatarInfo",
              canonicalReference: "decentraland-ecs!BasicAvatarInfo:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "avatar",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!RaycastHitAvatars:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface RaycastHitAvatars extends "
          }, {
            kind: "Reference",
            text: "RaycastHit",
            canonicalReference: "decentraland-ecs!RaycastHit:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "RaycastHitAvatars",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHitAvatars#avatars:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "avatars: "
            }, {
              kind: "Reference",
              text: "BasicAvatarInfo",
              canonicalReference: "decentraland-ecs!BasicAvatarInfo:interface"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "avatars",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }],
          extendsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!RaycastHitEntities:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface RaycastHitEntities extends "
          }, {
            kind: "Reference",
            text: "RaycastHit",
            canonicalReference: "decentraland-ecs!RaycastHit:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "RaycastHitEntities",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHitEntities#entities:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entities: "
            }, {
              kind: "Reference",
              text: "RaycastHitEntity",
              canonicalReference: "decentraland-ecs!RaycastHitEntity:interface"
            }, {
              kind: "Content",
              text: "[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entities",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            }
          }],
          extendsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Interface",
          canonicalReference: "decentraland-ecs!RaycastHitEntity:interface",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export interface RaycastHitEntity extends "
          }, {
            kind: "Reference",
            text: "RaycastHit",
            canonicalReference: "decentraland-ecs!RaycastHit:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "RaycastHitEntity",
          members: [{
            kind: "PropertySignature",
            canonicalReference: "decentraland-ecs!RaycastHitEntity#entity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "entity: "
            }, {
              kind: "Reference",
              text: "HitEntityInfo",
              canonicalReference: "decentraland-ecs!HitEntityInfo:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "entity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          extendsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!RaycastResponse:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class RaycastResponse<T> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          name: "RaycastResponse",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!RaycastResponse:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `RaycastResponse` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(payload: "
            }, {
              kind: "Content",
              text: "{\n        queryId: string;\n        queryType: string;\n        payload: T;\n    }"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "payload",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!RaycastResponse#payload:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly payload: "
            }, {
              kind: "Content",
              text: "{\n        queryId: string;\n        queryType: string;\n        payload: T;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "payload",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ReadOnlyColor4:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ReadOnlyColor4 = "
          }, {
            kind: "Content",
            text: "{\n    readonly r: number;\n    readonly g: number;\n    readonly b: number;\n    readonly a: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ReadOnlyColor4",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ReadOnlyQuaternion:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ReadOnlyQuaternion = "
          }, {
            kind: "Content",
            text: "{\n    readonly x: number;\n    readonly y: number;\n    readonly z: number;\n    readonly w: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ReadOnlyQuaternion",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ReadOnlyVector2:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ReadOnlyVector2 = "
          }, {
            kind: "Content",
            text: "{\n    readonly x: number;\n    readonly y: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ReadOnlyVector2",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ReadOnlyVector3:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ReadOnlyVector3 = "
          }, {
            kind: "Content",
            text: "{\n    readonly y: number;\n    readonly x: number;\n    readonly z: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ReadOnlyVector3",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!ReadOnlyVector4:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type ReadOnlyVector4 = "
          }, {
            kind: "Content",
            text: "{\n    readonly y: number;\n    readonly x: number;\n    readonly z: number;\n    readonly w: number;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "ReadOnlyVector4",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Scalar:class",
          docComment: "/**\n * Scalar computation library\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Scalar "
          }],
          releaseTag: "Public",
          name: "Scalar",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Clamp:member(1)",
            docComment: "/**\n * Returns the value itself if it's between min and max. Returns min if the value is lower than min. Returns max if the value is greater than max.\n *\n * @param value - the value to clmap\n *\n * @param min - the min value to clamp to (default: 0)\n *\n * @param max - the max value to clamp to (default: 1)\n *\n * @returns the clamped value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Clamp(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", min?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Clamp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.DeltaAngle:member(1)",
            docComment: "/**\n * Calculates the shortest difference between two given angles given in degrees.\n *\n * @param current - current angle in degrees\n *\n * @param target - target angle in degrees\n *\n * @returns the delta\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static DeltaAngle(current: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "current",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "DeltaAngle"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Denormalize:member(1)",
            docComment: "/**\n * Denormalize the value from 0.0 and 1.0 using min and max values\n *\n * @param normalized - value to denormalize\n *\n * @param min - max to denormalize between\n *\n * @param max - min to denormalize between\n *\n * @returns the denormalized value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Denormalize(normalized: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "normalized",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Denormalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Hermite:member(1)",
            docComment: '/**\n * Returns a new scalar located for "amount" (float) on the Hermite spline defined by the scalars "value1", "value3", "tangent1", "tangent2". {@link http://mathworld.wolfram.com/HermitePolynomial.html}\n *\n * @param value1 - spline value\n *\n * @param tangent1 - spline value\n *\n * @param value2 - spline value\n *\n * @param tangent2 - spline value\n *\n * @param amount - input value\n *\n * @returns hermite result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Hermite(value1: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", tangent1: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", tangent2: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "tangent1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "tangent2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "Hermite"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.InverseLerp:member(1)",
            docComment: "/**\n * Calculates the linear parameter t that produces the interpolant value within the range [a, b].\n *\n * @param a - start value\n *\n * @param b - target value\n *\n * @param value - value between a and b\n *\n * @returns the inverseLerp value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static InverseLerp(a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "InverseLerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Lerp:member(1)",
            docComment: '/**\n * Creates a new scalar with values linearly interpolated of "amount" between the start scalar and the end scalar.\n *\n * @param start - start value\n *\n * @param end - target value\n *\n * @param amount - amount to lerp between\n *\n * @returns the lerped value\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(start: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.LerpAngle:member(1)",
            docComment: "/**\n * Same as Lerp but makes sure the values interpolate correctly when they wrap around 360 degrees. The parameter t is clamped to the range [0, 1]. Variables a and b are assumed to be in degrees.\n *\n * @param start - start value\n *\n * @param end - target value\n *\n * @param amount - amount to lerp between\n *\n * @returns the lerped value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static LerpAngle(start: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "LerpAngle"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Log2:member(1)",
            docComment: "/**\n * the log2 of value.\n *\n * @param value - the value to compute log2 of\n *\n * @returns the log2 of value.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Log2(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Log2"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.MoveTowards:member(1)",
            docComment: "/**\n * Moves a value current towards target.\n *\n * This is essentially the same as Mathf.Lerp but instead the function will ensure that the speed never exceeds maxDelta. Negative values of maxDelta pushes the value away from target.\n *\n * @param current - current value\n *\n * @param target - target value\n *\n * @param maxDelta - max distance to move\n *\n * @returns resulting value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static MoveTowards(current: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", maxDelta: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "current",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "maxDelta",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "MoveTowards"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.MoveTowardsAngle:member(1)",
            docComment: "/**\n * Same as MoveTowards but makes sure the values interpolate correctly when they wrap around 360 degrees.\n *\n * Variables current and target are assumed to be in degrees. For optimization reasons, negative values of maxDelta are not supported and may cause oscillation. To push current away from a target angle, add 180 to that angle instead.\n *\n * @param current - current value\n *\n * @param target - target value\n *\n * @param maxDelta - max distance to move\n *\n * @returns resulting angle\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static MoveTowardsAngle(current: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", target: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", maxDelta: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "current",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "maxDelta",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "MoveTowardsAngle"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Normalize:member(1)",
            docComment: "/**\n * Normalize the value between 0.0 and 1.0 using min and max values\n *\n * @param value - value to normalize\n *\n * @param min - max to normalize between\n *\n * @param max - min to normalize between\n *\n * @returns the normalized value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Normalize(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.NormalizeRadians:member(1)",
            docComment: "/**\n * Returns the angle converted to equivalent value between -Math.PI and Math.PI radians.\n *\n * @param angle - The angle to normalize in radian.\n *\n * @returns The converted angle.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static NormalizeRadians(angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "NormalizeRadians"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.PercentToRange:member(1)",
            docComment: "/**\n * This function returns number that corresponds to the percentage in a given range.\n *\n * PercentToRange(0.34,0,100) will return 34.\n *\n * @param percent - to convert to number\n *\n * @param min - min range\n *\n * @param max - max range\n *\n * @returns the number\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PercentToRange(percent: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "percent",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "PercentToRange"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.PingPong:member(1)",
            docComment: "/**\n * PingPongs the value t, so that it is never larger than length and never smaller than 0.\n *\n * @param tx - value\n *\n * @param length - length\n *\n * @returns The returned value will move back and forth between 0 and length\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static PingPong(tx: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", length: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "tx",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "length",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "PingPong"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.RandomRange:member(1)",
            docComment: "/**\n * Returns a random float number between and min and max values\n *\n * @param min - min value of random\n *\n * @param max - max value of random\n *\n * @returns random value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RandomRange(min: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "RandomRange"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.RangeToPercent:member(1)",
            docComment: "/**\n * This function returns percentage of a number in a given range.\n *\n * RangeToPercent(40,20,60) will return 0.5 (50%) RangeToPercent(34,0,100) will return 0.34 (34%)\n *\n * @param num - to convert to percentage\n *\n * @param min - min range\n *\n * @param max - max range\n *\n * @returns the percentage\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RangeToPercent(num: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "num",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RangeToPercent"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Repeat:member(1)",
            docComment: "/**\n * Loops the value, so that it is never larger than length and never smaller than 0.\n *\n * This is similar to the modulo operator but it works with floating point numbers. For example, using 3.0 for t and 2.5 for length, the result would be 0.5. With t = 5 and length = 2.5, the result would be 0.0. Note, however, that the behaviour is not defined for negative numbers as it is for the modulo operator\n *\n * @param value - the value\n *\n * @param length - the length\n *\n * @returns the looped value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Repeat(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", length: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "length",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Repeat"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.Sign:member(1)",
            docComment: "/**\n * Returns -1 if value is negative and +1 is value is positive.\n *\n * @param _value - the value\n *\n * @returns the value itself if it's equal to zero.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Sign(value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Sign"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.SmoothStep:member(1)",
            docComment: "/**\n * Interpolates between min and max with smoothing at the limits.\n *\n * This function interpolates between min and max in a similar way to Lerp. However, the interpolation will gradually speed up from the start and slow down toward the end. This is useful for creating natural-looking animation, fading and other transitions.\n *\n * @param from - from\n *\n * @param to - to\n *\n * @param tx - value\n *\n * @returns the smooth stepped value\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static SmoothStep(from: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", to: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", tx: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "from",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "to",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "tx",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "SmoothStep"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.ToHex:member(1)",
            docComment: "/**\n * Returns a string : the upper case translation of the number i to hexadecimal.\n *\n * @param i - number\n *\n * @returns the upper case translation of the number i to hexadecimal.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static ToHex(i: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "i",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "ToHex"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Scalar.TwoPi:member",
            docComment: "/**\n * Two pi constants convenient for computation.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TwoPi: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "TwoPi",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: true
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Scalar.WithinEpsilon:member(1)",
            docComment: "/**\n * Boolean : true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)\n *\n * @param a - number\n *\n * @param b - number\n *\n * @param epsilon - (default = 1.401298E-45)\n *\n * @returns true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static WithinEpsilon(a: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", b: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", epsilon?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "a",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "b",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "epsilon",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "WithinEpsilon"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Shape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Shape extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Shape",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!Shape#isPointerBlocker:member",
            docComment: "/**\n * Set to true to turn on the PointerEvents blocking for the entity.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "isPointerBlocker: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isPointerBlocker",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Shape#visible:member",
            docComment: "/**\n * Defines if the entity and its children should be rendered\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "visible: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "visible",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Shape#withCollisions:member",
            docComment: "/**\n * Set to true to turn on the collider for the entity.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "withCollisions: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "withCollisions",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Size:class",
          docComment: "/**\n * Size containing widht and height\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Size implements "
          }, {
            kind: "Reference",
            text: "ISize",
            canonicalReference: "decentraland-ecs!ISize:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Size",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Size:constructor(1)",
            docComment: "/**\n * Creates a Size object from the given width and height (floats).\n *\n * @param width - width of the new size\n *\n * @param height - height of the new size\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#add:member(1)",
            docComment: "/**\n * Sums the width and height of two sizes\n *\n * @param otherSize - size to add to this size\n *\n * @returns a new Size set as the addition result of the current Size and the given one.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(otherSize: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherSize",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#clone:member(1)",
            docComment: "/**\n * Clones the size\n *\n * @returns a new Size copied from the given one.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#copyFrom:member(1)",
            docComment: "/**\n * Updates the current size from the given one.\n *\n * @param src - the given size\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(src: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#copyFromFloats:member(1)",
            docComment: "/**\n * Updates in place the current Size from the given floats.\n *\n * @param width - width of the new size\n *\n * @param height - height of the new size\n *\n * @returns the updated Size.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#equals:member(1)",
            docComment: "/**\n * True if the current Size and the given one width and height are strictly equal.\n *\n * @param other - the other size to compare against\n *\n * @returns True if the current Size and the given one width and height are strictly equal.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(other: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#getClassName:member(1)",
            docComment: '/**\n * "Size"\n *\n * @returns the string "Size"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#getHashCode:member(1)",
            docComment: "/**\n * Returns the Size hash code.\n *\n * @returns a hash code for a unique width and height\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Size#height:member",
            docComment: "/**\n * Height\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "height",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size.Lerp:member(1)",
            docComment: '/**\n * Creates a new Size set at the linear interpolation "amount" between "start" and "end"\n *\n * @param start - starting size to lerp between\n *\n * @param end - end size to lerp between\n *\n * @param amount - amount to lerp between the start and end values\n *\n * @returns a new Size set at the linear interpolation "amount" between "start" and "end"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(start: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#multiplyByFloats:member(1)",
            docComment: "/**\n * Multiplies the width and height by numbers\n *\n * @param w - factor to multiple the width by\n *\n * @param h - factor to multiple the height by\n *\n * @returns a new Size set with the multiplication result of the current Size and the given floats.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyByFloats(w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", h: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "h",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyByFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#set:member(1)",
            docComment: "/**\n * Updates in place the current Size from the given floats.\n *\n * @param width - width to set\n *\n * @param height - height to set\n *\n * @returns the updated Size.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "width",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "height",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#subtract:member(1)",
            docComment: "/**\n * Subtracts the width and height of two\n *\n * @param otherSize - size to subtract to this size\n *\n * @returns a new Size set as the subtraction result of the given one from the current Size.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(otherSize: "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherSize",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size#toString:member(1)",
            docComment: "/**\n * Returns a string with the Size width and height\n *\n * @returns a string with the Size width and height\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Size#width:member",
            docComment: "/**\n * Width\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "width",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Size.Zero:member(1)",
            docComment: "/**\n * Create a new size of zero\n *\n * @returns a new Size set to (0.0, 0.0)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Size",
              canonicalReference: "decentraland-ecs!Size:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!Space:enum",
          docComment: "/**\n * Defines supported spaces\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum Space "
          }],
          releaseTag: "Public",
          name: "Space",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Space.BONE:member",
            docComment: "/**\n * Bone space\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "BONE = "
            }, {
              kind: "Content",
              text: "2"
            }],
            releaseTag: "Public",
            name: "BONE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Space.LOCAL:member",
            docComment: "/**\n * Local (object) space\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "LOCAL = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "LOCAL",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!Space.WORLD:member",
            docComment: "/**\n * World space\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "WORLD = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "WORLD",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!SphereShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class SphereShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "SphereShape",
          members: [],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!TaskResult:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type TaskResult<T> = "
          }, {
            kind: "Reference",
            text: "Promise",
            canonicalReference: "!Promise:interface"
          }, {
            kind: "Content",
            text: "<T> & {\n    isComplete: boolean;\n    didFail?: boolean;\n    error?: "
          }, {
            kind: "Reference",
            text: "Error",
            canonicalReference: "!Error:interface"
          }, {
            kind: "Content",
            text: ";\n    result?: T;\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "TaskResult",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 0,
              endIndex: 0
            }
          }],
          typeTokenRange: {
            startIndex: 1,
            endIndex: 5
          }
        }, {
          kind: "Function",
          canonicalReference: "decentraland-ecs!teleportTo:function(1)",
          docComment: '/**\n * teleport player to a destination\n *\n * @param  - destination "coordX,coordY", "magic", "crowd"\n */\n',
          excerptTokens: [{
            kind: "Content",
            text: "export declare function teleportTo(destination: "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: "): "
          }, {
            kind: "Content",
            text: "void"
          }, {
            kind: "Content",
            text: ";"
          }],
          returnTypeTokenRange: {
            startIndex: 3,
            endIndex: 4
          },
          releaseTag: "Public",
          overloadIndex: 1,
          parameters: [{
            parameterName: "destination",
            parameterTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "teleportTo"
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!TextShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class TextShape extends "
          }, {
            kind: "Reference",
            text: "Shape",
            canonicalReference: "decentraland-ecs!Shape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "TextShape",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!TextShape:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `TextShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(value?: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#billboard:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "billboard: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "billboard",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#font:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "font?: "
            }, {
              kind: "Reference",
              text: "Font",
              canonicalReference: "decentraland-ecs!Font:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "font",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#fontSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontSize: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#fontWeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontWeight: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontWeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#height:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "height: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "height",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#hTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#isPickable:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isPickable: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isPickable",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#lineCount:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "lineCount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "lineCount",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#lineSpacing:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "lineSpacing: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "lineSpacing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#opacity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "opacity: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "opacity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#outlineColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#outlineWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineWidth: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#resizeToFit:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "resizeToFit: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "resizeToFit",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#shadowBlur:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowBlur: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#shadowColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowColor: "
            }, {
              kind: "Reference",
              text: "Color3",
              canonicalReference: "decentraland-ecs!Color3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#shadowOffsetX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#shadowOffsetY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#textWrapping:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "textWrapping: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "textWrapping",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#value:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "value: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "value",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#vTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "vTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "vTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#width:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "width: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "width",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!TextShape#zIndex:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "zIndex: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "zIndex",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Texture:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Texture extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Texture",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Texture:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Texture` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", opts?: "
            }, {
              kind: "Reference",
              text: "Partial",
              canonicalReference: "!Partial:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Pick",
              canonicalReference: "!Pick:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ", 'samplingMode' | 'wrap' | 'hasAlpha'>>"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "src",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "opts",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 9
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Texture#hasAlpha:member",
            docComment: "/**\n * Defines if this texture has an alpha channel\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly hasAlpha: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hasAlpha",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Texture#samplingMode:member",
            docComment: "/**\n * Enables crisper images based on the provided sampling mode. | Value | Type | |-------|-----------| | 0 | NEAREST | | 1 | BILINEAR | | 2 | TRILINEAR |\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly samplingMode: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "samplingMode",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Texture#src:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly src: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "src",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Texture#wrap:member",
            docComment: "/**\n * Enables texture wrapping for this material. | Value | Type | |-------|-----------| | 0 | CLAMP | | 1 | WRAP | | 2 | MIRROR |\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly wrap: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "wrap",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!ToGammaSpace:var",
          docComment: "/**\n * Constant used to convert a value to gamma space\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "ToGammaSpace: "
          }, {
            kind: "Content",
            text: "number"
          }],
          releaseTag: "Public",
          name: "ToGammaSpace",
          variableTypeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }, {
          kind: "Variable",
          canonicalReference: "decentraland-ecs!ToLinearSpace:var",
          docComment: "/**\n * Constant used to convert a value to linear space\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "ToLinearSpace = 2.2"
          }],
          releaseTag: "Public",
          name: "ToLinearSpace",
          variableTypeTokenRange: {
            startIndex: 0,
            endIndex: 0
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!TranformConstructorArgs:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type TranformConstructorArgs = "
          }, {
            kind: "Content",
            text: "{\n    position?: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n    rotation?: "
          }, {
            kind: "Reference",
            text: "Quaternion",
            canonicalReference: "decentraland-ecs!Quaternion:class"
          }, {
            kind: "Content",
            text: ";\n    scale?: "
          }, {
            kind: "Reference",
            text: "Vector3",
            canonicalReference: "decentraland-ecs!Vector3:class"
          }, {
            kind: "Content",
            text: ";\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "TranformConstructorArgs",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 8
          }
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Transform:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Transform extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "Transform",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Transform:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `Transform` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(args?: "
            }, {
              kind: "Reference",
              text: "TranformConstructorArgs",
              canonicalReference: "decentraland-ecs!TranformConstructorArgs:type"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "args",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Transform#lookAt:member(1)",
            docComment: "/**\n * Rotates the transform so the forward vector points at target's current position.\n *\n * @public\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "lookAt(target: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", worldUp?: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "target",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "worldUp",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "lookAt"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Transform#position:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "position: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "position",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Transform#rotate:member(1)",
            docComment: "/**\n * Applies a rotation of euler angles around the x, y and z axis.\n *\n * @public\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "rotate(axis: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", angle: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "angle",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "rotate"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Transform#rotation:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "rotation: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "rotation",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Transform#scale:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "scale: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "scale",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Transform#translate:member(1)",
            docComment: "/**\n * Moves the transform in the direction and distance of translation.\n *\n * @public\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "translate(vec: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "this"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vec",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "translate"
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!TransparencyMode:enum",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum TransparencyMode "
          }],
          releaseTag: "Public",
          name: "TransparencyMode",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!TransparencyMode.ALPHA_BLEND:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ALPHA_BLEND = "
            }, {
              kind: "Content",
              text: "2"
            }],
            releaseTag: "Public",
            name: "ALPHA_BLEND",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!TransparencyMode.ALPHA_TEST:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ALPHA_TEST = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "ALPHA_TEST",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!TransparencyMode.ALPHA_TEST_AND_BLEND:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "ALPHA_TEST_AND_BLEND = "
            }, {
              kind: "Content",
              text: "3"
            }],
            releaseTag: "Public",
            name: "ALPHA_TEST_AND_BLEND",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!TransparencyMode.AUTO:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "AUTO = "
            }, {
              kind: "Content",
              text: "4"
            }],
            releaseTag: "Public",
            name: "AUTO",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!TransparencyMode.OPAQUE:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "OPAQUE = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "OPAQUE",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIButton:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIButton extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIButton",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#background:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "background: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "background",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#cornerRadius:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "cornerRadius: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "cornerRadius",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#fontSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontSize: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#fontWeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontWeight: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontWeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#shadowBlur:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowBlur: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#shadowColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#shadowOffsetX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#shadowOffsetY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#text:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "text: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "text",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIButton#thickness:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "thickness: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "thickness",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UICanvas:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UICanvas extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UICanvas",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!UICanvas:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `UICanvas` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor();"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: []
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIContainerRect:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIContainerRect extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIContainerRect",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerRect#adaptHeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptHeight: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerRect#adaptWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptWidth: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerRect#alignmentUsesSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "alignmentUsesSize: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "alignmentUsesSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerRect#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerRect#thickness:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "thickness: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "thickness",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIContainerStack:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIContainerStack extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIContainerStack",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerStack#adaptHeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptHeight: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerStack#adaptWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptWidth: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerStack#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerStack#spacing:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "spacing: "
            }, {
              kind: "Reference",
              text: "Number",
              canonicalReference: "!Number:interface"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "spacing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIContainerStack#stackOrientation:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "stackOrientation: "
            }, {
              kind: "Reference",
              text: "UIStackOrientation",
              canonicalReference: "decentraland-ecs!UIStackOrientation:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "stackOrientation",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIImage:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIImage extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIImage",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!UIImage:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `UIImage` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(parent: "
            }, {
              kind: "Reference",
              text: "UIShape",
              canonicalReference: "decentraland-ecs!UIShape:class"
            }, {
              kind: "Content",
              text: ", source: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "parent",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#onClick:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onClick: "
            }, {
              kind: "Reference",
              text: "OnClick",
              canonicalReference: "decentraland-ecs!OnClick:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onClick",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#sizeInPixels:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "sizeInPixels: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sizeInPixels",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#source:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "source?: "
            }, {
              kind: "Reference",
              text: "Texture",
              canonicalReference: "decentraland-ecs!Texture:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "source",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#sourceHeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "sourceHeight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sourceHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#sourceLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "sourceLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sourceLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#sourceTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "sourceTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sourceTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIImage#sourceWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "sourceWidth: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "sourceWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIInputText:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIInputText extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIInputText",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#autoStretchWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "autoStretchWidth: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "autoStretchWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#background:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "background: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "background",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#focusedBackground:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "focusedBackground: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "focusedBackground",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#font:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "font?: "
            }, {
              kind: "Reference",
              text: "Font",
              canonicalReference: "decentraland-ecs!Font:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "font",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#fontSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontSize: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#fontWeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontWeight: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontWeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#hTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#margin:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "margin: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "margin",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#maxWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "maxWidth: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "maxWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#onBlur:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onBlur: "
            }, {
              kind: "Reference",
              text: "OnBlur",
              canonicalReference: "decentraland-ecs!OnBlur:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#onChanged:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onChanged: "
            }, {
              kind: "Reference",
              text: "OnChanged",
              canonicalReference: "decentraland-ecs!OnChanged:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onChanged",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#onFocus:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onFocus: "
            }, {
              kind: "Reference",
              text: "OnFocus",
              canonicalReference: "decentraland-ecs!OnFocus:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onFocus",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#onTextSubmit:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onTextSubmit: "
            }, {
              kind: "Reference",
              text: "OnTextSubmit",
              canonicalReference: "decentraland-ecs!OnTextSubmit:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onTextSubmit",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#outlineColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#outlineWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineWidth: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#placeholder:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "placeholder: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "placeholder",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#placeholderColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "placeholderColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "placeholderColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#shadowBlur:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowBlur: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#shadowColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#shadowOffsetX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#shadowOffsetY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#textWrapping:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "textWrapping: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "textWrapping",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#thickness:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "thickness: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "thickness",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#value:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "value: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "value",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIInputText#vTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "vTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "vTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIScrollRect:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIScrollRect extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIScrollRect",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#backgroundColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "backgroundColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "backgroundColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#borderColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "borderColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "borderColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#isHorizontal:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isHorizontal: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isHorizontal",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#isVertical:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isVertical: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isVertical",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#onChanged:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onChanged: "
            }, {
              kind: "Reference",
              text: "OnChanged",
              canonicalReference: "decentraland-ecs!OnChanged:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "onChanged",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 3
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#valueX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "valueX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "valueX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIScrollRect#valueY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "valueY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "valueY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIShape:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare abstract class UIShape extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIShape",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!UIShape:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `UIShape` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(parent: "
            }, {
              kind: "Reference",
              text: "UIShape",
              canonicalReference: "decentraland-ecs!UIShape:class"
            }, {
              kind: "Content",
              text: " | null"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "parent",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#hAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#height:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "height: "
            }, {
              kind: "Content",
              text: "string | number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "height",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#isPointerBlocker:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "isPointerBlocker: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "isPointerBlocker",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#name:member",
            docComment: "/**\n * Defines if the entity and its children should be rendered\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "name: "
            }, {
              kind: "Content",
              text: "string | null"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "name",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#opacity:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "opacity: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "opacity",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#positionX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "positionX: "
            }, {
              kind: "Content",
              text: "string | number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "positionX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#positionY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "positionY: "
            }, {
              kind: "Content",
              text: "string | number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "positionY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#vAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "vAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "vAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#visible:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "visible: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "visible",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIShape#width:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "width: "
            }, {
              kind: "Content",
              text: "string | number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "width",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!UIStackOrientation:enum",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum UIStackOrientation "
          }],
          releaseTag: "Public",
          name: "UIStackOrientation",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!UIStackOrientation.HORIZONTAL:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "HORIZONTAL = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "HORIZONTAL",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!UIStackOrientation.VERTICAL:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "VERTICAL = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "VERTICAL",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIText:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIText extends "
          }, {
            kind: "Reference",
            text: "UIShape",
            canonicalReference: "decentraland-ecs!UIShape:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UIText",
          members: [{
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#adaptHeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptHeight: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptHeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#adaptWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "adaptWidth: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "adaptWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#color:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "color: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "color",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#font:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "font?: "
            }, {
              kind: "Reference",
              text: "Font",
              canonicalReference: "decentraland-ecs!Font:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "font",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#fontAutoSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontAutoSize: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontAutoSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#fontSize:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontSize: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontSize",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#fontWeight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "fontWeight: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "fontWeight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#hTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "hTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "hTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#lineCount:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "lineCount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "lineCount",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#lineSpacing:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "lineSpacing: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "lineSpacing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#outlineColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#outlineWidth:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "outlineWidth: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "outlineWidth",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#paddingBottom:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingBottom: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingBottom",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#paddingLeft:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingLeft: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingLeft",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#paddingRight:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingRight: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingRight",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#paddingTop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "paddingTop: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "paddingTop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#shadowBlur:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowBlur: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowBlur",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#shadowColor:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowColor: "
            }, {
              kind: "Reference",
              text: "Color4",
              canonicalReference: "decentraland-ecs!Color4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowColor",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#shadowOffsetX:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetX: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetX",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#shadowOffsetY:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "shadowOffsetY: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "shadowOffsetY",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#textWrapping:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "textWrapping: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "textWrapping",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#value:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "value: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "value",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIText#vTextAlign:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "vTextAlign: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "vTextAlign",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UIValue:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UIValue "
          }],
          releaseTag: "Public",
          name: "UIValue",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!UIValue:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `UIValue` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(value: "
            }, {
              kind: "Content",
              text: "string | number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!UIValue#toString:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIValue#type:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "type: "
            }, {
              kind: "Reference",
              text: "UIValueType",
              canonicalReference: "decentraland-ecs!UIValueType:enum"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "type",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UIValue#value:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "value: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "value",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Enum",
          canonicalReference: "decentraland-ecs!UIValueType:enum",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare enum UIValueType "
          }],
          releaseTag: "Public",
          name: "UIValueType",
          members: [{
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!UIValueType.PERCENT:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "PERCENT = "
            }, {
              kind: "Content",
              text: "0"
            }],
            releaseTag: "Public",
            name: "PERCENT",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }, {
            kind: "EnumMember",
            canonicalReference: "decentraland-ecs!UIValueType.PIXELS:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "PIXELS = "
            }, {
              kind: "Content",
              text: "1"
            }],
            releaseTag: "Public",
            name: "PIXELS",
            initializerTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UUIDEvent:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UUIDEvent<T = "
          }, {
            kind: "Content",
            text: "any"
          }, {
            kind: "Content",
            text: "> "
          }],
          releaseTag: "Public",
          typeParameters: [{
            typeParameterName: "T",
            constraintTokenRange: {
              startIndex: 0,
              endIndex: 0
            },
            defaultTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            }
          }],
          name: "UUIDEvent",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!UUIDEvent:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `UUIDEvent` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(uuid: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ", payload: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "uuid",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "payload",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UUIDEvent#payload:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly payload: "
            }, {
              kind: "Content",
              text: "T"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "payload",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UUIDEvent#uuid:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly uuid: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "uuid",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!UUIDEventSystem:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class UUIDEventSystem implements "
          }, {
            kind: "Reference",
            text: "ISystem",
            canonicalReference: "decentraland-ecs!ISystem:interface"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "UUIDEventSystem",
          members: [{
            kind: "Method",
            canonicalReference: "decentraland-ecs!UUIDEventSystem#activate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "activate(engine: "
            }, {
              kind: "Reference",
              text: "Engine",
              canonicalReference: "decentraland-ecs!Engine:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "engine",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "activate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!UUIDEventSystem#deactivate:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "deactivate(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "deactivate"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!UUIDEventSystem#handlerMap:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "handlerMap: "
            }, {
              kind: "Content",
              text: "{\n        [uuid: string]: "
            }, {
              kind: "Reference",
              text: "OnUUIDEvent",
              canonicalReference: "decentraland-ecs!OnUUIDEvent:class"
            }, {
              kind: "Content",
              text: "<any>;\n    }"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "handlerMap",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 4
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!UUIDEventSystem#onAddEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onAddEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "onAddEntity"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!UUIDEventSystem#onRemoveEntity:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "onRemoveEntity(entity: "
            }, {
              kind: "Reference",
              text: "IEntity",
              canonicalReference: "decentraland-ecs!IEntity:interface"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "entity",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "onRemoveEntity"
          }],
          implementsTokenRanges: [{
            startIndex: 1,
            endIndex: 3
          }]
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Vector2:class",
          docComment: "/**\n * Class representing a vector containing 2 coordinates\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Vector2 "
          }],
          releaseTag: "Public",
          name: "Vector2",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Vector2:constructor(1)",
            docComment: "/**\n * Creates a new Vector2 from the given x and y coordinates\n *\n * @param x - defines the first coordinate\n *\n * @param y - defines the second coordinate\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    x?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    y?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#add:member(1)",
            docComment: "/**\n * Add another vector with the current one\n *\n * @param otherVector - defines the other vector\n *\n * @returns a new Vector2 set with the addition of the current Vector2 and the given one coordinates\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Add:member(1)",
            docComment: "/**\n * Returns a new Vector2 as the result of the addition of the two given vectors.\n *\n * @param vector1 - the first vector\n *\n * @param vector2 - the second vector\n *\n * @returns the resulting vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Add(vector1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", vector2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "vector2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#addInPlace:member(1)",
            docComment: "/**\n * Set the Vector2 coordinates by adding the given Vector2 coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#addToRef:member(1)",
            docComment: '/**\n * Sets the "result" coordinates with the addition of the current Vector2 and the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @param result - defines the target vector\n *\n * @returns the unmodified current Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "addToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#addVector3:member(1)",
            docComment: "/**\n * Gets a new Vector2 by adding the current Vector2 coordinates to the given Vector3 x, y coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addVector3(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addVector3"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#asArray:member(1)",
            docComment: "/**\n * Copy the current vector to an array\n *\n * @returns a new array with 2 elements: the Vector2 coordinates.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.CatmullRom:member(1)",
            docComment: '/**\n * Gets a new Vector2 located for "amount" (float) on the CatmullRom spline defined by the given four Vector2\n *\n * @param value1 - defines 1st point of control\n *\n * @param value2 - defines 2nd point of control\n *\n * @param value3 - defines 3rd point of control\n *\n * @param value4 - defines 4th point of control\n *\n * @param amount - defines the interpolation factor\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static CatmullRom(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value3: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value4: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "value4",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "CatmullRom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Center:member(1)",
            docComment: '/**\n * Gets a new Vector2 located at the center of the vectors "value1" and "value2"\n *\n * @param value1 - defines first vector\n *\n * @param value2 - defines second vector\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Center(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Center"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Clamp:member(1)",
            docComment: '/**\n * Returns a new Vector2 set with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max". If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate. If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate\n *\n * @param value - defines the value to clamp\n *\n * @param min - defines the lower limit\n *\n * @param max - defines the upper limit\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Clamp(value: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Clamp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#clone:member(1)",
            docComment: "/**\n * Gets a new Vector2 copied from the Vector2\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#copyFrom:member(1)",
            docComment: "/**\n * Sets the Vector2 coordinates with the given Vector2 coordinates\n *\n * @param source - defines the source Vector2\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(source: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#copyFromFloats:member(1)",
            docComment: "/**\n * Sets the Vector2 coordinates with the given floats\n *\n * @param x - defines the first coordinate\n *\n * @param y - defines the second coordinate\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Distance:member(1)",
            docComment: '/**\n * Gets the distance between the vectors "value1" and "value2"\n *\n * @param value1 - defines first vector\n *\n * @param value2 - defines second vector\n *\n * @returns the distance between vectors\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Distance(value1: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Distance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.DistanceOfPointFromSegment:member(1)",
            docComment: '/**\n * Gets the shortest distance (float) between the point "p" and the segment defined by the two points "segA" and "segB".\n *\n * @param p - defines the middle point\n *\n * @param segA - defines one point of the segment\n *\n * @param segB - defines the other point of the segment\n *\n * @returns the shortest distance\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DistanceOfPointFromSegment(p: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", segA: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", segB: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "p",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "segA",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "segB",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "DistanceOfPointFromSegment"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.DistanceSquared:member(1)",
            docComment: '/**\n * Returns the squared distance between the vectors "value1" and "value2"\n *\n * @param value1 - defines first vector\n *\n * @param value2 - defines second vector\n *\n * @returns the squared distance between vectors\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DistanceSquared(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "DistanceSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#divide:member(1)",
            docComment: "/**\n * Returns a new Vector2 set with the Vector2 coordinates divided by the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divide(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divide"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#divideInPlace:member(1)",
            docComment: "/**\n * Divides the current Vector2 coordinates by the given ones\n *\n * @param otherVector - defines the other vector\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divideInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divideInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#divideToRef:member(1)",
            docComment: '/**\n * Sets the "result" coordinates with the Vector2 divided by the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @param result - defines the target vector\n *\n * @returns the unmodified current Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "divideToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "divideToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Dot:member(1)",
            docComment: '/**\n * Gets the dot product of the vector "left" and the vector "right"\n *\n * @param left - defines first vector\n *\n * @param right - defines second vector\n *\n * @returns the dot product (float)\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Dot(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Dot"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#equals:member(1)",
            docComment: "/**\n * Gets a boolean if two vectors are equals\n *\n * @param otherVector - defines the other vector\n *\n * @returns true if the given vector coordinates strictly equal the current Vector2 ones\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#equalsWithEpsilon:member(1)",
            docComment: "/**\n * Gets a boolean if two vectors are equals (using an epsilon value)\n *\n * @param otherVector - defines the other vector\n *\n * @param epsilon - defines the minimal distance to consider equality\n *\n * @returns true if the given vector coordinates are close to the current ones by a distance of epsilon.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equalsWithEpsilon(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", epsilon?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "epsilon",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "equalsWithEpsilon"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#floor:member(1)",
            docComment: "/**\n * Gets a new Vector2 from current Vector2 floored values\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "floor(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "floor"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#fract:member(1)",
            docComment: "/**\n * Gets a new Vector2 from current Vector2 floored values\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "fract(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "fract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.FromArray:member(1)",
            docComment: "/**\n * Gets a new Vector2 set from the given index element of the given array\n *\n * @param array - defines the data source\n *\n * @param offset - defines the offset in the data source\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.FromArrayToRef:member(1)",
            docComment: '/**\n * Sets "result" from the given index element of the given array\n *\n * @param array - defines the data source\n *\n * @param offset - defines the offset in the data source\n *\n * @param result - defines the target vector\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "FromArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#getClassName:member(1)",
            docComment: '/**\n * Gets class name\n *\n * @returns the string "Vector2"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#getHashCode:member(1)",
            docComment: "/**\n * Gets current vector hash code\n *\n * @returns the Vector2 hash code as a number\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Hermite:member(1)",
            docComment: '/**\n * Returns a new Vector2 located for "amount" (float) on the Hermite spline defined by the vectors "value1", "value3", "tangent1", "tangent2"\n *\n * @param value1 - defines the 1st control point\n *\n * @param tangent1 - defines the outgoing tangent\n *\n * @param value2 - defines the 2nd control point\n *\n * @param tangent2 - defines the incoming tangent\n *\n * @param amount - defines the interpolation factor\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Hermite(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", tangent1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", tangent2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "tangent1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "tangent2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "Hermite"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#length:member(1)",
            docComment: "/**\n * Gets the length of the vector\n *\n * @returns the vector length (float)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "length(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "length"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#lengthSquared:member(1)",
            docComment: "/**\n * Gets the vector squared length\n *\n * @returns the vector squared length (float)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "lengthSquared(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "lengthSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Lerp:member(1)",
            docComment: '/**\n * Returns a new Vector2 located for "amount" (float) on the linear interpolation between the vector "start" adn the vector "end".\n *\n * @param start - defines the start vector\n *\n * @param end - defines the end vector\n *\n * @param amount - defines the interpolation factor\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(start: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Maximize:member(1)",
            docComment: '/**\n * Gets a new Vecto2 set with the maximal coordinate values from the "left" and "right" vectors\n *\n * @param left - defines 1st vector\n *\n * @param right - defines 2nd vector\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Maximize(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Maximize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Minimize:member(1)",
            docComment: '/**\n * Gets a new Vector2 set with the minimal coordinate values from the "left" and "right" vectors\n *\n * @param left - defines 1st vector\n *\n * @param right - defines 2nd vector\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Minimize(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Minimize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#multiply:member(1)",
            docComment: "/**\n * Returns a new Vector2 set with the multiplication of the current Vector2 and the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#multiplyByFloats:member(1)",
            docComment: "/**\n * Gets a new Vector2 set with the Vector2 coordinates multiplied by the given floats\n *\n * @param x - defines the first coordinate\n *\n * @param y - defines the second coordinate\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyByFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyByFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#multiplyInPlace:member(1)",
            docComment: "/**\n * Multiplies in place the current Vector2 coordinates by the given ones\n *\n * @param otherVector - defines the other vector\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiplyInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#multiplyToRef:member(1)",
            docComment: '/**\n * Sets "result" coordinates with the multiplication of the current Vector2 and the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @param result - defines the target vector\n *\n * @returns the unmodified current Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#negate:member(1)",
            docComment: "/**\n * Gets a new Vector2 with current Vector2 negated coordinates\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "negate(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "negate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#normalize:member(1)",
            docComment: "/**\n * Normalize the vector\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalize(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Normalize:member(1)",
            docComment: "/**\n * Returns a new Vector2 equal to the normalized given vector\n *\n * @param vector - defines the vector to normalize\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Normalize(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.One:member(1)",
            docComment: "/**\n * Gets a new Vector2(1, 1)\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static One(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "One"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.PointInTriangle:member(1)",
            docComment: '/**\n * Determines if a given vector is included in a triangle\n *\n * @param p - defines the vector to test\n *\n * @param p0 - defines 1st triangle point\n *\n * @param p1 - defines 2nd triangle point\n *\n * @param p2 - defines 3rd triangle point\n *\n * @returns true if the point "p" is in the triangle defined by the vertors "p0", "p1", "p2"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static PointInTriangle(p: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", p0: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", p1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", p2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "p",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "p0",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "p1",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "p2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "PointInTriangle"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#scale:member(1)",
            docComment: '/**\n * Returns a new Vector2 scaled by "scale" from the current Vector2\n *\n * @param scale - defines the scaling factor\n *\n * @returns a new Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current Vector2 values by a factor and add the result to a given Vector2\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Vector2 object where to store the result\n *\n * @returns the unmodified current Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#scaleInPlace:member(1)",
            docComment: "/**\n * Multiply the Vector2 coordinates by scale\n *\n * @param scale - defines the scaling factor\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleInPlace(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scaleInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#scaleToRef:member(1)",
            docComment: "/**\n * Scale the current Vector2 values by a factor to a given Vector2\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Vector2 object where to store the result\n *\n * @returns the unmodified current Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#set:member(1)",
            docComment: "/**\n * Sets the Vector2 coordinates with the given floats\n *\n * @param x - defines the first coordinate\n *\n * @param y - defines the second coordinate\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#subtract:member(1)",
            docComment: "/**\n * Gets a new Vector2 set with the subtracted coordinates of the given one from the current Vector2\n *\n * @param otherVector - defines the other vector\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#subtractInPlace:member(1)",
            docComment: "/**\n * Sets the current Vector2 coordinates by subtracting from it the given one coordinates\n *\n * @param otherVector - defines the other vector\n *\n * @returns the current updated Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtractInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtractInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#subtractToRef:member(1)",
            docComment: '/**\n * Sets the "result" coordinates with the subtraction of the given one from the current Vector2 coordinates.\n *\n * @param otherVector - defines the other vector\n *\n * @param result - defines the target vector\n *\n * @returns the unmodified current Vector2\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "subtractToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#toArray:member(1)",
            docComment: "/**\n * Sets the Vector2 coordinates in the given array or FloatArray from the given index.\n *\n * @param array - defines the source array\n *\n * @param index - defines the offset in source array\n *\n * @returns the current Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", index?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2#toString:member(1)",
            docComment: "/**\n * Gets a string with the Vector2 coordinates\n *\n * @returns a string with the Vector2 coordinates\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Transform:member(1)",
            docComment: "/**\n * Gets a new Vector2 set with the transformed coordinates of the given vector by the given transformation matrix\n *\n * @param vector - defines the vector to transform\n *\n * @param transformation - defines the matrix to apply\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Transform(vector: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Transform"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.TransformToRef:member(1)",
            docComment: '/**\n * Transforms the given vector coordinates by the given transformation matrix and stores the result in the vector "result" coordinates\n *\n * @param vector - defines the vector to transform\n *\n * @param transformation - defines the matrix to apply\n *\n * @param result - defines the target vector\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformToRef(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector2",
              canonicalReference: "decentraland-ecs!ReadOnlyVector2:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "TransformToRef"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector2#x:member",
            docComment: "/**\n * defines the first coordinate\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "x",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector2#y:member",
            docComment: "/**\n * defines the second coordinate\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector2.Zero:member(1)",
            docComment: "/**\n * Gets a new Vector2(0, 0)\n *\n * @returns a new Vector2\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Vector2",
              canonicalReference: "decentraland-ecs!Vector2:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Vector3:class",
          docComment: "/**\n * Classed used to store (x,y,z) vector representation A Vector3 is the main object used in 3D geometry It can represent etiher the coordinates of a point the space, either a direction Reminder: Babylon.js uses a left handed forward facing system\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Vector3 "
          }],
          releaseTag: "Public",
          name: "Vector3",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Vector3:constructor(1)",
            docComment: "/**\n * Creates a new Vector3 object from the given x, y, z (floats) coordinates.\n *\n * @param x - defines the first coordinates (on X axis)\n *\n * @param y - defines the second coordinates (on Y axis)\n *\n * @param z - defines the third coordinates (on Z axis)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    x?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    y?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    z?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#add:member(1)",
            docComment: "/**\n * Gets a new Vector3, result of the addition the current Vector3 and the given vector\n *\n * @param otherVector - defines the second operand\n *\n * @returns the resulting Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Add:member(1)",
            docComment: "/**\n * Returns a new Vector3 as the result of the addition of the two given vectors.\n *\n * @param vector1 - the first vector\n *\n * @param vector2 - the second vector\n *\n * @returns the resulting vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Add(vector1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", vector2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "vector2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#addInPlace:member(1)",
            docComment: "/**\n * Adds the given vector to the current Vector3\n *\n * @param otherVector - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#addInPlaceFromFloats:member(1)",
            docComment: "/**\n * Adds the given coordinates to the current Vector3\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addInPlaceFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "addInPlaceFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#addToRef:member(1)",
            docComment: '/**\n * Adds the current Vector3 to the given one and stores the result in the vector "result"\n *\n * @param otherVector - defines the second operand\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "addToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#applyMatrix4:member(1)",
            docComment: "/**\n * Multiplies this vector (with an implicit 1 in the 4th dimension) and m, and divides by perspective\n *\n * @param matrix - The transformation matrix\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "applyMatrix4(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "applyMatrix4"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#applyMatrix4ToRef:member(1)",
            docComment: '/**\n * Multiplies this vector (with an implicit 1 in the 4th dimension) and m, and divides by perspective and set the given vector "result" with this result\n *\n * @param matrix - The transformation matrix\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "applyMatrix4ToRef(matrix: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "matrix",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "applyMatrix4ToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#asArray:member(1)",
            docComment: "/**\n * Creates an array containing three elements : the coordinates of the Vector3\n *\n * @returns a new array of numbers\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Backward:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (0.0, 0.0, -1.0)\n *\n * @returns a new forward Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Backward(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Backward"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.CatmullRom:member(1)",
            docComment: '/**\n * Returns a new Vector3 located for "amount" on the CatmullRom interpolation spline defined by the vectors "value1", "value2", "value3", "value4"\n *\n * @param value1 - defines the first control point\n *\n * @param value2 - defines the second control point\n *\n * @param value3 - defines the third control point\n *\n * @param value4 - defines the fourth control point\n *\n * @param amount - defines the amount on the spline to use\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static CatmullRom(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value3: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value4: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "value4",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "CatmullRom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Center:member(1)",
            docComment: '/**\n * Returns a new Vector3 located at the center between "value1" and "value2"\n *\n * @param value1 - defines the first operand\n *\n * @param value2 - defines the second operand\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Center(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Center"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Clamp:member(1)",
            docComment: '/**\n * Returns a new Vector3 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max" If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one\n *\n * @param value - defines the current value\n *\n * @param min - defines the lower range value\n *\n * @param max - defines the upper range value\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Clamp(value: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Clamp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.ClampToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max" If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one\n *\n * @param value - defines the current value\n *\n * @param min - defines the lower range value\n *\n * @param max - defines the upper range value\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static ClampToRef(value: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", min: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", max: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "min",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "max",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "ClampToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#clone:member(1)",
            docComment: "/**\n * Creates a new Vector3 copied from the current Vector3\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#copyFrom:member(1)",
            docComment: "/**\n * Copies the given vector coordinates to the current Vector3 ones\n *\n * @param source - defines the source Vector3\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(source: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#copyFromFloats:member(1)",
            docComment: "/**\n * Copies the given floats to the current Vector3 coordinates\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Cross:member(1)",
            docComment: '/**\n * Returns a new Vector3 as the cross product of the vectors "left" and "right" The cross product is then orthogonal to both "left" and "right"\n *\n * @param left - defines the left operand\n *\n * @param right - defines the right operand\n *\n * @returns the cross product\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Cross(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Cross"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.CrossToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the cross product of "left" and "right" The cross product is then orthogonal to both "left" and "right"\n *\n * @param left - defines the left operand\n *\n * @param right - defines the right operand\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static CrossToRef(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "CrossToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Distance:member(1)",
            docComment: '/**\n * Returns the distance between the vectors "value1" and "value2"\n *\n * @param value1 - defines the first operand\n *\n * @param value2 - defines the second operand\n *\n * @returns the distance\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Distance(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Distance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.DistanceSquared:member(1)",
            docComment: '/**\n * Returns the squared distance between the vectors "value1" and "value2"\n *\n * @param value1 - defines the first operand\n *\n * @param value2 - defines the second operand\n *\n * @returns the squared distance\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DistanceSquared(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "DistanceSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#divide:member(1)",
            docComment: "/**\n * Returns a new Vector3 set with the result of the division of the current Vector3 coordinates by the given ones\n *\n * @param otherVector - defines the second operand\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divide(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divide"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#divideInPlace:member(1)",
            docComment: "/**\n * Divides the current Vector3 coordinates by the given ones.\n *\n * @param otherVector - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divideInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divideInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#divideToRef:member(1)",
            docComment: '/**\n * Divides the current Vector3 coordinates by the given ones and stores the result in the given vector "result"\n *\n * @param otherVector - defines the second operand\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "divideToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "divideToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Dot:member(1)",
            docComment: '/**\n * Returns the dot product (float) between the vectors "left" and "right"\n *\n * @param left - defines the left operand\n *\n * @param right - defines the right operand\n *\n * @returns the dot product\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Dot(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Dot"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Down:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (0.0, -1.0, 0.0)\n *\n * @returns a new down Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Down(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Down"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#equals:member(1)",
            docComment: "/**\n * Returns true if the current Vector3 and the given vector coordinates are strictly equal\n *\n * @param otherVector - defines the second operand\n *\n * @returns true if both vectors are equals\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#equalsToFloats:member(1)",
            docComment: "/**\n * Returns true if the current Vector3 coordinates equals the given floats\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns true if both vectors are equals\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equalsToFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "equalsToFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#equalsWithEpsilon:member(1)",
            docComment: "/**\n * Returns true if the current Vector3 and the given vector coordinates are distant less than epsilon\n *\n * @param otherVector - defines the second operand\n *\n * @param epsilon - defines the minimal distance to define values as equals\n *\n * @returns true if both vectors are distant less than epsilon\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equalsWithEpsilon(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", epsilon?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "epsilon",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "equalsWithEpsilon"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#floor:member(1)",
            docComment: "/**\n * Gets a new Vector3 from current Vector3 floored values\n *\n * @returns a new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "floor(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "floor"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Forward:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (0.0, 0.0, 1.0)\n *\n * @returns a new forward Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Forward(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Forward"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#fract:member(1)",
            docComment: "/**\n * Gets a new Vector3 from current Vector3 floored values\n *\n * @returns a new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "fract(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "fract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.FromArray:member(1)",
            docComment: '/**\n * Returns a new Vector3 set from the index "offset" of the given array\n *\n * @param array - defines the source array\n *\n * @param offset - defines the offset in the source array\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.FromArrayToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the element values from the index "offset" of the given array\n *\n * @param array - defines the source array\n *\n * @param offset - defines the offset in the source array\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "FromArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.FromFloatArray:member(1)",
            docComment: '/**\n * Returns a new Vector3 set from the index "offset" of the given FloatArray This function is deprecated. Use FromArray instead\n *\n * @param array - defines the source array\n *\n * @param offset - defines the offset in the source array\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "FromFloatArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.FromFloatArrayToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the element values from the index "offset" of the given FloatArray This function is deprecated. Use FromArrayToRef instead.\n *\n * @param array - defines the source array\n *\n * @param offset - defines the offset in the source array\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "FromFloatArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.FromFloatsToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the given floats.\n *\n * @param x - defines the x coordinate of the source\n *\n * @param y - defines the y coordinate of the source\n *\n * @param z - defines the z coordinate of the source\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "FromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.GetAngleBetweenVectors:member(1)",
            docComment: "/**\n * Get angle between two vectors\n *\n * @param vector0 - angle between vector0 and vector1\n *\n * @param vector1 - angle between vector0 and vector1\n *\n * @param normal - direction of the normal\n *\n * @returns the angle between vector0 and vector1\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetAngleBetweenVectors(vector0: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", vector1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", normal: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector0",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "vector1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "normal",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "GetAngleBetweenVectors"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#getClassName:member(1)",
            docComment: '/**\n * Gets the class name\n *\n * @returns the string "Vector3"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.GetClipFactor:member(1)",
            docComment: "/**\n * Get the clip factor between two vectors\n *\n * @param vector0 - defines the first operand\n *\n * @param vector1 - defines the second operand\n *\n * @param axis - defines the axis to use\n *\n * @param size - defines the size along the axis\n *\n * @returns the clip factor\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static GetClipFactor(vector0: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", vector1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", axis: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", size: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector0",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "vector1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "axis",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "size",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "GetClipFactor"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#getHashCode:member(1)",
            docComment: "/**\n * Creates the Vector3 hash code\n *\n * @returns a number which tends to be unique between Vector3 instances\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Hermite:member(1)",
            docComment: '/**\n * Returns a new Vector3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"\n *\n * @param value1 - defines the first control point\n *\n * @param tangent1 - defines the first tangent vector\n *\n * @param value2 - defines the second control point\n *\n * @param tangent2 - defines the second tangent vector\n *\n * @param amount - defines the amount on the interpolation spline (between 0 and 1)\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Hermite(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", tangent1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", tangent2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "tangent1",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "tangent2",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "Hermite"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Left:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (-1.0, 0.0, 0.0)\n *\n * @returns a new left Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Left(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Left"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#length:member(1)",
            docComment: "/**\n * Gets the length of the Vector3\n *\n * @returns the length of the Vecto3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "length(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "length"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#lengthSquared:member(1)",
            docComment: "/**\n * Gets the squared length of the Vector3\n *\n * @returns squared length of the Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "lengthSquared(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "lengthSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Lerp:member(1)",
            docComment: '/**\n * Returns a new Vector3 located for "amount" (float) on the linear interpolation between the vectors "start" and "end"\n *\n * @param start - defines the start value\n *\n * @param end - defines the end value\n *\n * @param amount - max defines amount between both (between 0 and 1)\n *\n * @returns the new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Lerp(start: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "Lerp"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.LerpToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"\n *\n * @param start - defines the start value\n *\n * @param end - defines the end value\n *\n * @param amount - max defines amount between both (between 0 and 1)\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static LerpToRef(start: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", end: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", amount: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "start",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "end",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "amount",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "LerpToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Maximize:member(1)",
            docComment: "/**\n * Gets the maximal coordinate values between two Vector3\n *\n * @param left - defines the first operand\n *\n * @param right - defines the second operand\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Maximize(left: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Maximize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#maximizeInPlace:member(1)",
            docComment: "/**\n * Updates the current Vector3 with the maximal coordinate values between its and the given vector ones.\n *\n * @param other - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "maximizeInPlace(other: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "maximizeInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#maximizeInPlaceFromFloats:member(1)",
            docComment: "/**\n * Updates the current Vector3 with the maximal coordinate values between its and the given coordinates.\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "maximizeInPlaceFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "maximizeInPlaceFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Minimize:member(1)",
            docComment: "/**\n * Gets the minimal coordinate values between two Vector3\n *\n * @param left - defines the first operand\n *\n * @param right - defines the second operand\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Minimize(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Minimize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#minimizeInPlace:member(1)",
            docComment: "/**\n * Updates the current Vector3 with the minimal coordinate values between its and the given vector ones\n *\n * @param other - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "minimizeInPlace(other: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "minimizeInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#minimizeInPlaceFromFloats:member(1)",
            docComment: "/**\n * Updates the current Vector3 with the minimal coordinate values between its and the given coordinates\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "minimizeInPlaceFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "minimizeInPlaceFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#multiply:member(1)",
            docComment: "/**\n * Returns a new Vector3, result of the multiplication of the current Vector3 by the given vector\n *\n * @param otherVector - defines the second operand\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#multiplyByFloats:member(1)",
            docComment: "/**\n * Returns a new Vector3 set with the result of the mulliplication of the current Vector3 coordinates by the given floats\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyByFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "multiplyByFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#multiplyInPlace:member(1)",
            docComment: "/**\n * Multiplies the current Vector3 coordinates by the given ones\n *\n * @param otherVector - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiplyInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#multiplyToRef:member(1)",
            docComment: '/**\n * Multiplies the current Vector3 by the given one and stores the result in the given vector "result"\n *\n * @param otherVector - defines the second operand\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#negate:member(1)",
            docComment: "/**\n * Gets a new Vector3 set with the current Vector3 negated coordinates\n *\n * @returns a new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "negate(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "negate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#normalize:member(1)",
            docComment: "/**\n * Normalize the current Vector3. Please note that this is an in place operation.\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalize(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Normalize:member(1)",
            docComment: "/**\n * Returns a new Vector3 as the normalization of the given vector\n *\n * @param vector - defines the Vector3 to normalize\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Normalize(vector: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#normalizeFromLength:member(1)",
            docComment: "/**\n * Normalize the current Vector3 with the given input length. Please note that this is an in place operation.\n *\n * @param len - the length of the vector\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalizeFromLength(len: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "len",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "normalizeFromLength"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#normalizeToNew:member(1)",
            docComment: "/**\n * Normalize the current Vector3 to a new vector\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalizeToNew(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalizeToNew"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#normalizeToRef:member(1)",
            docComment: "/**\n * Normalize the current Vector3 to the reference\n *\n * @param reference - define the Vector3 to update\n *\n * @returns the updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalizeToRef(reference: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "reference",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "normalizeToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.NormalizeToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the normalization of the given first vector\n *\n * @param vector - defines the Vector3 to normalize\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static NormalizeToRef(vector: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "NormalizeToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.One:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (1.0, 1.0, 1.0)\n *\n * @returns a new unit Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static One(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "One"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Right:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (1.0, 0.0, 0.0)\n *\n * @returns a new right Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Right(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Right"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#rotate:member(1)",
            docComment: "/**\n * Rotates the current Vector3 based on the given quaternion\n *\n * @param q - defines the Quaternion\n *\n * @returns the current Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "rotate(q: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "rotate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#rotateToRef:member(1)",
            docComment: "/**\n * Rotates current Vector3 based on the given quaternion, but applies the rotation to target Vector3.\n *\n * @param q - defines the Quaternion\n *\n * @param result - defines the target Vector3\n *\n * @returns the current Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "rotateToRef(q: "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "q",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "rotateToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.RotationFromAxis:member(1)",
            docComment: "/**\n * Given three orthogonal normalized left-handed oriented Vector3 axis in space (target system), RotationFromAxis() returns the rotation Euler angles (ex : rotation.x, rotation.y, rotation.z) to apply to something in order to rotate it from its local system to the given target system Note: axis1, axis2 and axis3 are normalized during this operation\n *\n * @param axis1 - defines the first axis\n *\n * @param axis2 - defines the second axis\n *\n * @param axis3 - defines the third axis\n *\n * @returns a new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationFromAxis(axis1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "axis2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "axis3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "RotationFromAxis"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.RotationFromAxisToRef:member(1)",
            docComment: "/**\n * The same than RotationFromAxis but updates the given ref Vector3 parameter instead of returning a new Vector3\n *\n * @param axis1 - defines the first axis\n *\n * @param axis2 - defines the second axis\n *\n * @param axis3 - defines the third axis\n *\n * @param ref - defines the Vector3 where to store the result\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static RotationFromAxisToRef(axis1: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis2: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", axis3: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ", ref: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "axis1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "axis2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "axis3",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "ref",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "RotationFromAxisToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#scale:member(1)",
            docComment: '/**\n * Returns a new Vector3 set with the current Vector3 coordinates multiplied by the float "scale"\n *\n * @param scale - defines the multiplier factor\n *\n * @returns a new Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current Vector3 values by a factor and add the result to a given Vector3\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the unmodified current Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#scaleInPlace:member(1)",
            docComment: '/**\n * Multiplies the Vector3 coordinates by the float "scale"\n *\n * @param scale - defines the multiplier factor\n *\n * @returns the current updated Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scaleInPlace(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scaleInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#scaleToRef:member(1)",
            docComment: '/**\n * Multiplies the current Vector3 coordinates by the float "scale" and stores the result in the given vector "result" coordinates\n *\n * @param scale - defines the multiplier factor\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#set:member(1)",
            docComment: "/**\n * Copies the given floats to the current Vector3 coordinates\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#setAll:member(1)",
            docComment: "/**\n * Copies the given float to the current Vector3 coordinates\n *\n * @param v - defines the x, y and z coordinates of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setAll(v: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "v",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "setAll"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#subtract:member(1)",
            docComment: "/**\n * Returns a new Vector3, result of the subtraction of the given vector from the current Vector3\n *\n * @param otherVector - defines the second operand\n *\n * @returns the resulting Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#subtractFromFloats:member(1)",
            docComment: "/**\n * Returns a new Vector3 set with the subtraction of the given floats from the current Vector3 coordinates\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @returns the resulting Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtractFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "subtractFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#subtractFromFloatsToRef:member(1)",
            docComment: '/**\n * Subtracts the given floats from the current Vector3 coordinates and set the given vector "result" with this result\n *\n * @param x - defines the x coordinate of the operand\n *\n * @param y - defines the y coordinate of the operand\n *\n * @param z - defines the z coordinate of the operand\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractFromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "subtractFromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#subtractInPlace:member(1)",
            docComment: "/**\n * Subtract the given vector from the current Vector3\n *\n * @param otherVector - defines the second operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtractInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtractInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#subtractToRef:member(1)",
            docComment: '/**\n * Subtracts the given vector from the current Vector3 and stores the result in the vector "result".\n *\n * @param otherVector - defines the second operand\n *\n * @param result - defines the Vector3 object where to store the result\n *\n * @returns the current Vector3\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "subtractToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#toArray:member(1)",
            docComment: "/**\n * Populates the given array or FloatArray from the given index with the successive coordinates of the Vector3\n *\n * @param array - defines the destination array\n *\n * @param index - defines the offset in the destination array\n *\n * @returns the current Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", index?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#toQuaternion:member(1)",
            docComment: "/**\n * Converts the current Vector3 into a quaternion (considering that the Vector3 contains Euler angles representation of a rotation)\n *\n * @returns a new Quaternion object, computed from the Vector3 coordinates\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toQuaternion(): "
            }, {
              kind: "Reference",
              text: "Quaternion",
              canonicalReference: "decentraland-ecs!Quaternion:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toQuaternion"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3#toString:member(1)",
            docComment: "/**\n * Creates a string representation of the Vector3\n *\n * @returns a string with the Vector3 coordinates.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformCoordinates:member(1)",
            docComment: "/**\n * Returns a new Vector3 set with the result of the transformation by the given matrix of the given vector. This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)\n *\n * @param vector - defines the Vector3 to transform\n *\n * @param transformation - defines the transformation matrix\n *\n * @returns the transformed Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TransformCoordinates(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "TransformCoordinates"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformCoordinatesFromFloatsToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z) This method computes tranformed coordinates only, not transformed direction vectors\n *\n * @param x - define the x coordinate of the source vector\n *\n * @param y - define the y coordinate of the source vector\n *\n * @param z - define the z coordinate of the source vector\n *\n * @param transformation - defines the transformation matrix\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformCoordinatesFromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 14,
              endIndex: 15
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 11
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 12,
                endIndex: 13
              }
            }],
            name: "TransformCoordinatesFromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformCoordinatesToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)\n *\n * @param vector - defines the Vector3 to transform\n *\n * @param transformation - defines the transformation matrix\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformCoordinatesToRef(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 10,
              endIndex: 11
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 7
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 8,
                endIndex: 9
              }
            }],
            name: "TransformCoordinatesToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformNormal:member(1)",
            docComment: "/**\n * Returns a new Vector3 set with the result of the normal transformation by the given matrix of the given vector This methods computes transformed normalized direction vectors only (ie. it does not apply translation)\n *\n * @param vector - defines the Vector3 to transform\n *\n * @param transformation - defines the transformation matrix\n *\n * @returns the new Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormal(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "TransformNormal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformNormalFromFloatsToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z) This methods computes transformed normalized direction vectors only (ie. it does not apply translation)\n *\n * @param x - define the x coordinate of the source vector\n *\n * @param y - define the y coordinate of the source vector\n *\n * @param z - define the z coordinate of the source vector\n *\n * @param transformation - defines the transformation matrix\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormalFromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 14,
              endIndex: 15
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 11
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 12,
                endIndex: 13
              }
            }],
            name: "TransformNormalFromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.TransformNormalToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector This methods computes transformed normalized direction vectors only (ie. it does not apply translation)\n *\n * @param vector - defines the Vector3 to transform\n *\n * @param transformation - defines the transformation matrix\n *\n * @param result - defines the Vector3 where to store the result\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormalToRef(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector3",
              canonicalReference: "decentraland-ecs!ReadOnlyVector3:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Readonly",
              canonicalReference: "!Readonly:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ">"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 10,
              endIndex: 11
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 7
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 8,
                endIndex: 9
              }
            }],
            name: "TransformNormalToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Up:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (0.0, 1.0, 0.0)\n *\n * @returns a new up Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Up(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Up"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector3#x:member",
            docComment: "/**\n * Defines the first coordinates (on X axis)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "x",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector3#y:member",
            docComment: "/**\n * Defines the second coordinates (on Y axis)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector3#z:member",
            docComment: "/**\n * Defines the third coordinates (on Z axis)\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "z",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector3.Zero:member(1)",
            docComment: "/**\n * Returns a new Vector3 set to (0.0, 0.0, 0.0)\n *\n * @returns a new empty Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!Vector4:class",
          docComment: "/**\n * Vector4 class created for EulerAngle class conversion to Quaternion\n *\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class Vector4 "
          }],
          releaseTag: "Public",
          name: "Vector4",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!Vector4:constructor(1)",
            docComment: "/**\n * Creates a Vector4 object from the given floats.\n *\n * @param x - x value of the vector\n *\n * @param y - y value of the vector\n *\n * @param z - z value of the vector\n *\n * @param w - w value of the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(\n    x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", \n    w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }]
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#add:member(1)",
            docComment: "/**\n * Returns a new Vector4 as the result of the addition of the current Vector4 and the given one.\n *\n * @param otherVector - the vector to add\n *\n * @returns the resulting vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "add(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Add:member(1)",
            docComment: "/**\n * Returns a new Vector4 as the result of the addition of the two given vectors.\n *\n * @param vector1 - the first vector\n *\n * @param vector2 - the second vector\n *\n * @returns the resulting vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Add(vector1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", vector2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "vector2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Add"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#addInPlace:member(1)",
            docComment: "/**\n * Adds the given vector to the current Vector4.\n *\n * @param otherVector - the vector to add\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "addInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "addInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#addToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" with the result of the addition of the current Vector4 and the given one.\n *\n * @param otherVector - the vector to add\n *\n * @param result - the vector to store the result\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "addToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "addToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#asArray:member(1)",
            docComment: "/**\n * Returns a new array populated with 4 elements : the Vector4 coordinates.\n *\n * @returns the resulting array\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "asArray(): "
            }, {
              kind: "Content",
              text: "number[]"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "asArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Center:member(1)",
            docComment: '/**\n * Returns a new Vector4 located at the center between the vectors "value1" and "value2".\n *\n * @param value1 - value to calulate the center between\n *\n * @param value2 - value to calulate the center between\n *\n * @returns the center between the two vectors\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Center(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Center"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#clone:member(1)",
            docComment: "/**\n * Returns a new Vector4 copied from the current one.\n *\n * @returns the new cloned vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "clone(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "clone"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#copyFrom:member(1)",
            docComment: "/**\n * Updates the current Vector4 with the given one coordinates.\n *\n * @param source - the source vector to copy from\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFrom(source: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "source",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "copyFrom"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#copyFromFloats:member(1)",
            docComment: "/**\n * Updates the current Vector4 coordinates with the given floats.\n *\n * @param x - float to copy from\n *\n * @param y - float to copy from\n *\n * @param z - float to copy from\n *\n * @param w - float to copy from\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "copyFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "copyFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Distance:member(1)",
            docComment: '/**\n * Returns the distance (float) between the vectors "value1" and "value2".\n *\n * @param value1 - value to calulate the distance between\n *\n * @param value2 - value to calulate the distance between\n *\n * @returns the distance between the two vectors\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static Distance(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Distance"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.DistanceSquared:member(1)",
            docComment: '/**\n * Returns the squared distance (float) between the vectors "value1" and "value2".\n *\n * @param value1 - value to calulate the distance between\n *\n * @param value2 - value to calulate the distance between\n *\n * @returns the distance between the two vectors squared\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static DistanceSquared(value1: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", value2: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "value1",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "value2",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "DistanceSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#divide:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the division result of the current Vector4 by the given one.\n *\n * @param otherVector - vector to devide with\n *\n * @returns resulting new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divide(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divide"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#divideInPlace:member(1)",
            docComment: "/**\n * Divides the current Vector3 coordinates by the given ones.\n *\n * @param otherVector - vector to devide with\n *\n * @returns the updated Vector3.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "divideInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "divideInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#divideToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" with the division result of the current Vector4 by the given one.\n *\n * @param otherVector - vector to devide with\n *\n * @param result - vector to store the result\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "divideToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "divideToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#equals:member(1)",
            docComment: "/**\n * Boolean : True if the current Vector4 coordinates are stricly equal to the given ones.\n *\n * @param otherVector - the vector to compare against\n *\n * @returns true if they are equal\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equals(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "equals"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#equalsToFloats:member(1)",
            docComment: "/**\n * Boolean : True if the given floats are strictly equal to the current Vector4 coordinates.\n *\n * @param x - x value to compare against\n *\n * @param y - y value to compare against\n *\n * @param z - z value to compare against\n *\n * @param w - w value to compare against\n *\n * @returns true if equal\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "equalsToFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "equalsToFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#equalsWithEpsilon:member(1)",
            docComment: '/**\n * Boolean : True if the current Vector4 coordinates are each beneath the distance "epsilon" from the given vector ones.\n *\n * @param otherVector - vector to compare against\n *\n * @param epsilon - (Default: very small number)\n *\n * @returns true if they are equal\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "equalsWithEpsilon(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", epsilon?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "epsilon",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "equalsWithEpsilon"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#floor:member(1)",
            docComment: "/**\n * Gets a new Vector4 from current Vector4 floored values\n *\n * @returns a new Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "floor(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "floor"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#fract:member(1)",
            docComment: "/**\n * Gets a new Vector4 from current Vector3 floored values\n *\n * @returns a new Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "fract(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "fract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.FromArray:member(1)",
            docComment: "/**\n * Returns a new Vector4 set from the starting index of the given array.\n *\n * @param array - the array to pull values from\n *\n * @param offset - the offset into the array to start at\n *\n * @returns the new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static FromArray(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 6,
              endIndex: 7
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }],
            name: "FromArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.FromArrayToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" from the starting index of the given array.\n *\n * @param array - the array to pull values from\n *\n * @param offset - the offset into the array to start at\n *\n * @param result - the vector to store the result in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "ArrayLike",
              canonicalReference: "!ArrayLike:interface"
            }, {
              kind: "Content",
              text: "<number>"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 8,
              endIndex: 9
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 3
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 4,
                endIndex: 5
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 6,
                endIndex: 7
              }
            }],
            name: "FromArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.FromFloatArrayToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" from the starting index of the given FloatArray.\n *\n * @param array - the array to pull values from\n *\n * @param offset - the offset into the array to start at\n *\n * @param result - the vector to store the result in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatArrayToRef(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", offset: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "offset",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "FromFloatArrayToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.FromFloatsToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" coordinates from the given floats.\n *\n * @param x - float to set from\n *\n * @param y - float to set from\n *\n * @param z - float to set from\n *\n * @param w - float to set from\n *\n * @param result - the vector to the floats in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static FromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "FromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#getClassName:member(1)",
            docComment: '/**\n * Returns the string "Vector4".\n *\n * @returns "Vector4"\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "getClassName(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getClassName"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#getHashCode:member(1)",
            docComment: "/**\n * Returns the Vector4 hash code.\n *\n * @returns a unique hash code\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "getHashCode(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "getHashCode"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#length:member(1)",
            docComment: "/**\n * Returns the Vector4 length (float).\n *\n * @returns the length\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "length(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "length"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#lengthSquared:member(1)",
            docComment: "/**\n * Returns the Vector4 squared length (float).\n *\n * @returns the length squared\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "lengthSquared(): "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "lengthSquared"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Maximize:member(1)",
            docComment: "/**\n * Returns a vector with the maximum values from the left and right vectors\n *\n * @param left - left vector to maximize\n *\n * @param right - right vector to maximize\n *\n * @returns a new vector with the maximum of the left and right vector values\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Maximize(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Maximize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#maximizeInPlace:member(1)",
            docComment: "/**\n * Updates the Vector4 coordinates with the maximum values between its own and the given vector ones\n *\n * @param other - defines the second operand\n *\n * @returns the current updated Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "maximizeInPlace(other: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "maximizeInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Minimize:member(1)",
            docComment: "/**\n * Returns a vector with the minimum values from the left and right vectors\n *\n * @param left - left vector to minimize\n *\n * @param right - right vector to minimize\n *\n * @returns a new vector with the minimum of the left and right vector values\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Minimize(left: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", right: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "left",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "right",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "Minimize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#minimizeInPlace:member(1)",
            docComment: "/**\n * Updates the Vector4 coordinates with the minimum values between its own and the given vector ones\n *\n * @param other - defines the second operand\n *\n * @returns the current updated Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "minimizeInPlace(other: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "other",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "minimizeInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#multiply:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the multiplication result of the current Vector4 and the given one.\n *\n * @param otherVector - vector to multiple with\n *\n * @returns resulting new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiply(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiply"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#multiplyByFloats:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the multiplication result of the given floats and the current Vector4 coordinates.\n *\n * @param x - x value multiply with\n *\n * @param y - y value multiply with\n *\n * @param z - z value multiply with\n *\n * @param w - w value multiply with\n *\n * @returns resulting new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyByFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "multiplyByFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#multiplyInPlace:member(1)",
            docComment: "/**\n * Multiplies in place the current Vector4 by the given one.\n *\n * @param otherVector - vector to multiple with\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "multiplyInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "multiplyInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#multiplyToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" with the multiplication result of the current Vector4 and the given one.\n *\n * @param otherVector - vector to multiple with\n *\n * @param result - vector to store the result\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "multiplyToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "multiplyToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#negate:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the current Vector4 negated coordinates.\n *\n * @returns a new vector with the negated values\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "negate(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "negate"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#normalize:member(1)",
            docComment: "/**\n * Normalizes in place the Vector4.\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "normalize(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Normalize:member(1)",
            docComment: "/**\n * Returns a new normalized Vector4 from the given one.\n *\n * @param vector - the vector to normalize\n *\n * @returns the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Normalize(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "Normalize"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.NormalizeToRef:member(1)",
            docComment: '/**\n * Updates the given vector "result" from the normalization of the given one.\n *\n * @param vector - the vector to normalize\n *\n * @param result - the vector to store the result in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static NormalizeToRef(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "NormalizeToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.One:member(1)",
            docComment: "/**\n * Returns a new Vector4 set to (1.0, 1.0, 1.0, 1.0)\n *\n * @returns the new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static One(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "One"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#scale:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the current Vector4 coordinates multiplied by scale (float).\n *\n * @param scale - the number to scale with\n *\n * @returns a new vector with the result\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scale(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scale"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#scaleAndAddToRef:member(1)",
            docComment: "/**\n * Scale the current Vector4 values by a factor and add the result to a given Vector4\n *\n * @param scale - defines the scale factor\n *\n * @param result - defines the Vector4 object where to store the result\n *\n * @returns the unmodified current Vector4\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleAndAddToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleAndAddToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#scaleInPlace:member(1)",
            docComment: "/**\n * Multiplies the current Vector4 coordinates by scale (float).\n *\n * @param scale - the number to scale with\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "scaleInPlace(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "scaleInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#scaleToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the current Vector4 coordinates multiplied by scale (float).\n *\n * @param scale - the number to scale with\n *\n * @param result - a vector to store the result in\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "scaleToRef(scale: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "scale",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "scaleToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#set:member(1)",
            docComment: "/**\n * Updates the current Vector4 coordinates with the given floats.\n *\n * @param x - float to set from\n *\n * @param y - float to set from\n *\n * @param z - float to set from\n *\n * @param w - float to set from\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "set(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "set"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#setAll:member(1)",
            docComment: "/**\n * Copies the given float to the current Vector3 coordinates\n *\n * @param v - defines the x, y, z and w coordinates of the operand\n *\n * @returns the current updated Vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "setAll(v: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "v",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "setAll"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#subtract:member(1)",
            docComment: "/**\n * Returns a new Vector4 with the result of the subtraction of the given vector from the current Vector4.\n *\n * @param otherVector - the vector to add\n *\n * @returns the new vector with the result\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtract(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtract"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#subtractFromFloats:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.\n *\n * @param x - value to subtract\n *\n * @param y - value to subtract\n *\n * @param z - value to subtract\n *\n * @param w - value to subtract\n *\n * @returns new vector containing the result\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtractFromFloats(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 9,
              endIndex: 10
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }],
            name: "subtractFromFloats"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#subtractFromFloatsToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" set with the result of the subtraction of the given floats from the current Vector4 coordinates.\n *\n * @param x - value to subtract\n *\n * @param y - value to subtract\n *\n * @param z - value to subtract\n *\n * @param w - value to subtract\n *\n * @param result - the vector to store the result in\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractFromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 11,
              endIndex: 12
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }],
            name: "subtractFromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#subtractInPlace:member(1)",
            docComment: "/**\n * Subtract in place the given vector from the current Vector4.\n *\n * @param otherVector - the vector to subtract\n *\n * @returns the updated Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "subtractInPlace(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "subtractInPlace"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#subtractToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the subtraction of the given vector from the current Vector4.\n *\n * @param otherVector - the vector to subtract\n *\n * @param result - the vector to store the result\n *\n * @returns the current Vector4.\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "subtractToRef(otherVector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "otherVector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "subtractToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#toArray:member(1)",
            docComment: "/**\n * Populates the given array from the given index with the Vector4 coordinates.\n *\n * @param array - array to populate\n *\n * @param index - index of the array to start at (default: 0)\n *\n * @returns the Vector4.\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toArray(array: "
            }, {
              kind: "Reference",
              text: "FloatArray",
              canonicalReference: "decentraland-ecs!FloatArray:type"
            }, {
              kind: "Content",
              text: ", index?: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "array",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "index",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "toArray"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#toString:member(1)",
            docComment: "/**\n * Returns the string with the Vector4 coordinates.\n *\n * @returns a string containing all the vector values\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toString(): "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toString"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4#toVector3:member(1)",
            docComment: "/**\n * Returns a new Vector3 from the Vector4 (x, y, z) coordinates.\n *\n * @returns this converted to a new vector3\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "toVector3(): "
            }, {
              kind: "Reference",
              text: "Vector3",
              canonicalReference: "decentraland-ecs!Vector3:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toVector3"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.TransformNormal:member(1)",
            docComment: "/**\n * Returns a new Vector4 set with the result of the normal transformation by the given matrix of the given vector. This methods computes transformed normalized direction vectors only.\n *\n * @param vector - the vector to transform\n *\n * @param transformation - the transformation matrix to apply\n *\n * @returns the new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormal(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 5,
              endIndex: 6
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }],
            name: "TransformNormal"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.TransformNormalFromFloatsToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z, w). This methods computes transformed normalized direction vectors only.\n *\n * @param x - value to transform\n *\n * @param y - value to transform\n *\n * @param z - value to transform\n *\n * @param w - value to transform\n *\n * @param transformation - the transformation matrix to apply\n *\n * @param result - the vector to store the results in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormalFromFloatsToRef(x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 13,
              endIndex: 14
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "x",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "y",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "z",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }, {
              parameterName: "w",
              parameterTypeTokenRange: {
                startIndex: 7,
                endIndex: 8
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 9,
                endIndex: 10
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 11,
                endIndex: 12
              }
            }],
            name: "TransformNormalFromFloatsToRef"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.TransformNormalToRef:member(1)",
            docComment: '/**\n * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector. This methods computes transformed normalized direction vectors only.\n *\n * @param vector - the vector to transform\n *\n * @param transformation - the transformation matrix to apply\n *\n * @param result - the vector to store the result in\n */\n',
            excerptTokens: [{
              kind: "Content",
              text: "static TransformNormalToRef(vector: "
            }, {
              kind: "Reference",
              text: "ReadOnlyVector4",
              canonicalReference: "decentraland-ecs!ReadOnlyVector4:type"
            }, {
              kind: "Content",
              text: ", transformation: "
            }, {
              kind: "Reference",
              text: "Matrix",
              canonicalReference: "decentraland-ecs!Matrix:class"
            }, {
              kind: "Content",
              text: ", result: "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 7,
              endIndex: 8
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "vector",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "transformation",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 4
              }
            }, {
              parameterName: "result",
              parameterTypeTokenRange: {
                startIndex: 5,
                endIndex: 6
              }
            }],
            name: "TransformNormalToRef"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector4#w:member",
            docComment: "/**\n * w value of the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "w: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "w",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector4#x:member",
            docComment: "/**\n * x value of the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "x: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "x",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector4#y:member",
            docComment: "/**\n * y value of the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "y: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "y",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!Vector4#z:member",
            docComment: "/**\n * z value of the vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "z: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "z",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!Vector4.Zero:member(1)",
            docComment: "/**\n * Returns a new Vector4 set to (0.0, 0.0, 0.0, 0.0)\n *\n * @returns the new vector\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "static Zero(): "
            }, {
              kind: "Reference",
              text: "Vector4",
              canonicalReference: "decentraland-ecs!Vector4:class"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: true,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "Zero"
          }],
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!VideoClip:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class VideoClip extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "VideoClip",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!VideoClip:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `VideoClip` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "url",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoClip#url:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly url: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "url",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "Class",
          canonicalReference: "decentraland-ecs!VideoTexture:class",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare class VideoTexture extends "
          }, {
            kind: "Reference",
            text: "ObservableComponent",
            canonicalReference: "decentraland-ecs!ObservableComponent:class"
          }, {
            kind: "Content",
            text: " "
          }],
          releaseTag: "Public",
          name: "VideoTexture",
          members: [{
            kind: "Constructor",
            canonicalReference: "decentraland-ecs!VideoTexture:constructor(1)",
            docComment: "/**\n * Constructs a new instance of the `VideoTexture` class\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "constructor(videoClip: "
            }, {
              kind: "Reference",
              text: "VideoClip",
              canonicalReference: "decentraland-ecs!VideoClip:class"
            }, {
              kind: "Content",
              text: ", opts?: "
            }, {
              kind: "Reference",
              text: "Partial",
              canonicalReference: "!Partial:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "Pick",
              canonicalReference: "!Pick:type"
            }, {
              kind: "Content",
              text: "<"
            }, {
              kind: "Reference",
              text: "VideoTexture",
              canonicalReference: "decentraland-ecs!VideoTexture:class"
            }, {
              kind: "Content",
              text: ", 'samplingMode' | 'wrap'>>"
            }, {
              kind: "Content",
              text: ");"
            }],
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "videoClip",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }, {
              parameterName: "opts",
              parameterTypeTokenRange: {
                startIndex: 3,
                endIndex: 9
              }
            }]
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#loop:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "loop: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "loop",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!VideoTexture#pause:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "pause(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "pause"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!VideoTexture#play:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "play(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "play"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#playbackRate:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "playbackRate: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "playbackRate",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#playing:member",
            docComment: "/**\n * Is this VideoTexture playing?\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "playing: "
            }, {
              kind: "Content",
              text: "boolean"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "playing",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!VideoTexture#reset:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "reset(): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "reset"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#samplingMode:member",
            docComment: "/**\n * Enables crisper images based on the provided sampling mode. | Value | Type | |-------|-----------| | 1 | NEAREST | | 2 | BILINEAR | | 3 | TRILINEAR |\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly samplingMode: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "samplingMode",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#seek:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "seek: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "seek",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!VideoTexture#seekTime:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "seekTime(seconds: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: "): "
            }, {
              kind: "Content",
              text: "void"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 3,
              endIndex: 4
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [{
              parameterName: "seconds",
              parameterTypeTokenRange: {
                startIndex: 1,
                endIndex: 2
              }
            }],
            name: "seekTime"
          }, {
            kind: "Method",
            canonicalReference: "decentraland-ecs!VideoTexture#toJSON:member(1)",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "toJSON(): "
            }, {
              kind: "Content",
              text: "any"
            }, {
              kind: "Content",
              text: ";"
            }],
            isStatic: false,
            returnTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            releaseTag: "Public",
            overloadIndex: 1,
            parameters: [],
            name: "toJSON"
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#videoClipId:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "readonly videoClipId: "
            }, {
              kind: "Content",
              text: "string"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "videoClipId",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#volume:member",
            docComment: "",
            excerptTokens: [{
              kind: "Content",
              text: "volume: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "volume",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }, {
            kind: "Property",
            canonicalReference: "decentraland-ecs!VideoTexture#wrap:member",
            docComment: "/**\n * Enables texture wrapping for this material. | Value | Type | |-------|-----------| | 1 | CLAMP | | 2 | WRAP | | 3 | MIRROR |\n */\n",
            excerptTokens: [{
              kind: "Content",
              text: "readonly wrap: "
            }, {
              kind: "Content",
              text: "number"
            }, {
              kind: "Content",
              text: ";"
            }],
            releaseTag: "Public",
            name: "wrap",
            propertyTypeTokenRange: {
              startIndex: 1,
              endIndex: 2
            },
            isStatic: false
          }],
          extendsTokenRange: {
            startIndex: 1,
            endIndex: 3
          },
          implementsTokenRanges: []
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!Wearable:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type Wearable = "
          }, {
            kind: "Content",
            text: "{\n    id: "
          }, {
            kind: "Reference",
            text: "WearableId",
            canonicalReference: "decentraland-ecs!WearableId:type"
          }, {
            kind: "Content",
            text: ";\n    type: 'wearable';\n    category: string;\n    baseUrl: string;\n    tags: string[];\n    representations: "
          }, {
            kind: "Reference",
            text: "BodyShapeRespresentation",
            canonicalReference: "decentraland-ecs!BodyShapeRespresentation:type"
          }, {
            kind: "Content",
            text: "[];\n}"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "Wearable",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 6
          }
        }, {
          kind: "TypeAlias",
          canonicalReference: "decentraland-ecs!WearableId:type",
          docComment: "/**\n * @public\n */\n",
          excerptTokens: [{
            kind: "Content",
            text: "export declare type WearableId = "
          }, {
            kind: "Content",
            text: "string"
          }, {
            kind: "Content",
            text: ";"
          }],
          releaseTag: "Public",
          name: "WearableId",
          typeTokenRange: {
            startIndex: 1,
            endIndex: 2
          }
        }]
      }]
    };
  },
  946: function _() {
    !function (e, n) {
      for (var t in n) {
        e[t] = n[t];
      }
    }(this, function (e) {
      var t = {};

      function n(a) {
        if (t[a]) return t[a].exports;
        var r = t[a] = {
          i: a,
          l: !1,
          exports: {}
        };
        return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, a) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: a
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var a = Object.create(null);
        if (n.r(a), Object.defineProperty(a, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var r in e) {
          n.d(a, r, function (n) {
            return e[n];
          }.bind(null, r));
        }
        return a;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, n) {
        return Object.prototype.hasOwnProperty.call(e, n);
      }, n.p = "", n(n.s = 30);
    }([function (e, n, a) {
      "use strict";

      var r = this && this.__assign || function () {
        return (r = Object.assign || function (e) {
          for (var n, t = 1, a = arguments.length; t < a; t++) {
            for (var r in n = arguments[t]) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          o = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      },
          i = this && this.__read || function (e, n) {
        var t = "function" == typeof Symbol && e[Symbol.iterator];
        if (!t) return e;
        var a,
            r,
            o = t.call(e),
            d = [];

        try {
          for (; (void 0 === n || n-- > 0) && !(a = o.next()).done;) {
            d.push(a.value);
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            a && !a.done && (t = o.return) && t.call(o);
          } finally {
            if (r) throw r.error;
          }
        }

        return d;
      },
          c = this && this.__spread || function () {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e = e.concat(i(arguments[n]));
        }

        return e;
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var s = a(1),
          l = a(8),
          m = a(18),
          p = function () {
        function t(e, n, t) {
          this.componentId = e, this.componentName = n, this.classId = t;
        }

        return t = o([l.EventConstructor()], t);
      }();

      n.DisposableComponentCreated = p;

      var x = function () {
        function t(e) {
          this.componentId = e;
        }

        return t = o([l.EventConstructor()], t);
      }();

      n.DisposableComponentRemoved = x;

      var k = function () {
        function t(e, n) {
          this.componentId = e, this.component = n;
        }

        return t = o([l.EventConstructor()], t);
      }();

      function d(e, n) {
        return function (t) {
          if (t.isComponent) throw new TypeError("You cannot extend a component. Trying to extend " + t.originalClassName + " with: " + e);
          if ("number" != typeof n || isNaN(n)) throw new Error("classId: " + n + " is an invalid integer");

          var a = t,
              r = function r() {
            if (!d.engine) throw new Error("You need to set a DisposableComponent.engine before creating disposable components");
            var t = Array.prototype.slice.call(arguments),
                r = new (a.bind.apply(a, c([void 0], t)))(),
                o = s.newId("C");
            return Object.defineProperty(r, "__name__symbol_", {
              enumerable: !1,
              writable: !1,
              configurable: !1,
              value: e
            }), Object.defineProperty(r, "__component__id_", {
              enumerable: !1,
              writable: !1,
              configurable: !1,
              value: o
            }), void 0 !== n && Object.defineProperty(r, "__classId__symbol_", {
              enumerable: !1,
              writable: !1,
              configurable: !1,
              value: n
            }), d.engine && d.engine.registerComponent(r), r;
          };

          return void 0 !== n && (r.__classId__symbol_ = n), r.__name__symbol_ = e, r.isComponent = !0, r.isDisposableComponent = !0, r.originalClassName = e, (r.prototype = t.prototype).constructor = t, r;
        };
      }

      function f(e) {
        if (!e) throw new TypeError(e + " is not a component.");
        if (e.__component__id_) return e.__component__id_;
        throw new TypeError(e + " is not a registered disposable component.");
      }

      n.DisposableComponentUpdated = k, n.Component = function (e, n) {
        return function (t) {
          if (t.isComponent) throw new TypeError("You cannot extend a component. Trying to extend " + t.originalClassName + " with: " + e);

          var a = t,
              r = function r() {
            var t = Array.prototype.slice.call(arguments),
                r = new (a.bind.apply(a, c([void 0], t)))();
            return Object.defineProperty(r, "__name__symbol_", {
              enumerable: !1,
              writable: !1,
              configurable: !1,
              value: e
            }), void 0 !== n && Object.defineProperty(r, "__classId__symbol_", {
              enumerable: !1,
              writable: !1,
              configurable: !1,
              value: n
            }), r;
          };

          return void 0 !== n && (r.__classId__symbol_ = n), r.__name__symbol_ = e, r.isComponent = !0, r.originalClassName = e, (r.prototype = t.prototype).constructor = t, r;
        };
      }, n.DisposableComponent = d, function (e) {
        e.engine = null;
      }(d = n.DisposableComponent || (n.DisposableComponent = {})), n.getComponentName = function (e) {
        if (!e) throw new TypeError(e + " is not a component.");
        if (e.__name__symbol_) return e.__name__symbol_;
        throw new TypeError(e + " is not a registered component.");
      }, n.getComponentClassId = function (e) {
        if (!e) throw new TypeError(e + " is not a component.");
        if (e.__classId__symbol_) return e.__classId__symbol_;
        if (!e.__name__symbol_) throw new TypeError(e + " is not a registered component.");
        return null;
      }, n.getComponentId = f;

      var u = function () {
        function t() {
          this.dirty = !1, this.data = {}, this.subscriptions = [];
        }

        return t.component = function (e, n) {
          if (delete e[n]) {
            var t = n + "_" + Math.random();
            e[t] = void 0, Object.defineProperty(e, t, r(r({}, Object.getOwnPropertyDescriptor(e, t)), {
              enumerable: !1
            })), Object.defineProperty(e, n.toString(), {
              get: function get() {
                return this[t];
              },
              set: function set(e) {
                var a = this[t];

                if (this.data[n] = e ? f(e) : null, this[t] = e, e !== a) {
                  this.dirty = !0;

                  for (var r = 0; r < this.subscriptions.length; r++) {
                    this.subscriptions[r](n, e, a);
                  }
                }
              },
              enumerable: !0
            });
          }
        }, t.field = function (e, n) {
          delete e[n] && Object.defineProperty(e, n.toString(), {
            get: function get() {
              return this.data[n];
            },
            set: function set(e) {
              var t = this.data[n];

              if (this.data[n] = e, e !== t) {
                this.dirty = !0;

                for (var a = 0; a < this.subscriptions.length; a++) {
                  this.subscriptions[a](n, e, t);
                }
              }
            },
            enumerable: !0
          });
        }, t.uiValue = function (e, n) {
          delete e[n] && Object.defineProperty(e, n.toString(), {
            get: function get() {
              return this.data[n].toString();
            },
            set: function set(e) {
              var t = this.data[n],
                  a = new m.UIValue(e);

              if (this.data[n] = a, a !== t) {
                this.dirty = !0;

                for (var r = 0; r < this.subscriptions.length; r++) {
                  this.subscriptions[r](n, a, t);
                }
              }
            },
            enumerable: !0
          });
        }, t.readonly = function (e, n) {
          delete e[n] && Object.defineProperty(e, n.toString(), {
            get: function get() {
              if (n in this.data == !1) throw new Error("The field " + n + " is uninitialized");
              return this.data[n];
            },
            set: function set(e) {
              if (n in this.data) throw new Error("The field " + n + " is readonly");
              this.data[n] = e, this.dirty = !0;
            },
            enumerable: !0,
            configurable: !1
          });
        }, t.prototype.onChange = function (e) {
          return this.subscriptions.push(e), this;
        }, t.prototype.toJSON = function () {
          return this.data;
        }, t;
      }();

      n.ObservableComponent = u, n.isDisposableComponent = function (e) {
        return "__component__id_" in e;
      };
    }, function (e, n, t) {
      "use strict";

      var a = this && this.__read || function (e, n) {
        var t = "function" == typeof Symbol && e[Symbol.iterator];
        if (!t) return e;
        var a,
            r,
            o = t.call(e),
            d = [];

        try {
          for (; (void 0 === n || n-- > 0) && !(a = o.next()).done;) {
            d.push(a.value);
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            a && !a.done && (t = o.return) && t.call(o);
          } finally {
            if (r) throw r.error;
          }
        }

        return d;
      },
          r = this && this.__spread || function () {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e = e.concat(a(arguments[n]));
        }

        return e;
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var o = 0;
      n.log = function () {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        "undefined" != typeof dcl ? dcl.log.apply(dcl, r(e)) : console.log.apply(console, r(["DEBUG:"], e));
      }, n.error = function (e, n) {
        "undefined" != typeof dcl ? dcl.error(e, n) : console.error("ERROR:", e, n);
      }, n.newId = function (e) {
        if (o++, 0 === e.length) throw new Error("newId(type: string): type cannot be empty");
        return e + o.toString(36);
      }, n.uuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
          var n = 16 * Math.random() | 0;
          return ("x" === e ? n : 3 & n | 8).toString(16);
        });
      }, n.buildArray = function (e, n) {
        for (var t = [], a = 0; a < e; ++a) {
          t.push(n());
        }

        return t;
      }, n.openExternalURL = function (e) {
        "undefined" != typeof dcl ? dcl.openExternalUrl(e) : console.error("ERROR: openExternalURL dcl is undefined");
      }, n.openNFTDialog = function (e, n) {
        if (void 0 === n && (n = null), "undefined" != typeof dcl) {
          var t = e.match(/ethereum:\/\/(.+)\/(.+)/);
          if (!t || t.length < 3) return;
          dcl.openNFTDialog(t[1], t[2], n);
        } else console.error("ERROR: openNFTDialog dcl is undefined");
      };
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      }), function (e) {
        e[e.CW = 0] = "CW", e[e.CCW = 1] = "CCW";
      }(n.Orientation || (n.Orientation = {})), function (e) {
        e[e.LOCAL = 0] = "LOCAL", e[e.WORLD = 1] = "WORLD", e[e.BONE = 2] = "BONE";
      }(n.Space || (n.Space = {})), n.ToGammaSpace = 1 / 2.2, n.ToLinearSpace = 2.2, n.Epsilon = 1e-6, n.DEG2RAD = Math.PI / 180, n.RAD2DEG = 360 / (2 * Math.PI);
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(9),
          o = a(2),
          d = a(10),
          i = a(6),
          c = function () {
        function t(e, n, t) {
          void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === t && (t = 0), this.x = e, this.y = n, this.z = t;
        }

        return Object.defineProperty(t.prototype, "isNonUniform", {
          get: function get() {
            var e = Math.abs(this.x),
                n = Math.abs(this.y);
            if (e !== n) return !0;
            var t = Math.abs(this.z);
            return e !== t || n !== t;
          },
          enumerable: !0,
          configurable: !0
        }), t.Add = function (e, n) {
          return new t(e.x, e.y, e.z).addInPlace(n);
        }, t.GetClipFactor = function (e, n, a, r) {
          var o = t.Dot(e, a) - r;
          return o / (o - (t.Dot(n, a) - r));
        }, t.GetAngleBetweenVectors = function (e, n, a) {
          var o = e.normalizeToRef(r.MathTmp.Vector3[1]),
              d = n.normalizeToRef(r.MathTmp.Vector3[2]),
              i = t.Dot(o, d),
              c = r.MathTmp.Vector3[3];
          return t.CrossToRef(o, d, c), t.Dot(c, a) > 0 ? Math.acos(i) : -Math.acos(i);
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1], e[n + 2]);
        }, t.FromFloatArray = function (e, n) {
          return t.FromArray(e, n);
        }, t.FromArrayToRef = function (e, n, t) {
          t.x = e[n], t.y = e[n + 1], t.z = e[n + 2];
        }, t.FromFloatArrayToRef = function (e, n, a) {
          return t.FromArrayToRef(e, n, a);
        }, t.FromFloatsToRef = function (e, n, t, a) {
          a.copyFromFloats(e, n, t);
        }, t.Zero = function () {
          return new t(0, 0, 0);
        }, t.One = function () {
          return new t(1, 1, 1);
        }, t.Up = function () {
          return new t(0, 1, 0);
        }, t.Down = function () {
          return new t(0, -1, 0);
        }, t.Forward = function () {
          return new t(0, 0, 1);
        }, t.Backward = function () {
          return new t(0, 0, -1);
        }, t.Right = function () {
          return new t(1, 0, 0);
        }, t.Left = function () {
          return new t(-1, 0, 0);
        }, t.TransformCoordinates = function (e, n) {
          var a = t.Zero();
          return t.TransformCoordinatesToRef(e, n, a), a;
        }, t.TransformCoordinatesToRef = function (e, n, a) {
          return t.TransformCoordinatesFromFloatsToRef(e.x, e.y, e.z, n, a);
        }, t.TransformCoordinatesFromFloatsToRef = function (e, n, t, a, r) {
          var o = a.m,
              d = e * o[0] + n * o[4] + t * o[8] + o[12],
              i = e * o[1] + n * o[5] + t * o[9] + o[13],
              c = e * o[2] + n * o[6] + t * o[10] + o[14],
              s = 1 / (e * o[3] + n * o[7] + t * o[11] + o[15]);
          r.x = d * s, r.y = i * s, r.z = c * s;
        }, t.TransformNormal = function (e, n) {
          var a = t.Zero();
          return t.TransformNormalToRef(e, n, a), a;
        }, t.TransformNormalToRef = function (e, n, t) {
          this.TransformNormalFromFloatsToRef(e.x, e.y, e.z, n, t);
        }, t.TransformNormalFromFloatsToRef = function (e, n, t, a, r) {
          var o = a.m;
          r.x = e * o[0] + n * o[4] + t * o[8], r.y = e * o[1] + n * o[5] + t * o[9], r.z = e * o[2] + n * o[6] + t * o[10];
        }, t.CatmullRom = function (e, n, a, r, o) {
          var d = o * o,
              i = o * d;
          return new t(.5 * (2 * n.x + (-e.x + a.x) * o + (2 * e.x - 5 * n.x + 4 * a.x - r.x) * d + (-e.x + 3 * n.x - 3 * a.x + r.x) * i), .5 * (2 * n.y + (-e.y + a.y) * o + (2 * e.y - 5 * n.y + 4 * a.y - r.y) * d + (-e.y + 3 * n.y - 3 * a.y + r.y) * i), .5 * (2 * n.z + (-e.z + a.z) * o + (2 * e.z - 5 * n.z + 4 * a.z - r.z) * d + (-e.z + 3 * n.z - 3 * a.z + r.z) * i));
        }, t.Clamp = function (e, n, a) {
          var r = new t();
          return t.ClampToRef(e, n, a, r), r;
        }, t.ClampToRef = function (e, n, t, a) {
          var r = e.x;
          r = (r = r > t.x ? t.x : r) < n.x ? n.x : r;
          var o = e.y;
          o = (o = o > t.y ? t.y : o) < n.y ? n.y : o;
          var d = e.z;
          d = (d = d > t.z ? t.z : d) < n.z ? n.z : d, a.copyFromFloats(r, o, d);
        }, t.Hermite = function (e, n, a, r, o) {
          var d = o * o,
              i = o * d,
              c = 2 * i - 3 * d + 1,
              s = -2 * i + 3 * d,
              l = i - 2 * d + o,
              m = i - d;
          return new t(e.x * c + a.x * s + n.x * l + r.x * m, e.y * c + a.y * s + n.y * l + r.y * m, e.z * c + a.z * s + n.z * l + r.z * m);
        }, t.Lerp = function (e, n, a) {
          var r = new t(0, 0, 0);
          return t.LerpToRef(e, n, a, r), r;
        }, t.LerpToRef = function (e, n, t, a) {
          a.x = e.x + (n.x - e.x) * t, a.y = e.y + (n.y - e.y) * t, a.z = e.z + (n.z - e.z) * t;
        }, t.Dot = function (e, n) {
          return e.x * n.x + e.y * n.y + e.z * n.z;
        }, t.Cross = function (e, n) {
          var a = t.Zero();
          return t.CrossToRef(e, n, a), a;
        }, t.CrossToRef = function (e, n, t) {
          var a = e.y * n.z - e.z * n.y,
              r = e.z * n.x - e.x * n.z,
              o = e.x * n.y - e.y * n.x;
          t.copyFromFloats(a, r, o);
        }, t.Normalize = function (e) {
          var n = t.Zero();
          return t.NormalizeToRef(e, n), n;
        }, t.NormalizeToRef = function (e, n) {
          e.normalizeToRef(n);
        }, t.Minimize = function (e, n) {
          var a = new t(e.x, e.y, e.z);
          return a.minimizeInPlace(n), a;
        }, t.Maximize = function (e, n) {
          var a = new t(e.x, e.y, e.z);
          return a.maximizeInPlace(n), a;
        }, t.Distance = function (e, n) {
          return Math.sqrt(t.DistanceSquared(e, n));
        }, t.DistanceSquared = function (e, n) {
          var t = e.x - n.x,
              a = e.y - n.y,
              r = e.z - n.z;
          return t * t + a * a + r * r;
        }, t.Center = function (e, n) {
          var a = t.Add(e, n);
          return a.scaleInPlace(.5), a;
        }, t.RotationFromAxis = function (e, n, a) {
          var r = t.Zero();
          return t.RotationFromAxisToRef(e, n, a, r), r;
        }, t.RotationFromAxisToRef = function (e, n, t, a) {
          var o = r.MathTmp.Quaternion[0];
          d.Quaternion.RotationQuaternionFromAxisToRef(e, n, t, o), a.copyFrom(o.eulerAngles);
        }, t.prototype.toString = function () {
          return "(" + this.x + ", " + this.y + ", " + this.z + ")";
        }, t.prototype.getClassName = function () {
          return "Vector3";
        }, t.prototype.getHashCode = function () {
          var e = this.x || 0;
          return e = 397 * (e = 397 * e ^ (this.y || 0)) ^ (this.z || 0);
        }, t.prototype.asArray = function () {
          var e = [];
          return this.toArray(e, 0), e;
        }, t.prototype.toArray = function (e, n) {
          return void 0 === n && (n = 0), e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, this;
        }, t.prototype.toQuaternion = function () {
          return d.Quaternion.Identity.setEuler(this.y, this.x, this.z);
        }, t.prototype.addInPlace = function (e) {
          return this.addInPlaceFromFloats(e.x, e.y, e.z);
        }, t.prototype.addInPlaceFromFloats = function (e, n, t) {
          return this.x += e, this.y += n, this.z += t, this;
        }, t.prototype.add = function (e) {
          return new t(this.x + e.x, this.y + e.y, this.z + e.z);
        }, t.prototype.addToRef = function (e, n) {
          return n.copyFromFloats(this.x + e.x, this.y + e.y, this.z + e.z);
        }, t.prototype.subtractInPlace = function (e) {
          return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
        }, t.prototype.subtract = function (e) {
          return new t(this.x - e.x, this.y - e.y, this.z - e.z);
        }, t.prototype.subtractToRef = function (e, n) {
          return this.subtractFromFloatsToRef(e.x, e.y, e.z, n);
        }, t.prototype.subtractFromFloats = function (e, n, a) {
          return new t(this.x - e, this.y - n, this.z - a);
        }, t.prototype.subtractFromFloatsToRef = function (e, n, t, a) {
          return a.copyFromFloats(this.x - e, this.y - n, this.z - t);
        }, t.prototype.applyMatrix4 = function (e) {
          this.applyMatrix4ToRef(e, this);
        }, t.prototype.applyMatrix4ToRef = function (e, n) {
          var t = this.x,
              a = this.y,
              r = this.z,
              o = e.m,
              d = 1 / (o[3] * t + o[7] * a + o[11] * r + o[15]);
          return n.x = (o[0] * t + o[4] * a + o[8] * r + o[12]) * d, n.y = (o[1] * t + o[5] * a + o[9] * r + o[13]) * d, n.z = (o[2] * t + o[6] * a + o[10] * r + o[14]) * d, n;
        }, t.prototype.rotate = function (e) {
          return this.rotateToRef(e, this);
        }, t.prototype.rotateToRef = function (e, n) {
          var t = this.x,
              a = this.y,
              r = this.z,
              o = e.x,
              d = e.y,
              i = e.z,
              c = e.w,
              s = c * t + d * r - i * a,
              l = c * a + i * t - o * r,
              m = c * r + o * a - d * t,
              p = -o * t - d * a - i * r;
          return n.x = s * c + p * -o + l * -i - m * -d, n.y = l * c + p * -d + m * -o - s * -i, n.z = m * c + p * -i + s * -d - l * -o, n;
        }, t.prototype.negate = function () {
          return new t(-this.x, -this.y, -this.z);
        }, t.prototype.scaleInPlace = function (e) {
          return this.x *= e, this.y *= e, this.z *= e, this;
        }, t.prototype.scale = function (e) {
          return new t(this.x * e, this.y * e, this.z * e);
        }, t.prototype.scaleToRef = function (e, n) {
          return n.copyFromFloats(this.x * e, this.y * e, this.z * e);
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.addInPlaceFromFloats(this.x * e, this.y * e, this.z * e);
        }, t.prototype.equals = function (e) {
          return e && this.x === e.x && this.y === e.y && this.z === e.z;
        }, t.prototype.equalsWithEpsilon = function (e, n) {
          return void 0 === n && (n = o.Epsilon), e && i.Scalar.WithinEpsilon(this.x, e.x, n) && i.Scalar.WithinEpsilon(this.y, e.y, n) && i.Scalar.WithinEpsilon(this.z, e.z, n);
        }, t.prototype.equalsToFloats = function (e, n, t) {
          return this.x === e && this.y === n && this.z === t;
        }, t.prototype.multiplyInPlace = function (e) {
          return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
        }, t.prototype.multiply = function (e) {
          return this.multiplyByFloats(e.x, e.y, e.z);
        }, t.prototype.multiplyToRef = function (e, n) {
          return n.copyFromFloats(this.x * e.x, this.y * e.y, this.z * e.z);
        }, t.prototype.multiplyByFloats = function (e, n, a) {
          return new t(this.x * e, this.y * n, this.z * a);
        }, t.prototype.divide = function (e) {
          return new t(this.x / e.x, this.y / e.y, this.z / e.z);
        }, t.prototype.divideToRef = function (e, n) {
          return n.copyFromFloats(this.x / e.x, this.y / e.y, this.z / e.z);
        }, t.prototype.divideInPlace = function (e) {
          return this.divideToRef(e, this);
        }, t.prototype.minimizeInPlace = function (e) {
          return this.minimizeInPlaceFromFloats(e.x, e.y, e.z);
        }, t.prototype.maximizeInPlace = function (e) {
          return this.maximizeInPlaceFromFloats(e.x, e.y, e.z);
        }, t.prototype.minimizeInPlaceFromFloats = function (e, n, t) {
          return e < this.x && (this.x = e), n < this.y && (this.y = n), t < this.z && (this.z = t), this;
        }, t.prototype.maximizeInPlaceFromFloats = function (e, n, t) {
          return e > this.x && (this.x = e), n > this.y && (this.y = n), t > this.z && (this.z = t), this;
        }, t.prototype.floor = function () {
          return new t(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z));
        }, t.prototype.fract = function () {
          return new t(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z));
        }, t.prototype.length = function () {
          return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }, t.prototype.lengthSquared = function () {
          return this.x * this.x + this.y * this.y + this.z * this.z;
        }, t.prototype.normalize = function () {
          return this.normalizeFromLength(this.length());
        }, t.prototype.normalizeFromLength = function (e) {
          return 0 === e || 1 === e ? this : this.scaleInPlace(1 / e);
        }, t.prototype.normalizeToNew = function () {
          var e = new t(0, 0, 0);
          return this.normalizeToRef(e), e;
        }, t.prototype.normalizeToRef = function (e) {
          var n = this.length();
          return 0 === n || 1 === n ? e.copyFromFloats(this.x, this.y, this.z) : this.scaleToRef(1 / n, e);
        }, t.prototype.clone = function () {
          return new t(this.x, this.y, this.z);
        }, t.prototype.copyFrom = function (e) {
          return this.copyFromFloats(e.x, e.y, e.z);
        }, t.prototype.copyFromFloats = function (e, n, t) {
          return this.x = e, this.y = n, this.z = t, this;
        }, t.prototype.set = function (e, n, t) {
          return this.copyFromFloats(e, n, t);
        }, t.prototype.setAll = function (e) {
          return this.x = this.y = this.z = e, this;
        }, t;
      }();

      n.Vector3 = c;
    }, function (t, a, r) {
      "use strict";

      var _o3,
          d = this && this.__extends || (_o3 = function o(e, n) {
        return (_o3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var n, t = 1, a = arguments.length; t < a; t++) {
            for (var r in n = arguments[t]) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          c = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });
      var s,
          l = r(0),
          m = r(5),
          p = r(26),
          x = r(1),
          k = r(16);
      !function (e) {
        e[e.TRANSFORM = 1] = "TRANSFORM", e[e.UUID_CALLBACK = 8] = "UUID_CALLBACK", e[e.BOX_SHAPE = 16] = "BOX_SHAPE", e[e.SPHERE_SHAPE = 17] = "SPHERE_SHAPE", e[e.PLANE_SHAPE = 18] = "PLANE_SHAPE", e[e.CONE_SHAPE = 19] = "CONE_SHAPE", e[e.CYLINDER_SHAPE = 20] = "CYLINDER_SHAPE", e[e.TEXT_SHAPE = 21] = "TEXT_SHAPE", e[e.NFT_SHAPE = 22] = "NFT_SHAPE", e[e.UI_WORLD_SPACE_SHAPE = 23] = "UI_WORLD_SPACE_SHAPE", e[e.UI_SCREEN_SPACE_SHAPE = 24] = "UI_SCREEN_SPACE_SHAPE", e[e.UI_CONTAINER_RECT = 25] = "UI_CONTAINER_RECT", e[e.UI_CONTAINER_STACK = 26] = "UI_CONTAINER_STACK", e[e.UI_TEXT_SHAPE = 27] = "UI_TEXT_SHAPE", e[e.UI_INPUT_TEXT_SHAPE = 28] = "UI_INPUT_TEXT_SHAPE", e[e.UI_IMAGE_SHAPE = 29] = "UI_IMAGE_SHAPE", e[e.UI_SLIDER_SHAPE = 30] = "UI_SLIDER_SHAPE", e[e.CIRCLE_SHAPE = 31] = "CIRCLE_SHAPE", e[e.BILLBOARD = 32] = "BILLBOARD", e[e.ANIMATION = 33] = "ANIMATION", e[e.FONT = 34] = "FONT", e[e.UI_FULLSCREEN_SHAPE = 40] = "UI_FULLSCREEN_SHAPE", e[e.UI_BUTTON_SHAPE = 41] = "UI_BUTTON_SHAPE", e[e.GLTF_SHAPE = 54] = "GLTF_SHAPE", e[e.OBJ_SHAPE = 55] = "OBJ_SHAPE", e[e.AVATAR_SHAPE = 56] = "AVATAR_SHAPE", e[e.BASIC_MATERIAL = 64] = "BASIC_MATERIAL", e[e.PBR_MATERIAL = 65] = "PBR_MATERIAL", e[e.HIGHLIGHT_ENTITY = 66] = "HIGHLIGHT_ENTITY", e[e.SOUND = 67] = "SOUND", e[e.TEXTURE = 68] = "TEXTURE", e[e.VIDEO_CLIP = 70] = "VIDEO_CLIP", e[e.VIDEO_TEXTURE = 71] = "VIDEO_TEXTURE", e[e.AUDIO_CLIP = 200] = "AUDIO_CLIP", e[e.AUDIO_SOURCE = 201] = "AUDIO_SOURCE", e[e.AUDIO_STREAM = 202] = "AUDIO_STREAM", e[e.GIZMOS = 203] = "GIZMOS", e[e.SMART_ITEM = 204] = "SMART_ITEM";
      }(s = a.CLASS_ID || (a.CLASS_ID = {}));

      var u = function (n) {
        function e(e) {
          void 0 === e && (e = {});
          var t = n.call(this) || this;
          return t.position = e.position || m.Vector3.Zero(), t.rotation = e.rotation || m.Quaternion.Identity, t.scale = e.scale || new m.Vector3(1, 1, 1), t;
        }

        return d(e, n), Object.defineProperty(e.prototype, "eulerAngles", {
          get: function get() {
            return this.rotation.eulerAngles;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.lookAt = function (e, n) {
          void 0 === n && (n = m.MathTmp.staticUp);
          var t = new m.Matrix();
          return m.Matrix.LookAtLHToRef(this.position, e, n, t), t.invert(), m.Quaternion.FromRotationMatrixToRef(t, this.rotation), this;
        }, e.prototype.rotate = function (e, n) {
          return this.rotation.multiplyInPlace(this.rotation.angleAxis(n, e)), this;
        }, e.prototype.translate = function (e) {
          return this.position.addInPlace(e), this;
        }, c([l.ObservableComponent.field], e.prototype, "position", void 0), c([l.ObservableComponent.field], e.prototype, "rotation", void 0), c([l.ObservableComponent.field], e.prototype, "scale", void 0), e = c([l.Component("engine.transform", s.TRANSFORM)], e);
      }(l.ObservableComponent);

      a.Transform = u;

      var f = function (n) {
        function e(e, t, a) {
          void 0 === e && (e = !0), void 0 === t && (t = !0), void 0 === a && (a = !0);
          var r = n.call(this) || this;
          return r.x = !0, r.y = !0, r.z = !0, r.x = e, r.y = t, r.z = a, r;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "x", void 0), c([l.ObservableComponent.field], e.prototype, "y", void 0), c([l.ObservableComponent.field], e.prototype, "z", void 0), e = c([l.Component("engine.billboard", s.BILLBOARD)], e);
      }(l.ObservableComponent);

      a.Billboard = f;

      var T = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.withCollisions = !0, e.isPointerBlocker = !0, e.visible = !0, e;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "withCollisions", void 0), c([l.ObservableComponent.field], e.prototype, "isPointerBlocker", void 0), c([l.ObservableComponent.field], e.prototype, "visible", void 0), e;
      }(l.ObservableComponent);

      a.Shape = T;

      var C = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return d(e, n), e = c([l.DisposableComponent("engine.shape", s.BOX_SHAPE)], e);
      }(T);

      a.BoxShape = C;

      var R = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return d(e, n), e = c([l.DisposableComponent("engine.shape", s.SPHERE_SHAPE)], e);
      }(T);

      a.SphereShape = R;

      var y = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "segments", void 0), c([l.ObservableComponent.field], e.prototype, "arc", void 0), e = c([l.DisposableComponent("engine.shape", s.CIRCLE_SHAPE)], e);
      }(T);

      a.CircleShape = y;

      var h = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.width = 1, e.height = 1, e;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "width", void 0), c([l.ObservableComponent.field], e.prototype, "height", void 0), c([l.ObservableComponent.field], e.prototype, "uvs", void 0), e = c([l.DisposableComponent("engine.shape", s.PLANE_SHAPE)], e);
      }(T);

      a.PlaneShape = h;

      var g = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.radiusTop = 0, e.radiusBottom = 1, e.segmentsHeight = 1, e.segmentsRadial = 36, e.openEnded = !1, e.radius = null, e.arc = 360, e;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "radiusTop", void 0), c([l.ObservableComponent.field], e.prototype, "radiusBottom", void 0), c([l.ObservableComponent.field], e.prototype, "segmentsHeight", void 0), c([l.ObservableComponent.field], e.prototype, "segmentsRadial", void 0), c([l.ObservableComponent.field], e.prototype, "openEnded", void 0), c([l.ObservableComponent.field], e.prototype, "radius", void 0), c([l.ObservableComponent.field], e.prototype, "arc", void 0), e = c([l.DisposableComponent("engine.shape", s.CONE_SHAPE)], e);
      }(T);

      a.ConeShape = g;

      var I = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.radiusTop = 0, e.radiusBottom = 1, e.segmentsHeight = 1, e.segmentsRadial = 36, e.openEnded = !1, e.radius = null, e.arc = 360, e;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "radiusTop", void 0), c([l.ObservableComponent.field], e.prototype, "radiusBottom", void 0), c([l.ObservableComponent.field], e.prototype, "segmentsHeight", void 0), c([l.ObservableComponent.field], e.prototype, "segmentsRadial", void 0), c([l.ObservableComponent.field], e.prototype, "openEnded", void 0), c([l.ObservableComponent.field], e.prototype, "radius", void 0), c([l.ObservableComponent.field], e.prototype, "arc", void 0), e = c([l.DisposableComponent("engine.shape", s.CYLINDER_SHAPE)], e);
      }(T);

      a.CylinderShape = I;

      var b,
          v = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.src = e, t;
        }

        return d(e, n), c([T.readonly], e.prototype, "src", void 0), e = c([l.DisposableComponent("engine.shape", s.GLTF_SHAPE)], e);
      }(T);

      a.GLTFShape = v, function (e) {
        e[e.Classic = 0] = "Classic", e[e.Baroque_Ornament = 1] = "Baroque_Ornament", e[e.Diamond_Ornament = 2] = "Diamond_Ornament", e[e.Minimal_Wide = 3] = "Minimal_Wide", e[e.Minimal_Grey = 4] = "Minimal_Grey", e[e.Blocky = 5] = "Blocky", e[e.Gold_Edges = 6] = "Gold_Edges", e[e.Gold_Carved = 7] = "Gold_Carved", e[e.Gold_Wide = 8] = "Gold_Wide", e[e.Gold_Rounded = 9] = "Gold_Rounded", e[e.Metal_Medium = 10] = "Metal_Medium", e[e.Metal_Wide = 11] = "Metal_Wide", e[e.Metal_Slim = 12] = "Metal_Slim", e[e.Metal_Rounded = 13] = "Metal_Rounded", e[e.Pins = 14] = "Pins", e[e.Minimal_Black = 15] = "Minimal_Black", e[e.Minimal_White = 16] = "Minimal_White", e[e.Tape = 17] = "Tape", e[e.Wood_Slim = 18] = "Wood_Slim", e[e.Wood_Wide = 19] = "Wood_Wide", e[e.Wood_Twigs = 20] = "Wood_Twigs", e[e.Canvas = 21] = "Canvas";
      }(b = a.PictureFrameStyle || (a.PictureFrameStyle = {}));

      var P = function (n) {
        function e(e, t) {
          void 0 === t && (t = {});
          var a = n.call(this) || this;
          a.src = e;
          var r = new m.Color3(.6404918, .611472, .8584906),
              o = b.Classic;
          return t instanceof m.Color3 ? r = t : null != t && (t.color && (r = t.color), t.style && (o = t.style)), a.color = r, a.style = o, a;
        }

        return d(e, n), c([T.readonly], e.prototype, "src", void 0), c([T.readonly], e.prototype, "style", void 0), c([l.ObservableComponent.field], e.prototype, "color", void 0), e = c([l.DisposableComponent("engine.shape", s.NFT_SHAPE)], e);
      }(T);

      a.NFTShape = P;

      var S = function (n) {
        function e(e, t) {
          var a = n.call(this) || this;
          if (a.src = e, t) for (var r in t) {
            a[r] = t[r];
          }
          return a;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "src", void 0), c([l.ObservableComponent.readonly], e.prototype, "samplingMode", void 0), c([l.ObservableComponent.readonly], e.prototype, "wrap", void 0), c([l.ObservableComponent.readonly], e.prototype, "hasAlpha", void 0), e = c([l.DisposableComponent("engine.texture", s.TEXTURE)], e);
      }(l.ObservableComponent);

      a.Texture = S;

      var w = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.states = [], e;
        }

        return d(e, n), e.prototype.addClip = function (e) {
          var n = this;
          return this.states.push(e), e.onChange(function () {
            n.dirty = !0;
          }), this;
        }, e.prototype.getClip = function (e) {
          for (var n = 0; n < this.states.length; n++) {
            var t = this.states[n];
            if (t.clip === e) return t;
          }

          var a = new p.AnimationState(e);
          return this.addClip(a), a;
        }, c([l.ObservableComponent.readonly], e.prototype, "states", void 0), e = c([l.Component("engine.animator", s.ANIMATION)], e);
      }(T);

      a.Animator = w;

      var V = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.src = e, t;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "src", void 0), e = c([l.DisposableComponent("engine.shape", s.OBJ_SHAPE)], e);
      }(T);

      a.OBJShape = V;

      var M = function (n) {
        function e(e) {
          void 0 === e && (e = "");
          var t = n.call(this) || this;
          return t.src = e, t;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "src", void 0), e = c([l.DisposableComponent("engine.font", s.FONT)], e);
      }(l.ObservableComponent);

      a.Font = M, function (e) {
        e.SanFrancisco = "builtin:SF-UI-Text-Regular SDF", e.SanFrancisco_Heavy = "builtin:SF-UI-Text-Heavy SDF", e.SanFrancisco_Semibold = "builtin:SF-UI-Text-Semibold SDF", e.LiberationSans = "builtin:LiberationSans SDF";
      }(a.Fonts || (a.Fonts = {}));

      var N,
          O = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.outlineWidth = 0, t.outlineColor = new m.Color3(1, 1, 1), t.color = new m.Color3(1, 1, 1), t.fontSize = 10, t.fontWeight = "normal", t.opacity = 1, t.value = "", t.lineSpacing = "0px", t.lineCount = 0, t.resizeToFit = !1, t.textWrapping = !1, t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0, t.shadowColor = new m.Color3(1, 1, 1), t.zIndex = 0, t.hTextAlign = "center", t.vTextAlign = "center", t.width = 1, t.height = 1, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.paddingLeft = 0, t.isPickable = !1, t.billboard = !1, e && (t.value = e), t;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "outlineWidth", void 0), c([l.ObservableComponent.field], e.prototype, "outlineColor", void 0), c([l.ObservableComponent.field], e.prototype, "color", void 0), c([l.ObservableComponent.field], e.prototype, "fontSize", void 0), c([l.ObservableComponent.field], e.prototype, "fontWeight", void 0), c([l.ObservableComponent.component], e.prototype, "font", void 0), c([l.ObservableComponent.field], e.prototype, "opacity", void 0), c([l.ObservableComponent.field], e.prototype, "value", void 0), c([l.ObservableComponent.field], e.prototype, "lineSpacing", void 0), c([l.ObservableComponent.field], e.prototype, "lineCount", void 0), c([l.ObservableComponent.field], e.prototype, "resizeToFit", void 0), c([l.ObservableComponent.field], e.prototype, "textWrapping", void 0), c([l.ObservableComponent.field], e.prototype, "shadowBlur", void 0), c([l.ObservableComponent.field], e.prototype, "shadowOffsetX", void 0), c([l.ObservableComponent.field], e.prototype, "shadowOffsetY", void 0), c([l.ObservableComponent.field], e.prototype, "shadowColor", void 0), c([l.ObservableComponent.field], e.prototype, "zIndex", void 0), c([l.ObservableComponent.field], e.prototype, "hTextAlign", void 0), c([l.ObservableComponent.field], e.prototype, "vTextAlign", void 0), c([l.ObservableComponent.field], e.prototype, "width", void 0), c([l.ObservableComponent.field], e.prototype, "height", void 0), c([l.ObservableComponent.field], e.prototype, "paddingTop", void 0), c([l.ObservableComponent.field], e.prototype, "paddingRight", void 0), c([l.ObservableComponent.field], e.prototype, "paddingBottom", void 0), c([l.ObservableComponent.field], e.prototype, "paddingLeft", void 0), c([l.ObservableComponent.field], e.prototype, "isPickable", void 0), c([l.ObservableComponent.field], e.prototype, "billboard", void 0), e = c([l.Component("engine.text", s.TEXT_SHAPE)], e);
      }(T);

      a.TextShape = O, function (e) {
        e[e.OPAQUE = 0] = "OPAQUE", e[e.ALPHA_TEST = 1] = "ALPHA_TEST", e[e.ALPHA_BLEND = 2] = "ALPHA_BLEND", e[e.ALPHA_TEST_AND_BLEND = 3] = "ALPHA_TEST_AND_BLEND", e[e.AUTO = 4] = "AUTO";
      }(N = a.TransparencyMode || (a.TransparencyMode = {}));

      var E = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.alphaTest = .5, e.transparencyMode = N.AUTO, e;
        }

        return d(e, n), c([l.ObservableComponent.field], e.prototype, "alphaTest", void 0), c([l.ObservableComponent.field], e.prototype, "albedoColor", void 0), c([l.ObservableComponent.field], e.prototype, "emissiveColor", void 0), c([l.ObservableComponent.field], e.prototype, "metallic", void 0), c([l.ObservableComponent.field], e.prototype, "roughness", void 0), c([l.ObservableComponent.field], e.prototype, "ambientColor", void 0), c([l.ObservableComponent.field], e.prototype, "reflectionColor", void 0), c([l.ObservableComponent.field], e.prototype, "reflectivityColor", void 0), c([l.ObservableComponent.field], e.prototype, "directIntensity", void 0), c([l.ObservableComponent.field], e.prototype, "microSurface", void 0), c([l.ObservableComponent.field], e.prototype, "emissiveIntensity", void 0), c([l.ObservableComponent.field], e.prototype, "environmentIntensity", void 0), c([l.ObservableComponent.field], e.prototype, "specularIntensity", void 0), c([l.ObservableComponent.component], e.prototype, "albedoTexture", void 0), c([l.ObservableComponent.component], e.prototype, "alphaTexture", void 0), c([l.ObservableComponent.component], e.prototype, "emissiveTexture", void 0), c([l.ObservableComponent.component], e.prototype, "bumpTexture", void 0), c([l.ObservableComponent.component], e.prototype, "refractionTexture", void 0), c([l.ObservableComponent.field], e.prototype, "disableLighting", void 0), c([l.ObservableComponent.field], e.prototype, "transparencyMode", void 0), e = c([l.DisposableComponent("engine.material", s.PBR_MATERIAL)], e);
      }(l.ObservableComponent);

      a.Material = E;

      var A = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.alphaTest = .5, e;
        }

        return d(e, n), c([l.ObservableComponent.component], e.prototype, "texture", void 0), c([l.ObservableComponent.field], e.prototype, "alphaTest", void 0), e = c([l.DisposableComponent("engine.material", s.BASIC_MATERIAL)], e);
      }(l.ObservableComponent);

      a.BasicMaterial = A;

      var z = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          if (t.uuid = x.newId("UUID"), !e || !("apply" in e) || !("call" in e)) throw new Error("Callback is not a function");
          return t.callback = e, t;
        }

        return d(e, n), e.uuidEvent = function (n, t) {
          if (delete n[t]) {
            var a = t + "_" + Math.random();
            n[a] = void 0, Object.defineProperty(n, a, i(i({}, Object.getOwnPropertyDescriptor(n, a)), {
              enumerable: !1
            })), Object.defineProperty(n, t.toString(), {
              get: function get() {
                return this[a];
              },
              set: function set(n) {
                var r = this[a];

                if (n) {
                  if (!(n instanceof e)) throw new Error("value is not an OnUUIDEvent");
                  this.data[t] = n.uuid;
                } else this.data[t] = null;

                if (this[a] = n, n !== r) {
                  this.dirty = !0;

                  for (var o = 0; o < this.subscriptions.length; o++) {
                    this.subscriptions[o](t, n, r);
                  }
                }
              },
              enumerable: !0
            });
          }
        }, e.prototype.toJSON = function () {
          return {
            uuid: this.uuid,
            type: this.type
          };
        }, c([l.ObservableComponent.field], e.prototype, "callback", void 0), e;
      }(l.ObservableComponent);

      a.OnUUIDEvent = z;

      var _ = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.button = k.ActionButton.ANY, e.hoverText = "Interact", e.distance = 10, e.showFeedback = !0, e;
        }

        return d(e, n), e.prototype.toJSON = function () {
          return {
            uuid: this.uuid,
            type: this.type,
            button: this.button,
            hoverText: this.hoverText,
            distance: this.distance,
            showFeedback: this.showFeedback
          };
        }, c([l.ObservableComponent.field], e.prototype, "button", void 0), c([l.ObservableComponent.field], e.prototype, "hoverText", void 0), c([l.ObservableComponent.field], e.prototype, "distance", void 0), c([l.ObservableComponent.field], e.prototype, "showFeedback", void 0), e;
      }(z);

      a.OnPointerUUIDEvent = _;

      var F = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.type = "onPointerLock", e;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "type", void 0), e = c([l.Component("engine.onPointerLock", s.UUID_CALLBACK)], e);
      }(z);

      a.OnPointerLock = F;

      var D = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.type = "onAnimationEnd", e;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "type", void 0), e = c([l.Component("engine.onAnimationEnd", s.UUID_CALLBACK)], e);
      }(z);

      a.OnAnimationEnd = D;

      var U = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return d(e, n), e = c([l.Component("engine.smartItem", s.SMART_ITEM)], e);
      }(l.ObservableComponent);

      a.SmartItem = U;

      var L = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.url = e, t;
        }

        return d(e, n), c([l.ObservableComponent.readonly], e.prototype, "url", void 0), e = c([l.DisposableComponent("engine.VideoClip", s.VIDEO_CLIP)], e);
      }(l.ObservableComponent);

      a.VideoClip = L;

      var B = function (n) {
        function e(e, t) {
          var a = n.call(this) || this;
          if (a.volume = 1, a.playbackRate = 1, a.loop = !1, a.seek = -1, a.playing = !1, !(e instanceof L)) throw new Error("Trying to create VideoTexture(VideoClip) with an invalid VideoClip");
          if (a.videoClipId = l.getComponentId(e), t) for (var r in t) {
            a[r] = t[r];
          }
          return a;
        }

        return d(e, n), e.prototype.play = function () {
          this.playing = !0;
        }, e.prototype.pause = function () {
          this.playing = !1;
        }, e.prototype.reset = function () {
          this.seekTime(0);
        }, e.prototype.seekTime = function (e) {
          this.seek = e, this.dirty = !0, this.data.nonce = Math.random();
        }, e.prototype.toJSON = function () {
          if (this.seek < 0) return n.prototype.toJSON.call(this);
          var e = JSON.parse(JSON.stringify(n.prototype.toJSON.call(this)));
          return this.seek = -1, e;
        }, c([l.ObservableComponent.readonly], e.prototype, "videoClipId", void 0), c([l.ObservableComponent.readonly], e.prototype, "samplingMode", void 0), c([l.ObservableComponent.readonly], e.prototype, "wrap", void 0), c([l.ObservableComponent.field], e.prototype, "volume", void 0), c([l.ObservableComponent.field], e.prototype, "playbackRate", void 0), c([l.ObservableComponent.field], e.prototype, "loop", void 0), c([l.ObservableComponent.field], e.prototype, "seek", void 0), c([l.ObservableComponent.field], e.prototype, "playing", void 0), e = c([l.DisposableComponent("engine.VideoTexture", s.VIDEO_TEXTURE)], e);
      }(l.ObservableComponent);

      a.VideoTexture = B;
    }, function (e, n, t) {
      "use strict";

      function o(e) {
        for (var t in e) {
          n.hasOwnProperty(t) || (n[t] = e[t]);
        }
      }

      Object.defineProperty(n, "__esModule", {
        value: !0
      }), o(t(2)), o(t(9)), o(t(22)), o(t(23)), o(t(36)), o(t(37)), o(t(38)), o(t(24)), o(t(39)), o(t(40)), o(t(11)), o(t(41)), o(t(42)), o(t(25)), o(t(10)), o(t(6)), o(t(43)), o(t(15)), o(t(3)), o(t(21)), o(t(5));
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = function () {
        function t() {}

        return t.WithinEpsilon = function (e, n, t) {
          void 0 === t && (t = 1.401298e-45);
          var a = e - n;
          return -t <= a && a <= t;
        }, t.ToHex = function (e) {
          var n = e.toString(16);
          return e <= 15 ? ("0" + n).toUpperCase() : n.toUpperCase();
        }, t.Sign = function (e) {
          var n = +e;
          return 0 === n || isNaN(n) ? n : n > 0 ? 1 : -1;
        }, t.Clamp = function (e, n, t) {
          return void 0 === n && (n = 0), void 0 === t && (t = 1), Math.min(t, Math.max(n, e));
        }, t.Log2 = function (e) {
          return Math.log(e) * Math.LOG2E;
        }, t.Repeat = function (e, n) {
          return e - Math.floor(e / n) * n;
        }, t.Normalize = function (e, n, t) {
          return (e - n) / (t - n);
        }, t.Denormalize = function (e, n, t) {
          return e * (t - n) + n;
        }, t.DeltaAngle = function (e, n) {
          var a = t.Repeat(n - e, 360);
          return a > 180 && (a -= 360), a;
        }, t.PingPong = function (e, n) {
          var a = t.Repeat(e, 2 * n);
          return n - Math.abs(a - n);
        }, t.SmoothStep = function (e, n, a) {
          var r = t.Clamp(a);
          return n * (r = -2 * r * r * r + 3 * r * r) + e * (1 - r);
        }, t.MoveTowards = function (e, n, a) {
          return Math.abs(n - e) <= a ? n : e + t.Sign(n - e) * a;
        }, t.MoveTowardsAngle = function (e, n, a) {
          var r = t.DeltaAngle(e, n);
          return -a < r && r < a ? n : t.MoveTowards(e, e + r, a);
        }, t.Lerp = function (e, n, t) {
          return e + (n - e) * t;
        }, t.LerpAngle = function (e, n, a) {
          var r = t.Repeat(n - e, 360);
          return r > 180 && (r -= 360), e + r * t.Clamp(a);
        }, t.InverseLerp = function (e, n, a) {
          return e !== n ? t.Clamp((a - e) / (n - e)) : 0;
        }, t.Hermite = function (e, n, t, a, r) {
          var o = r * r,
              d = r * o;
          return e * (2 * d - 3 * o + 1) + t * (-2 * d + 3 * o) + n * (d - 2 * o + r) + a * (d - o);
        }, t.RandomRange = function (e, n) {
          return e === n ? e : Math.random() * (n - e) + e;
        }, t.RangeToPercent = function (e, n, t) {
          return (e - n) / (t - n);
        }, t.PercentToRange = function (e, n, t) {
          return (t - n) * e + n;
        }, t.NormalizeRadians = function (e) {
          return e - t.TwoPi * Math.floor((e + Math.PI) / t.TwoPi);
        }, t.TwoPi = 2 * Math.PI, t;
      }();

      n.Scalar = a;
    }, function (e, n, a) {
      "use strict";

      var r = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var o = a(8),
          d = function () {
        function t(e, n, t) {
          this.entity = e, this.componentName = n, this.component = t;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.ComponentRemoved = d;

      var i = function () {
        function t(e, n, t) {
          this.entity = e, this.componentName = n, this.classId = t;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.ComponentAdded = i;

      var c = function () {
        function t(e, n) {
          this.entity = e, this.parent = n;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.ParentChanged = c;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = a(1),
          o = [];

      function i(e) {
        if (!("__event_name__" in e) || "string" != typeof e.__event_name__) throw new Error("The EventConstructor is not registered");
        return e.__event_name__;
      }

      var d = function () {
        function t() {
          this.listeners = {};
        }

        return t.prototype.addListener = function (e, n, t) {
          if (!e || "function" != typeof e) throw new Error("Invalid EventConstructor");
          var a = i(e),
              r = this.listeners[a];
          r || (r = this.listeners[a] = []);

          for (var o = 0; o < r.length; o++) {
            if (r[o].listener === n) throw new Error("The provided listener is already registered");
          }

          return r.push({
            listener: n,
            fn: t
          }), this;
        }, t.prototype.removeListener = function (e, n) {
          if (!n || "function" != typeof n) throw new Error("Invalid EventConstructor");
          var t = i(n),
              a = this.listeners[t];
          if (!a) return !1;

          for (var r = 0; r < a.length; r++) {
            if (a[r].listener === e) return a.splice(r, 1), !0;
          }

          return !1;
        }, t.prototype.fireEvent = function (e) {
          var n = i(e.constructor),
              t = this.listeners[n];
          if (t) for (var a = 0; a < t.length; a++) {
            try {
              var o = t[a];
              o.fn.call(o.listener, e);
            } catch (e) {
              r.error(e);
            }
          }
          return this;
        }, t;
      }();

      n.EventManager = d, n.EventConstructor = function () {
        var e = r.newId("EV");
        if (-1 !== o.indexOf(e)) throw new Error("The event name " + e + " is already taken");
        return o.push(e), function (n) {
          return n.__event_name__ = e, n;
        };
      };
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var a = t(1),
          r = t(3),
          o = t(10),
          d = t(11);
      n.MathTmp = {
        Vector3: a.buildArray(6, r.Vector3.Zero),
        Matrix: a.buildArray(2, d.Matrix.Identity),
        Quaternion: a.buildArray(3, o.Quaternion.Zero),
        staticUp: r.Vector3.Up(),
        tmpMatrix: d.Matrix.Zero()
      };
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(11),
          o = a(3),
          d = a(9),
          i = a(2),
          c = function () {
        function t(e, n, t, a) {
          void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === t && (t = 0), void 0 === a && (a = 1), this.x = e, this.y = n, this.z = t, this.w = a;
        }

        return t.FromRotationMatrix = function (e) {
          var n = new t();
          return t.FromRotationMatrixToRef(e, n), n;
        }, t.FromRotationMatrixToRef = function (e, n) {
          var t,
              a = e.m,
              r = a[0],
              o = a[4],
              d = a[8],
              i = a[1],
              c = a[5],
              s = a[9],
              l = a[2],
              m = a[6],
              p = a[10],
              x = r + c + p;
          x > 0 ? (t = .5 / Math.sqrt(x + 1), n.w = .25 / t, n.x = (m - s) * t, n.y = (d - l) * t, n.z = (i - o) * t) : r > c && r > p ? (t = 2 * Math.sqrt(1 + r - c - p), n.w = (m - s) / t, n.x = .25 * t, n.y = (o + i) / t, n.z = (d + l) / t) : c > p ? (t = 2 * Math.sqrt(1 + c - r - p), n.w = (d - l) / t, n.x = (o + i) / t, n.y = .25 * t, n.z = (s + m) / t) : (t = 2 * Math.sqrt(1 + p - r - c), n.w = (i - o) / t, n.x = (d + l) / t, n.y = (s + m) / t, n.z = .25 * t);
        }, t.Dot = function (e, n) {
          return e.x * n.x + e.y * n.y + e.z * n.z + e.w * n.w;
        }, t.AreClose = function (e, n) {
          return t.Dot(e, n) >= 0;
        }, t.Zero = function () {
          return new t(0, 0, 0, 0);
        }, t.Inverse = function (e) {
          return new t(-e.x, -e.y, -e.z, e.w);
        }, t.IsIdentity = function (e) {
          return e && 0 === e.x && 0 === e.y && 0 === e.z && 1 === e.w;
        }, t.RotationAxis = function (e, n) {
          var a = n * i.DEG2RAD;
          return t.RotationAxisToRef(e, a, new t());
        }, t.RotationAxisToRef = function (e, n, t) {
          var a = n * i.DEG2RAD,
              r = Math.sin(a / 2);
          return e.normalize(), t.w = Math.cos(a / 2), t.x = e.x * r, t.y = e.y * r, t.z = e.z * r, t;
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1], e[n + 2], e[n + 3]);
        }, t.FromEulerAnglesRef = function (e, n, a, r) {
          return t.RotationYawPitchRollToRef(n * i.DEG2RAD, e * i.DEG2RAD, a * i.DEG2RAD, r);
        }, t.RotationYawPitchRoll = function (e, n, a) {
          var r = new t();
          return t.RotationYawPitchRollToRef(e, n, a, r), r;
        }, t.RotationYawPitchRollToRef = function (e, n, t, a) {
          var r = .5 * t,
              o = .5 * n,
              d = .5 * e,
              i = Math.cos(o),
              c = Math.cos(d),
              s = Math.cos(r),
              l = Math.sin(o),
              m = Math.sin(d),
              p = Math.sin(r);
          a.x = l * c * s + i * m * p, a.y = i * m * s - l * c * p, a.z = i * c * p + l * m * s, a.w = i * c * s - l * m * p;
        }, t.RotationAlphaBetaGamma = function (e, n, a) {
          var r = new t();
          return t.RotationAlphaBetaGammaToRef(e, n, a, r), r;
        }, t.RotationAlphaBetaGammaToRef = function (e, n, t, a) {
          var r = .5 * (t + e),
              o = .5 * (t - e),
              d = .5 * n;
          a.x = Math.cos(o) * Math.sin(d), a.y = Math.sin(o) * Math.sin(d), a.z = Math.sin(r) * Math.cos(d), a.w = Math.cos(r) * Math.cos(d);
        }, t.RotationQuaternionFromAxis = function (e, n, a) {
          var r = new t(0, 0, 0, 0);
          return t.RotationQuaternionFromAxisToRef(e, n, a, r), r;
        }, t.RotationQuaternionFromAxisToRef = function (e, n, a, o) {
          var i = d.MathTmp.Matrix[0];
          r.Matrix.FromXYZAxesToRef(e.normalize(), n.normalize(), a.normalize(), i), t.FromRotationMatrixToRef(i, o);
        }, t.Slerp = function (e, n, a) {
          var r = t.Identity;
          return t.SlerpToRef(e, n, a, r), r;
        }, t.SlerpToRef = function (e, n, t, a) {
          var r,
              o,
              d = e.x * n.x + e.y * n.y + e.z * n.z + e.w * n.w,
              i = !1;
          if (d < 0 && (i = !0, d = -d), d > .999999) o = 1 - t, r = i ? -t : t;else {
            var c = Math.acos(d),
                s = 1 / Math.sin(c);
            o = Math.sin((1 - t) * c) * s, r = i ? -Math.sin(t * c) * s : Math.sin(t * c) * s;
          }
          a.x = o * e.x + r * n.x, a.y = o * e.y + r * n.y, a.z = o * e.z + r * n.z, a.w = o * e.w + r * n.w;
        }, t.Hermite = function (e, n, a, r, o) {
          var d = o * o,
              i = o * d,
              c = 2 * i - 3 * d + 1,
              s = -2 * i + 3 * d,
              l = i - 2 * d + o,
              m = i - d;
          return new t(e.x * c + a.x * s + n.x * l + r.x * m, e.y * c + a.y * s + n.y * l + r.y * m, e.z * c + a.z * s + n.z * l + r.z * m, e.w * c + a.w * s + n.w * l + r.w * m);
        }, Object.defineProperty(t, "Identity", {
          get: function get() {
            return new t(0, 0, 0, 1);
          },
          enumerable: !0,
          configurable: !0
        }), t.Angle = function (e, n) {
          var a = t.Dot(e, n);
          return 2 * Math.acos(Math.min(Math.abs(a), 1)) * i.RAD2DEG;
        }, t.Euler = function (e, n, a) {
          return t.RotationYawPitchRoll(n * i.DEG2RAD, e * i.DEG2RAD, a * i.DEG2RAD);
        }, t.LookRotation = function (e, n) {
          void 0 === n && (n = d.MathTmp.staticUp);
          var a = o.Vector3.Normalize(e),
              r = o.Vector3.Normalize(o.Vector3.Cross(n, a)),
              i = o.Vector3.Cross(a, r),
              c = r.x,
              s = r.y,
              l = r.z,
              m = i.x,
              p = i.y,
              x = i.z,
              k = a.x,
              u = a.y,
              f = a.z,
              T = c + p + f,
              C = new t();

          if (T > 0) {
            var R = Math.sqrt(T + 1);
            return C.w = .5 * R, R = .5 / R, C.x = (x - u) * R, C.y = (k - l) * R, C.z = (s - m) * R, C;
          }

          if (c >= p && c >= f) {
            var y = Math.sqrt(1 + c - p - f),
                h = .5 / y;
            return C.x = .5 * y, C.y = (s + m) * h, C.z = (l + k) * h, C.w = (x - u) * h, C;
          }

          if (p > f) {
            var g = Math.sqrt(1 + p - c - f),
                I = .5 / g;
            return C.x = (m + s) * I, C.y = .5 * g, C.z = (u + x) * I, C.w = (k - l) * I, C;
          }

          var b = Math.sqrt(1 + f - c - p),
              v = .5 / b;
          return C.x = (k + l) * v, C.y = (u + x) * v, C.z = .5 * b, C.w = (s - m) * v, C;
        }, t.RotateTowards = function (e, n, a) {
          var r = t.Angle(e, n);
          if (0 === r) return n;
          var o = Math.min(1, a / r);
          return t.Slerp(e, n, o);
        }, t.FromToRotation = function (e, n) {
          var a = new t(),
              r = e.normalize(),
              d = n.normalize(),
              c = o.Vector3.Dot(r, d);

          if (c > -1 + i.Epsilon) {
            var s = Math.sqrt(2 * (1 + c)),
                l = 1 / s,
                m = o.Vector3.Cross(r, d).scaleInPlace(l);
            a.set(m.x, m.y, m.z, .5 * s);
          } else {
            if (c > 1 - i.Epsilon) return new t(0, 0, 0, 1);
            var p = o.Vector3.Cross(o.Vector3.Right(), r);
            p.lengthSquared() < i.Epsilon && (p = o.Vector3.Cross(o.Vector3.Forward(), r)), a.set(p.x, p.y, p.z, 0);
          }

          return a.normalize();
        }, Object.defineProperty(t.prototype, "normalized", {
          get: function get() {
            return this.normalize();
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.setFromToRotation = function (e, n, a) {
          void 0 === a && (a = d.MathTmp.staticUp), d.MathTmp.tmpMatrix = r.Matrix.Zero(), r.Matrix.LookAtLHToRef(e, n, a, d.MathTmp.tmpMatrix), d.MathTmp.tmpMatrix.invert(), t.FromRotationMatrixToRef(d.MathTmp.tmpMatrix, this);
        }, Object.defineProperty(t.prototype, "eulerAngles", {
          get: function get() {
            var e = new o.Vector3(),
                n = new r.Matrix();
            this.toRotationMatrix(n);
            var t = r.Matrix.GetAsMatrix3x3(n);
            return e.y = i.RAD2DEG * Math.asin(Math.max(-1, Math.min(1, t[6]))), Math.abs(t[6]) < .99999 ? (e.x = i.RAD2DEG * Math.atan2(-t[7], t[8]), e.z = i.RAD2DEG * Math.atan2(-t[3], t[0])) : (e.x = i.RAD2DEG * Math.atan2(t[5], t[4]), e.z = 0), e;
          },
          set: function set(e) {
            this.setEuler(e.x, e.y, e.z);
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.toString = function () {
          return "(" + this.x + ", " + this.y + ", " + this.z + ", " + this.w + ")";
        }, Object.defineProperty(t.prototype, "length", {
          get: function get() {
            return Math.sqrt(this.lengthSquared);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "lengthSquared", {
          get: function get() {
            return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.getClassName = function () {
          return "Quaternion";
        }, t.prototype.getHashCode = function () {
          var e = this.x || 0;
          return e = 397 * (e = 397 * (e = 397 * e ^ (this.y || 0)) ^ (this.z || 0)) ^ (this.w || 0);
        }, t.prototype.asArray = function () {
          return [this.x, this.y, this.z, this.w];
        }, t.prototype.equals = function (e) {
          return e && this.x === e.x && this.y === e.y && this.z === e.z && this.w === e.w;
        }, t.prototype.clone = function () {
          return new t(this.x, this.y, this.z, this.w);
        }, t.prototype.copyFrom = function (e) {
          return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w, this;
        }, t.prototype.copyFromFloats = function (e, n, t, a) {
          return this.x = e, this.y = n, this.z = t, this.w = a, this;
        }, t.prototype.set = function (e, n, t, a) {
          return this.copyFromFloats(e, n, t, a);
        }, t.prototype.setEuler = function (e, n, a) {
          return t.RotationYawPitchRollToRef(n * i.DEG2RAD, e * i.DEG2RAD, a * i.DEG2RAD, this), this;
        }, t.prototype.add = function (e) {
          return new t(this.x + e.x, this.y + e.y, this.z + e.z, this.w + e.w);
        }, t.prototype.addInPlace = function (e) {
          return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
        }, t.prototype.subtract = function (e) {
          return new t(this.x - e.x, this.y - e.y, this.z - e.z, this.w - e.w);
        }, t.prototype.scale = function (e) {
          return new t(this.x * e, this.y * e, this.z * e, this.w * e);
        }, t.prototype.scaleToRef = function (e, n) {
          return n.x = this.x * e, n.y = this.y * e, n.z = this.z * e, n.w = this.w * e, this;
        }, t.prototype.scaleInPlace = function (e) {
          return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.x += this.x * e, n.y += this.y * e, n.z += this.z * e, n.w += this.w * e, this;
        }, t.prototype.multiply = function (e) {
          var n = new t(0, 0, 0, 1);
          return this.multiplyToRef(e, n), n;
        }, t.prototype.multiplyToRef = function (e, n) {
          var t = this.x * e.w + this.y * e.z - this.z * e.y + this.w * e.x,
              a = -this.x * e.z + this.y * e.w + this.z * e.x + this.w * e.y,
              r = this.x * e.y - this.y * e.x + this.z * e.w + this.w * e.z,
              o = -this.x * e.x - this.y * e.y - this.z * e.z + this.w * e.w;
          return n.copyFromFloats(t, a, r, o), this;
        }, t.prototype.multiplyInPlace = function (e) {
          return this.multiplyToRef(e, this), this;
        }, t.prototype.conjugateToRef = function (e) {
          return e.copyFromFloats(-this.x, -this.y, -this.z, this.w), this;
        }, t.prototype.conjugateInPlace = function () {
          return this.x *= -1, this.y *= -1, this.z *= -1, this;
        }, t.prototype.conjugate = function () {
          return new t(-this.x, -this.y, -this.z, this.w);
        }, t.prototype.normalize = function () {
          var e = 1 / this.length;
          return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
        }, t.prototype.angleAxis = function (e, n) {
          if (0 === n.lengthSquared()) return t.Identity;
          var a = t.Identity,
              r = e * i.DEG2RAD;
          r *= .5;
          var o = n.normalize();
          return o = n.scaleInPlace(Math.sin(r)), a.x = o.x, a.y = o.y, a.z = o.z, a.w = Math.cos(r), a.normalize();
        }, t.prototype.toRotationMatrix = function (e) {
          return r.Matrix.FromQuaternionToRef(this, e), this;
        }, t.prototype.fromRotationMatrix = function (e) {
          return t.FromRotationMatrixToRef(e, this), this;
        }, t;
      }();

      n.Quaternion = c;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(3),
          o = a(10),
          d = a(9),
          i = a(21),
          c = function () {
        function t() {
          this._isIdentity = !1, this._isIdentityDirty = !0, this._isIdentity3x2 = !0, this._isIdentity3x2Dirty = !0, this._m = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this._updateIdentityStatus(!1);
        }

        return Object.defineProperty(t.prototype, "m", {
          get: function get() {
            return this._m;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t, "IdentityReadOnly", {
          get: function get() {
            return t._identityReadOnly;
          },
          enumerable: !0,
          configurable: !0
        }), t.FromArray = function (e, n) {
          void 0 === n && (n = 0);
          var a = new t();
          return t.FromArrayToRef(e, n, a), a;
        }, t.FromArrayToRef = function (e, n, t) {
          for (var a = 0; a < 16; a++) {
            t._m[a] = e[a + n];
          }

          t._markAsUpdated();
        }, t.FromFloatArrayToRefScaled = function (e, n, t, a) {
          for (var r = 0; r < 16; r++) {
            a._m[r] = e[r + n] * t;
          }

          a._markAsUpdated();
        }, t.FromValuesToRef = function (e, n, t, a, r, o, d, i, c, s, l, m, p, x, k, u, f) {
          var T = f._m;
          T[0] = e, T[1] = n, T[2] = t, T[3] = a, T[4] = r, T[5] = o, T[6] = d, T[7] = i, T[8] = c, T[9] = s, T[10] = l, T[11] = m, T[12] = p, T[13] = x, T[14] = k, T[15] = u, f._markAsUpdated();
        }, t.FromValues = function (e, n, a, r, o, d, i, c, s, l, m, p, x, k, u, f) {
          var T = new t(),
              C = T._m;
          return C[0] = e, C[1] = n, C[2] = a, C[3] = r, C[4] = o, C[5] = d, C[6] = i, C[7] = c, C[8] = s, C[9] = l, C[10] = m, C[11] = p, C[12] = x, C[13] = k, C[14] = u, C[15] = f, T._markAsUpdated(), T;
        }, t.Compose = function (e, n, a) {
          var r = new t();
          return t.ComposeToRef(e, n, a, r), r;
        }, t.ComposeToRef = function (e, n, a, r) {
          t.ScalingToRef(e.x, e.y, e.z, d.MathTmp.Matrix[1]), n.toRotationMatrix(d.MathTmp.Matrix[0]), d.MathTmp.Matrix[1].multiplyToRef(d.MathTmp.Matrix[0], r), r.setTranslation(a);
        }, t.Identity = function () {
          var e = t.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
          return e._updateIdentityStatus(!0), e;
        }, t.IdentityToRef = function (e) {
          t.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, e), e._updateIdentityStatus(!0);
        }, t.Zero = function () {
          var e = t.FromValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          return e._updateIdentityStatus(!1), e;
        }, t.RotationX = function (e) {
          var n = new t();
          return t.RotationXToRef(e, n), n;
        }, t.Invert = function (e) {
          var n = new t();
          return e.invertToRef(n), n;
        }, t.RotationXToRef = function (e, n) {
          var a = Math.sin(e),
              r = Math.cos(e);
          t.FromValuesToRef(1, 0, 0, 0, 0, r, a, 0, 0, -a, r, 0, 0, 0, 0, 1, n), n._updateIdentityStatus(1 === r && 0 === a);
        }, t.RotationY = function (e) {
          var n = new t();
          return t.RotationYToRef(e, n), n;
        }, t.RotationYToRef = function (e, n) {
          var a = Math.sin(e),
              r = Math.cos(e);
          t.FromValuesToRef(r, 0, -a, 0, 0, 1, 0, 0, a, 0, r, 0, 0, 0, 0, 1, n), n._updateIdentityStatus(1 === r && 0 === a);
        }, t.RotationZ = function (e) {
          var n = new t();
          return t.RotationZToRef(e, n), n;
        }, t.RotationZToRef = function (e, n) {
          var a = Math.sin(e),
              r = Math.cos(e);
          t.FromValuesToRef(r, a, 0, 0, -a, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, n), n._updateIdentityStatus(1 === r && 0 === a);
        }, t.RotationAxis = function (e, n) {
          var a = new t();
          return t.RotationAxisToRef(e, n, a), a;
        }, t.RotationAxisToRef = function (e, n, t) {
          var a = Math.sin(-n),
              r = Math.cos(-n),
              o = 1 - r;
          e.normalize();
          var d = t._m;
          d[0] = e.x * e.x * o + r, d[1] = e.x * e.y * o - e.z * a, d[2] = e.x * e.z * o + e.y * a, d[3] = 0, d[4] = e.y * e.x * o + e.z * a, d[5] = e.y * e.y * o + r, d[6] = e.y * e.z * o - e.x * a, d[7] = 0, d[8] = e.z * e.x * o - e.y * a, d[9] = e.z * e.y * o + e.x * a, d[10] = e.z * e.z * o + r, d[11] = 0, d[12] = 0, d[13] = 0, d[14] = 0, d[15] = 1, t._markAsUpdated();
        }, t.RotationYawPitchRoll = function (e, n, a) {
          var r = new t();
          return t.RotationYawPitchRollToRef(e, n, a, r), r;
        }, t.RotationYawPitchRollToRef = function (e, n, t, a) {
          o.Quaternion.RotationYawPitchRollToRef(e, n, t, d.MathTmp.Quaternion[0]), d.MathTmp.Quaternion[0].toRotationMatrix(a);
        }, t.Scaling = function (e, n, a) {
          var r = new t();
          return t.ScalingToRef(e, n, a, r), r;
        }, t.ScalingToRef = function (e, n, a, r) {
          t.FromValuesToRef(e, 0, 0, 0, 0, n, 0, 0, 0, 0, a, 0, 0, 0, 0, 1, r), r._updateIdentityStatus(1 === e && 1 === n && 1 === a);
        }, t.Translation = function (e, n, a) {
          var r = new t();
          return t.TranslationToRef(e, n, a, r), r;
        }, t.TranslationToRef = function (e, n, a, r) {
          t.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, e, n, a, 1, r), r._updateIdentityStatus(0 === e && 0 === n && 0 === a);
        }, t.Lerp = function (e, n, a) {
          var r = new t();
          return t.LerpToRef(e, n, a, r), r;
        }, t.LerpToRef = function (e, n, t, a) {
          for (var r = 0; r < 16; r++) {
            a._m[r] = e._m[r] * (1 - t) + n._m[r] * t;
          }

          a._markAsUpdated();
        }, t.DecomposeLerp = function (e, n, a) {
          var r = new t();
          return t.DecomposeLerpToRef(e, n, a, r), r;
        }, t.DecomposeLerpToRef = function (e, n, a, i) {
          var c = d.MathTmp.Vector3[0],
              s = d.MathTmp.Quaternion[0],
              l = d.MathTmp.Vector3[1];
          e.decompose(c, s, l);
          var m = d.MathTmp.Vector3[2],
              p = d.MathTmp.Quaternion[1],
              x = d.MathTmp.Vector3[3];
          n.decompose(m, p, x);
          var k = d.MathTmp.Vector3[4];
          r.Vector3.LerpToRef(c, m, a, k);
          var u = d.MathTmp.Quaternion[2];
          o.Quaternion.SlerpToRef(s, p, a, u);
          var f = d.MathTmp.Vector3[5];
          r.Vector3.LerpToRef(l, x, a, f), t.ComposeToRef(k, u, f, i);
        }, t.LookAtLH = function (e, n, a) {
          var r = new t();
          return t.LookAtLHToRef(e, n, a, r), r;
        }, t.LookAtLHToRef = function (e, n, a, o) {
          var i = d.MathTmp.Vector3[0],
              c = d.MathTmp.Vector3[1],
              s = d.MathTmp.Vector3[2];
          n.subtractToRef(e, s), s.normalize(), r.Vector3.CrossToRef(a, s, i);
          var l = i.lengthSquared();
          0 === l ? i.x = 1 : i.normalizeFromLength(Math.sqrt(l)), r.Vector3.CrossToRef(s, i, c), c.normalize();
          var m = -r.Vector3.Dot(i, e),
              p = -r.Vector3.Dot(c, e),
              x = -r.Vector3.Dot(s, e);
          t.FromValuesToRef(i.x, c.x, s.x, 0, i.y, c.y, s.y, 0, i.z, c.z, s.z, 0, m, p, x, 1, o);
        }, t.LookAtRH = function (e, n, a) {
          var r = new t();
          return t.LookAtRHToRef(e, n, a, r), r;
        }, t.LookAtRHToRef = function (e, n, a, o) {
          var i = d.MathTmp.Vector3[0],
              c = d.MathTmp.Vector3[1],
              s = d.MathTmp.Vector3[2];
          e.subtractToRef(n, s), s.normalize(), r.Vector3.CrossToRef(a, s, i);
          var l = i.lengthSquared();
          0 === l ? i.x = 1 : i.normalizeFromLength(Math.sqrt(l)), r.Vector3.CrossToRef(s, i, c), c.normalize();
          var m = -r.Vector3.Dot(i, e),
              p = -r.Vector3.Dot(c, e),
              x = -r.Vector3.Dot(s, e);
          t.FromValuesToRef(i.x, c.x, s.x, 0, i.y, c.y, s.y, 0, i.z, c.z, s.z, 0, m, p, x, 1, o);
        }, t.OrthoLH = function (e, n, a, r) {
          var o = new t();
          return t.OrthoLHToRef(e, n, a, r, o), o;
        }, t.OrthoLHToRef = function (e, n, a, r, o) {
          var d = 2 / e,
              i = 2 / n,
              c = 2 / (r - a),
              s = -(r + a) / (r - a);
          t.FromValuesToRef(d, 0, 0, 0, 0, i, 0, 0, 0, 0, c, 0, 0, 0, s, 1, o), o._updateIdentityStatus(1 === d && 1 === i && 1 === c && 0 === s);
        }, t.OrthoOffCenterLH = function (e, n, a, r, o, d) {
          var i = new t();
          return t.OrthoOffCenterLHToRef(e, n, a, r, o, d, i), i;
        }, t.OrthoOffCenterLHToRef = function (e, n, a, r, o, d, i) {
          var c = 2 / (n - e),
              s = 2 / (r - a),
              l = 2 / (d - o),
              m = -(d + o) / (d - o),
              p = (e + n) / (e - n),
              x = (r + a) / (a - r);
          t.FromValuesToRef(c, 0, 0, 0, 0, s, 0, 0, 0, 0, l, 0, p, x, m, 1, i), i._markAsUpdated();
        }, t.OrthoOffCenterRH = function (e, n, a, r, o, d) {
          var i = new t();
          return t.OrthoOffCenterRHToRef(e, n, a, r, o, d, i), i;
        }, t.OrthoOffCenterRHToRef = function (e, n, a, r, o, d, i) {
          t.OrthoOffCenterLHToRef(e, n, a, r, o, d, i), i._m[10] *= -1;
        }, t.PerspectiveLH = function (e, n, a, r) {
          var o = new t(),
              d = 2 * a / e,
              i = 2 * a / n,
              c = (r + a) / (r - a),
              s = -2 * r * a / (r - a);
          return t.FromValuesToRef(d, 0, 0, 0, 0, i, 0, 0, 0, 0, c, 1, 0, 0, s, 0, o), o._updateIdentityStatus(!1), o;
        }, t.PerspectiveFovLH = function (e, n, a, r) {
          var o = new t();
          return t.PerspectiveFovLHToRef(e, n, a, r, o), o;
        }, t.PerspectiveFovLHToRef = function (e, n, a, r, o, d) {
          void 0 === d && (d = !0);
          var i = a,
              c = r,
              s = 1 / Math.tan(.5 * e),
              l = d ? s / n : s,
              m = d ? s : s * n,
              p = (c + i) / (c - i),
              x = -2 * c * i / (c - i);
          t.FromValuesToRef(l, 0, 0, 0, 0, m, 0, 0, 0, 0, p, 1, 0, 0, x, 0, o), o._updateIdentityStatus(!1);
        }, t.PerspectiveFovRH = function (e, n, a, r) {
          var o = new t();
          return t.PerspectiveFovRHToRef(e, n, a, r, o), o;
        }, t.PerspectiveFovRHToRef = function (e, n, a, r, o, d) {
          void 0 === d && (d = !0);
          var i = a,
              c = r,
              s = 1 / Math.tan(.5 * e),
              l = d ? s / n : s,
              m = d ? s : s * n,
              p = -(c + i) / (c - i),
              x = -2 * c * i / (c - i);
          t.FromValuesToRef(l, 0, 0, 0, 0, m, 0, 0, 0, 0, p, -1, 0, 0, x, 0, o), o._updateIdentityStatus(!1);
        }, t.PerspectiveFovWebVRToRef = function (e, n, t, a, r) {
          void 0 === r && (r = !1);
          var o = r ? -1 : 1,
              d = Math.tan(e.upDegrees * Math.PI / 180),
              i = Math.tan(e.downDegrees * Math.PI / 180),
              c = Math.tan(e.leftDegrees * Math.PI / 180),
              s = Math.tan(e.rightDegrees * Math.PI / 180),
              l = 2 / (c + s),
              m = 2 / (d + i),
              p = a._m;
          p[0] = l, p[1] = p[2] = p[3] = p[4] = 0, p[5] = m, p[6] = p[7] = 0, p[8] = (c - s) * l * .5, p[9] = -(d - i) * m * .5, p[10] = -t / (n - t), p[11] = 1 * o, p[12] = p[13] = p[15] = 0, p[14] = -2 * t * n / (t - n), a._markAsUpdated();
        }, t.GetAsMatrix2x2 = function (e) {
          return [e._m[0], e._m[1], e._m[4], e._m[5]];
        }, t.GetAsMatrix3x3 = function (e) {
          return [e._m[0], e._m[1], e._m[2], e._m[4], e._m[5], e._m[6], e._m[8], e._m[9], e._m[10]];
        }, t.Transpose = function (e) {
          var n = new t();
          return t.TransposeToRef(e, n), n;
        }, t.TransposeToRef = function (e, n) {
          var t = n._m,
              a = e._m;
          t[0] = a[0], t[1] = a[4], t[2] = a[8], t[3] = a[12], t[4] = a[1], t[5] = a[5], t[6] = a[9], t[7] = a[13], t[8] = a[2], t[9] = a[6], t[10] = a[10], t[11] = a[14], t[12] = a[3], t[13] = a[7], t[14] = a[11], t[15] = a[15], n._updateIdentityStatus(e._isIdentity, e._isIdentityDirty);
        }, t.Reflection = function (e) {
          var n = new t();
          return t.ReflectionToRef(e, n), n;
        }, t.ReflectionToRef = function (e, n) {
          e.normalize();
          var a = e.normal.x,
              r = e.normal.y,
              o = e.normal.z,
              d = -2 * a,
              i = -2 * r,
              c = -2 * o;
          t.FromValuesToRef(d * a + 1, i * a, c * a, 0, d * r, i * r + 1, c * r, 0, d * o, i * o, c * o + 1, 0, d * e.d, i * e.d, c * e.d, 1, n);
        }, t.FromXYZAxesToRef = function (e, n, a, r) {
          t.FromValuesToRef(e.x, e.y, e.z, 0, n.x, n.y, n.z, 0, a.x, a.y, a.z, 0, 0, 0, 0, 1, r);
        }, t.FromQuaternionToRef = function (e, n) {
          var t = e.x * e.x,
              a = e.y * e.y,
              r = e.z * e.z,
              o = e.x * e.y,
              d = e.z * e.w,
              i = e.z * e.x,
              c = e.y * e.w,
              s = e.y * e.z,
              l = e.x * e.w;
          n._m[0] = 1 - 2 * (a + r), n._m[1] = 2 * (o + d), n._m[2] = 2 * (i - c), n._m[3] = 0, n._m[4] = 2 * (o - d), n._m[5] = 1 - 2 * (r + t), n._m[6] = 2 * (s + l), n._m[7] = 0, n._m[8] = 2 * (i + c), n._m[9] = 2 * (s - l), n._m[10] = 1 - 2 * (a + t), n._m[11] = 0, n._m[12] = 0, n._m[13] = 0, n._m[14] = 0, n._m[15] = 1, n._markAsUpdated();
        }, t.prototype._markAsUpdated = function () {
          this.updateFlag = t._updateFlagSeed++, this._isIdentity = !1, this._isIdentity3x2 = !1, this._isIdentityDirty = !0, this._isIdentity3x2Dirty = !0;
        }, t.prototype.isIdentity = function () {
          if (this._isIdentityDirty) {
            this._isIdentityDirty = !1;
            var e = this._m;
            this._isIdentity = 1 === e[0] && 0 === e[1] && 0 === e[2] && 0 === e[3] && 0 === e[4] && 1 === e[5] && 0 === e[6] && 0 === e[7] && 0 === e[8] && 0 === e[9] && 1 === e[10] && 0 === e[11] && 0 === e[12] && 0 === e[13] && 0 === e[14] && 1 === e[15];
          }

          return this._isIdentity;
        }, t.prototype.isIdentityAs3x2 = function () {
          return this._isIdentity3x2Dirty && (this._isIdentity3x2Dirty = !1, 1 !== this._m[0] || 1 !== this._m[5] || 1 !== this._m[15] || 0 !== this._m[1] || 0 !== this._m[2] || 0 !== this._m[3] || 0 !== this._m[4] || 0 !== this._m[6] || 0 !== this._m[7] || 0 !== this._m[8] || 0 !== this._m[9] || 0 !== this._m[10] || 0 !== this._m[11] || 0 !== this._m[12] || 0 !== this._m[13] || 0 !== this._m[14] ? this._isIdentity3x2 = !1 : this._isIdentity3x2 = !0), this._isIdentity3x2;
        }, t.prototype.determinant = function () {
          if (!0 === this._isIdentity) return 1;
          var e = this._m,
              n = e[0],
              t = e[1],
              a = e[2],
              r = e[3],
              o = e[4],
              d = e[5],
              i = e[6],
              c = e[7],
              s = e[8],
              l = e[9],
              m = e[10],
              p = e[11],
              x = e[12],
              k = e[13],
              u = e[14],
              f = e[15],
              T = m * f - u * p,
              C = l * f - k * p,
              R = l * u - k * m,
              y = s * f - x * p,
              h = s * u - m * x,
              g = s * k - x * l;
          return n * +(d * T - i * C + c * R) + t * -(o * T - i * y + c * h) + a * +(o * C - d * y + c * g) + r * -(o * R - d * h + i * g);
        }, t.prototype.toArray = function () {
          return this._m;
        }, t.prototype.asArray = function () {
          return this._m;
        }, t.prototype.invert = function () {
          return this.invertToRef(this), this;
        }, t.prototype.reset = function () {
          return t.FromValuesToRef(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, this), this._updateIdentityStatus(!1), this;
        }, t.prototype.add = function (e) {
          var n = new t();
          return this.addToRef(e, n), n;
        }, t.prototype.addToRef = function (e, n) {
          for (var t = 0; t < 16; t++) {
            n._m[t] = this._m[t] + e._m[t];
          }

          return n._markAsUpdated(), this;
        }, t.prototype.addToSelf = function (e) {
          for (var n = 0; n < 16; n++) {
            this._m[n] += e._m[n];
          }

          return this._markAsUpdated(), this;
        }, t.prototype.invertToRef = function (e) {
          if (!0 === this._isIdentity) return t.IdentityToRef(e), this;
          var n = this._m,
              a = n[0],
              r = n[1],
              o = n[2],
              d = n[3],
              i = n[4],
              c = n[5],
              s = n[6],
              l = n[7],
              m = n[8],
              p = n[9],
              x = n[10],
              k = n[11],
              u = n[12],
              f = n[13],
              T = n[14],
              C = n[15],
              R = x * C - T * k,
              y = p * C - f * k,
              h = p * T - f * x,
              g = m * C - u * k,
              I = m * T - x * u,
              b = m * f - u * p,
              v = +(c * R - s * y + l * h),
              P = -(i * R - s * g + l * I),
              S = +(i * y - c * g + l * b),
              w = -(i * h - c * I + s * b),
              V = a * v + r * P + o * S + d * w;
          if (0 === V) return e.copyFrom(this), this;

          var M = 1 / V,
              N = s * C - T * l,
              O = c * C - f * l,
              E = c * T - f * s,
              A = i * C - u * l,
              z = i * T - u * s,
              _ = i * f - u * c,
              F = s * k - x * l,
              D = c * k - p * l,
              U = c * x - p * s,
              L = i * k - m * l,
              B = i * x - m * s,
              H = i * p - m * c,
              q = -(r * R - o * y + d * h),
              j = +(a * R - o * g + d * I),
              G = -(a * y - r * g + d * b),
              Q = +(a * h - r * I + o * b),
              W = +(r * N - o * O + d * E),
              Y = -(a * N - o * A + d * z),
              X = +(a * O - r * A + d * _),
              Z = -(a * E - r * z + o * _),
              J = -(r * F - o * D + d * U),
              $ = +(a * F - o * L + d * B),
              K = -(a * D - r * L + d * H),
              ee = +(a * U - r * B + o * H);

          return t.FromValuesToRef(v * M, q * M, W * M, J * M, P * M, j * M, Y * M, $ * M, S * M, G * M, X * M, K * M, w * M, Q * M, Z * M, ee * M, e), this;
        }, t.prototype.addAtIndex = function (e, n) {
          return this._m[e] += n, this._markAsUpdated(), this;
        }, t.prototype.multiplyAtIndex = function (e, n) {
          return this._m[e] *= n, this._markAsUpdated(), this;
        }, t.prototype.setTranslationFromFloats = function (e, n, t) {
          return this._m[12] = e, this._m[13] = n, this._m[14] = t, this._markAsUpdated(), this;
        }, t.prototype.setTranslation = function (e) {
          return this.setTranslationFromFloats(e.x, e.y, e.z);
        }, t.prototype.getTranslation = function () {
          return new r.Vector3(this._m[12], this._m[13], this._m[14]);
        }, t.prototype.getTranslationToRef = function (e) {
          return e.x = this._m[12], e.y = this._m[13], e.z = this._m[14], this;
        }, t.prototype.removeRotationAndScaling = function () {
          var e = this.m;
          return t.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, e[12], e[13], e[14], e[15], this), this._updateIdentityStatus(0 === e[12] && 0 === e[13] && 0 === e[14] && 1 === e[15]), this;
        }, t.prototype.multiply = function (e) {
          var n = new t();
          return this.multiplyToRef(e, n), n;
        }, t.prototype.copyFrom = function (e) {
          e.copyToArray(this._m);
          var n = e;
          return this._updateIdentityStatus(n._isIdentity, n._isIdentityDirty, n._isIdentity3x2, n._isIdentity3x2Dirty), this;
        }, t.prototype.copyToArray = function (e, n) {
          void 0 === n && (n = 0);

          for (var t = 0; t < 16; t++) {
            e[n + t] = this._m[t];
          }

          return this;
        }, t.prototype.multiplyToRef = function (e, n) {
          return this._isIdentity ? (n.copyFrom(e), this) : e._isIdentity ? (n.copyFrom(this), this) : (this.multiplyToArray(e, n._m, 0), n._markAsUpdated(), this);
        }, t.prototype.multiplyToArray = function (e, n, t) {
          var a = this._m,
              r = e.m,
              o = a[0],
              d = a[1],
              i = a[2],
              c = a[3],
              s = a[4],
              l = a[5],
              m = a[6],
              p = a[7],
              x = a[8],
              k = a[9],
              u = a[10],
              f = a[11],
              T = a[12],
              C = a[13],
              R = a[14],
              y = a[15],
              h = r[0],
              g = r[1],
              I = r[2],
              b = r[3],
              v = r[4],
              P = r[5],
              S = r[6],
              w = r[7],
              V = r[8],
              M = r[9],
              N = r[10],
              O = r[11],
              E = r[12],
              A = r[13],
              z = r[14],
              _ = r[15];
          return n[t] = o * h + d * v + i * V + c * E, n[t + 1] = o * g + d * P + i * M + c * A, n[t + 2] = o * I + d * S + i * N + c * z, n[t + 3] = o * b + d * w + i * O + c * _, n[t + 4] = s * h + l * v + m * V + p * E, n[t + 5] = s * g + l * P + m * M + p * A, n[t + 6] = s * I + l * S + m * N + p * z, n[t + 7] = s * b + l * w + m * O + p * _, n[t + 8] = x * h + k * v + u * V + f * E, n[t + 9] = x * g + k * P + u * M + f * A, n[t + 10] = x * I + k * S + u * N + f * z, n[t + 11] = x * b + k * w + u * O + f * _, n[t + 12] = T * h + C * v + R * V + y * E, n[t + 13] = T * g + C * P + R * M + y * A, n[t + 14] = T * I + C * S + R * N + y * z, n[t + 15] = T * b + C * w + R * O + y * _, this;
        }, t.prototype.equals = function (e) {
          var n = e;
          if (!n) return !1;
          if ((this._isIdentity || n._isIdentity) && !this._isIdentityDirty && !n._isIdentityDirty) return this._isIdentity && n._isIdentity;
          var t = this.m,
              a = n.m;
          return t[0] === a[0] && t[1] === a[1] && t[2] === a[2] && t[3] === a[3] && t[4] === a[4] && t[5] === a[5] && t[6] === a[6] && t[7] === a[7] && t[8] === a[8] && t[9] === a[9] && t[10] === a[10] && t[11] === a[11] && t[12] === a[12] && t[13] === a[13] && t[14] === a[14] && t[15] === a[15];
        }, t.prototype.clone = function () {
          var e = new t();
          return e.copyFrom(this), e;
        }, t.prototype.getClassName = function () {
          return "Matrix";
        }, t.prototype.getHashCode = function () {
          for (var e = this._m[0] || 0, n = 1; n < 16; n++) {
            e = 397 * e ^ (this._m[n] || 0);
          }

          return e;
        }, t.prototype.decompose = function (e, n, a) {
          if (this._isIdentity) return a && a.setAll(0), e && e.setAll(1), n && n.copyFromFloats(0, 0, 0, 1), !0;
          var r = this._m;
          a && a.copyFromFloats(r[12], r[13], r[14]);
          var i = e || d.MathTmp.Vector3[0];
          if (i.x = Math.sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2]), i.y = Math.sqrt(r[4] * r[4] + r[5] * r[5] + r[6] * r[6]), i.z = Math.sqrt(r[8] * r[8] + r[9] * r[9] + r[10] * r[10]), this.determinant() <= 0 && (i.y *= -1), 0 === i.x || 0 === i.y || 0 === i.z) return n && n.copyFromFloats(0, 0, 0, 1), !1;

          if (n) {
            var c = 1 / i.x,
                s = 1 / i.y,
                l = 1 / i.z;
            t.FromValuesToRef(r[0] * c, r[1] * c, r[2] * c, 0, r[4] * s, r[5] * s, r[6] * s, 0, r[8] * l, r[9] * l, r[10] * l, 0, 0, 0, 0, 1, d.MathTmp.Matrix[0]), o.Quaternion.FromRotationMatrixToRef(d.MathTmp.Matrix[0], n);
          }

          return !0;
        }, t.prototype.getRow = function (e) {
          if (e < 0 || e > 3) return null;
          var n = 4 * e;
          return new i.Vector4(this._m[n + 0], this._m[n + 1], this._m[n + 2], this._m[n + 3]);
        }, t.prototype.setRow = function (e, n) {
          return this.setRowFromFloats(e, n.x, n.y, n.z, n.w);
        }, t.prototype.transpose = function () {
          return t.Transpose(this);
        }, t.prototype.transposeToRef = function (e) {
          return t.TransposeToRef(this, e), this;
        }, t.prototype.setRowFromFloats = function (e, n, t, a, r) {
          if (e < 0 || e > 3) return this;
          var o = 4 * e;
          return this._m[o + 0] = n, this._m[o + 1] = t, this._m[o + 2] = a, this._m[o + 3] = r, this._markAsUpdated(), this;
        }, t.prototype.scale = function (e) {
          var n = new t();
          return this.scaleToRef(e, n), n;
        }, t.prototype.scaleToRef = function (e, n) {
          for (var t = 0; t < 16; t++) {
            n._m[t] = this._m[t] * e;
          }

          return n._markAsUpdated(), this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          for (var t = 0; t < 16; t++) {
            n._m[t] += this._m[t] * e;
          }

          return n._markAsUpdated(), this;
        }, t.prototype.toNormalMatrix = function (e) {
          var n = d.MathTmp.Matrix[0];
          this.invertToRef(n), n.transposeToRef(e);
          var a = e._m;
          t.FromValuesToRef(a[0], a[1], a[2], 0, a[4], a[5], a[6], 0, a[8], a[9], a[10], 0, 0, 0, 0, 1, e);
        }, t.prototype.getRotationMatrix = function () {
          var e = new t();
          return this.getRotationMatrixToRef(e), e;
        }, t.prototype.getRotationMatrixToRef = function (e) {
          var n = d.MathTmp.Vector3[0];
          if (!this.decompose(n)) return t.IdentityToRef(e), this;
          var a = this._m,
              r = 1 / n.x,
              o = 1 / n.y,
              i = 1 / n.z;
          return t.FromValuesToRef(a[0] * r, a[1] * r, a[2] * r, 0, a[4] * o, a[5] * o, a[6] * o, 0, a[8] * i, a[9] * i, a[10] * i, 0, 0, 0, 0, 1, e), this;
        }, t.prototype.toggleModelMatrixHandInPlace = function () {
          var e = this._m;
          e[2] *= -1, e[6] *= -1, e[8] *= -1, e[9] *= -1, e[14] *= -1, this._markAsUpdated();
        }, t.prototype.toggleProjectionMatrixHandInPlace = function () {
          var e = this._m;
          e[8] *= -1, e[9] *= -1, e[10] *= -1, e[11] *= -1, this._markAsUpdated();
        }, t.prototype._updateIdentityStatus = function (e, n, a, r) {
          void 0 === n && (n = !1), void 0 === a && (a = !1), void 0 === r && (r = !0), this.updateFlag = t._updateFlagSeed++, this._isIdentity = e, this._isIdentity3x2 = e || a, this._isIdentityDirty = !this._isIdentity && n, this._isIdentity3x2Dirty = !this._isIdentity3x2 && r;
        }, t._updateFlagSeed = 0, t._identityReadOnly = t.Identity(), t;
      }();

      n.Matrix = c;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(0),
          o = a(7),
          d = a(1),
          i = function () {
        function t(e) {
          this.name = e, this.children = {}, this.eventManager = null, this.alive = !1, this.uuid = d.newId("E"), this.components = {}, this.engine = null, this._parent = null;
        }

        return t.prototype.addComponentOrReplace = function (e) {
          if ("function" == typeof e) throw new Error("You passed a function or class as a component, an instance of component is expected");
          if ("object" != typeof e) throw new Error("You passed a " + typeof e + ", an instance of component is expected");
          var n = r.getComponentName(e);

          if (this.components[n]) {
            if (this.components[n] === e) return e;
            this.removeComponent(this.components[n], !1);
          }

          return this.addComponent(e);
        }, t.prototype.hasComponent = function (e) {
          var n = typeof e;
          if ("string" !== n && "object" !== n && "function" !== n) throw new Error("Entity#has(component): component is not a class, name or instance");
          if (null == e) return !1;
          var t = "string" === n ? e : r.getComponentName(e),
              a = this.components[t];
          return !!a && ("object" === n ? a === e : "function" !== n || a instanceof e);
        }, t.prototype.getComponent = function (e) {
          var n = typeof e;
          if ("string" !== n && "function" !== n) throw new Error("Entity#get(component): component is not a class or name");
          var t = "string" === n ? e : r.getComponentName(e),
              a = this.components[t];
          if (!a) throw new Error('Can not get component "' + t + '" from entity "' + this.identifier + '"');

          if ("function" === n) {
            if (a instanceof e) return a;
            throw new Error('Can not get component "' + t + '" from entity "' + this.identifier + '" (by instance)');
          }

          return a;
        }, t.prototype.getComponentOrNull = function (e) {
          var n = typeof e;
          if ("string" !== n && "function" !== n) throw new Error("Entity#getOrNull(component): component is not a class or name");
          var t = "string" === n ? e : r.getComponentName(e),
              a = this.components[t];
          return a ? "function" === n ? a instanceof e ? a : null : a : null;
        }, t.prototype.getComponentOrCreate = function (e) {
          if ("function" != typeof e) throw new Error("Entity#getOrCreate(component): component is not a class");
          var n = this.getComponentOrNull(e);
          return n || (n = new e(), r.getComponentName(n), this.addComponentOrReplace(n)), n;
        }, t.prototype.addComponent = function (e) {
          if ("object" != typeof e) throw new Error("Entity#add(component): You passed a function or class as a component, an instance of component is expected");
          var n = r.getComponentName(e),
              t = r.getComponentClassId(e);
          if (this.components[n]) throw new Error('A component of type "' + n + '" is already present in entity "' + this.identifier + '"');
          this.components[n] = e, this.eventManager && this.eventManager.fireEvent(new o.ComponentAdded(this, n, t));
          var a = e;
          return "function" == typeof a.addedToEntity && a.addedToEntity(this), e;
        }, t.prototype.removeComponent = function (e, n) {
          void 0 === n && (n = !0);
          var t = typeof e;
          if ("string" !== t && "function" !== t && "object" !== t) throw new Error("Entity#remove(component): component is not a class, class or name");
          var a = "string" === t ? e : r.getComponentName(e),
              i = this.components[a];

          if (i) {
            if ("function" === t) return i instanceof e ? (delete this.components[a], void (i && (n && this.eventManager && this.eventManager.fireEvent(new o.ComponentRemoved(this, a, i)), "function" == typeof i.removedFromEntity && i.removedFromEntity(this)))) : void d.log('Entity Warning: Trying to remove wrong (by constructor) component "' + a + '" from entity "' + this.identifier + '"');
            delete this.components[a], i && (n && this.eventManager && this.eventManager.fireEvent(new o.ComponentRemoved(this, a, i)), "function" == typeof i.removedFromEntity && i.removedFromEntity(this));
          } else d.log('Entity Warning: Trying to remove inexisting component "' + a + '" from entity "' + this.identifier + '"');
        }, t.prototype.isAddedToEngine = function () {
          return !(!this.engine || !(this.uuid in this.engine.entities) && this.engine.rootEntity !== this);
        }, t.prototype.setParent = function (e) {
          var n;

          if (e && "getEntityRepresentation" in e) {
            if (!this.engine) throw new Error("In order to set an attachable as parent, you first need to add the entity to the engine.");
            n = e.getEntityRepresentation(this.engine);
          } else n = !e && this.engine ? this.engine.rootEntity : e;

          var t = this.getParent();
          if (n === this) throw new Error('Failed to set parent for entity "' + this.identifier + "\": An entity can't set itself as a its own parent");
          if (n === t) return this;
          var a = this.getCircularAncestor(n);
          if (a) throw new Error('Failed to set parent for entity "' + this.identifier + '": Circular parent references are not allowed (See entity "' + a + '")');
          return t && delete t.children[this.uuid], null !== n && "0" !== n.uuid && (!n.isAddedToEngine() && this.isAddedToEngine() && this.engine.removeEntity(this), n.isAddedToEngine() && !this.isAddedToEngine() && n.engine.addEntity(this)), this._parent = n || null, this.registerAsChild(), this.eventManager && this.engine && this.eventManager.fireEvent(new o.ParentChanged(this, n)), this;
        }, t.prototype.getParent = function () {
          return this._parent;
        }, Object.defineProperty(t.prototype, "identifier", {
          get: function get() {
            return this.name || this.uuid;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.getCircularAncestor = function (e) {
          for (var n = this.engine ? this.engine.rootEntity : null, t = e; t && t !== n;) {
            var a = t.getParent();
            if (a === this) return t.uuid;
            t = a;
          }

          return null;
        }, t.prototype.registerAsChild = function () {
          var e = this.getParent();
          this.uuid && e && (e.children[this.uuid] = this);
        }, t;
      }();

      n.Entity = i;
    }, function (e, n, a) {
      "use strict";

      var r = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var o = a(8),
          d = function () {
        function t(e, n) {
          this.uuid = e, this.payload = n;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.UUIDEvent = d;

      var i = function () {
        function t(e) {
          this.payload = e;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.RaycastResponse = i;

      var c = function () {
        function t(e) {
          this.payload = e;
        }

        return t = r([o.EventConstructor()], t);
      }();

      n.PointerEvent = c;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(13),
          o = a(4),
          d = a(7),
          i = a(16),
          c = a(28),
          s = function () {
        function t() {}

        return t.prototype.activate = function (e) {
          e.eventManager.addListener(r.RaycastResponse, this, function (e) {
            "HitFirst" === e.payload.queryType ? c.PhysicsCast.instance.handleRaycastHitFirstResponse(e) : "HitAll" === e.payload.queryType && c.PhysicsCast.instance.handleRaycastHitAllResponse(e);
          }), "undefined" != typeof dcl && dcl.subscribe("raycastResponse");
        }, t.prototype.deactivate = function () {
          "undefined" != typeof dcl && dcl.unsubscribe("raycastResponse");
        }, t;
      }();

      n.RaycastEventSystem = s, n.raycastEventSystem = new s();

      var l = function () {
        function t() {}

        return t.prototype.activate = function (e) {
          e.eventManager.addListener(r.PointerEvent, this, function (e) {
            i.Input.instance.handlePointerEvent(e.payload);
          }), "undefined" != typeof dcl && (dcl.subscribe("pointerUp"), dcl.subscribe("pointerDown"), dcl.subscribe("pointerEvent"));
        }, t.prototype.deactivate = function () {
          "undefined" != typeof dcl && (dcl.unsubscribe("pointerUp"), dcl.unsubscribe("pointerDown"), dcl.unsubscribe("pointerEvent"));
        }, t;
      }();

      n.PointerEventSystem = l, n.pointerEventSystem = new l();

      var m = function () {
        function t() {
          this.handlerMap = {};
        }

        return t.prototype.activate = function (e) {
          e.eventManager.addListener(r.UUIDEvent, this, this.handleEvent), e.eventManager.addListener(d.ComponentAdded, this, this.componentAdded), e.eventManager.addListener(d.ComponentRemoved, this, this.componentRemoved), "undefined" != typeof dcl && dcl.subscribe("uuidEvent");
        }, t.prototype.deactivate = function () {
          "undefined" != typeof dcl && dcl.unsubscribe("uuidEvent");
        }, t.prototype.onAddEntity = function (e) {
          for (var n in e.components) {
            var t = e.components[n];
            t instanceof o.OnUUIDEvent && (this.handlerMap[t.uuid] = t);
          }
        }, t.prototype.onRemoveEntity = function (e) {
          for (var n in e.components) {
            var t = e.components[n];
            t instanceof o.OnUUIDEvent && delete this.handlerMap[t.uuid];
          }
        }, t.prototype.componentAdded = function (e) {
          if (e.entity.isAddedToEngine()) {
            var n = e.entity.components[e.componentName];
            n instanceof o.OnUUIDEvent && (this.handlerMap[n.uuid] = n);
          }
        }, t.prototype.componentRemoved = function (e) {
          e.entity.isAddedToEngine() && e.component instanceof o.OnUUIDEvent && delete this.handlerMap[e.component.uuid];
        }, t.prototype.handleEvent = function (e) {
          if (e.uuid in this.handlerMap) {
            var n = this.handlerMap[e.uuid];
            n && n.callback && "call" in n.callback && n.callback(e.payload);
          }
        }, t;
      }();

      n.UUIDEventSystem = m, n.uuidEventSystem = new m();
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(2),
          o = a(6),
          d = function () {
        function t(e, n) {
          void 0 === e && (e = 0), void 0 === n && (n = 0), this.x = e, this.y = n;
        }

        return t.Zero = function () {
          return new t(0, 0);
        }, t.One = function () {
          return new t(1, 1);
        }, t.Add = function (e, n) {
          return new t(e.x, e.y).addInPlace(n);
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1]);
        }, t.FromArrayToRef = function (e, n, t) {
          t.x = e[n], t.y = e[n + 1];
        }, t.CatmullRom = function (e, n, a, r, o) {
          var d = o * o,
              i = o * d;
          return new t(.5 * (2 * n.x + (-e.x + a.x) * o + (2 * e.x - 5 * n.x + 4 * a.x - r.x) * d + (-e.x + 3 * n.x - 3 * a.x + r.x) * i), .5 * (2 * n.y + (-e.y + a.y) * o + (2 * e.y - 5 * n.y + 4 * a.y - r.y) * d + (-e.y + 3 * n.y - 3 * a.y + r.y) * i));
        }, t.Clamp = function (e, n, a) {
          var r = e.x;
          r = (r = r > a.x ? a.x : r) < n.x ? n.x : r;
          var o = e.y;
          return new t(r, o = (o = o > a.y ? a.y : o) < n.y ? n.y : o);
        }, t.Hermite = function (e, n, a, r, o) {
          var d = o * o,
              i = o * d,
              c = 2 * i - 3 * d + 1,
              s = -2 * i + 3 * d,
              l = i - 2 * d + o,
              m = i - d;
          return new t(e.x * c + a.x * s + n.x * l + r.x * m, e.y * c + a.y * s + n.y * l + r.y * m);
        }, t.Lerp = function (e, n, a) {
          return new t(e.x + (n.x - e.x) * a, e.y + (n.y - e.y) * a);
        }, t.Dot = function (e, n) {
          return e.x * n.x + e.y * n.y;
        }, t.Normalize = function (e) {
          var n = new t(e.x, e.y);
          return n.normalize(), n;
        }, t.Minimize = function (e, n) {
          return new t(e.x < n.x ? e.x : n.x, e.y < n.y ? e.y : n.y);
        }, t.Maximize = function (e, n) {
          return new t(e.x > n.x ? e.x : n.x, e.y > n.y ? e.y : n.y);
        }, t.Transform = function (e, n) {
          var a = t.Zero();
          return t.TransformToRef(e, n, a), a;
        }, t.TransformToRef = function (e, n, t) {
          var a = n.m,
              r = e.x * a[0] + e.y * a[4] + a[12],
              o = e.x * a[1] + e.y * a[5] + a[13];
          t.x = r, t.y = o;
        }, t.PointInTriangle = function (e, n, t, a) {
          var r = .5 * (-t.y * a.x + n.y * (-t.x + a.x) + n.x * (t.y - a.y) + t.x * a.y),
              o = r < 0 ? -1 : 1,
              d = (n.y * a.x - n.x * a.y + (a.y - n.y) * e.x + (n.x - a.x) * e.y) * o,
              i = (n.x * t.y - n.y * t.x + (n.y - t.y) * e.x + (t.x - n.x) * e.y) * o;
          return d > 0 && i > 0 && d + i < 2 * r * o;
        }, t.Distance = function (e, n) {
          return Math.sqrt(t.DistanceSquared(e, n));
        }, t.DistanceSquared = function (e, n) {
          var t = e.x - n.x,
              a = e.y - n.y;
          return t * t + a * a;
        }, t.Center = function (e, n) {
          var a = t.Add(e, n);
          return a.scaleInPlace(.5), a;
        }, t.DistanceOfPointFromSegment = function (e, n, a) {
          var r = t.DistanceSquared(n, a);
          if (0 === r) return t.Distance(e, n);
          var o = a.subtract(n),
              d = Math.max(0, Math.min(1, t.Dot(e.subtract(n), o) / r)),
              i = n.add(o.multiplyByFloats(d, d));
          return t.Distance(e, i);
        }, t.prototype.toString = function () {
          return "{X: " + this.x + " Y:" + this.y + "}";
        }, t.prototype.getClassName = function () {
          return "Vector2";
        }, t.prototype.getHashCode = function () {
          var e = this.x || 0;
          return e = 397 * e ^ (this.y || 0);
        }, t.prototype.toArray = function (e, n) {
          return void 0 === n && (n = 0), e[n] = this.x, e[n + 1] = this.y, this;
        }, t.prototype.asArray = function () {
          var e = new Array();
          return this.toArray(e, 0), e;
        }, t.prototype.copyFrom = function (e) {
          return this.x = e.x, this.y = e.y, this;
        }, t.prototype.copyFromFloats = function (e, n) {
          return this.x = e, this.y = n, this;
        }, t.prototype.set = function (e, n) {
          return this.copyFromFloats(e, n);
        }, t.prototype.add = function (e) {
          return new t(this.x + e.x, this.y + e.y);
        }, t.prototype.addToRef = function (e, n) {
          return n.x = this.x + e.x, n.y = this.y + e.y, this;
        }, t.prototype.addInPlace = function (e) {
          return this.x += e.x, this.y += e.y, this;
        }, t.prototype.addVector3 = function (e) {
          return new t(this.x + e.x, this.y + e.y);
        }, t.prototype.subtract = function (e) {
          return new t(this.x - e.x, this.y - e.y);
        }, t.prototype.subtractToRef = function (e, n) {
          return n.x = this.x - e.x, n.y = this.y - e.y, this;
        }, t.prototype.subtractInPlace = function (e) {
          return this.x -= e.x, this.y -= e.y, this;
        }, t.prototype.multiplyInPlace = function (e) {
          return this.x *= e.x, this.y *= e.y, this;
        }, t.prototype.multiply = function (e) {
          return new t(this.x * e.x, this.y * e.y);
        }, t.prototype.multiplyToRef = function (e, n) {
          return n.x = this.x * e.x, n.y = this.y * e.y, this;
        }, t.prototype.multiplyByFloats = function (e, n) {
          return new t(this.x * e, this.y * n);
        }, t.prototype.divide = function (e) {
          return new t(this.x / e.x, this.y / e.y);
        }, t.prototype.divideToRef = function (e, n) {
          return n.x = this.x / e.x, n.y = this.y / e.y, this;
        }, t.prototype.divideInPlace = function (e) {
          return this.divideToRef(e, this);
        }, t.prototype.negate = function () {
          return new t(-this.x, -this.y);
        }, t.prototype.scaleInPlace = function (e) {
          return this.x *= e, this.y *= e, this;
        }, t.prototype.scale = function (e) {
          var n = new t(0, 0);
          return this.scaleToRef(e, n), n;
        }, t.prototype.scaleToRef = function (e, n) {
          return n.x = this.x * e, n.y = this.y * e, this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.x += this.x * e, n.y += this.y * e, this;
        }, t.prototype.equals = function (e) {
          return e && this.x === e.x && this.y === e.y;
        }, t.prototype.equalsWithEpsilon = function (e, n) {
          return void 0 === n && (n = r.Epsilon), e && o.Scalar.WithinEpsilon(this.x, e.x, n) && o.Scalar.WithinEpsilon(this.y, e.y, n);
        }, t.prototype.floor = function () {
          return new t(Math.floor(this.x), Math.floor(this.y));
        }, t.prototype.fract = function () {
          return new t(this.x - Math.floor(this.x), this.y - Math.floor(this.y));
        }, t.prototype.length = function () {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, t.prototype.lengthSquared = function () {
          return this.x * this.x + this.y * this.y;
        }, t.prototype.normalize = function () {
          var e = this.length();
          if (0 === e) return this;
          var n = 1 / e;
          return this.x *= n, this.y *= n, this;
        }, t.prototype.clone = function () {
          return new t(this.x, this.y);
        }, t;
      }();

      n.Vector2 = d;
    }, function (a, r, o) {
      "use strict";

      var _d3,
          i = this && this.__extends || (_d3 = function d(e, n) {
        return (_d3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _d3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          c = this && this.__assign || function () {
        return (c = Object.assign || function (e) {
          for (var n, t = 1, a = arguments.length; t < a; t++) {
            for (var r in n = arguments[t]) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          s = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var l,
          m = o(27),
          p = o(5),
          x = o(0);
      !function (e) {
        e.POINTER = "POINTER", e.PRIMARY = "PRIMARY", e.SECONDARY = "SECONDARY", e.ANY = "ANY";
      }(l = r.ActionButton || (r.ActionButton = {}));

      var k = function k(e) {
        if (this.callback = e, !e || !("apply" in e) || !("call" in e)) throw new Error("Callback is not a function");
        C.ensureInstance();
      };

      r.PointerEventComponent = k;

      var u = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return i(e, n), e = s([x.Component("pointerDown")], e);
      }(k);

      r.GlobalPointerDown = u;

      var f = function (n) {
        function e() {
          return null !== n && n.apply(this, arguments) || this;
        }

        return i(e, n), e = s([x.Component("pointerUp")], e);
      }(k);

      r.GlobalPointerUp = f;

      var T = function T(e, n) {
        this.fn = e, this.useRaycast = n;
      },
          C = function () {
        function t() {
          var e, n;
          this.subscriptions = ((e = {})[l.POINTER] = {
            BUTTON_DOWN: [],
            BUTTON_UP: []
          }, e[l.PRIMARY] = {
            BUTTON_DOWN: [],
            BUTTON_UP: []
          }, e[l.SECONDARY] = {
            BUTTON_DOWN: [],
            BUTTON_UP: []
          }, e[l.ANY] = {
            BUTTON_DOWN: [],
            BUTTON_UP: []
          }, e), this.internalState = ((n = {})[l.POINTER] = {
            BUTTON_DOWN: !1
          }, n[l.PRIMARY] = {
            BUTTON_DOWN: !1
          }, n[l.SECONDARY] = {
            BUTTON_DOWN: !1
          }, n[l.ANY] = {
            BUTTON_DOWN: !1
          }, n);
        }

        return Object.defineProperty(t, "instance", {
          get: function get() {
            return t.ensureInstance(), t._instance;
          },
          enumerable: !0,
          configurable: !0
        }), t.ensureInstance = function () {
          t._instance || (t._instance = new t());
        }, t.prototype.isButtonPressed = function (e) {
          return this.internalState[e];
        }, t.prototype.subscribe = function (e, n, t, a) {
          var r = this;
          return this.subscriptions[n][e].push(new T(a, t)), function () {
            return r.unsubscribe(e, n, a);
          };
        }, t.prototype.unsubscribe = function (e, n, t) {
          var a = this.getSubscriptionId(e, n, t);
          return a > -1 && this.subscriptions[n][e].splice(a, 1);
        }, t.prototype.handlePointerEvent = function (e) {
          var n = this.getPointerById(e.buttonId),
              t = c(c({}, e), {
            button: n,
            direction: new p.Vector3().copyFrom(e.direction),
            origin: new p.Vector3().copyFrom(e.origin),
            hit: void 0
          }),
              a = e.hit ? c(c({}, e.hit), {
            hitPoint: new p.Vector3().copyFrom(e.hit.hitPoint),
            normal: new p.Vector3().copyFrom(e.hit.normal),
            worldNormal: new p.Vector3().copyFrom(e.hit.worldNormal)
          }) : void 0;

          if (e.type === m.InputEventType.DOWN) {
            this.internalState[n].BUTTON_DOWN = !0;

            for (var r = 0; r < this.subscriptions[n].BUTTON_DOWN.length; r++) {
              (o = this.subscriptions[n].BUTTON_DOWN[r]).useRaycast ? t.hit = a : t.hit = void 0, o.fn(t);
            }

            if (a && a.entityId && x.DisposableComponent.engine) (i = (d = x.DisposableComponent.engine.entities[a.entityId]) && d.getComponentOrNull(u)) && (t.hit = a, i.callback(t));
          } else {
            this.internalState[n].BUTTON_DOWN = !1;

            for (r = 0; r < this.subscriptions[n].BUTTON_UP.length; r++) {
              var o;
              (o = this.subscriptions[n].BUTTON_UP[r]).useRaycast ? t.hit = a : t.hit = void 0, o.fn(t);
            }

            var d, i;
            if (a && a.entityId && x.DisposableComponent.engine) (i = (d = x.DisposableComponent.engine.entities[a.entityId]) && d.getComponentOrNull(f)) && (t.hit = a, i.callback(t));
          }
        }, t.prototype.getSubscriptionId = function (e, n, t) {
          for (var a = 0; a < this.subscriptions[n][e].length; a++) {
            if (this.subscriptions[n][e][a].fn === t) return a;
          }

          return -1;
        }, t.prototype.getPointerById = function (e) {
          return 0 === e ? l.POINTER : 1 === e ? l.PRIMARY : l.SECONDARY;
        }, t;
      }();

      r.Input = C;
    }, function (e, n, a) {
      "use strict";

      var r = this && this.__read || function (e, n) {
        var t = "function" == typeof Symbol && e[Symbol.iterator];
        if (!t) return e;
        var a,
            r,
            o = t.call(e),
            d = [];

        try {
          for (; (void 0 === n || n-- > 0) && !(a = o.next()).done;) {
            d.push(a.value);
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            a && !a.done && (t = o.return) && t.call(o);
          } finally {
            if (r) throw r.error;
          }
        }

        return d;
      },
          o = this && this.__spread || function () {
        for (var e = [], n = 0; n < arguments.length; n++) {
          e = e.concat(r(arguments[n]));
        }

        return e;
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var d = a(7),
          i = a(0),
          c = a(8),
          s = a(32),
          l = a(1),
          m = a(12),
          p = function () {
        function t(e) {
          this.eventManager = new c.EventManager(), this.systems = [], this.entityLists = {}, this.addedSystems = [], this._entities = {}, this._disposableComponents = {}, this._componentGroups = {}, this.simpleSystems = [], this.eventManager.addListener(d.ComponentAdded, this, this.componentAddedHandler), this.eventManager.addListener(d.ComponentRemoved, this, this.componentRemovedHandler), this.rootEntity = e, this.firstPersonCameraEntity = new m.Entity(), this.firstPersonCameraEntity.uuid = "FirstPersonCameraEntityReference", this.addEntity(this.firstPersonCameraEntity), this.avatarEntity = new m.Entity(), this.avatarEntity.uuid = "AvatarEntityReference", this.addEntity(this.avatarEntity);
        }

        return Object.defineProperty(t.prototype, "entities", {
          get: function get() {
            return this._entities;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "disposableComponents", {
          get: function get() {
            return this._disposableComponents;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.addEntity = function (e) {
          var n = e.getParent();
          if (e.isAddedToEngine()) return e;

          for (var t in e.eventManager = this.eventManager, e.engine = this, this._entities[e.uuid] = e, this.checkRequirementsAndAdd(e), n ? n.isAddedToEngine() || n === this.rootEntity || l.log("Engine: warning, added an entity with a parent not present in the engine. Parent id: " + n.uuid) : e.setParent(this.rootEntity), e.alive = !0, e.children) {
            var a = e.children[t];
            a && (a.isAddedToEngine() || this.addEntity(a));
          }

          return e;
        }, t.prototype.removeEntity = function (e) {
          var n = e.uuid;

          if (e.isAddedToEngine()) {
            for (var t in e.components) {
              var a = this._componentGroups[t];
              if (a) for (var r in a) {
                a[r].removeEntity(e);
              }
              delete this.entityLists[t][n];
            }

            for (var o = 0; o < this.simpleSystems.length; o++) {
              var d = this.simpleSystems[o];
              d.onRemoveEntity && d.onRemoveEntity(e);
            }

            for (var o in e.children) {
              var i = e.children[o];
              i && this.removeEntity(i);
            }

            return e.alive = !1, e.eventManager = null, delete this._entities[n], !0;
          }

          for (var t in l.log("Engine: Trying to remove non existent entity from engine."), e.isAddedToEngine() ? l.log("Engine: Entity id: " + n) : l.log('Engine: Entity "' + e.uuid + '" has not been added to any engine yet.'), l.log("Engine: Entity's components:"), e.components) {
            l.log(t);
          }

          return !1;
        }, t.prototype.addSystem = function (e, n) {
          if (void 0 === n && (n = 0), -1 !== this.addedSystems.indexOf(e)) return l.log("Engine: Trying to add a system that is already added. Aborting"), e;
          if (this.systems.length > 0) for (var t = 0; t < this.systems.length; t++) {
            var a = this.systems[t],
                r = t === this.systems.length - 1;

            if (a.priority > n) {
              this.addedSystems.push(e), this.systems.splice(t, 0, {
                system: e,
                priority: n
              });
              break;
            }

            if (r) {
              this.addedSystems.push(e), this.systems.splice(t + 1, 0, {
                system: e,
                priority: n
              });
              break;
            }
          } else this.addedSystems.push(e), this.systems.splice(1, 0, {
            system: e,
            priority: n
          });
          return this.registerSystem(e), e;
        }, t.prototype.removeSystem = function (e) {
          var n = this.addedSystems.indexOf(e);

          if (-1 !== n) {
            e.active = !1, e.deactivate && e.deactivate(), this.addedSystems.splice(n, 1);

            for (var t = 0; t < this.systems.length; t++) {
              this.systems[t].system === e && this.systems.splice(t, 1);
            }

            return !0;
          }

          return !1;
        }, t.prototype.update = function (e) {
          for (var n in this.systems) {
            var t = this.systems[n].system;
            if (t.active && t.update) try {
              t.update(e);
            } catch (e) {
              l.error(e);
            }
          }

          return this;
        }, t.prototype.getEntitiesWithComponent = function (e) {
          var n = "string" == typeof e ? e : i.getComponentName(e);
          return n in this.entityLists ? this.entityLists[n] : this.entityLists[n] = {};
        }, t.prototype.registerComponent = function (e) {
          var n = i.getComponentId(e),
              t = i.getComponentName(e),
              a = i.getComponentClassId(e);
          this._disposableComponents[n] = e, null !== a && (this.eventManager.fireEvent(new i.DisposableComponentCreated(n, t, a)), this.eventManager.fireEvent(new i.DisposableComponentUpdated(n, e)));
        }, t.prototype.disposeComponent = function (e) {
          var n = i.getComponentId(e);
          return delete this._disposableComponents[n] && (this.eventManager.fireEvent(new i.DisposableComponentRemoved(n)), e.onDispose && e.onDispose(), !0);
        }, t.prototype.updateComponent = function (e) {
          this.eventManager.fireEvent(new i.DisposableComponentUpdated(i.getComponentId(e), e));
        }, t.prototype.getComponentGroup = function () {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e[n] = arguments[n];
          }

          var t = new (s.ComponentGroup.bind.apply(s.ComponentGroup, o([void 0], e)))();
          t.active = !0;

          for (var a = t.requiresNames, r = 0; r < a.length; r++) {
            var d = a[r],
                i = this._componentGroups[d];
            i || (this._componentGroups[d] = i = []), -1 === i.indexOf(t) && i.push(t);
          }

          for (var c in this._entities) {
            this.checkRequirements(this._entities[c], t);
          }

          return t;
        }, t.prototype.removeComponentGroup = function (e) {
          if (e.active) {
            e.active = !1;

            for (var n = e.requiresNames, t = 0; t < n.length; t++) {
              var a = n[t],
                  r = this._componentGroups[a];

              if (r) {
                var o = r.indexOf(e);
                -1 !== o && r.splice(o, 1);
              }
            }

            return !0;
          }

          return !1;
        }, t.prototype.registerSystem = function (e) {
          e.active = !0, e.activate && e.activate(this), this.simpleSystems.push(e);
        }, t.prototype.checkRequirementsAndAdd = function (e) {
          if (e.isAddedToEngine()) {
            for (var n in e.components) {
              n in this.entityLists || (this.entityLists[n] = {}), this.entityLists[n][e.uuid] = e;
              var t = this._componentGroups[n];
              if (t) for (var a in t) {
                this.checkRequirements(e, t[a]);
              }
            }

            for (var r = 0; r < this.simpleSystems.length; r++) {
              var o = this.simpleSystems[r];
              o.onAddEntity && o.onAddEntity(e);
            }
          }
        }, t.prototype.checkRequirements = function (e, n) {
          n.meetsRequirements(e) ? n.hasEntity(e) || n.addEntity(e) : n.hasEntity(e) && n.removeEntity(e);
        }, t.prototype.componentAddedHandler = function (e) {
          var n,
              t = e.entity,
              a = e.componentName;

          if (t.isAddedToEngine()) {
            this.entityLists[a] ? this.entityLists[a][t.uuid] = t : this.entityLists[a] = ((n = {})[t.uuid] = t, n);
            var r = this._componentGroups[a];
            if (r) for (var o in r) {
              this.checkRequirements(t, r[o]);
            }
          }
        }, t.prototype.componentRemovedHandler = function (e) {
          var n = e.entity,
              t = e.componentName;

          if (n.isAddedToEngine()) {
            delete this.entityLists[t][n.uuid];
            var a = this._componentGroups[t];
            if (a) for (var r in a) {
              this.checkRequirements(n, a[r]);
            }
          }
        }, t;
      }();

      n.Engine = p;
    }, function (e, n, a) {
      "use strict";

      var r;
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), function (e) {
        e[e.PERCENT = 0] = "PERCENT", e[e.PIXELS = 1] = "PIXELS";
      }(r = n.UIValueType || (n.UIValueType = {}));

      var o = function () {
        function t(e) {
          if (this.type = r.PIXELS, "string" == typeof e) {
            var n = e;
            n.indexOf("px") > -1 ? this.type = r.PIXELS : n.indexOf("%") > -1 && (this.type = r.PERCENT), this.value = parseFloat(n);
          } else this.value = e;
        }

        return t.prototype.toString = function () {
          var e = this.value.toString();
          return this.type === r.PERCENT ? e += "%" : e += "px", e;
        }, t;
      }();

      n.UIValue = o;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var a = t(1),
          r = Promise.resolve().then.bind(Promise.resolve());

      n.executeTask = function (e) {
        var n = r(e);
        return n.isComplete = !1, n.then(function (e) {
          n.isComplete = !0, n.result = e, n.didFail = !1;
        }).catch(function (e) {
          n.isComplete = !0, n.error = e, n.didFail = !0, a.error("executeTask: FAILED " + e.toString(), e);
        }), n;
      };
    }, function (e, n, a) {
      "use strict";

      var r = this && this.__awaiter || function (e, n, t, r) {
        return new (t || (t = Promise))(function (o, d) {
          function s(e) {
            try {
              p(r.next(e));
            } catch (e) {
              d(e);
            }
          }

          function a(e) {
            try {
              p(r.throw(e));
            } catch (e) {
              d(e);
            }
          }

          function p(e) {
            var n;
            e.done ? o(e.value) : (n = e.value, n instanceof t ? n : new t(function (e) {
              e(n);
            })).then(s, a);
          }

          p((r = r.apply(e, n || [])).next());
        });
      },
          o = this && this.__generator || function (e, n) {
        var t,
            r,
            o,
            d,
            i = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return d = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (d[Symbol.iterator] = function () {
          return this;
        }), d;

        function a(a) {
          return function (d) {
            return function (a) {
              if (t) throw new TypeError("Generator is already executing.");

              for (; i;) {
                try {
                  if (t = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;

                  switch (r = 0, o && (a = [2 & a[0], o.value]), a[0]) {
                    case 0:
                    case 1:
                      o = a;
                      break;

                    case 4:
                      return i.label++, {
                        value: a[1],
                        done: !1
                      };

                    case 5:
                      i.label++, r = a[1], a = [0];
                      continue;

                    case 7:
                      a = i.ops.pop(), i.trys.pop();
                      continue;

                    default:
                      if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                        i = 0;
                        continue;
                      }

                      if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                        i.label = a[1];
                        break;
                      }

                      if (6 === a[0] && i.label < o[1]) {
                        i.label = o[1], o = a;
                        break;
                      }

                      if (o && i.label < o[2]) {
                        i.label = o[2], i.ops.push(a);
                        break;
                      }

                      o[2] && i.ops.pop(), i.trys.pop();
                      continue;
                  }

                  a = n.call(e, i);
                } catch (e) {
                  a = [6, e], r = 0;
                } finally {
                  t = o = 0;
                }
              }

              if (5 & a[0]) throw a[1];
              return {
                value: a[0] ? a[1] : void 0,
                done: !0
              };
            }([a, d]);
          };
        }
      },
          d = this && this.__values || function (e) {
        var n = "function" == typeof Symbol && Symbol.iterator,
            t = n && e[n],
            a = 0;
        if (t) return t.call(e);
        if (e && "number" == typeof e.length) return {
          next: function next() {
            return e && a >= e.length && (e = void 0), {
              value: e && e[a++],
              done: !e
            };
          }
        };
        throw new TypeError(n ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var i = a(19),
          c = function () {
        function t(e, n, t, a) {
          void 0 === n && (n = !1), this.initalize(e, n, t, a);
        }

        return t.prototype.initalize = function (e, n, t, a) {
          return void 0 === n && (n = !1), this.mask = e, this.skipNextObservers = n, this.target = t, this.currentTarget = a, this;
        }, t;
      }();

      n.ObserverEventState = c;

      var s = function s(e, n, t) {
        void 0 === t && (t = null), this.callback = e, this.mask = n, this.scope = t, this.unregisterOnNextCall = !1, this._willBeUnregistered = !1;
      };

      n.Observer = s;

      var l = function () {
        function t() {
          this._observers = null, this._observables = null;
        }

        return t.Watch = function (e, n, a, r) {
          var o, i;
          void 0 === a && (a = -1), void 0 === r && (r = null);
          var c = new t();
          c._observers = new Array(), c._observables = e;

          try {
            for (var s = d(e), l = s.next(); !l.done; l = s.next()) {
              var m = l.value.add(n, a, !1, r);
              m && c._observers.push(m);
            }
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              l && !l.done && (i = s.return) && i.call(s);
            } finally {
              if (o) throw o.error;
            }
          }

          return c;
        }, t.prototype.dispose = function () {
          if (this._observers && this._observables) for (var e = 0; e < this._observers.length; e++) {
            this._observables[e].remove(this._observers[e]);
          }
          this._observers = null, this._observables = null;
        }, t;
      }();

      n.MultiObserver = l;

      var m = function () {
        function t(e) {
          this._observers = new Array(), this._onObserverAdded = null, this._eventState = new c(0), e && (this._onObserverAdded = e);
        }

        return t.prototype.add = function (e, n, t, a, r) {
          if (void 0 === n && (n = -1), void 0 === t && (t = !1), void 0 === a && (a = null), void 0 === r && (r = !1), !e) return null;
          var o = new s(e, n, a);
          return o.unregisterOnNextCall = r, t ? this._observers.unshift(o) : this._observers.push(o), this._onObserverAdded && this._onObserverAdded(o), o;
        }, t.prototype.addOnce = function (e) {
          return this.add(e, void 0, void 0, void 0, !0);
        }, t.prototype.remove = function (e) {
          return !!e && -1 !== this._observers.indexOf(e) && (this._deferUnregister(e), !0);
        }, t.prototype.removeCallback = function (e, n) {
          for (var t = 0; t < this._observers.length; t++) {
            if (this._observers[t].callback === e && (!n || n === this._observers[t].scope)) return this._deferUnregister(this._observers[t]), !0;
          }

          return !1;
        }, t.prototype.notifyObservers = function (e, n, t, a) {
          var r, o;
          if (void 0 === n && (n = -1), !this._observers.length) return !0;
          var i = this._eventState;
          i.mask = n, i.target = t, i.currentTarget = a, i.skipNextObservers = !1, i.lastReturnValue = e;

          try {
            for (var c = d(this._observers), s = c.next(); !s.done; s = c.next()) {
              var l = s.value;
              if (!l._willBeUnregistered && (l.mask & n && (l.scope ? i.lastReturnValue = l.callback.apply(l.scope, [e, i]) : i.lastReturnValue = l.callback(e, i), l.unregisterOnNextCall && this._deferUnregister(l)), i.skipNextObservers)) return !1;
            }
          } catch (e) {
            r = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (o = c.return) && o.call(c);
            } finally {
              if (r) throw r.error;
            }
          }

          return !0;
        }, t.prototype.notifyObserversWithPromise = function (e, n, t, a) {
          var r = this;
          void 0 === n && (n = -1);
          var o = Promise.resolve(e);
          if (!this._observers.length) return o;
          var d = this._eventState;
          return d.mask = n, d.target = t, d.currentTarget = a, d.skipNextObservers = !1, this._observers.forEach(function (t) {
            d.skipNextObservers || t._willBeUnregistered || t.mask & n && (o = t.scope ? o.then(function (n) {
              return d.lastReturnValue = n, t.callback.apply(t.scope, [e, d]);
            }) : o.then(function (n) {
              return d.lastReturnValue = n, t.callback(e, d);
            }), t.unregisterOnNextCall && r._deferUnregister(t));
          }), o.then(function () {
            return e;
          });
        }, t.prototype.notifyObserver = function (e, n, t) {
          void 0 === t && (t = -1);
          var a = this._eventState;
          a.mask = t, a.skipNextObservers = !1, e.callback(n, a);
        }, t.prototype.hasObservers = function () {
          return this._observers.length > 0;
        }, t.prototype.clear = function () {
          this._observers = new Array(), this._onObserverAdded = null;
        }, t.prototype.clone = function () {
          var e = new t();
          return e._observers = this._observers.slice(0), e;
        }, t.prototype.hasSpecificMask = function (e) {
          var n, t;
          void 0 === e && (e = -1);

          try {
            for (var a = d(this._observers), r = a.next(); !r.done; r = a.next()) {
              var o = r.value;
              if (o.mask & e || o.mask === e) return !0;
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (t = a.return) && t.call(a);
            } finally {
              if (n) throw n.error;
            }
          }

          return !1;
        }, t.prototype._deferUnregister = function (e) {
          var n = this;
          e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, i.executeTask(function () {
            return r(n, void 0, void 0, function () {
              return o(this, function (n) {
                return [2, this._remove(e)];
              });
            });
          });
        }, t.prototype._remove = function (e) {
          if (!e) return !1;

          var n = this._observers.indexOf(e);

          return -1 !== n && (this._observers.splice(n, 1), !0);
        }, t;
      }();

      n.Observable = m;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(2),
          o = a(6),
          d = a(3),
          i = function () {
        function t(e, n, t, a) {
          this.x = e, this.y = n, this.z = t, this.w = a;
        }

        return t.Add = function (e, n) {
          return new t(e.x, e.y, e.z, e.w).addInPlace(n);
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1], e[n + 2], e[n + 3]);
        }, t.FromArrayToRef = function (e, n, t) {
          t.x = e[n], t.y = e[n + 1], t.z = e[n + 2], t.w = e[n + 3];
        }, t.FromFloatArrayToRef = function (e, n, a) {
          t.FromArrayToRef(e, n, a);
        }, t.FromFloatsToRef = function (e, n, t, a, r) {
          r.x = e, r.y = n, r.z = t, r.w = a;
        }, t.Zero = function () {
          return new t(0, 0, 0, 0);
        }, t.One = function () {
          return new t(1, 1, 1, 1);
        }, t.Normalize = function (e) {
          var n = t.Zero();
          return t.NormalizeToRef(e, n), n;
        }, t.NormalizeToRef = function (e, n) {
          n.copyFrom(e), n.normalize();
        }, t.Minimize = function (e, n) {
          var a = new t(e.x, e.y, e.z, e.w);
          return a.minimizeInPlace(n), a;
        }, t.Maximize = function (e, n) {
          var a = new t(e.x, e.y, e.z, e.w);
          return a.maximizeInPlace(n), a;
        }, t.Distance = function (e, n) {
          return Math.sqrt(t.DistanceSquared(e, n));
        }, t.DistanceSquared = function (e, n) {
          var t = e.x - n.x,
              a = e.y - n.y,
              r = e.z - n.z,
              o = e.w - n.w;
          return t * t + a * a + r * r + o * o;
        }, t.Center = function (e, n) {
          var a = t.Add(e, n);
          return a.scaleInPlace(.5), a;
        }, t.TransformNormal = function (e, n) {
          var a = t.Zero();
          return t.TransformNormalToRef(e, n, a), a;
        }, t.TransformNormalToRef = function (e, n, t) {
          var a = n.m,
              r = e.x * a[0] + e.y * a[4] + e.z * a[8],
              o = e.x * a[1] + e.y * a[5] + e.z * a[9],
              d = e.x * a[2] + e.y * a[6] + e.z * a[10];
          t.x = r, t.y = o, t.z = d, t.w = e.w;
        }, t.TransformNormalFromFloatsToRef = function (e, n, t, a, r, o) {
          var d = r.m;
          o.x = e * d[0] + n * d[4] + t * d[8], o.y = e * d[1] + n * d[5] + t * d[9], o.z = e * d[2] + n * d[6] + t * d[10], o.w = a;
        }, t.prototype.toString = function () {
          return "{X: " + this.x + " Y:" + this.y + " Z:" + this.z + " W:" + this.w + "}";
        }, t.prototype.getClassName = function () {
          return "Vector4";
        }, t.prototype.getHashCode = function () {
          var e = this.x || 0;
          return e = 397 * (e = 397 * (e = 397 * e ^ (this.y || 0)) ^ (this.z || 0)) ^ (this.w || 0);
        }, t.prototype.asArray = function () {
          var e = new Array();
          return this.toArray(e, 0), e;
        }, t.prototype.toArray = function (e, n) {
          return void 0 === n && (n = 0), e[n] = this.x, e[n + 1] = this.y, e[n + 2] = this.z, e[n + 3] = this.w, this;
        }, t.prototype.addInPlace = function (e) {
          return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
        }, t.prototype.add = function (e) {
          return new t(this.x + e.x, this.y + e.y, this.z + e.z, this.w + e.w);
        }, t.prototype.addToRef = function (e, n) {
          return n.x = this.x + e.x, n.y = this.y + e.y, n.z = this.z + e.z, n.w = this.w + e.w, this;
        }, t.prototype.subtractInPlace = function (e) {
          return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
        }, t.prototype.subtract = function (e) {
          return new t(this.x - e.x, this.y - e.y, this.z - e.z, this.w - e.w);
        }, t.prototype.subtractToRef = function (e, n) {
          return n.x = this.x - e.x, n.y = this.y - e.y, n.z = this.z - e.z, n.w = this.w - e.w, this;
        }, t.prototype.subtractFromFloats = function (e, n, a, r) {
          return new t(this.x - e, this.y - n, this.z - a, this.w - r);
        }, t.prototype.subtractFromFloatsToRef = function (e, n, t, a, r) {
          return r.x = this.x - e, r.y = this.y - n, r.z = this.z - t, r.w = this.w - a, this;
        }, t.prototype.negate = function () {
          return new t(-this.x, -this.y, -this.z, -this.w);
        }, t.prototype.scaleInPlace = function (e) {
          return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
        }, t.prototype.scale = function (e) {
          return new t(this.x * e, this.y * e, this.z * e, this.w * e);
        }, t.prototype.scaleToRef = function (e, n) {
          return n.x = this.x * e, n.y = this.y * e, n.z = this.z * e, n.w = this.w * e, this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.x += this.x * e, n.y += this.y * e, n.z += this.z * e, n.w += this.w * e, this;
        }, t.prototype.equals = function (e) {
          return e && this.x === e.x && this.y === e.y && this.z === e.z && this.w === e.w;
        }, t.prototype.equalsWithEpsilon = function (e, n) {
          return void 0 === n && (n = r.Epsilon), e && o.Scalar.WithinEpsilon(this.x, e.x, n) && o.Scalar.WithinEpsilon(this.y, e.y, n) && o.Scalar.WithinEpsilon(this.z, e.z, n) && o.Scalar.WithinEpsilon(this.w, e.w, n);
        }, t.prototype.equalsToFloats = function (e, n, t, a) {
          return this.x === e && this.y === n && this.z === t && this.w === a;
        }, t.prototype.multiplyInPlace = function (e) {
          return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
        }, t.prototype.multiply = function (e) {
          return new t(this.x * e.x, this.y * e.y, this.z * e.z, this.w * e.w);
        }, t.prototype.multiplyToRef = function (e, n) {
          return n.x = this.x * e.x, n.y = this.y * e.y, n.z = this.z * e.z, n.w = this.w * e.w, this;
        }, t.prototype.multiplyByFloats = function (e, n, a, r) {
          return new t(this.x * e, this.y * n, this.z * a, this.w * r);
        }, t.prototype.divide = function (e) {
          return new t(this.x / e.x, this.y / e.y, this.z / e.z, this.w / e.w);
        }, t.prototype.divideToRef = function (e, n) {
          return n.x = this.x / e.x, n.y = this.y / e.y, n.z = this.z / e.z, n.w = this.w / e.w, this;
        }, t.prototype.divideInPlace = function (e) {
          return this.divideToRef(e, this);
        }, t.prototype.minimizeInPlace = function (e) {
          return e.x < this.x && (this.x = e.x), e.y < this.y && (this.y = e.y), e.z < this.z && (this.z = e.z), e.w < this.w && (this.w = e.w), this;
        }, t.prototype.maximizeInPlace = function (e) {
          return e.x > this.x && (this.x = e.x), e.y > this.y && (this.y = e.y), e.z > this.z && (this.z = e.z), e.w > this.w && (this.w = e.w), this;
        }, t.prototype.floor = function () {
          return new t(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z), Math.floor(this.w));
        }, t.prototype.fract = function () {
          return new t(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z), this.w - Math.floor(this.w));
        }, t.prototype.length = function () {
          return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
        }, t.prototype.lengthSquared = function () {
          return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
        }, t.prototype.normalize = function () {
          var e = this.length();
          return 0 === e ? this : this.scaleInPlace(1 / e);
        }, t.prototype.toVector3 = function () {
          return new d.Vector3(this.x, this.y, this.z);
        }, t.prototype.clone = function () {
          return new t(this.x, this.y, this.z, this.w);
        }, t.prototype.copyFrom = function (e) {
          return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w, this;
        }, t.prototype.copyFromFloats = function (e, n, t, a) {
          return this.x = e, this.y = n, this.z = t, this.w = a, this;
        }, t.prototype.set = function (e, n, t, a) {
          return this.copyFromFloats(e, n, t, a);
        }, t.prototype.setAll = function (e) {
          return this.x = this.y = this.z = this.w = e, this;
        }, t;
      }();

      n.Vector4 = i;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = function () {
        function t(e) {
          this._radians = e, this._radians < 0 && (this._radians += 2 * Math.PI);
        }

        return t.BetweenTwoPoints = function (e, n) {
          var a = n.subtract(e);
          return new t(Math.atan2(a.y, a.x));
        }, t.FromRadians = function (e) {
          return new t(e);
        }, t.FromDegrees = function (e) {
          return new t(e * Math.PI / 180);
        }, t.prototype.degrees = function () {
          return 180 * this._radians / Math.PI;
        }, t.prototype.radians = function () {
          return this._radians;
        }, t;
      }();

      n.Angle = a;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = t(22),
          r = t(15),
          o = t(2),
          d = function d(e, n, t) {
        this.startPoint = e, this.midPoint = n, this.endPoint = t;
        var d = Math.pow(n.x, 2) + Math.pow(n.y, 2),
            i = (Math.pow(e.x, 2) + Math.pow(e.y, 2) - d) / 2,
            c = (d - Math.pow(t.x, 2) - Math.pow(t.y, 2)) / 2,
            s = (e.x - n.x) * (n.y - t.y) - (n.x - t.x) * (e.y - n.y);
        this.centerPoint = new r.Vector2((i * (n.y - t.y) - c * (e.y - n.y)) / s, ((e.x - n.x) * c - (n.x - t.x) * i) / s), this.radius = this.centerPoint.subtract(this.startPoint).length(), this.startAngle = a.Angle.BetweenTwoPoints(this.centerPoint, this.startPoint);
        var l = this.startAngle.degrees(),
            m = a.Angle.BetweenTwoPoints(this.centerPoint, this.midPoint).degrees(),
            p = a.Angle.BetweenTwoPoints(this.centerPoint, this.endPoint).degrees();
        m - l > 180 && (m -= 360), m - l < -180 && (m += 360), p - m > 180 && (p -= 360), p - m < -180 && (p += 360), this.orientation = m - l < 0 ? o.Orientation.CW : o.Orientation.CCW, this.angle = a.Angle.FromDegrees(this.orientation === o.Orientation.CW ? l - p : p - l);
      };

      n.Arc2 = d;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(6),
          o = a(2),
          d = function () {
        function t(e, n, t, a) {
          void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === t && (t = 0), void 0 === a && (a = 1), this.r = e, this.g = n, this.b = t, this.a = a;
        }

        return t.FromHexString = function (e) {
          if ("#" !== e.substring(0, 1) || 9 !== e.length) return new t(0, 0, 0, 0);
          var n = parseInt(e.substring(1, 3), 16),
              a = parseInt(e.substring(3, 5), 16),
              r = parseInt(e.substring(5, 7), 16),
              o = parseInt(e.substring(7, 9), 16);
          return t.FromInts(n, a, r, o);
        }, t.Lerp = function (e, n, a) {
          var r = new t(0, 0, 0, 0);
          return t.LerpToRef(e, n, a, r), r;
        }, t.LerpToRef = function (e, n, t, a) {
          a.r = e.r + (n.r - e.r) * t, a.g = e.g + (n.g - e.g) * t, a.b = e.b + (n.b - e.b) * t, a.a = e.a + (n.a - e.a) * t;
        }, t.Red = function () {
          return new t(1, 0, 0, 1);
        }, t.Green = function () {
          return new t(0, 1, 0, 1);
        }, t.Blue = function () {
          return new t(0, 0, 1, 1);
        }, t.Black = function () {
          return new t(0, 0, 0, 1);
        }, t.White = function () {
          return new t(1, 1, 1, 1);
        }, t.Purple = function () {
          return new t(.5, 0, .5, 1);
        }, t.Magenta = function () {
          return new t(1, 0, 1, 1);
        }, t.Yellow = function () {
          return new t(1, 1, 0, 1);
        }, t.Gray = function () {
          return new t(.5, .5, .5, 1);
        }, t.Teal = function () {
          return new t(0, 1, 1, 1);
        }, t.Clear = function () {
          return new t(0, 0, 0, 0);
        }, t.FromColor3 = function (e, n) {
          return void 0 === n && (n = 1), new t(e.r, e.g, e.b, n);
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1], e[n + 2], e[n + 3]);
        }, t.FromInts = function (e, n, a, r) {
          return new t(e / 255, n / 255, a / 255, r / 255);
        }, t.CheckColors4 = function (e, n) {
          if (e.length === 3 * n) {
            for (var t = [], a = 0; a < e.length; a += 3) {
              var r = a / 3 * 4;
              t[r] = e[a], t[r + 1] = e[a + 1], t[r + 2] = e[a + 2], t[r + 3] = 1;
            }

            return t;
          }

          return e;
        }, t.prototype.addInPlace = function (e) {
          return this.r += e.r, this.g += e.g, this.b += e.b, this.a += e.a, this;
        }, t.prototype.asArray = function () {
          var e = new Array();
          return this.toArray(e, 0), e;
        }, t.prototype.toArray = function (e, n) {
          return void 0 === n && (n = 0), e[n] = this.r, e[n + 1] = this.g, e[n + 2] = this.b, e[n + 3] = this.a, this;
        }, t.prototype.add = function (e) {
          return new t(this.r + e.r, this.g + e.g, this.b + e.b, this.a + e.a);
        }, t.prototype.subtract = function (e) {
          return new t(this.r - e.r, this.g - e.g, this.b - e.b, this.a - e.a);
        }, t.prototype.subtractToRef = function (e, n) {
          return n.r = this.r - e.r, n.g = this.g - e.g, n.b = this.b - e.b, n.a = this.a - e.a, this;
        }, t.prototype.scale = function (e) {
          return new t(this.r * e, this.g * e, this.b * e, this.a * e);
        }, t.prototype.scaleToRef = function (e, n) {
          return n.r = this.r * e, n.g = this.g * e, n.b = this.b * e, n.a = this.a * e, this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.r += this.r * e, n.g += this.g * e, n.b += this.b * e, n.a += this.a * e, this;
        }, t.prototype.clampToRef = function (e, n, t) {
          return void 0 === e && (e = 0), void 0 === n && (n = 1), t.r = r.Scalar.Clamp(this.r, e, n), t.g = r.Scalar.Clamp(this.g, e, n), t.b = r.Scalar.Clamp(this.b, e, n), t.a = r.Scalar.Clamp(this.a, e, n), this;
        }, t.prototype.multiply = function (e) {
          return new t(this.r * e.r, this.g * e.g, this.b * e.b, this.a * e.a);
        }, t.prototype.multiplyToRef = function (e, n) {
          return n.r = this.r * e.r, n.g = this.g * e.g, n.b = this.b * e.b, n.a = this.a * e.a, n;
        }, t.prototype.toString = function () {
          return "{R: " + this.r + " G:" + this.g + " B:" + this.b + " A:" + this.a + "}";
        }, t.prototype.getClassName = function () {
          return "Color4";
        }, t.prototype.getHashCode = function () {
          var e = this.r || 0;
          return e = 397 * (e = 397 * (e = 397 * e ^ (this.g || 0)) ^ (this.b || 0)) ^ (this.a || 0);
        }, t.prototype.clone = function () {
          return new t(this.r, this.g, this.b, this.a);
        }, t.prototype.copyFrom = function (e) {
          return this.r = e.r, this.g = e.g, this.b = e.b, this.a = e.a, this;
        }, t.prototype.copyFromFloats = function (e, n, t, a) {
          return this.r = e, this.g = n, this.b = t, this.a = a, this;
        }, t.prototype.set = function (e, n, t, a) {
          return this.copyFromFloats(e, n, t, a);
        }, t.prototype.toHexString = function () {
          var e = 255 * this.r | 0,
              n = 255 * this.g | 0,
              t = 255 * this.b | 0,
              a = 255 * this.a | 0;
          return "#" + r.Scalar.ToHex(e) + r.Scalar.ToHex(n) + r.Scalar.ToHex(t) + r.Scalar.ToHex(a);
        }, t.prototype.toLinearSpace = function () {
          var e = new t();
          return this.toLinearSpaceToRef(e), e;
        }, t.prototype.toLinearSpaceToRef = function (e) {
          return e.r = Math.pow(this.r, o.ToLinearSpace), e.g = Math.pow(this.g, o.ToLinearSpace), e.b = Math.pow(this.b, o.ToLinearSpace), e.a = this.a, this;
        }, t.prototype.toGammaSpace = function () {
          var e = new t();
          return this.toGammaSpaceToRef(e), e;
        }, t.prototype.toGammaSpaceToRef = function (e) {
          return e.r = Math.pow(this.r, o.ToGammaSpace), e.g = Math.pow(this.g, o.ToGammaSpace), e.b = Math.pow(this.b, o.ToGammaSpace), e.a = this.a, this;
        }, t;
      }();

      n.Color4 = d;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(3),
          o = a(11),
          d = a(9),
          i = function () {
        function t(e, n, t, a) {
          this.normal = new r.Vector3(e, n, t), this.d = a;
        }

        return t.FromArray = function (e) {
          return new t(e[0], e[1], e[2], e[3]);
        }, t.FromPoints = function (e, n, a) {
          var r = new t(0, 0, 0, 0);
          return r.copyFromPoints(e, n, a), r;
        }, t.FromPositionAndNormal = function (e, n) {
          var a = new t(0, 0, 0, 0);
          return n.normalize(), a.normal = n, a.d = -(n.x * e.x + n.y * e.y + n.z * e.z), a;
        }, t.SignedDistanceToPlaneFromPositionAndNormal = function (e, n, t) {
          var a = -(n.x * e.x + n.y * e.y + n.z * e.z);
          return r.Vector3.Dot(t, n) + a;
        }, t.prototype.asArray = function () {
          return [this.normal.x, this.normal.y, this.normal.z, this.d];
        }, t.prototype.clone = function () {
          return new t(this.normal.x, this.normal.y, this.normal.z, this.d);
        }, t.prototype.getClassName = function () {
          return "Plane";
        }, t.prototype.getHashCode = function () {
          var e = this.normal.getHashCode();
          return e = 397 * e ^ (this.d || 0);
        }, t.prototype.normalize = function () {
          var e = Math.sqrt(this.normal.x * this.normal.x + this.normal.y * this.normal.y + this.normal.z * this.normal.z),
              n = 0;
          return 0 !== e && (n = 1 / e), this.normal.x *= n, this.normal.y *= n, this.normal.z *= n, this.d *= n, this;
        }, t.prototype.transform = function (e) {
          var n = d.MathTmp.Matrix[0];
          o.Matrix.TransposeToRef(e, n);
          var a = n.m,
              r = this.normal.x,
              i = this.normal.y,
              c = this.normal.z,
              s = this.d;
          return new t(r * a[0] + i * a[1] + c * a[2] + s * a[3], r * a[4] + i * a[5] + c * a[6] + s * a[7], r * a[8] + i * a[9] + c * a[10] + s * a[11], r * a[12] + i * a[13] + c * a[14] + s * a[15]);
        }, t.prototype.dotCoordinate = function (e) {
          return this.normal.x * e.x + this.normal.y * e.y + this.normal.z * e.z + this.d;
        }, t.prototype.copyFromPoints = function (e, n, t) {
          var a,
              r = n.x - e.x,
              o = n.y - e.y,
              d = n.z - e.z,
              i = t.x - e.x,
              c = t.y - e.y,
              s = t.z - e.z,
              l = o * s - d * c,
              m = d * i - r * s,
              p = r * c - o * i,
              x = Math.sqrt(l * l + m * m + p * p);
          return a = 0 !== x ? 1 / x : 0, this.normal.x = l * a, this.normal.y = m * a, this.normal.z = p * a, this.d = -(this.normal.x * e.x + this.normal.y * e.y + this.normal.z * e.z), this;
        }, t.prototype.isFrontFacingTo = function (e, n) {
          return r.Vector3.Dot(this.normal, e) <= n;
        }, t.prototype.signedDistanceTo = function (e) {
          return r.Vector3.Dot(e, this.normal) + this.d;
        }, t;
      }();

      n.Plane = i;
    }, function (t, a, r) {
      "use strict";

      var _o4,
          d = this && this.__extends || (_o4 = function o(e, n) {
        return (_o4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var n, t = 1, a = arguments.length; t < a; t++) {
            for (var r in n = arguments[t]) {
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          c = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });

      var s = r(0),
          l = r(1),
          m = {
        looping: !0,
        speed: 1,
        weight: 1
      },
          p = function (n) {
        function e(e, t) {
          void 0 === t && (t = m);
          var a = n.call(this) || this;
          return a.isAnimationClip = !0, a.looping = m.looping, a.weight = m.weight, a.playing = !1, a.shouldReset = !1, a.speed = m.speed, a.name = l.newId("AnimClip"), a.clip = e, a.setParams(i({}, t)), a;
        }

        return d(e, n), e.prototype.setParams = function (e) {
          return this.looping = void 0 !== e.looping ? e.looping : this.looping, this.speed = e.speed || this.speed, this;
        }, e.prototype.toJSON = function () {
          var e = JSON.parse(JSON.stringify(n.prototype.toJSON.call(this)));
          return this.shouldReset && (this.shouldReset = !1), e;
        }, e.prototype.play = function () {
          this.playing = !0;
        }, e.prototype.pause = function () {
          this.playing = !1;
        }, e.prototype.reset = function () {
          this.shouldReset = !0;
        }, e.prototype.stop = function () {
          this.reset(), this.pause();
        }, c([s.ObservableComponent.readonly], e.prototype, "clip", void 0), c([s.ObservableComponent.field], e.prototype, "looping", void 0), c([s.ObservableComponent.field], e.prototype, "weight", void 0), c([s.ObservableComponent.field], e.prototype, "playing", void 0), c([s.ObservableComponent.field], e.prototype, "shouldReset", void 0), c([s.ObservableComponent.field], e.prototype, "speed", void 0), c([s.ObservableComponent.readonly], e.prototype, "name", void 0), e;
      }(s.ObservableComponent);

      a.AnimationState = p;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      }), function (e) {
        e[e.DOWN = 0] = "DOWN", e[e.UP = 1] = "UP";
      }(n.InputEventType || (n.InputEventType = {})), n.AVATAR_OBSERVABLE = "AVATAR_OBSERVABLE";
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r,
          o = a(5),
          d = a(1),
          i = a(29);
      !function (e) {
        e.HitFirst = "rqhf", e.HitAll = "rqha";
      }(r || (r = {}));

      var c = function () {
        function t() {
          this.queries = {};
        }

        return Object.defineProperty(t, "instance", {
          get: function get() {
            return t.ensureInstance(), t._instance;
          },
          enumerable: !0,
          configurable: !0
        }), t.ensureInstance = function () {
          t._instance || (t._instance = new t());
        }, t.prototype.getRayFromCamera = function (e) {
          var n = i.Camera.instance.rotation,
              t = o.Matrix.Identity();
          n.toRotationMatrix(t);
          var a = o.Vector3.TransformCoordinates(o.Vector3.Forward(), t);
          return {
            origin: i.Camera.instance.position,
            direction: a,
            distance: e
          };
        }, t.prototype.getRayFromPositions = function (e, n) {
          var t = n.subtract(e),
              a = t.length();
          return {
            origin: e,
            direction: t.normalize(),
            distance: a
          };
        }, t.prototype.hitFirst = function (e, n, t) {
          var a = "number" == typeof t ? r.HitFirst + t : d.uuid();
          this.queries[a] = n, dcl && dcl.query("raycast", {
            queryId: a,
            queryType: "HitFirst",
            ray: e
          });
        }, t.prototype.hitAll = function (e, n, t) {
          var a = "number" == typeof t ? r.HitAll + t : d.uuid();
          this.queries[a] = n, dcl && dcl.query("raycast", {
            queryId: a,
            queryType: "HitAll",
            ray: e
          });
        }, t.prototype.hitFirstAvatar = function (e, n) {
          d.log("not implemented yet");
        }, t.prototype.hitAllAvatars = function (e, n) {
          d.log("not implemented yet");
        }, t.prototype.handleRaycastHitFirstResponse = function (e) {
          this.queries[e.payload.queryId](e.payload.payload), delete this.queries[e.payload.queryId];
        }, t.prototype.handleRaycastHitAllResponse = function (e) {
          this.queries[e.payload.queryId](e.payload.payload), delete this.queries[e.payload.queryId];
        }, t;
      }();

      n.PhysicsCast = c;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(5),
          o = function () {
        function t() {
          var e = this;
          this.position = new r.Vector3(), this.rotation = new r.Quaternion(), this.feetPosition = new r.Vector3(), this.worldPosition = new r.Vector3(), this.lastEventPosition = {
            x: 0,
            y: 0,
            z: 0
          }, this.lastEventWorldPosition = {
            x: 0,
            y: 0,
            z: 0
          }, this.lastEventRotation = {
            x: 0,
            y: 0,
            z: 0,
            w: 1
          }, this._playerHeight = 1.6, "undefined" != typeof dcl && (dcl.subscribe("positionChanged"), dcl.subscribe("rotationChanged"), dcl.onEvent(function (n) {
            switch (n.type) {
              case "positionChanged":
                e.positionChanged(n.data);
                break;

              case "rotationChanged":
                e.rotationChanged(n.data);
            }
          })), Object.defineProperty(this.position, "x", {
            get: function get() {
              return e.lastEventPosition.x;
            }
          }), Object.defineProperty(this.position, "y", {
            get: function get() {
              return e.lastEventPosition.y;
            }
          }), Object.defineProperty(this.position, "z", {
            get: function get() {
              return e.lastEventPosition.z;
            }
          }), Object.defineProperty(this.worldPosition, "x", {
            get: function get() {
              return e.lastEventWorldPosition.x;
            }
          }), Object.defineProperty(this.worldPosition, "y", {
            get: function get() {
              return e.lastEventWorldPosition.y;
            }
          }), Object.defineProperty(this.worldPosition, "z", {
            get: function get() {
              return e.lastEventWorldPosition.z;
            }
          }), Object.defineProperty(this.feetPosition, "x", {
            get: function get() {
              return e.lastEventPosition.x;
            }
          }), Object.defineProperty(this.feetPosition, "y", {
            get: function get() {
              return e.lastEventPosition.y - e.playerHeight;
            }
          }), Object.defineProperty(this.feetPosition, "z", {
            get: function get() {
              return e.lastEventPosition.z;
            }
          }), Object.defineProperty(this.rotation, "x", {
            get: function get() {
              return e.lastEventRotation.x;
            }
          }), Object.defineProperty(this.rotation, "y", {
            get: function get() {
              return e.lastEventRotation.y;
            }
          }), Object.defineProperty(this.rotation, "z", {
            get: function get() {
              return e.lastEventRotation.z;
            }
          }), Object.defineProperty(this.rotation, "w", {
            get: function get() {
              return e.lastEventRotation.w;
            }
          });
        }

        return Object.defineProperty(t, "instance", {
          get: function get() {
            return t._instance || (t._instance = new t()), t._instance;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "playerHeight", {
          get: function get() {
            return this._playerHeight;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.positionChanged = function (e) {
          this.lastEventPosition = e.position, this.lastEventWorldPosition = e.cameraPosition, this._playerHeight = e.playerHeight;
        }, t.prototype.rotationChanged = function (e) {
          this.lastEventRotation = e.quaternion;
        }, t;
      }();

      n.Camera = o;
    }, function (e, n, t) {
      "use strict";

      function o(e) {
        for (var t in e) {
          n.hasOwnProperty(t) || (n[t] = e[t]);
        }
      }

      Object.defineProperty(n, "__esModule", {
        value: !0
      }), o(t(31)), o(t(17)), o(t(0)), o(t(12)), o(t(7)), o(t(19)), o(t(1)), o(t(20)), o(t(18)), o(t(8)), o(t(33)), o(t(34));
      var a = t(35),
          r = t(17),
          d = new (t(12).Entity)("scene");
      d.uuid = "0";
      var i = new r.Engine(d);
      n.engine = i, t(0).DisposableComponent.engine = i, "undefined" != typeof dcl && i.addSystem(new a.DecentralandSynchronizationSystem(dcl), 1 / 0);
      var c = t(14);
      i.addSystem(c.uuidEventSystem), i.addSystem(c.pointerEventSystem), i.addSystem(c.raycastEventSystem), o(t(27)), o(t(4)), o(t(14)), o(t(13)), o(t(29)), o(t(5)), o(t(26)), o(t(16)), o(t(44)), o(t(45)), o(t(46)), o(t(47)), o(t(48)), o(t(49)), o(t(28));
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = function () {
        function t() {}

        return t.AVATAR = {
          getEntityRepresentation: function getEntityRepresentation(e) {
            return e.avatarEntity;
          }
        }, t.FIRST_PERSON_CAMERA = {
          getEntityRepresentation: function getEntityRepresentation(e) {
            return e.firstPersonCameraEntity;
          }
        }, t;
      }();

      n.Attachable = a;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(0),
          o = function () {
        function t() {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e[n] = arguments[n];
          }

          if (this.entities = [], this.active = !1, this._requiresNames = [], !e) throw new Error("ComponentGroup: Could not load the requires list");
          if (!(e instanceof Array)) throw new Error("ComponentGroup: requires list is not an Array");
          Object.defineProperty(this, "requires", {
            get: function get() {
              return e.slice();
            }
          }), Object.defineProperty(this, "requiresNames", {
            get: function get() {
              return this._requiresNames.slice();
            }
          });

          for (var t = function t(n) {
            var t = e[n],
                o = null;
            if (!t) throw new Error("ComponentGroup: the required component at location " + n + " is invalid");

            try {
              o = r.getComponentName(t);
            } catch (e) {
              throw new Error("ComponentGroup: the required component at location " + n + " is not registered as a @Component. Remember to provide the class of the component, not the name");
            }

            if (a._requiresNames.some(function (e) {
              return e === o;
            })) throw new Error("ComponentGroup: the required component list has a repeated name " + o);

            a._requiresNames.push(o);
          }, a = this, o = 0; o < e.length; o++) {
            t(o);
          }
        }

        return t.prototype.hasEntity = function (e) {
          return !!e.isAddedToEngine() && -1 !== this.entities.indexOf(e);
        }, t.prototype.addEntity = function (e) {
          if (!e.isAddedToEngine()) throw new TypeError("ComponentGroup: Cannot add a entity that is not added to the engine");
          -1 === this.entities.indexOf(e) && this.entities.push(e);
        }, t.prototype.removeEntity = function (e) {
          var n = this.entities.indexOf(e);
          -1 !== n && this.entities.splice(n, 1);
        }, t.prototype.componentRemoved = function (e, n) {
          -1 !== this._requiresNames.indexOf(n) && this.removeEntity(e);
        }, t.prototype.meetsRequirements = function (e) {
          for (var n = 0; n < this._requiresNames.length; n++) {
            if (!(this._requiresNames[n] in e.components)) return !1;
          }

          return !0;
        }, t;
      }();

      n.ComponentGroup = o;
    }, function (e, n, t) {
      "use strict";

      var a;
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.teleportTo = function (e) {
        var n, t;
        n = "requestTeleport", t = [e], void 0 === a && "undefined" != typeof dcl && (a = dcl.loadModule("@decentraland/UserActionModule")), void 0 !== a && "undefined" != typeof dcl && a.then(function (e) {
          dcl.callRpc(e.rpcHandle, n, t);
        });
      };
    }, function (e, n, t) {
      "use strict";

      var a;
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.movePlayerTo = function (e, n) {
        var t, r;
        t = "movePlayerTo", r = [e, n], void 0 === a && "undefined" != typeof dcl && (a = dcl.loadModule("@decentraland/RestrictedActionModule")), void 0 !== a && "undefined" != typeof dcl && a.then(function (e) {
          dcl.callRpc(e.rpcHandle, t, r);
        });
      };
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(0),
          o = a(7),
          d = a(13),
          i = function () {
        function t(e) {
          this.dcl = e, this.cachedComponents = {};
        }

        return t.prototype.activate = function (e) {
          var n = this;
          this.engine = e, e.eventManager.addListener(o.ComponentAdded, this, this.componentAdded), e.eventManager.addListener(o.ComponentRemoved, this, this.componentRemoved), e.eventManager.addListener(r.DisposableComponentCreated, this, this.disposableComponentCreated), e.eventManager.addListener(r.DisposableComponentRemoved, this, this.disposableComponentRemoved), e.eventManager.addListener(r.DisposableComponentUpdated, this, this.disposableComponentUpdated), e.eventManager.addListener(o.ParentChanged, this, this.parentChanged);
          var t = e.rootEntity.uuid;
          this.dcl.addEntity(t), this.dcl.onUpdate(function (t) {
            e.update(t), n.presentEntities();
          }), this.dcl.onEvent(function (n) {
            var t = n.data;

            switch (n.type) {
              case "uuidEvent":
                e.eventManager.fireEvent(new d.UUIDEvent(t.uuid, t.payload));
                break;

              case "raycastResponse":
                ("HitFirst" === t.queryType || "HitAll" === t.queryType) && e.eventManager.fireEvent(new d.RaycastResponse(t));
                break;

              case "pointerEvent":
                e.eventManager.fireEvent(new d.PointerEvent(t.payload));
            }
          });
        }, t.prototype.onAddEntity = function (e) {
          if (e && e.isAddedToEngine()) {
            var n = e.uuid,
                t = e.getParent();

            for (var a in this.dcl.addEntity(n), t && this.dcl.setParent(n, t.uuid), this.cachedComponents[n] = {}, e.components) {
              var o = e.components[a],
                  d = r.getComponentClassId(o);
              if (null !== d) if (r.isDisposableComponent(o)) this.dcl.attachEntityComponent(e.uuid, a, r.getComponentId(o));else {
                var i = JSON.stringify(o);
                this.dcl.updateEntityComponent(n, a, d, i), this.cachedComponents[n][a] = i;
              }
            }
          }
        }, t.prototype.onRemoveEntity = function (e) {
          if (e.isAddedToEngine()) {
            var n = e.uuid;
            this.dcl.removeEntity(n), delete this.cachedComponents[n];
          }
        }, t.prototype.presentEntities = function () {
          for (var e in this.engine.entities) {
            var n = this.engine.entities[e];

            for (var t in n.components) {
              var a = n.components[t],
                  o = r.getComponentClassId(a);

              if (null !== o && !r.isDisposableComponent(a)) {
                var d = this.getJsonIfDirty(n.uuid, t, a);
                d && (this.dcl.updateEntityComponent(n.uuid, t, o, d), this.clearDirty(n.uuid, t, a, d));
              }
            }
          }

          for (var i in this.engine.disposableComponents) {
            (a = this.engine.disposableComponents[i]) instanceof r.ObservableComponent && a.dirty && (this.dcl.componentUpdated(i, JSON.stringify(a)), a.dirty = !1);
          }
        }, t.prototype.componentAdded = function (e) {
          if (e.entity.isAddedToEngine()) {
            var n = e.entity.components[e.componentName];
            if (r.isDisposableComponent(n)) this.dcl.attachEntityComponent(e.entity.uuid, e.componentName, r.getComponentId(n));else if (null !== e.classId) {
              var t = JSON.stringify(n);
              this.dcl.updateEntityComponent(e.entity.uuid, e.componentName, e.classId, t), this.cachedComponents[e.entity.uuid][e.componentName] = t;
            }
          }
        }, t.prototype.componentRemoved = function (e) {
          e.entity.isAddedToEngine() && (this.dcl.removeEntityComponent(e.entity.uuid, e.componentName), delete this.cachedComponents[e.entity.uuid][e.componentName]);
        }, t.prototype.disposableComponentCreated = function (e) {
          this.dcl.componentCreated(e.componentId, e.componentName, e.classId);
        }, t.prototype.disposableComponentRemoved = function (e) {
          this.dcl.componentDisposed(e.componentId);
        }, t.prototype.disposableComponentUpdated = function (e) {
          this.dcl.componentUpdated(e.componentId, JSON.stringify(e.component));
        }, t.prototype.parentChanged = function (e) {
          this.dcl.setParent(e.entity.uuid, e.parent ? e.parent.uuid : "0");
        }, t.prototype.getJsonIfDirty = function (e, n, t) {
          var a = JSON.stringify(t);
          return a !== this.cachedComponents[e][n] && a;
        }, t.prototype.clearDirty = function (e, n, t, a) {
          this.cachedComponents[e][n] = a;
        }, t;
      }();

      n.DecentralandSynchronizationSystem = i;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(3),
          o = function () {
        function t() {}

        return t.X = new r.Vector3(1, 0, 0), t.Y = new r.Vector3(0, 1, 0), t.Z = new r.Vector3(0, 0, 1), t;
      }();

      n.Axis = o;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = function () {
        function t() {}

        return t.Interpolate = function (e, n, t, a, r) {
          for (var o = 1 - 3 * a + 3 * n, d = 3 * a - 6 * n, i = 3 * n, c = e, s = 0; s < 5; s++) {
            var l = c * c;
            c -= (o * (l * c) + d * l + i * c - e) * (1 / (3 * o * l + 2 * d * c + i)), c = Math.min(1, Math.max(0, c));
          }

          return 3 * Math.pow(1 - c, 2) * c * t + 3 * (1 - c) * Math.pow(c, 2) * r + Math.pow(c, 3);
        }, t;
      }();

      n.BezierCurve = a;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(2),
          o = a(24),
          d = a(6),
          i = function () {
        function t(e, n, t) {
          void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === t && (t = 0), this.r = e, this.g = n, this.b = t;
        }

        return t.FromHexString = function (e) {
          if ("#" !== e.substring(0, 1) || 7 !== e.length) return new t(0, 0, 0);
          var n = parseInt(e.substring(1, 3), 16),
              a = parseInt(e.substring(3, 5), 16),
              r = parseInt(e.substring(5, 7), 16);
          return t.FromInts(n, a, r);
        }, t.FromArray = function (e, n) {
          return void 0 === n && (n = 0), new t(e[n], e[n + 1], e[n + 2]);
        }, t.FromInts = function (e, n, a) {
          return new t(e / 255, n / 255, a / 255);
        }, t.Lerp = function (e, n, a) {
          var r = new t(0, 0, 0);
          return t.LerpToRef(e, n, a, r), r;
        }, t.LerpToRef = function (e, n, t, a) {
          a.r = e.r + (n.r - e.r) * t, a.g = e.g + (n.g - e.g) * t, a.b = e.b + (n.b - e.b) * t;
        }, t.Red = function () {
          return new t(1, 0, 0);
        }, t.Green = function () {
          return new t(0, 1, 0);
        }, t.Blue = function () {
          return new t(0, 0, 1);
        }, t.Black = function () {
          return new t(0, 0, 0);
        }, t.White = function () {
          return new t(1, 1, 1);
        }, t.Purple = function () {
          return new t(.5, 0, .5);
        }, t.Magenta = function () {
          return new t(1, 0, 1);
        }, t.Yellow = function () {
          return new t(1, 1, 0);
        }, t.Gray = function () {
          return new t(.5, .5, .5);
        }, t.Teal = function () {
          return new t(0, 1, 1);
        }, t.Random = function () {
          return new t(Math.random(), Math.random(), Math.random());
        }, t.prototype.toString = function () {
          return "{R: " + this.r + " G:" + this.g + " B:" + this.b + "}";
        }, t.prototype.getClassName = function () {
          return "Color3";
        }, t.prototype.getHashCode = function () {
          var e = this.r || 0;
          return e = 397 * (e = 397 * e ^ (this.g || 0)) ^ (this.b || 0);
        }, t.prototype.toArray = function (e, n) {
          return void 0 === n && (n = 0), e[n] = this.r, e[n + 1] = this.g, e[n + 2] = this.b, this;
        }, t.prototype.toColor4 = function (e) {
          return void 0 === e && (e = 1), new o.Color4(this.r, this.g, this.b, e);
        }, t.prototype.asArray = function () {
          var e = new Array();
          return this.toArray(e, 0), e;
        }, t.prototype.toLuminance = function () {
          return .3 * this.r + .59 * this.g + .11 * this.b;
        }, t.prototype.multiply = function (e) {
          return new t(this.r * e.r, this.g * e.g, this.b * e.b);
        }, t.prototype.multiplyToRef = function (e, n) {
          return n.r = this.r * e.r, n.g = this.g * e.g, n.b = this.b * e.b, this;
        }, t.prototype.equals = function (e) {
          return e && this.r === e.r && this.g === e.g && this.b === e.b;
        }, t.prototype.equalsFloats = function (e, n, t) {
          return this.r === e && this.g === n && this.b === t;
        }, t.prototype.scale = function (e) {
          return new t(this.r * e, this.g * e, this.b * e);
        }, t.prototype.scaleToRef = function (e, n) {
          return n.r = this.r * e, n.g = this.g * e, n.b = this.b * e, this;
        }, t.prototype.scaleAndAddToRef = function (e, n) {
          return n.r += this.r * e, n.g += this.g * e, n.b += this.b * e, this;
        }, t.prototype.clampToRef = function (e, n, t) {
          return void 0 === e && (e = 0), void 0 === n && (n = 1), t.r = d.Scalar.Clamp(this.r, e, n), t.g = d.Scalar.Clamp(this.g, e, n), t.b = d.Scalar.Clamp(this.b, e, n), this;
        }, t.prototype.add = function (e) {
          return new t(this.r + e.r, this.g + e.g, this.b + e.b);
        }, t.prototype.addToRef = function (e, n) {
          return n.r = this.r + e.r, n.g = this.g + e.g, n.b = this.b + e.b, this;
        }, t.prototype.subtract = function (e) {
          return new t(this.r - e.r, this.g - e.g, this.b - e.b);
        }, t.prototype.subtractToRef = function (e, n) {
          return n.r = this.r - e.r, n.g = this.g - e.g, n.b = this.b - e.b, this;
        }, t.prototype.clone = function () {
          return new t(this.r, this.g, this.b);
        }, t.prototype.copyFrom = function (e) {
          return this.r = e.r, this.g = e.g, this.b = e.b, this;
        }, t.prototype.copyFromFloats = function (e, n, t) {
          return this.r = e, this.g = n, this.b = t, this;
        }, t.prototype.set = function (e, n, t) {
          return this.copyFromFloats(e, n, t);
        }, t.prototype.toHexString = function () {
          var e = 255 * this.r | 0,
              n = 255 * this.g | 0,
              t = 255 * this.b | 0;
          return "#" + d.Scalar.ToHex(e) + d.Scalar.ToHex(n) + d.Scalar.ToHex(t);
        }, t.prototype.toLinearSpace = function () {
          var e = new t();
          return this.toLinearSpaceToRef(e), e;
        }, t.prototype.toLinearSpaceToRef = function (e) {
          return e.r = Math.pow(this.r, r.ToLinearSpace), e.g = Math.pow(this.g, r.ToLinearSpace), e.b = Math.pow(this.b, r.ToLinearSpace), this;
        }, t.prototype.toGammaSpace = function () {
          var e = new t();
          return this.toGammaSpaceToRef(e), e;
        }, t.prototype.toGammaSpaceToRef = function (e) {
          return e.r = Math.pow(this.r, r.ToGammaSpace), e.g = Math.pow(this.g, r.ToGammaSpace), e.b = Math.pow(this.b, r.ToGammaSpace), this;
        }, t.prototype.toJSON = function () {
          return {
            r: this.r,
            g: this.g,
            b: this.b
          };
        }, t;
      }();

      n.Color3 = i;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(3),
          o = function () {
        function t(e) {
          this._length = 0, this._points = e, this._length = this._computeLength(e);
        }

        return t.CreateQuadraticBezier = function (e, n, a, o) {
          o = o > 2 ? o : 3;

          for (var d = new Array(), i = function i(e, n, t, a) {
            return (1 - e) * (1 - e) * n + 2 * e * (1 - e) * t + e * e * a;
          }, c = 0; c <= o; c++) {
            d.push(new r.Vector3(i(c / o, e.x, n.x, a.x), i(c / o, e.y, n.y, a.y), i(c / o, e.z, n.z, a.z)));
          }

          return new t(d);
        }, t.CreateCubicBezier = function (e, n, a, o, d) {
          d = d > 3 ? d : 4;

          for (var i = new Array(), c = function c(e, n, t, a, r) {
            return (1 - e) * (1 - e) * (1 - e) * n + 3 * e * (1 - e) * (1 - e) * t + 3 * e * e * (1 - e) * a + e * e * e * r;
          }, s = 0; s <= d; s++) {
            i.push(new r.Vector3(c(s / d, e.x, n.x, a.x, o.x), c(s / d, e.y, n.y, a.y, o.y), c(s / d, e.z, n.z, a.z, o.z)));
          }

          return new t(i);
        }, t.CreateHermiteSpline = function (e, n, a, o, d) {
          for (var i = new Array(), c = 1 / d, s = 0; s <= d; s++) {
            i.push(r.Vector3.Hermite(e, n, a, o, s * c));
          }

          return new t(i);
        }, t.CreateCatmullRomSpline = function (e, n, a) {
          var o = new Array(),
              d = 1 / n,
              i = 0;

          if (a) {
            for (var c = e.length, s = 0; s < c; s++) {
              i = 0;

              for (var l = 0; l < n; l++) {
                o.push(r.Vector3.CatmullRom(e[s % c], e[(s + 1) % c], e[(s + 2) % c], e[(s + 3) % c], i)), i += d;
              }
            }

            o.push(o[0]);
          } else {
            var m = new Array();
            m.push(e[0].clone()), Array.prototype.push.apply(m, e), m.push(e[e.length - 1].clone());
            s = 0;

            for (s = 0; s < m.length - 3; s++) {
              i = 0;

              for (l = 0; l < n; l++) {
                o.push(r.Vector3.CatmullRom(m[s], m[s + 1], m[s + 2], m[s + 3], i)), i += d;
              }
            }

            s--, o.push(r.Vector3.CatmullRom(m[s], m[s + 1], m[s + 2], m[s + 3], i));
          }

          return new t(o);
        }, t.prototype.getPoints = function () {
          return this._points;
        }, t.prototype.length = function () {
          return this._length;
        }, t.prototype.continue = function (e) {
          for (var n = this._points[this._points.length - 1], a = this._points.slice(), r = e.getPoints(), o = 1; o < r.length; o++) {
            a.push(r[o].subtract(r[0]).add(n));
          }

          return new t(a);
        }, t.prototype._computeLength = function (e) {
          for (var n = 0, t = 1; t < e.length; t++) {
            n += e[t].subtract(e[t - 1]).length();
          }

          return n;
        }, t;
      }();

      n.Curve3 = o;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(25),
          o = function () {
        function t() {}

        return t.GetPlanes = function (e) {
          for (var n = [], a = 0; a < 6; a++) {
            n.push(new r.Plane(0, 0, 0, 0));
          }

          return t.GetPlanesToRef(e, n), n;
        }, t.GetNearPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] + t[2], n.normal.y = t[7] + t[6], n.normal.z = t[11] + t[10], n.d = t[15] + t[14], n.normalize();
        }, t.GetFarPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] - t[2], n.normal.y = t[7] - t[6], n.normal.z = t[11] - t[10], n.d = t[15] - t[14], n.normalize();
        }, t.GetLeftPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] + t[0], n.normal.y = t[7] + t[4], n.normal.z = t[11] + t[8], n.d = t[15] + t[12], n.normalize();
        }, t.GetRightPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] - t[0], n.normal.y = t[7] - t[4], n.normal.z = t[11] - t[8], n.d = t[15] - t[12], n.normalize();
        }, t.GetTopPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] - t[1], n.normal.y = t[7] - t[5], n.normal.z = t[11] - t[9], n.d = t[15] - t[13], n.normalize();
        }, t.GetBottomPlaneToRef = function (e, n) {
          var t = e.m;
          n.normal.x = t[3] + t[1], n.normal.y = t[7] + t[5], n.normal.z = t[11] + t[9], n.d = t[15] + t[13], n.normalize();
        }, t.GetPlanesToRef = function (e, n) {
          t.GetNearPlaneToRef(e, n[0]), t.GetFarPlaneToRef(e, n[1]), t.GetLeftPlaneToRef(e, n[2]), t.GetRightPlaneToRef(e, n[3]), t.GetTopPlaneToRef(e, n[4]), t.GetBottomPlaneToRef(e, n[5]);
        }, t;
      }();

      n.Frustum = o;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(15),
          o = a(23),
          d = a(2),
          i = function () {
        function t(e, n) {
          this.closed = !1, this._points = new Array(), this._length = 0, this._points.push(new r.Vector2(e, n));
        }

        return t.StartingAt = function (e, n) {
          return new t(e, n);
        }, t.prototype.addLineTo = function (e, n) {
          if (this.closed) return this;
          var t = new r.Vector2(e, n),
              a = this._points[this._points.length - 1];
          return this._points.push(t), this._length += t.subtract(a).length(), this;
        }, t.prototype.addArcTo = function (e, n, t, a, i) {
          if (void 0 === i && (i = 36), this.closed) return this;
          var c = this._points[this._points.length - 1],
              s = new r.Vector2(e, n),
              l = new r.Vector2(t, a),
              m = new o.Arc2(c, s, l),
              p = m.angle.radians() / i;
          m.orientation === d.Orientation.CW && (p *= -1);

          for (var x = m.startAngle.radians() + p, k = 0; k < i; k++) {
            var u = Math.cos(x) * m.radius + m.centerPoint.x,
                f = Math.sin(x) * m.radius + m.centerPoint.y;
            this.addLineTo(u, f), x += p;
          }

          return this;
        }, t.prototype.close = function () {
          return this.closed = !0, this;
        }, t.prototype.length = function () {
          var e = this._length;

          if (!this.closed) {
            var n = this._points[this._points.length - 1];
            e += this._points[0].subtract(n).length();
          }

          return e;
        }, t.prototype.getPoints = function () {
          return this._points;
        }, t.prototype.getPointAtLengthPosition = function (e) {
          if (e < 0 || e > 1) return r.Vector2.Zero();

          for (var n = e * this.length(), t = 0, a = 0; a < this._points.length; a++) {
            var o = (a + 1) % this._points.length,
                d = this._points[a],
                i = this._points[o].subtract(d),
                c = i.length() + t;

            if (n >= t && n <= c) {
              var s = i.normalize(),
                  l = n - t;
              return new r.Vector2(d.x + s.x * l, d.y + s.y * l);
            }

            t = c;
          }

          return r.Vector2.Zero();
        }, t;
      }();

      n.Path2 = i;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var r = a(3),
          o = a(2),
          d = a(6),
          i = function () {
        function t(e, n, t) {
          void 0 === n && (n = null), this.path = e, this._curve = new Array(), this._distances = new Array(), this._tangents = new Array(), this._normals = new Array(), this._binormals = new Array();

          for (var a = 0; a < e.length; a++) {
            this._curve[a] = e[a].clone();
          }

          this._raw = t || !1, this._compute(n);
        }

        return t.prototype.getCurve = function () {
          return this._curve;
        }, t.prototype.getTangents = function () {
          return this._tangents;
        }, t.prototype.getNormals = function () {
          return this._normals;
        }, t.prototype.getBinormals = function () {
          return this._binormals;
        }, t.prototype.getDistances = function () {
          return this._distances;
        }, t.prototype.update = function (e, n) {
          void 0 === n && (n = null);

          for (var t = 0; t < e.length; t++) {
            this._curve[t].x = e[t].x, this._curve[t].y = e[t].y, this._curve[t].z = e[t].z;
          }

          return this._compute(n), this;
        }, t.prototype._compute = function (e) {
          var n = this._curve.length;
          this._tangents[0] = this._getFirstNonNullVector(0), this._raw || this._tangents[0].normalize(), this._tangents[n - 1] = this._curve[n - 1].subtract(this._curve[n - 2]), this._raw || this._tangents[n - 1].normalize();

          var t,
              a,
              o,
              d,
              i = this._tangents[0],
              c = this._normalVector(this._curve[0], i, e);

          this._normals[0] = c, this._raw || this._normals[0].normalize(), this._binormals[0] = r.Vector3.Cross(i, this._normals[0]), this._raw || this._binormals[0].normalize(), this._distances[0] = 0;

          for (var s = 1; s < n; s++) {
            t = this._getLastNonNullVector(s), s < n - 1 && (a = this._getFirstNonNullVector(s), this._tangents[s] = t.add(a), this._tangents[s].normalize()), this._distances[s] = this._distances[s - 1] + t.length(), o = this._tangents[s], d = this._binormals[s - 1], this._normals[s] = r.Vector3.Cross(d, o), this._raw || this._normals[s].normalize(), this._binormals[s] = r.Vector3.Cross(o, this._normals[s]), this._raw || this._binormals[s].normalize();
          }
        }, t.prototype._getFirstNonNullVector = function (e) {
          for (var n = 1, t = this._curve[e + n].subtract(this._curve[e]); 0 === t.length() && e + n + 1 < this._curve.length;) {
            n++, t = this._curve[e + n].subtract(this._curve[e]);
          }

          return t;
        }, t.prototype._getLastNonNullVector = function (e) {
          for (var n = 1, t = this._curve[e].subtract(this._curve[e - n]); 0 === t.length() && e > n + 1;) {
            n++, t = this._curve[e].subtract(this._curve[e - n]);
          }

          return t;
        }, t.prototype._normalVector = function (e, n, t) {
          var a,
              i = n.length();

          if (0 === i && (i = 1), null == t) {
            var c = void 0;
            c = d.Scalar.WithinEpsilon(Math.abs(n.y) / i, 1, o.Epsilon) ? d.Scalar.WithinEpsilon(Math.abs(n.x) / i, 1, o.Epsilon) ? d.Scalar.WithinEpsilon(Math.abs(n.z) / i, 1, o.Epsilon) ? r.Vector3.Zero() : new r.Vector3(0, 0, 1) : new r.Vector3(1, 0, 0) : new r.Vector3(0, -1, 0), a = r.Vector3.Cross(n, c);
          } else a = r.Vector3.Cross(n, t), r.Vector3.CrossToRef(a, n, a);

          return a.normalize(), a;
        }, t;
      }();

      n.Path3D = i;
    }, function (e, n, t) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });

      var a = function () {
        function t(e, n) {
          this.width = e, this.height = n;
        }

        return Object.defineProperty(t.prototype, "surface", {
          get: function get() {
            return this.width * this.height;
          },
          enumerable: !0,
          configurable: !0
        }), t.Zero = function () {
          return new t(0, 0);
        }, t.Lerp = function (e, n, a) {
          return new t(e.width + (n.width - e.width) * a, e.height + (n.height - e.height) * a);
        }, t.prototype.toString = function () {
          return "{W: " + this.width + ", H: " + this.height + "}";
        }, t.prototype.getClassName = function () {
          return "Size";
        }, t.prototype.getHashCode = function () {
          var e = this.width || 0;
          return e = 397 * e ^ (this.height || 0);
        }, t.prototype.copyFrom = function (e) {
          this.width = e.width, this.height = e.height;
        }, t.prototype.copyFromFloats = function (e, n) {
          return this.width = e, this.height = n, this;
        }, t.prototype.set = function (e, n) {
          return this.copyFromFloats(e, n);
        }, t.prototype.multiplyByFloats = function (e, n) {
          return new t(this.width * e, this.height * n);
        }, t.prototype.clone = function () {
          return new t(this.width, this.height);
        }, t.prototype.equals = function (e) {
          return !!e && this.width === e.width && this.height === e.height;
        }, t.prototype.add = function (e) {
          return new t(this.width + e.width, this.height + e.height);
        }, t.prototype.subtract = function (e) {
          return new t(this.width - e.width, this.height - e.height);
        }, t;
      }();

      n.Size = a;
    }, function (t, a, r) {
      "use strict";

      var _o5,
          d = this && this.__extends || (_o5 = function o(e, n) {
        return (_o5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });

      var c = r(0),
          s = r(4),
          l = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.loop = !1, t.volume = 1, t.url = e, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "url", void 0), i([c.ObservableComponent.field], e.prototype, "loop", void 0), i([c.ObservableComponent.field], e.prototype, "loadingCompleteEventId", void 0), i([c.ObservableComponent.field], e.prototype, "volume", void 0), e = i([c.DisposableComponent("engine.AudioClip", s.CLASS_ID.AUDIO_CLIP)], e);
      }(c.ObservableComponent);

      a.AudioClip = l;

      var m = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          if (t.audioClip = e, t.loop = !1, t.volume = 1, t.playing = !1, t.pitch = 1, !(e instanceof l)) throw new Error("Trying to create AudioSource(AudioClip) with an invalid AudioClip");
          return t.audioClipId = c.getComponentId(e), t;
        }

        return d(e, n), e.prototype.playOnce = function () {
          return this.playing = !0, this.dirty = !0, this.data.nonce = Math.random(), this;
        }, i([c.ObservableComponent.readonly], e.prototype, "audioClipId", void 0), i([c.ObservableComponent.field], e.prototype, "loop", void 0), i([c.ObservableComponent.field], e.prototype, "volume", void 0), i([c.ObservableComponent.field], e.prototype, "playing", void 0), i([c.ObservableComponent.field], e.prototype, "pitch", void 0), e = i([c.Component("engine.AudioSource", s.CLASS_ID.AUDIO_SOURCE)], e);
      }(c.ObservableComponent);

      a.AudioSource = m;

      var p = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.playing = !1, t.volume = 1, t.url = e, t.playing = !0, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "url", void 0), i([c.ObservableComponent.field], e.prototype, "playing", void 0), i([c.ObservableComponent.field], e.prototype, "volume", void 0), e = i([c.Component("engine.AudioStream", s.CLASS_ID.AUDIO_STREAM)], e);
      }(c.ObservableComponent);

      a.AudioStream = p;
    }, function (t, a, r) {
      "use strict";

      var _o6,
          d = this && this.__extends || (_o6 = function o(e, n) {
        return (_o6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });
      var c = r(0),
          s = r(4);
      !function (e) {
        e.MOVE = "MOVE", e.ROTATE = "ROTATE", e.SCALE = "SCALE", e.NONE = "NONE";
      }(a.Gizmo || (a.Gizmo = {}));

      var l = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.type = "gizmoEvent", e;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.gizmoEvent", s.CLASS_ID.UUID_CALLBACK)], e);
      }(s.OnUUIDEvent);

      a.OnGizmoEvent = l;

      var m = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.position = !0, e.rotation = !0, e.scale = !0, e.cycle = !0, e.localReference = !1, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "position", void 0), i([c.ObservableComponent.field], e.prototype, "rotation", void 0), i([c.ObservableComponent.field], e.prototype, "scale", void 0), i([c.ObservableComponent.field], e.prototype, "cycle", void 0), i([c.ObservableComponent.field], e.prototype, "selectedGizmo", void 0), i([c.ObservableComponent.field], e.prototype, "localReference", void 0), e = i([c.Component("engine.gizmos", s.CLASS_ID.GIZMOS)], e);
      }(c.ObservableComponent);

      a.Gizmos = m;
    }, function (t, a, r) {
      "use strict";

      var _o7,
          d = this && this.__extends || (_o7 = function o(e, n) {
        return (_o7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });

      var c = r(0),
          s = r(4),
          l = r(5),
          m = function (n) {
        function e(e) {
          var t = n.call(this) || this;
          return t.name = null, t.visible = !0, t.opacity = 1, t.hAlign = "center", t.vAlign = "center", t.width = "100px", t.height = "50px", t.positionX = "0px", t.positionY = "0px", t.isPointerBlocker = !0, e && (t._parent = e, t.data.parentComponent = c.getComponentId(e)), t;
        }

        return d(e, n), Object.defineProperty(e.prototype, "parent", {
          get: function get() {
            return this._parent;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "parentComponent", {
          get: function get() {
            return this.data.parentComponent;
          },
          enumerable: !0,
          configurable: !0
        }), i([c.ObservableComponent.field], e.prototype, "name", void 0), i([c.ObservableComponent.field], e.prototype, "visible", void 0), i([c.ObservableComponent.field], e.prototype, "opacity", void 0), i([c.ObservableComponent.field], e.prototype, "hAlign", void 0), i([c.ObservableComponent.field], e.prototype, "vAlign", void 0), i([c.ObservableComponent.uiValue], e.prototype, "width", void 0), i([c.ObservableComponent.uiValue], e.prototype, "height", void 0), i([c.ObservableComponent.uiValue], e.prototype, "positionX", void 0), i([c.ObservableComponent.uiValue], e.prototype, "positionY", void 0), i([c.ObservableComponent.field], e.prototype, "isPointerBlocker", void 0), e;
      }(c.ObservableComponent);

      a.UIShape = m;

      var p = function (n) {
        function e() {
          return n.call(this, null) || this;
        }

        return d(e, n), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_FULLSCREEN_SHAPE)], e);
      }(m);

      a.UIFullScreen = p;

      var x = function (n) {
        function e() {
          return n.call(this, null) || this;
        }

        return d(e, n), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_WORLD_SPACE_SHAPE)], e);
      }(m);

      a.UIWorldSpace = x;

      var k = function (n) {
        function e() {
          return n.call(this, null) || this;
        }

        return d(e, n), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_SCREEN_SPACE_SHAPE)], e);
      }(m);

      a.UICanvas = k;

      var u,
          f = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.adaptWidth = !1, e.adaptHeight = !1, e.thickness = 0, e.color = l.Color4.Clear(), e.alignmentUsesSize = !0, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "adaptWidth", void 0), i([c.ObservableComponent.field], e.prototype, "adaptHeight", void 0), i([c.ObservableComponent.field], e.prototype, "thickness", void 0), i([c.ObservableComponent.field], e.prototype, "color", void 0), i([c.ObservableComponent.field], e.prototype, "alignmentUsesSize", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_CONTAINER_RECT)], e);
      }(m);

      a.UIContainerRect = f, function (e) {
        e[e.VERTICAL = 0] = "VERTICAL", e[e.HORIZONTAL = 1] = "HORIZONTAL";
      }(u = a.UIStackOrientation || (a.UIStackOrientation = {}));

      var T = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.adaptWidth = !0, e.adaptHeight = !0, e.color = l.Color4.Clear(), e.stackOrientation = u.VERTICAL, e.spacing = 0, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "adaptWidth", void 0), i([c.ObservableComponent.field], e.prototype, "adaptHeight", void 0), i([c.ObservableComponent.field], e.prototype, "color", void 0), i([c.ObservableComponent.field], e.prototype, "stackOrientation", void 0), i([c.ObservableComponent.field], e.prototype, "spacing", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_CONTAINER_STACK)], e);
      }(m);

      a.UIContainerStack = T;

      var C = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.fontSize = 10, e.fontWeight = "normal", e.thickness = 0, e.cornerRadius = 0, e.color = l.Color4.White(), e.background = l.Color4.White(), e.paddingTop = 0, e.paddingRight = 0, e.paddingBottom = 0, e.paddingLeft = 0, e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0, e.shadowColor = l.Color4.Black(), e.text = "button", e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "fontSize", void 0), i([c.ObservableComponent.field], e.prototype, "fontWeight", void 0), i([c.ObservableComponent.field], e.prototype, "thickness", void 0), i([c.ObservableComponent.field], e.prototype, "cornerRadius", void 0), i([c.ObservableComponent.field], e.prototype, "color", void 0), i([c.ObservableComponent.field], e.prototype, "background", void 0), i([c.ObservableComponent.field], e.prototype, "paddingTop", void 0), i([c.ObservableComponent.field], e.prototype, "paddingRight", void 0), i([c.ObservableComponent.field], e.prototype, "paddingBottom", void 0), i([c.ObservableComponent.field], e.prototype, "paddingLeft", void 0), i([c.ObservableComponent.field], e.prototype, "shadowBlur", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetX", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetY", void 0), i([c.ObservableComponent.field], e.prototype, "shadowColor", void 0), i([c.ObservableComponent.field], e.prototype, "text", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_BUTTON_SHAPE)], e);
      }(m);

      a.UIButton = C;

      var R = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.outlineWidth = 0, e.outlineColor = l.Color4.White(), e.color = l.Color4.White(), e.fontSize = 10, e.fontAutoSize = !1, e.fontWeight = "normal", e.value = "", e.lineSpacing = 0, e.lineCount = 0, e.adaptWidth = !1, e.adaptHeight = !1, e.textWrapping = !1, e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0, e.shadowColor = l.Color4.Black(), e.hTextAlign = "left", e.vTextAlign = "bottom", e.paddingTop = 0, e.paddingRight = 0, e.paddingBottom = 0, e.paddingLeft = 0, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "outlineWidth", void 0), i([c.ObservableComponent.field], e.prototype, "outlineColor", void 0), i([c.ObservableComponent.field], e.prototype, "color", void 0), i([c.ObservableComponent.field], e.prototype, "fontSize", void 0), i([c.ObservableComponent.field], e.prototype, "fontAutoSize", void 0), i([c.ObservableComponent.field], e.prototype, "fontWeight", void 0), i([c.ObservableComponent.component], e.prototype, "font", void 0), i([c.ObservableComponent.field], e.prototype, "value", void 0), i([c.ObservableComponent.field], e.prototype, "lineSpacing", void 0), i([c.ObservableComponent.field], e.prototype, "lineCount", void 0), i([c.ObservableComponent.field], e.prototype, "adaptWidth", void 0), i([c.ObservableComponent.field], e.prototype, "adaptHeight", void 0), i([c.ObservableComponent.field], e.prototype, "textWrapping", void 0), i([c.ObservableComponent.field], e.prototype, "shadowBlur", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetX", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetY", void 0), i([c.ObservableComponent.field], e.prototype, "shadowColor", void 0), i([c.ObservableComponent.field], e.prototype, "hTextAlign", void 0), i([c.ObservableComponent.field], e.prototype, "vTextAlign", void 0), i([c.ObservableComponent.field], e.prototype, "paddingTop", void 0), i([c.ObservableComponent.field], e.prototype, "paddingRight", void 0), i([c.ObservableComponent.field], e.prototype, "paddingBottom", void 0), i([c.ObservableComponent.field], e.prototype, "paddingLeft", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_TEXT_SHAPE)], e);
      }(m);

      a.UIText = R;

      var y = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.outlineWidth = 0, e.outlineColor = l.Color4.Black(), e.color = l.Color4.Clear(), e.thickness = 1, e.fontSize = 10, e.fontWeight = "normal", e.value = "", e.placeholderColor = l.Color4.White(), e.placeholder = "", e.margin = 10, e.maxWidth = 100, e.hTextAlign = "left", e.vTextAlign = "bottom", e.autoStretchWidth = !0, e.background = l.Color4.Black(), e.focusedBackground = l.Color4.Black(), e.textWrapping = !1, e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0, e.shadowColor = l.Color4.White(), e.paddingTop = 0, e.paddingRight = 0, e.paddingBottom = 0, e.paddingLeft = 0, e.onTextSubmit = null, e.onChanged = null, e.onFocus = null, e.onBlur = null, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "outlineWidth", void 0), i([c.ObservableComponent.field], e.prototype, "outlineColor", void 0), i([c.ObservableComponent.field], e.prototype, "color", void 0), i([c.ObservableComponent.field], e.prototype, "thickness", void 0), i([c.ObservableComponent.field], e.prototype, "fontSize", void 0), i([c.ObservableComponent.field], e.prototype, "fontWeight", void 0), i([c.ObservableComponent.component], e.prototype, "font", void 0), i([c.ObservableComponent.field], e.prototype, "value", void 0), i([c.ObservableComponent.field], e.prototype, "placeholderColor", void 0), i([c.ObservableComponent.field], e.prototype, "placeholder", void 0), i([c.ObservableComponent.field], e.prototype, "margin", void 0), i([c.ObservableComponent.field], e.prototype, "maxWidth", void 0), i([c.ObservableComponent.field], e.prototype, "hTextAlign", void 0), i([c.ObservableComponent.field], e.prototype, "vTextAlign", void 0), i([c.ObservableComponent.field], e.prototype, "autoStretchWidth", void 0), i([c.ObservableComponent.field], e.prototype, "background", void 0), i([c.ObservableComponent.field], e.prototype, "focusedBackground", void 0), i([c.ObservableComponent.field], e.prototype, "textWrapping", void 0), i([c.ObservableComponent.field], e.prototype, "shadowBlur", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetX", void 0), i([c.ObservableComponent.field], e.prototype, "shadowOffsetY", void 0), i([c.ObservableComponent.field], e.prototype, "shadowColor", void 0), i([c.ObservableComponent.field], e.prototype, "paddingTop", void 0), i([c.ObservableComponent.field], e.prototype, "paddingRight", void 0), i([c.ObservableComponent.field], e.prototype, "paddingBottom", void 0), i([c.ObservableComponent.field], e.prototype, "paddingLeft", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onTextSubmit", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onChanged", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onFocus", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onBlur", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_INPUT_TEXT_SHAPE)], e);
      }(m);

      a.UIInputText = y;

      var h = function (n) {
        function e(e, t) {
          var a = n.call(this, e) || this;
          return a.sourceLeft = 0, a.sourceTop = 0, a.sourceWidth = 1, a.sourceHeight = 1, a.paddingTop = 0, a.paddingRight = 0, a.paddingBottom = 0, a.paddingLeft = 0, a.sizeInPixels = !0, a.onClick = null, a.source = t, a;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "sourceLeft", void 0), i([c.ObservableComponent.field], e.prototype, "sourceTop", void 0), i([c.ObservableComponent.field], e.prototype, "sourceWidth", void 0), i([c.ObservableComponent.field], e.prototype, "sourceHeight", void 0), i([c.ObservableComponent.component], e.prototype, "source", void 0), i([c.ObservableComponent.field], e.prototype, "paddingTop", void 0), i([c.ObservableComponent.field], e.prototype, "paddingRight", void 0), i([c.ObservableComponent.field], e.prototype, "paddingBottom", void 0), i([c.ObservableComponent.field], e.prototype, "paddingLeft", void 0), i([c.ObservableComponent.field], e.prototype, "sizeInPixels", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onClick", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_IMAGE_SHAPE)], e);
      }(m);

      a.UIImage = h;

      var g = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.valueX = 0, e.valueY = 0, e.borderColor = l.Color4.White(), e.backgroundColor = l.Color4.Clear(), e.isHorizontal = !1, e.isVertical = !1, e.paddingTop = 0, e.paddingRight = 0, e.paddingBottom = 0, e.paddingLeft = 0, e.onChanged = null, e;
        }

        return d(e, n), i([c.ObservableComponent.field], e.prototype, "valueX", void 0), i([c.ObservableComponent.field], e.prototype, "valueY", void 0), i([c.ObservableComponent.field], e.prototype, "borderColor", void 0), i([c.ObservableComponent.field], e.prototype, "backgroundColor", void 0), i([c.ObservableComponent.field], e.prototype, "isHorizontal", void 0), i([c.ObservableComponent.field], e.prototype, "isVertical", void 0), i([c.ObservableComponent.field], e.prototype, "paddingTop", void 0), i([c.ObservableComponent.field], e.prototype, "paddingRight", void 0), i([c.ObservableComponent.field], e.prototype, "paddingBottom", void 0), i([c.ObservableComponent.field], e.prototype, "paddingLeft", void 0), i([s.OnUUIDEvent.uuidEvent], e.prototype, "onChanged", void 0), e = i([c.DisposableComponent("engine.shape", s.CLASS_ID.UI_SLIDER_SHAPE)], e);
      }(m);

      a.UIScrollRect = g;
    }, function (t, a, r) {
      "use strict";

      var _o8,
          d = this && this.__extends || (_o8 = function o(e, n) {
        return (_o8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });

      var c = r(0),
          s = r(4),
          l = function (n) {
        function e() {
          var e = null !== n && n.apply(this, arguments) || this;
          return e.useDummyModel = !1, e;
        }

        var t;
        return d(e, n), t = e, e.Dummy = function () {
          var e = new t();
          return e.useDummyModel = !0, e;
        }, i([c.ObservableComponent.field], e.prototype, "id", void 0), i([c.ObservableComponent.field], e.prototype, "name", void 0), i([c.ObservableComponent.field], e.prototype, "expressionTriggerId", void 0), i([c.ObservableComponent.field], e.prototype, "expressionTriggerTimestamp", void 0), i([c.ObservableComponent.field], e.prototype, "bodyShape", void 0), i([c.ObservableComponent.field], e.prototype, "wearables", void 0), i([c.ObservableComponent.field], e.prototype, "skinColor", void 0), i([c.ObservableComponent.field], e.prototype, "hairColor", void 0), i([c.ObservableComponent.field], e.prototype, "eyeColor", void 0), i([c.ObservableComponent.field], e.prototype, "useDummyModel", void 0), e = t = i([c.Component("engine.avatarShape", s.CLASS_ID.AVATAR_SHAPE)], e);
      }(c.ObservableComponent);

      a.AvatarShape = l;
    }, function (t, a, r) {
      "use strict";

      var _o9,
          d = this && this.__extends || (_o9 = function o(e, n) {
        return (_o9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, n) {
          e.__proto__ = n;
        } || function (e, n) {
          for (var t in n) {
            n.hasOwnProperty(t) && (e[t] = n[t]);
          }
        })(e, n);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _o9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          i = this && this.__decorate || function (e, n, t, a) {
        var r,
            o = arguments.length,
            d = o < 3 ? n : null === a ? a = Object.getOwnPropertyDescriptor(n, t) : a;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) d = Reflect.decorate(e, n, t, a);else for (var i = e.length - 1; i >= 0; i--) {
          (r = e[i]) && (d = (o < 3 ? r(d) : o > 3 ? r(n, t, d) : r(n, t)) || d);
        }
        return o > 3 && d && Object.defineProperty(n, t, d), d;
      };

      Object.defineProperty(a, "__esModule", {
        value: !0
      });

      var c = r(0),
          s = r(14),
          l = r(4),
          m = function (n) {
        function e(e) {
          var t = n.call(this, e) || this;
          return t.type = "onFocus", s.uuidEventSystem.handlerMap[t.uuid] = t, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onFocus", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnUUIDEvent);

      a.OnFocus = m;

      var p = function (n) {
        function e(e) {
          var t = n.call(this, e) || this;
          return t.type = "onTextSubmit", s.uuidEventSystem.handlerMap[t.uuid] = t, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onTextSubmit", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnUUIDEvent);

      a.OnTextSubmit = p;

      var x = function (n) {
        function e(e) {
          var t = n.call(this, e) || this;
          return t.type = "onBlur", s.uuidEventSystem.handlerMap[t.uuid] = t, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onBlur", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnUUIDEvent);

      a.OnBlur = x;

      var k = function (n) {
        function e(e) {
          var t = n.call(this, e) || this;
          return t.type = "onEnter", s.uuidEventSystem.handlerMap[t.uuid] = t, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onEnter", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnUUIDEvent);

      a.OnEnter = k;

      var u = function (n) {
        function e(e) {
          var t = n.call(this, e) || this;
          return t.type = "onChange", s.uuidEventSystem.handlerMap[t.uuid] = t, t;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onChange", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnUUIDEvent);

      a.OnChanged = u;

      var f = function (n) {
        function e(e, t) {
          var a = n.call(this, e) || this;
          return a.type = "onClick", s.uuidEventSystem.handlerMap[a.uuid] = a, t && (a.showFeedback = !(!1 === t.showFeedback), t.button && (a.button = t.button), t.hoverText && (a.hoverText = t.hoverText), t.distance && (a.distance = t.distance)), a;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.onClick", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnPointerUUIDEvent);

      a.OnClick = f;

      var T = function (n) {
        function e(e, t) {
          var a = n.call(this, e) || this;
          return a.type = "pointerDown", s.uuidEventSystem.handlerMap[a.uuid] = a, t && (a.showFeedback = !(!1 === t.showFeedback), t.button && (a.button = t.button), t.hoverText && (a.hoverText = t.hoverText), t.distance && (a.distance = t.distance)), a;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.pointerDown", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnPointerUUIDEvent);

      a.OnPointerDown = T;

      var C = function (n) {
        function e(e, t) {
          var a = n.call(this, e) || this;
          return a.type = "pointerUp", s.uuidEventSystem.handlerMap[a.uuid] = a, t && (a.showFeedback = !(!1 === t.showFeedback), t.button && (a.button = t.button), t.hoverText && (a.hoverText = t.hoverText), t.distance && (a.distance = t.distance)), a;
        }

        return d(e, n), i([c.ObservableComponent.readonly], e.prototype, "type", void 0), e = i([c.Component("engine.pointerUp", l.CLASS_ID.UUID_CALLBACK)], e);
      }(l.OnPointerUUIDEvent);

      a.OnPointerUp = C;
    }, function (e, n, a) {
      "use strict";

      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = a(20),
          o = a(1),
          d = null,
          i = null,
          c = null;

      function p() {
        return c || (c = new r.Observable()), c;
      }

      n.getMessageObserver = p;

      var s = function () {
        function t() {
          var e = this;
          this.messageQueue = [], this.connected = !1, this.flushing = !1, function () {
            if (!i) {
              (i = dcl.loadModule("@decentraland/CommunicationsController")).then(function (e) {
                d = e;
              });
              var e = p();
              dcl.subscribe("comms"), dcl.onEvent(function (n) {
                "comms" === n.type && e.notifyObservers(n.data);
              });
            }

            return i;
          }().then(function (n) {
            e.connected = !0, e.flush();
          });
        }

        return t.prototype.on = function (e, n) {
          return p().add(function (t) {
            try {
              var a = JSON.parse(t.message);
              a.message === e && n(a.payload, t.sender);
            } catch (t) {
              dcl.error("Error parsing comms message " + t.message, t);
            }
          });
        }, t.prototype.sendRaw = function (e) {
          this.messageQueue.push(e), this.connected && this.flush();
        }, t.prototype.emit = function (e, n) {
          var t = JSON.stringify({
            message: e,
            payload: n
          });
          this.sendRaw(t), p().notifyObservers({
            message: t,
            sender: "self"
          });
        }, t.prototype.flush = function () {
          var e = this;

          if (0 !== this.messageQueue.length && this.connected && d && !this.flushing) {
            var n = this.messageQueue.shift();
            this.flushing = !0, dcl.callRpc(d.rpcHandle, "send", [n]).then(function (n) {
              e.flushing = !1, e.flush();
            }, function (n) {
              e.flushing = !1, o.error("Error flushing MessageBus", n);
            });
          }
        }, t;
      }();

      n.MessageBus = s;
    }]));
  }
});